import React, { useRef, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./ExhibitorsPanel.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { BsBuildingsFill } from "react-icons/bs";
import { MdChair } from "react-icons/md";

// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import visitorsImg from "../../assets/Admin_VisitorsCounts.jpg";
import exhibitorsImg from "../../assets/Admin_Exhivitors.jpg";
import formsImg from "../../assets/Admin_forms.jpg";
import paymentsImg from "../../assets/Admin_payments.jpg";
import remaindersImg from "../../assets/Admin_Remainder.jpg";
import inquery from "../../assets/feedbacks.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faSearchPlus,
  faSearchMinus,
  faFileAlt,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import { LuFileBadge2 } from "react-icons/lu";

import { FaFileImage, FaExternalLinkAlt, FaRegTrashAlt } from "react-icons/fa";

import { FaCircleCheck, FaPowerOff } from "react-icons/fa6";
import { IoMdCloseCircle } from "react-icons/io";

// React Icons package
import {
  FaTachometerAlt,
  FaUser,
  FaWpforms,
  FaMoneyBill,
  FaUserPlus,
  FaFileExport,
  FaComments,
  FaDatabase,
  FaGlobe,
  FaSignOutAlt,
  FaBars,
  FaStore,
  FaBullhorn,
  FaHardHat,
  FaEdit,
  FaTrash,
  FaEnvelope,
  FaEye,
  FaDownload,
} from "react-icons/fa";
import TemplateLogo from "../../assets/RSD_invoice_logo.png";

import jsPDF from "jspdf";
import toast from "react-hot-toast";
import UpdateCompanyName from "./UpdateCompanyName";
// import { useMemo } from 'react';

const ExhibitorsPanel = () => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const [fromEmail, setFromEmail] = useState("");
  const [senderEmail, setSenderEmail] = useState("");
  const [attachPdf, setAttachPdf] = useState("");
  const [sendCopyToAdmin, setSendCopyToAdmin] = useState("");
  const [adminCopyEmail, setAdminCopyEmail] = useState("");
  const [isSendingMail, setIsSendingMail] = useState(false);

  const [boothDesignStatus, setBoothDesignStatus] = useState("pending");
  const [boothRejectReason, setBoothRejectReason] = useState("");

  const [showTermsDeclaration, setShowTermsDeclaration] = useState(false);
  const [hideMainDashboard, setHideMainDashboard] = useState(false);
  const [hasAcceptedTerms, setHasAcceptedTerms] = useState(false);
  const [undertakingStatus, setUndertakingStatus] = useState(null);
  const [selectedCompanyName, setSelectedCompanyName] = useState(null);

  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImagePreview, setSelectedImagePreview] = useState(null);
  const [mediaImages, setMediaImages] = useState([]);

  const [remarkText, setRemarkText] = useState("");
  const [remarkSaved, setRemarkSaved] = useState(false);
  const [companyRemarks, setCompanyRemarks] = useState([]);
  const [editingRemarkId, setEditingRemarkId] = useState(null);

  const [companySearch, setCompanySearch] = useState("");
  const [bsSearch, setBsSearch] = useState("");

  const handleImageSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSelectedImage(file);
    setSelectedImagePreview(URL.createObjectURL(file));
  };

  // const [selectedMail, setSelectedMail] = useState(null);
  // const [loadingMails, setLoadingMails] = useState(false);
  // const [mailsList, setMailsList] = useState([]);
  // Add these states at the top of your component or just before your JSX:
  const [loadingMails, setLoadingMails] = React.useState(false);
  const [mailsList, setMailsList] = React.useState([
    {
      id: 1,
      subject: "Welcome to Exhibitor Dashboard",
      sent_at: "2025-08-08T09:00:00Z",
      content: "<p>Hello Exhibitor, welcome to the dashboard!</p>",
    },
    {
      id: 2,
      subject: "Your Password Reset",
      sent_at: "2025-08-07T14:30:00Z",
      content:
        "<p>You requested a password reset. Click <a href='#'>here</a> to reset.</p>",
    },
    {
      id: 3,
      subject: "Exhibition Guidelines Updated",
      sent_at: "2025-08-06T18:45:00Z",
      content:
        "<p>Please review the updated exhibition guidelines on your dashboard.</p>",
    },
  ]);
  const [selectedMail, setSelectedMail] = React.useState(mailsList[0]);

  const [showGenericSearch, setShowGenericSearch] = useState(false);

  const [showFurnitureSearch, setShowFurnitureSearch] = useState(false);
  const [showPowerSearch, setShowPowerSearch] = useState(false);
  const [showBadgeSearch, setShowBadgeSearch] = useState(false);

  const [faciaBoard, setFaciaBoard] = useState("");
  const [brands, setBrands] = useState([]);

  const [showPaymentOverlay, setShowPaymentOverlay] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [editingIndex, setEditingIndex] = useState(null);
  const [showPaymentEditor, setShowPaymentEditor] = useState(false);
  const [selectedPaymentType, setSelectedPaymentType] = useState(""); // stall | power | badge

  const [activePaymentDetailsOverlay, setActiveOverlay] = useState(null);
  const [selectedStallIndex, setSelectedStallIndex] = useState(null);

  const [showWebsiteMenu, setShowWebsiteMenu] = useState(false);
  const [overlayContent, setOverlayContent] = useState(null);
  const [showMastersMenu, setShowMastersMenu] = useState(false);
  const [showStallsMenu, setShowStallsMenu] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);
  const [showContractorsMenu, setShowContractorsMenu] = useState(false);
  const [showSearchBox, setShowSearchBox] = useState(false);

  const [editId, setEditId] = useState(null);
  const [selectedBoothId, setSelectedBoothId] = useState(null);

  const [powerType, setPowerType] = useState("");
  const [price, setPrice] = useState("");
  const [powerData, setPowerData] = useState([]);
  const [showEditForm, setShowEditForm] = useState(false);
  const [editItemId, setEditItemId] = useState(null);
  const [editPowerType, setEditPowerType] = useState("");
  const [editPrice, setEditPrice] = useState("");

  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  const [contractorEmail, setContractorEmail] = useState("");

  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [rejecting, setRejecting] = useState(false);

  const [showBusinessForm, setShowBusinessForm] = useState(false);
  const [businessName, setBusinessName] = useState("");
  const [businessData, setBusinessData] = useState([]);
  const [showEditBusinessForm, setShowEditBusinessForm] = useState(false);
  const [editBusinessId, setEditBusinessId] = useState(null);
  const [editBusinessName, setEditBusinessName] = useState("");

  const [exhibitionData, setExhibitionData] = useState([]);
  const [exhibitionImage, setExhibitionImage] = useState(null);
  const [editExhibitionImage, setEditExhibitionImage] = useState(null);
  const [showExhibitionMapForm, setShowExhibitionMapForm] = useState(false);
  const [showEditExhibitionMapForm, setShowEditExhibitionMapForm] =
    useState(false);

  const [furnitureData, setFurnitureData] = useState([]);
  const [furniturePrice, setFurniturePrice] = useState("");
  const [furnitureName, setFurnitureName] = useState("");
  const [editFurnitureName, setEditFurnitureName] = useState("");
  const [furnitureImage, setFurnitureImage] = useState(null);
  const [showAddFurnitureForm, setShowAddFurnitureForm] = useState(false);

  const [isFurnitureSaved, setIsFurnitureSaved] = useState(false);

  const [editFurnitureId, setEditFurnitureId] = useState(null);
  const [editFurniturePrice, setEditFurniturePrice] = useState("");
  const [editFurnitureImage, setEditFurnitureImage] = useState(null);
  const [showEditFurnitureForm, setShowEditFurnitureForm] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [stallData, setStallData] = useState([]);
  const [stallNumber, setStallNumber] = useState("");
  const [hallNumber, setHallNumber] = useState("");
  const [searchStallQuery, setSearchStallQuery] = useState("");
  const [showStallAddForm, setShowStallAddForm] = useState(false);
  const [showStallEditForm, setShowStallEditForm] = useState(false);
  const [editStallId, setEditStallId] = useState(null);
  const [editStallNumber, setEditStallNumber] = useState("");
  const [editHallNumber, setEditHallNumber] = useState("");
  const [usedStallNumbers, setUsedStallNumbers] = useState([]);

  const [hallsData, setHallsData] = useState([]);
  const [hallsNumber, setHallsNumber] = useState("");
  const [editHallsId, setEditHallsId] = useState(null);
  const [editHallsNumber, setEditHallsNumber] = useState("");
  const [showEditHallsForm, setShowEditHallsForm] = useState(false);
  const [showAddHallsForm, setShowAddHallsForm] = useState(false);
  const [searchHallsQuery, setSearchHallsQuery] = useState("");
  const [stallCategories, setStallCategories] = useState([]);
  const [searchStallCategoriesQuery, setSearchStallCategoriesQuery] =
    useState("");
  const [stallCategoryDollar, setStallCategoryDollar] = useState("");
  const [stallCategoryEuro, setStallCategoryEuro] = useState("");
  const [editStallCategoryDollar, setEditStallCategoryDollar] = useState("");
  const [editStallCategoryEuro, setEditStallCategoryEuro] = useState("");

  const [showFaciaBoardTab, setShowFaciaBoardTab] = useState(false);

  const [showStallCategoriesAddForm, setShowStallCategoriesAddForm] =
    useState(false);
  const [stallCategory, setStallCategory] = useState("");
  const [stallCategoryType, setStallCategoryType] = useState("Bare Space");
  const [stallCategoryPrice, setStallCategoryPrice] = useState("");

  const [editStallCategoriesId, setEditStallCategoriesId] =
    React.useState(null);
  const [editStallCategory, setEditStallCategory] = React.useState("");
  const [editStallCategoryType, setEditStallCategoryType] =
    React.useState("Bare Space");
  const [editStallCategoryPrice, setEditStallCategoryPrice] =
    React.useState("");
  const [showStallCategoriesEditForm, setShowStallCategoriesEditForm] =
    React.useState(false);

  const [stallAreas, setStallAreas] = useState([]);
  const [searchQueryStallAreas, setSearchQueryStallAreas] = useState("");
  const [showAddStallAreaForm, setShowAddStallAreaForm] = useState(false);
  const [showEditStallAreaForm, setShowEditStallAreaForm] = useState(false);
  const [editStallAreaId, setEditStallAreaId] = useState(null);
  const [editStallArea, setEditStallArea] = useState("");
  const [newStallArea, setNewStallArea] = useState("");

  // Add the following state variables
  const [brandingData, setBrandingData] = useState([]);
  const [showAddBrandingForm, setShowAddBrandingForm] = useState(false);
  const [showEditBrandingForm, setShowEditBrandingForm] = useState(false);
  const [brandingImage, setBrandingImage] = useState(null);
  const [brandingName, setBrandingName] = useState("");
  const [brandingHeight, setBrandingHeight] = useState("");
  const [brandingWidth, setBrandingWidth] = useState("");
  const [brandingArea, setBrandingArea] = useState("");
  const [brandingFixedPrice, setBrandingFixedPrice] = useState("");
  const [brandingTotalPrice, setBrandingTotalPrice] = useState("");
  const [searchBrandingQuery, setSearchBrandingQuery] = useState("");
  const [editBrandingItem, setEditBrandingItem] = useState(null);

  // Taxes States
  const [taxesData, setTaxesData] = useState([]);
  const [taxName, setTaxName] = useState("");
  const [taxValue, setTaxValue] = useState("");
  const [editTaxId, setEditTaxId] = useState(null);
  const [editTaxName, setEditTaxName] = useState("");
  const [editTaxValue, setEditTaxValue] = useState("");

  // New states for Products
  const [products, setProducts] = useState([]);
  const [showAddProductForm, setShowAddProductForm] = useState(false);
  const [showEditProductForm, setShowEditProductForm] = useState(false);
  const [editProductId, setEditProductId] = useState(null);
  const [editProductName, setEditProductName] = useState("");
  const [newProductName, setNewProductName] = useState("");

  const [currencyData, setCurrencyData] = useState([]);
  const [currencyName, setCurrencyName] = useState("");
  const [searchCurrencyQuery, setSearchCurrencyQuery] = useState("");
  const [showCurrencyAddForm, setShowCurrencyAddForm] = useState(false);
  const [showCurrencyEditForm, setShowCurrencyEditForm] = useState(false);
  const [editCurrencyId, setEditCurrencyId] = useState(null);
  const [editCurrencyName, setEditCurrencyName] = useState("");

  const [badgeLimitsData, setBadgeLimitsData] = useState([]);
  const [searchBadgeQuery, setSearchBadgeQuery] = useState("");
  const [showBadgeLimitsAddForm, setShowBadgeLimitsAddForm] = useState(false);
  const [showBadgeLimitsEditForm, setShowBadgeLimitsEditForm] = useState(false);
  const [minSqFt, setMinSqFt] = useState("");
  const [maxSqFt, setMaxSqFt] = useState("");
  const [noOfBadges, setNoOfBadges] = useState("");
  const [editMinSqFt, setEditMinSqFt] = useState("");
  const [editMaxSqFt, setEditMaxSqFt] = useState("");
  const [editNoOfBadges, setEditNoOfBadges] = useState("");
  const [editingId, setEditingId] = useState(null);

  const [contractorRequirementData, setContractorRequirementData] = useState(
    [],
  );
  const [searchContractorQuery, setSearchContractorQuery] = useState("");
  const [
    showContractorRequirementAddForm,
    setShowContractorRequirementAddForm,
  ] = useState(false);
  const [
    showContractorRequirementEditForm,
    setShowContractorRequirementEditForm,
  ] = useState(false);
  const [showContractorSearch, setShowContractorSearch] = useState(false);

  const [viewedUndertaking, setViewedUndertaking] = useState(null);
  const [viewedRegistrationFees, setViewedRegistrationFees] = useState(null);

  const [contractorData, setContractorData] = useState([]);
  const [selectedContractorId, setSelectedContractorId] = useState(null);
  const [showContractorOverlay, setShowContractorOverlay] = useState(false);
  const [showContractorBadgesOverlay, setShowContractorBadgesOverlay] =
    useState(false);
  const [isUndertakingRead, setIsUndertakingRead] = useState(false);
  const [userName, setUserName] = useState("");
  const [userDesignation, setUserDesignation] = useState("");
  const [isSaved, setIsSaved] = useState(false);

  const [powerPayments, setPowerPayments] = useState([]);
  const [powerReceived, setPowerReceived] = useState("0.00");
  const [powerPending, setPowerPending] = useState("0.00");

  // Form fields
  const [powerPaymentType, setPowerPaymentType] = useState("");
  const [powerPaymentDate, setPowerPaymentDate] = useState("");
  const [powerBankName, setPowerBankName] = useState("");
  const [powerAmount, setPowerAmount] = useState("");
  const [powerTds, setPowerTds] = useState("");

  const [instructionData, setInstructionData] = useState([]);
  const [newInstructionContent, setNewInstructionContent] = useState("");
  const [editInstructionContent, setEditInstructionContent] = useState("");
  const [showExhibitorInstructionForm, setShowExhibitorInstructionForm] =
    useState(false);
  const [
    showEditExhibitorInstructionForm,
    setShowEditExhibitorInstructionForm,
  ] = useState(false);
  const [editInstructionId, setEditInstructionId] = useState(null);

  const [exhibitorScheduleData, setExhibitorScheduleData] = useState([]);
  const [exhibitorScheduleContent, setExhibitorScheduleContent] = useState("");
  const [editExhibitorScheduleContent, setEditExhibitorScheduleContent] =
    useState("");
  const [editingExhibitorScheduleId, setEditingExhibitorScheduleId] =
    useState(null);
  const [showExhibitorScheduleForm, setShowExhibitorScheduleForm] =
    useState(false);
  const [showEditExhibitorScheduleForm, setShowEditExhibitorScheduleForm] =
    useState(false);

  const [guidelineData, setGuidelineData] = useState([]);
  const [newGuidelineContent, setNewGuidelineContent] = useState("");
  const [editGuidelineId, setEditGuidelineId] = useState(null);
  const [editGuidelineContent, setEditGuidelineContent] = useState("");
  const [showGuidelineForm, setShowGuidelineForm] = useState(false);
  const [showEditGuidelineForm, setShowEditGuidelineForm] = useState(false);

  const [declarationData, setDeclarationData] = useState([]);
  const [newDeclarationContent, setNewDeclarationContent] = useState("");
  const [editDeclarationContent, setEditDeclarationContent] = useState("");
  const [editDeclarationId, setEditDeclarationId] = useState(null);
  const [showAddDeclarationForm, setShowAddDeclarationForm] = useState(false);
  const [showEditDeclarationForm, setShowEditDeclarationForm] = useState(false);

  const [contractorId, setContractorId] = useState(null);
  const [companyName, setCompanyName] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [pincode, setPincode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");

  const [receiverBankName, setReceiverBankName] = useState("");
  const [exhibitorBankName, setExhibitorBankName] = useState("");

  const [sponsorName, setSponsorName] = useState("");
  const [selectedFurnitureList, setSelectedFurnitureList] = useState([]);

  const [exhibitorData, setExhibitorData] = useState([]);
  const [showExhibitorAddForm, setShowExhibitorAddForm] = useState(false);
  const [showExhibitorEditForm, setShowExhibitorEditForm] = useState(false);
  const [editExhibitor, setEditExhibitor] = useState(null);
  const [exhibitorSearchQuery, setExhibitorSearchQuery] = useState("");
  const [activeNavbarItem, setActiveNavbarItem] = useState("BASIC DETAILS");
  const [isViewOnly, setIsViewOnly] = useState(false);

  const [currentStep, setCurrentStep] = useState(0);
  const [exhibitorSelectedDay, setExhibitorSelectedDay] = useState("");
  const [exhibitorPricePerKw, setExhibitorPricePerKw] = useState("");
  const [exhibitorPowerRequired, setExhibitorPowerRequired] = useState("");
  const [exhibitorPhase, setExhibitorPhase] = useState("Single Phase");
  const [exhibitorTotalAmount, setExhibitorTotalAmount] = useState("");
  const [exhibitorPreviewList, setExhibitorPreviewList] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [cgst, setCgst] = useState(0);
  const [sgst, setSgst] = useState(0);
  const [igst, setIgst] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);

  const [invoiceOverlayVisible, setInvoiceOverlayVisible] = useState(false);

  const [visitorMain, setVisitorMain] = useState({});
  const [visitorCards, setVisitorCards] = useState([]);
  const [showAddChoiceModal, setShowAddChoiceModal] = useState(false);
  const [showMainModal, setShowMainModal] = useState(false);
  const [showCardModal, setShowCardModal] = useState(false);

  const [mainHeader, setMainHeader] = useState("");
  const [mainText, setMainText] = useState("");
  const [cardTitle, setCardTitle] = useState("");
  const [cardDescription, setCardDescription] = useState("");

  const [editModeMain, setEditModeMain] = useState(false);
  const [editModeCard, setEditModeCard] = useState(false);

  // === For Exhibitors States ===
  const [exhibitorsMain, setExhibitorsMain] = useState({});
  const [exhibitorsCards, setExhibitorsCards] = useState([]);

  const [exhibitorsHeader, setExhibitorsHeader] = useState("");
  const [exhibitorsText, setExhibitorsText] = useState("");
  const [exhibitorsCardTitle, setExhibitorsCardTitle] = useState("");
  const [exhibitorsCardDescription, setExhibitorsCardDescription] =
    useState("");

  const [editModeExhibitorsMain, setEditModeExhibitorsMain] = useState(false);
  const [editModeExhibitorsCard, setEditModeExhibitorsCard] = useState(false);
  const [editingExhibitorsCardId, setEditingExhibitorsCardId] = useState(null);
  const [showAddExhibitorChoiceModal, setShowAddExhibitorChoiceModal] =
    useState(false);
  const [showExhibitorMainModal, setShowExhibitorMainModal] = useState(false);
  const [showExhibitorCardModal, setShowExhibitorCardModal] = useState(false);

  // Reach Yashobhoomi States
  const [reachMain, setReachMain] = useState({});
  const [reachCards, setReachCards] = useState([]);

  const [reachTitle, setReachTitle] = useState("");
  const [reachText, setReachText] = useState("");
  const [reachDescription, setReachDescription] = useState("");
  const [reachImage, setReachImage] = useState("");

  // --- Edit modes ---
  const [editModeReachMain, setEditModeReachMain] = useState(false);
  const [editModeReachCard, setEditModeReachCard] = useState(false);

  // --- Modal visibility ---
  const [showReachMainModal, setShowReachMainModal] = useState(false);
  const [showReachCardModal, setShowReachCardModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [reachPosition, setReachPosition] = useState("Right"); // default Left

  // === Visitor Metro Map ===
  const [metroMaps, setMetroMaps] = useState([]);
  const [metroDescription, setMetroDescription] = useState("");
  const [metroImage, setMetroImage] = useState("");
  const [editingMetroId, setEditingMetroId] = useState(null);
  const [showMetroModal, setShowMetroModal] = useState(false);
  const [editModeMetro, setEditModeMetro] = useState(false);

  const [furnitureVendorDetails, setFurnitureVendorDetails] = useState([]);
  const [showFurnitureVendorModal, setShowFurnitureVendorModal] =
    useState(false);
  const [furnitureVendorDescription, setFurnitureVendorDescription] =
    useState("");
  const [furnitureVendorEditMode, setFurnitureVendorEditMode] = useState(false);
  const [editingFurnitureVendorId, setEditingFurnitureVendorId] =
    useState(null);

  // About Us
  const [aboutUsData, setAboutUsData] = useState([]);
  const [ourVisionData, setOurVisionData] = useState([]);

  const [showAboutModal, setShowAboutModal] = useState(false);
  const [showVisionModal, setShowVisionModal] = useState(false);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const [editMode, setEditMode] = useState(false);
  const [showAboutChoiceModal, setShowAboutChoiceModal] = useState(false);
  // const [editingId, setEditingId] = useState(null);

  // --- State Hooks ---
  const [PoweringFutureBecomeAnExhibitor, setPoweringFutureBecomeAnExhibitor] =
    useState([]);
  const [WhyExhibitBecomeAnExhibitor, setWhyExhibitBecomeAnExhibitor] =
    useState([]);
  const [showExhibitorChoiceModal, setShowExhibitorChoiceModal] =
    useState(false);
  const [
    showPoweringFutureBecomeAnExhibitorModal,
    setShowPoweringFutureBecomeAnExhibitorModal,
  ] = useState(false);
  const [
    showWhyExhibitBecomeAnExhibitorModal,
    setShowWhyExhibitBecomeAnExhibitorModal,
  ] = useState(false);

  // Why Exhibit
  const [whyExhibitData, setWhyExhibitData] = useState([]);
  const [whyExhibitImageData, setWhyExhibitImageData] = useState([]);

  const [whyExhibitPdfData, setWhyExhibitPdfData] = useState([]);
  const [showWhyExhibitPdfModal, setShowWhyExhibitPdfModal] = useState(false);
  const [editModeWhyExhibitPdf, setEditModeWhyExhibitPdf] = useState(false);
  const [editingWhyExhibitPdfId, setEditingWhyExhibitPdfId] = useState(null);
  const [exhibitPdfTitle, setExhibitPdfTitle] = useState("");
  const [exhibitPdfFile, setExhibitPdfFile] = useState(null);

  // Modals
  const [showWhyExhibitModal, setShowWhyExhibitModal] = useState(false);
  const [showWhyExhibitImageModal, setShowWhyExhibitImageModal] =
    useState(false);

  // Fields
  const [exhibitTitle, setExhibitTitle] = useState("");
  const [exhibitText, setExhibitText] = useState("");
  const [exhibitImage, setExhibitImage] = useState(null);

  const [editModeWhyExhibit, setEditModeWhyExhibit] = useState(false);
  const [editingWhyExhibitId, setEditingWhyExhibitId] = useState(null);
  const [showWhyExhibitChoiceModal, setShowWhyExhibitChoiceModal] =
    useState(false);
  // const [exhibitImage, setExhibitImage] = useState(null);
  const [exhibitImagePreview, setExhibitImagePreview] = useState(null);

  // ==== Our Story States ====
  const [ourStoryData, setOurStoryData] = useState([]);
  const [showOurStoryModal, setShowOurStoryModal] = useState(false);

  const [storyTitle, setStoryTitle] = useState("");
  const [storyDescription, setStoryDescription] = useState("");
  const [storyEditMode, setStoryEditMode] = useState(false);
  const [editingStoryId, setEditingStoryId] = useState(null);

  // ==== Founder Section ========
  const [founderSectionData, setFounderSectionData] = useState([]);
  const [showFounderSectionModal, setShowFounderSectionModal] = useState(false);
  const [founderEditMode, setFounderEditMode] = useState(false);
  const [founderHeading, setFounderHeading] = useState("");
  const [founderDescription, setFounderDescription] = useState("");
  const [founderImage, setFounderImage] = useState(null);
  const [founderImagePreview, setFounderImagePreview] = useState(null);
  const [editingFounderId, setEditingFounderId] = useState(null);

  // ==== Footer States ====
  const [footerDetails1, setFooterDetails1] = useState([]);
  const [footerDetails2, setFooterDetails2] = useState([]);

  const [showFooterModal, setShowFooterModal] = useState(false);
  const [footerEditMode, setFooterEditMode] = useState(false);
  const [editingFooterId, setEditingFooterId] = useState(null);

  const [footerImage, setFooterImage] = useState("");
  const [footerTitle, setFooterTitle] = useState("");
  const [footerDescription, setFooterDescription] = useState("");

  // ==== Footer States ====
  const [showFooterChoiceModal, setShowFooterChoiceModal] = useState(false);
  const [showFooterDetails1Modal, setShowFooterDetails1Modal] = useState(false);
  const [showFooterDetails2Modal, setShowFooterDetails2Modal] = useState(false);
  const [footerDescription2, setFooterDescription2] = useState("");
  const [editingFooter2Id, setEditingFooter2Id] = useState(null);
  const [footerEditMode2, setFooterEditMode2] = useState(false);

  // ==== Footer States for Details 3 & 4 ====
  const [footerDetails3, setFooterDetails3] = useState([]);
  const [footerDetails4, setFooterDetails4] = useState([]);

  const [footerDescription3, setFooterDescription3] = useState("");
  const [footerTitle4, setFooterTitle4] = useState("");
  const [footerImage4, setFooterImage4] = useState("");

  const [showFooterDetails3Modal, setShowFooterDetails3Modal] = useState(false);
  const [showFooterDetails4Modal, setShowFooterDetails4Modal] = useState(false);

  const [footerEditMode3, setFooterEditMode3] = useState(false);
  const [footerEditMode4, setFooterEditMode4] = useState(false);

  const [editingFooter3Id, setEditingFooter3Id] = useState(null);
  const [editingFooter4Id, setEditingFooter4Id] = useState(null);

  // ==== Privacy Table States ====
  const [privacyDetails, setPrivacyDetails] = useState([]);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [privacyEditMode, setPrivacyEditMode] = useState(false);
  const [editingPrivacyId, setEditingPrivacyId] = useState(null);
  const [privacyTitle, setPrivacyTitle] = useState("");
  const [privacyDescription, setPrivacyDescription] = useState("");

  // ==== Terms & Conditions Table States ====
  const [termsDetails, setTermsDetails] = useState([]);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [termsEditMode, setTermsEditMode] = useState(false);
  const [editingTermsId, setEditingTermsId] = useState(null);
  const [termsTitle, setTermsTitle] = useState("");
  const [termsDescription, setTermsDescription] = useState("");
  // ==== Privacy & Terms Choice Modal State ====
  const [showPrivacyTermsChoiceModal, setShowPrivacyTermsChoiceModal] =
    useState(false);

  // ==== Rules & Policy Table States ====
  const [rulesDetails, setRulesDetails] = useState([]);
  const [showRulesModal, setShowRulesModal] = useState(false);
  const [rulesEditMode, setRulesEditMode] = useState(false);
  const [editingRulesId, setEditingRulesId] = useState(null);
  const [rulesTitle, setRulesTitle] = useState("");
  const [rulesDescription, setRulesDescription] = useState("");

  // ==== Press Release Table States ====
  const [pressReleaseDetails, setPressReleaseDetails] = useState([]);
  const [showPressReleaseModal, setShowPressReleaseModal] = useState(false);
  const [pressReleaseEditMode, setPressReleaseEditMode] = useState(false);
  const [editingPressReleaseId, setEditingPressReleaseId] = useState(null);
  const [pressReleaseTitle, setPressReleaseTitle] = useState("");
  const [pressReleaseDescription, setPressReleaseDescription] = useState("");

  const [mediaGalleryDetails, setMediaGalleryDetails] = useState([]);
  const [mediaGalleryHeading, setMediaGalleryHeading] = useState("");
  const [mediaGalleryImages, setMediaGalleryImages] = useState([]);
  const [showMediaGalleryModal, setShowMediaGalleryModal] = useState(false);
  const [mediaGalleryEditMode, setMediaGalleryEditMode] = useState(false);
  const [editingMediaGalleryId, setEditingMediaGalleryId] = useState(null);

  // ================= FLOATING CARD STATES =================
  const [floatingCards, setFloatingCards] = useState([]);
  const [showFloatingCardModal, setShowFloatingCardModal] = useState(false);
  const [isEditingFloatingCard, setIsEditingFloatingCard] = useState(false);
  const [editingFloatingCardId, setEditingFloatingCardId] = useState(null);
  const [floatingCardText, setFloatingCardText] = useState("");

  // ==== Exhibitor Login Table States ====
  const [exhibitorLoginDetails, setExhibitorLoginDetails] = useState([]);
  const [showExhibitorLoginModal, setShowExhibitorLoginModal] = useState(false);
  const [exhibitorLoginEditMode, setExhibitorLoginEditMode] = useState(false);
  const [editingExhibitorLoginId, setEditingExhibitorLoginId] = useState(null);
  const [exhibitorLoginDescription, setExhibitorLoginDescription] =
    useState("");

  const [activeOuterNavbarItem, setActiveOuterNavbarItem] = useState("");

  // ==== Unsubscribe States ====
  const [unsubscribeImages, setUnsubscribeImages] = useState([]);
  const [unsubscribeTexts, setUnsubscribeTexts] = useState([]);

  const [showUnsubChoiceModal, setShowUnsubChoiceModal] = useState(false);
  const [showUnsubImageModal, setShowUnsubImageModal] = useState(false);
  const [showUnsubTextModal, setShowUnsubTextModal] = useState(false);

  const [unsubImage, setUnsubImage] = useState("");
  const [unsubText, setUnsubText] = useState("");
  const [unsubForm, setUnsubForm] = useState("");

  const [selectedUnsubFile, setSelectedUnsubFile] = useState(null);

  const [unsubEditMode, setUnsubEditMode] = useState(false);
  const [editingUnsubImageId, setEditingUnsubImageId] = useState(null);

  const [unsubEditMode2, setUnsubEditMode2] = useState(false);
  const [editingUnsubTextId, setEditingUnsubTextId] = useState(null);

  const [activeWebsiteNavbarItem, setWebsiteActiveNavbarItem] =
    useState("Navbar");

  const [formTemplateData, setFormTemplateData] = useState({
    companyAddress:
      "A-99 Defence Colony\nNew Delhi - 110024\nPhone: +91-11-41815099\nEmail: rsdexpo@gmail.com\ninfoinoptics@gmail.com\nGST No.: 07AALPK3813G1ZT",
    recipient: "",
    address1: "",
    address2: "",
    cityCountry: "",
    date: "",
    category: "",
    stallNo: "",
    size: "",
    rate: "",
    total: "",
    discount: "",
    subtotal: "",
    sgst: "",
    cgst: "",
    grandTotal: "",
    amountWords: "",
  });

  {
    (formTemplateData.companyAddress || "")
      .split("\n")
      .map((line, i) => <p key={i}>{line}</p>);
  }

  // const handleDownloadPDF = () => {
  //   const element = document.getElementById('invoice-template');

  //   const opt = {
  //     margin: [20, 0, 0, 0],
  //     filename: 'Proforma_Invoice.pdf',
  //     image: { type: 'png', quality: 1.0 },
  //     html2canvas: {
  //       scale: 4,
  //       dpi: 600,
  //       letterRendering: true,
  //       useCORS: true,
  //       windowWidth: element.scrollWidth,
  //     },
  //     jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' },
  //     pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
  //   };

  //   html2pdf().set(opt).from(element).save();
  // };

  const handleDownloadPDF = async () => {
    const element = document.getElementById("invoice-template");
    if (!element) {
      alert("Invoice template not found!");
      return;
    }

    // Apply minimal spacing fixes
    const applyStyleRecursively = (el) => {
      el.style.wordSpacing = "-0.5px"; // Fix extra space between words
      el.style.letterSpacing = "-0.05px"; // Fix extra space within words
      Array.from(el.children).forEach(applyStyleRecursively);
    };
    applyStyleRecursively(element);

    // Inject your CSS with Arial font
    const style = document.createElement("style");
    style.textContent = `
    #invoice-template, #invoice-template * {
      word-spacing: -0.5px !important;
      letter-spacing: -0.05px !important;
    }
    .invoice-html-template {
      width: 794px;
      max-height: 1120px;
      overflow-y: auto;
      background: #fff;
      padding: 10px;
      border: 1.5px solid #000;
      margin: 0 auto;
      box-sizing: border-box;
      font-family: Arial, Helvetica, sans-serif;
      font-size: 12px;
      line-height: 1.4;
      color: #000;
    }
    .nowrap-text {
      white-space: nowrap;
    }
    .template-title {
      text-align: center;
      font-size: 22px;
      font-weight: 700;
      margin-bottom: 10px;
      letter-spacing: 0.5px;
      color: #000;
    }
    .invoice-html-template hr {
      margin: 16px auto 10px auto;
      border: none;
      border-top: 1.2px solid #000;
    }
    .invoice-header-row {
      display: flex;
      justify-content: space-between;
      margin: 6px 0;
      padding: 0 10px;
      position: relative;
    }
    .invoice-header-row::before {
      content: "";
      position: absolute;
      left: 50%;
      top: 0;
      bottom: 0;
      width: 1.2px;
      background-color: #000;
      transform: translateX(-50%);
    }
    .from-column {
      width: 50%;
      text-align: center;
    }
    .to-column {
      width: 50%;
      text-align: center;
      display: flex;
      justify-content: center;
    }
    .to-details {
      margin-top: 10px;
      text-align: center;
      display: inline-block;
      line-height: 1;
    }
    .to-details p {
      margin: 2px 0;
      font-size: 13px;
    }
    .invoice-logo {
      width: 150px;
      margin-bottom: 4px;
      object-fit: contain;
    }
    .from-address p {
      margin: 3px 0;
      font-size: 11px;
      line-height: 1.2;
      font-weight: 600;
      color: #000;
    }
    .to-column p {
      margin: 1px 0;
      font-size: 11px;
      line-height: 1.2;
      font-weight: 600;
      margin: 10px;
    }
    .invoice-meta-row {
      display: flex;
      justify-content: space-between;
      font-size: 13px;
      font-weight: 400;
      margin-bottom: -20px;
      color: #000;
    }
    .invoice-meta-left,
    .invoice-meta-right {
      flex: 1;
    }
    .invoice-meta-right {
      text-align: right;
    }
    .invoice-note-line {
      font-size: 11px;
      text-align: center;
      font-weight: 500;
      margin: 10px 0;
    }
    .invoice-table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 10px;
    }
    .invoice-table th,
    .invoice-table td {
      border: 1.2px solid #000;
      text-align: center;
      font-size: 11px;
      font-weight: 500;
    }
    .invoice-table thead {
      background-color: #f0f0f0;
    }
    .particular-cell {
      text-align: left;
      padding-left: 8px;
      vertical-align: top !important;
      z-index: 9999;
    }
      .particular-cell div {
    margin: 0;
    padding: 0;
    line-height: 1.2;
  }
    .bank-details {
      margin-top: 16px;
    }
    .bank-details h4 {
      font-size: 14px;
      margin-bottom: 8px;
      text-align: center;
      font-weight: 700;
      color: #000;
    }
    .bank-row {
      display: flex;
      justify-content: space-between;
      gap: 10px;
      margin-top: 10px;
    }
    .bank-column {
      flex: 1 1 23%;
      border: 1.2px solid #000;
      padding: 8px;
      font-size: 10px;
      background-color: #fdfdfd;
      color: #000;
    }
    .bank-column p {
      margin: 4px 0;
      font-size: 10px;
    }
    .bank-column p strong {
      color: #000;
      font-weight: 600;
    }
    .invoice-footer {
      margin-top: 20px;
      text-align: center;
      font-size: 10px;
      line-height: 1.5;
      font-weight: 600;
      color: #000;
    }
    .invoice-footer p {
      margin: 2px 0;
      font-weight: 500;
    }
      .summary-table td:last-child {
  text-align: right;
  padding-right: 20px;
  white-space: nowrap; 
}

.summary-table td:first-child {
  text-align: right;
  padding-right: 10px;
}
  `;
    document.head.appendChild(style);

    // Use px units to match CSS
    const pdf = new jsPDF({
      orientation: "p",
      unit: "px",
      format: [595, 842],
      hotfixes: ["px_scaling"],
    });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const marginTop = 20;
    const marginLeft = 10;
    const marginRight = 10;

    const elementWidth = element.scrollWidth; // Likely ~794px
    const elementHeight = element.scrollHeight;

    // Calculate scale to fit 794px width into 595px (A4 width)
    const scaleX = (pageWidth - marginLeft - marginRight) / elementWidth;
    const scaleY = (pageHeight - marginTop) / elementHeight;
    const scale = Math.min(scaleX, scaleY); // Keep original scale logic

    pdf.html(element, {
      x: marginLeft,
      y: marginTop,
      html2canvas: {
        scale: scale,
        useCORS: true,
        scrollY: 0,
      },
      width: pageWidth - marginLeft - marginRight, // Fit to A4 width
      autoPaging: "text",
      callback: function (pdf) {
        // Save with appropriate filename based on activePaymentDetailsOverlay
        const filename =
          activePaymentDetailsOverlay === "stall"
            ? "Proforma_Invoice_Stall.pdf"
            : "Proforma_Invoice_Power.pdf";
        pdf.save(filename);
        document.head.removeChild(style); // Clean up
      },
    });
  };

  // const handleSendPDFEmail = async () => {
  //   try {
  //     const element = document.getElementById('invoice-template');

  //     // Use company name from your data
  //     const companyName = stallList?.[0]?.company_name || 'Company';
  //     const fileName = `${companyName}_Stalls_Proforma_Invoice.pdf`;

  //     // Convert HTML to PDF Blob
  //     const pdfBlob = await html2pdf().from(element).outputPdf('blob');

  //     // Create a new File object from Blob
  //     const pdfFile = new File([pdfBlob], fileName, { type: 'application/pdf' });

  //     // Prepare FormData
  //     const formData = new FormData();
  //     formData.append('pdf', pdfFile);
  //     formData.append('to_email', formTemplateData.receiverEmail || 'default@inoptics.in');
  //     formData.append('subject', `Proforma Invoice of STALLS - ${companyName}`);
  //     formData.append('body', `Dear ${companyName},\n\nPlease find your Proforma Invoice attached.\n\nRegards,\nInOptics Accounts`);

  //     // Send to backend
  //     const res = await axios.post(
  //       'https://inoptics.in/api/send-invoice-StallPayment-email.php',
  //       formData,
  //       {
  //         headers: { 'Content-Type': 'multipart/form-data' },
  //       }
  //     );

  //     alert('✅ Email sent successfully!');
  //   } catch (err) {
  //     console.error('Email send failed:', err);
  //     alert('❌ Failed to send email. Please try again later.');
  //   }
  // };

  const handleSendPDFEmail = async () => {
    try {
      const element = document.getElementById("invoice-template");
      if (!element) {
        alert("Invoice template not found!");
        return;
      }

      // Apply minimal spacing fixes
      const applyStyleRecursively = (el) => {
        el.style.wordSpacing = "-0.5px"; // Fix extra space between words
        el.style.letterSpacing = "-0.05px"; // Fix extra space within words
        Array.from(el.children).forEach(applyStyleRecursively);
      };
      applyStyleRecursively(element);

      // Inject same CSS with Arial font as handleDownloadPDF
      const style = document.createElement("style");
      style.textContent = `
      #invoice-template, #invoice-template * {
        word-spacing: -0.5px !important;
        letter-spacing: -0.05px !important;
      }
      .invoice-html-template {
        width: 794px;
        max-height: 1120px;
        overflow-y: auto;
        background: #fff;
        padding: 10px;
        border: 1.5px solid #000;
        margin: 0 auto;
        box-sizing: border-box;
        font-family: Arial, Helvetica, sans-serif;
        font-size: 12px;
        line-height: 1.4;
        color: #000;
      }
      .nowrap-text {
        white-space: nowrap;
      }
      .template-title {
        text-align: center;
        font-size: 22px;
        font-weight: 700;
        margin-bottom: 10px;
        letter-spacing: 0.5px;
        color: #000;
      }
      .invoice-html-template hr {
        margin: 16px auto 10px auto;
        border: none;
        border-top: 1.2px solid #000;
      }
      .invoice-header-row {
        display: flex;
        justify-content: space-between;
        margin: 6px 0;
        padding: 0 10px;
        position: relative;
      }
      .invoice-header-row::before {
        content: "";
        position: absolute;
        left: 50%;
        top: 0;
        bottom: 0;
        width: 1.2px;
        background-color: #000;
        transform: translateX(-50%);
      }
      .from-column {
        width: 50%;
        text-align: center;
      }
      .to-column {
        width: 50%;
        text-align: center;
        display: flex;
        justify-content: center;
      }
      .to-details {
        margin-top: 10px;
        text-align: center;
        display: inline-block;
        line-height: 1;
      }
      .to-details p {
        margin: 2px 0;
        font-size: 13px;
      }
      .invoice-logo {
        width: 150px;
        margin-bottom: 4px;
        object-fit: contain;
      }
      .from-address p {
        margin: 3px 0;
        font-size: 11px;
        line-height: 1.2;
        font-weight: 600;
        color: #000;
      }
      .to-column p {
        margin: 1px 0;
        font-size: 11px;
        line-height: 1.2;
        font-weight: 600;
        margin: 10px;
      }
      .invoice-meta-row {
        display: flex;
        justify-content: space-between;
        font-size: 13px;
        font-weight: 400;
        margin-bottom: -20px;
        color: #000;
      }
      .invoice-meta-left,
      .invoice-meta-right {
        flex: 1;
      }
      .invoice-meta-right {
        text-align: right;
      }
      .invoice-note-line {
        font-size: 11px;
        text-align: center;
        font-weight: 500;
        margin: 10px 0;
      }
      .invoice-table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 10px;
      }
      .invoice-table th,
      .invoice-table td {
        border: 1.2px solid #000;
        text-align: center;
        font-size: 11px;
        font-weight: 500;
      }
      .invoice-table thead {
        background-color: #f0f0f0;
      }
      .particular-cell {
        text-align: left;
        padding-left: 8px;
      }
      .bank-details {
        margin-top: 16px;
      }
      .bank-details h4 {
        font-size: 14px;
        margin-bottom: 8px;
        text-align: center;
        font-weight: 700;
        color: #000;
      }
      .bank-row {
        display: flex;
        justify-content: space-between;
        gap: 10px;
        margin-top: 10px;
      }
      .bank-column {
        flex: 1 1 23%;
        border: 1.2px solid #000;
        padding: 8px;
        font-size: 10px;
        background-color: #fdfdfd;
        color: #000;
      }
      .bank-column p {
        margin: 4px 0;
        font-size: 10px;
      }
      .bank-column p strong {
        color: #000;
        font-weight: 600;
      }
      .invoice-footer {
        margin-top: 20px;
        text-align: center;
        font-size: 10px;
        line-height: 1.5;
        font-weight: 600;
        color: #000;
      }
      .invoice-footer p {
        margin: 2px 0;
        font-weight: 500;
      }
        .summary-table td:last-child {
  text-align: right;
  white-space: nowrap; /* prevents line breaks */
}

.summary-table td:first-child {
  text-align: right;
  padding-right: 10px;
}
    `;
      document.head.appendChild(style);

      // Use px units to match CSS
      const pdf = new jsPDF({
        orientation: "p",
        unit: "px",
        format: [595, 842],
        hotfixes: ["px_scaling"],
      });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const marginTop = 20;
      const marginLeft = 10;
      const marginRight = 10;

      const elementWidth = element.scrollWidth; // Likely ~794px
      const elementHeight = element.scrollHeight;

      // Calculate scale to fit 794px width into 595px (A4 width)
      const scaleX = (pageWidth - marginLeft - marginRight) / elementWidth;
      const scaleY = (pageHeight - marginTop) / elementHeight;
      const scale = Math.min(scaleX, scaleY); // Keep original scale logic

      // Generate PDF as Blob
      const pdfBlob = await new Promise((resolve) => {
        pdf.html(element, {
          x: marginLeft,
          y: marginTop,
          html2canvas: {
            scale: scale,
            useCORS: true,
            scrollY: 0,
          },
          width: pageWidth - marginLeft - marginRight,
          autoPaging: "text",
          callback: (pdfInstance) => {
            const blob = pdfInstance.output("blob");
            resolve(blob);
            document.head.removeChild(style); // Clean up
          },
        });
      });

      const companyName = stallList?.[0]?.company_name || "Company";
      const fileName =
        activePaymentDetailsOverlay === "stall"
          ? `${companyName}_Stalls_Proforma_Invoice.pdf`
          : `${companyName}_Power_Proforma_Invoice.pdf`;
      const pdfFile = new File([pdfBlob], fileName, {
        type: "application/pdf",
      });

      // Send via backend
      const formData = new FormData();
      formData.append("pdf", pdfFile);
      formData.append(
        "to_email",
        formTemplateData.receiverEmail || "default@inoptics.in",
      );
      formData.append(
        "subject",
        activePaymentDetailsOverlay === "stall"
          ? `Proforma Invoice of STALLS - ${companyName}`
          : `Proforma Invoice of POWER - ${companyName}`,
      );
      formData.append(
        "body",
        activePaymentDetailsOverlay === "stall"
          ? `Dear ${companyName},\n\nPlease find your Proforma Invoice for Stalls attached.\n\nRegards,\nInOptics Accounts`
          : `Dear ${companyName},\n\nPlease find your Proforma Invoice for Power attached.\n\nRegards,\nInOptics Accounts`,
      );

      const apiEndpoint =
        activePaymentDetailsOverlay === "stall"
          ? "https://inoptics.in/api/send-invoice-StallPayment-email.php"
          : "https://inoptics.in/api/send-invoice-PowerPayment-email.php";

      await axios.post(apiEndpoint, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("✅ Email sent successfully!");
    } catch (err) {
      console.error("Email send failed:", err);
      alert("❌ Failed to send email. Please try again later.");
    }
  };

  const [addresses, setAddresses] = useState([
    { id: 1, label: "Delhi Address", data: null, isActive: false },
    { id: 2, label: "Maharashtra Address", data: null, isActive: false },
  ]);

  const [services, setServices] = useState([]);

  const [showServiceModal, setShowServiceModal] = useState(false);
  const [currentEditingService, setCurrentEditingService] = useState(null);
  const [serviceForm, setServiceForm] = useState({
    name: "",
    description: "",
    selectedOptions: [],
  });

  const handleAddNewService = () => {
    setCurrentEditingService(null); // Add mode
    setServiceForm({ name: "", description: "", selectedOptions: [] }); // reset
    setShowServiceModal(true);
  };

  const handleEditService = (index) => {
    const serviceToEdit = services[index];
    setCurrentEditingService(index);
    setServiceForm({ ...serviceToEdit }); // will carry selectedOptions
    setShowServiceModal(true);
  };

  const handleSaveService = async () => {
    let updatedServices = [...services];

    if (currentEditingService !== null) {
      // EDIT SERVICE
      const oldService = updatedServices[currentEditingService];

      updatedServices[currentEditingService] = serviceForm;

      await fetch("https://inoptics.in/api/update_service.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          oldName: oldService.name,
          ...serviceForm,
          selectedOptions: serviceForm.selectedOptions, // ✅ send checkboxes
        }),
      });
    } else {
      // ADD SERVICE
      await fetch("https://inoptics.in/api/add_service.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...serviceForm,
          selectedOptions: serviceForm.selectedOptions, // ✅ send checkboxes
        }),
      });

      updatedServices = [...services, serviceForm];
    }

    setServices(updatedServices);
    setShowServiceModal(false);
  };

  const handleDeleteService = async (index) => {
    const serviceToDelete = services[index];

    await fetch("https://inoptics.in/api/delete_service.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name: serviceToDelete.name }),
    });

    const updatedServices = services.filter((_, i) => i !== index);
    setServices(updatedServices);
  };

  const handleSetActiveService = async (name) => {
    const updated = services.map((srv) =>
      srv.name === name
        ? { ...srv, isActive: true }
        : { ...srv, isActive: false },
    );

    setServices(updated);

    await fetch("https://inoptics.in/api/set_active_service.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name }),
    });
  };

  const handleFetchServices = async () => {
    const res = await fetch("https://inoptics.in/api/get_services.php");
    const data = await res.json();

    const updated = data.map((item) => ({
      name: item.name,
      description: item.description,
      quantityRange: item.quantityRange,
      isActive: item.is_active === "1" || item.is_active === 1,
      selectedOptions: item.selectedOptions
        ? item.selectedOptions.split(",").map((opt) => opt.trim())
        : [],
    }));

    setServices(updated);
  };

  useEffect(() => {
    handleFetchServices();
  }, []);

  const descriptions = {
    "Exhibition Services - Stalls": `**EXHIBITION SERVICES - STALLS**\nTo charges for your booth at \nInoptics 2026 @ New Delhi, \nMarch 28th–30th, 2026\nCategory/Stall No`,
    "Exhibition Services - Power Requirements": `**EXHIBITION SERVICES - POWER**\nTo charges for your power\nat Inoptics 2026 @ New Delhi, \nMarch 28th–30th, 2026`,
    "Exhibition Services - Badges": `**EXHIBITION SERVICES - BADGES**\nTo charges for exhibitor/representative badges\nfor Inoptics 2026 @ New Delhi, \nMarch 28th–30th, 2026`,
    "Exhibition Services - Promotions": `**EXHIBITION SERVICES - PROMOTIONS**\nTo charges for promotions/advertising\nfor Inoptics 2026 @ New Delhi, \nMarch 28th–30th, 2026`,
    "Exhibition Services - Sponsor": `**EXHIBITION SERVICES - SPONSOR**\nTo charges for sponsor participation\nin Inoptics 2026 @ New Delhi, \nMarch 28th–30th, 2026`,
  };
  const quantities = {
    "Exhibition Services - Stalls": "12 sq mtr",
    "Exhibition Services - Power Requirements": "8 units",
    "Exhibition Services - Badges": "10",
    "Exhibition Services - Promotions": "5 slots",
    "Exhibition Services - Sponsor": "1",
  };

  const serviceCodes = {
    "EXHIBITION SERVICES - STALLS": "S",
    "EXHIBITION SERVICES - POWER": "PR",
    "EXHIBITION SERVICES - BADGES": "EB",
    "EXHIBITION SERVICES - PROMOTIONS": "P",
    "EXHIBITION SERVICES - SPONSOR": "SP",
  };

  const [serialNumbers, setSerialNumbers] = useState({});
  const [proformaNumber, setProformaNumber] = useState("");
  const [rows, setRows] = useState([]);
  const [activeService, setActiveService] = useState(null);
  const [powerList, setPowerList] = useState([]); // Array of power objects

  const handleAddRow = (event) => {
    const selected = event.target.value;
    if (!selected) return;

    const companyName = formTemplateData.recipient; // user/company name
    const currentSerial = serialNumbers[companyName] || 1;
    const yearRange = "2025-26"; // or calculate dynamically

    // --- Handle 'All Services' ---
    if (selected === "Exhibition Services - All") {
      const allRows = services.map((service) => {
        const code = serviceCodes[service.name] || "XX";
        const formattedSerial = String(currentSerial).padStart(4, "0");

        // ✅ Generate proforma number for each service
        if (service.name === "EXHIBITION SERVICES - STALLS") {
          setProformaNumber(
            `INOPD-2026|${code}|${formattedSerial}| ${yearRange}`,
          );
        } else if (service.name === "EXHIBITION SERVICES - POWER") {
          setProformaNumber(
            `INOPD-2026|${code}|${formattedSerial}| ${yearRange}`,
          );
        }

        return {
          particular: `**${service.name}**\n${service.description}`,
          selectedOptions: service.selectedOptions || [],
          price: "",
          total: "",
        };
      });

      setRows(allRows);
      setActiveService(services[0]);
    }
    // --- Handle Single Service ---
    else {
      const selectedService = services.find(
        (service) => service.name === selected,
      );
      if (!selectedService) return;

      const code = serviceCodes[selectedService.name] || "XX";
      const formattedSerial = String(currentSerial).padStart(4, "0");
      const newProformaNo = `INOPD-2026|${code}|${formattedSerial}| ${yearRange}`;
      setProformaNumber(newProformaNo);

      // Update serial for next time
      setSerialNumbers((prev) => ({
        ...prev,
        [companyName]: currentSerial + 1,
      }));

      const newRow = {
        particular: `**${selectedService.name}**\n${selectedService.description}`,
        selectedOptions: selectedService.selectedOptions || [],
        price: "",
        total: "",
      };

      setRows([newRow]);
      setActiveService(selectedService);
    }

    event.target.value = "";
  };

  const issueDate = new Date().toLocaleDateString("en-GB"); // DD/MM/YYYY

  // Find the Stall service only once when rendering the invoice overlay
  const stallService = services.find(
    (service) => service.name === "EXHIBITION SERVICES - STALLS",
  );

  let stallProformaNumber = "";
  let stallServiceRows = [];

  if (stallService) {
    // Generate Proforma Invoice Number
    const currentSerial = serialNumbers[formTemplateData.recipient] || 1;
    const yearRange = "2025-26";
    const code = serviceCodes[stallService.name] || "S";
    stallProformaNumber = `INOPD-2026|${code}|${String(currentSerial).padStart(
      4,
      "0",
    )}| ${yearRange}`;

    // Generate table rows with Particulars + Description
    stallServiceRows = [
      {
        particular: `**${stallService.name}**\n${stallService.description}`,
        selectedOptions: stallService.selectedOptions || [],
        price: stallService.price || "",
        total: stallService.total || "",
      },
    ];
  }

  // ✅ For POWER Service
  const powerService = services.find(
    (service) => service.name === "EXHIBITION SERVICES - POWER",
  );

  let powerProformaNumber = "";
  let powerServiceRows = [];

  if (powerService) {
    const currentSerial = serialNumbers[formTemplateData.recipient] || 1;
    const yearRange = "2025-26";
    const code = serviceCodes[powerService.name] || "PR"; // different code for Power

    powerProformaNumber = `INOPD-2026|${code}|${String(currentSerial).padStart(
      4,
      "0",
    )}| ${yearRange}`;

    powerServiceRows = [
      {
        particular: `**${powerService.name}**\n${powerService.description}`,
        selectedOptions: powerService.selectedOptions || [],
        price: powerService.price || "",
        total: powerService.total || "",
      },
    ];
  }

  useEffect(() => {
    if (activePaymentDetailsOverlay === "power") {
      // Example: fetch from backend or compute from powerServiceRows
      const list = powerServiceRows.map((row) => ({
        particular: row.particular,
        price_per_kw: row.price_per_kw,
        power_required: row.power_required,
        phase: row.phase,
        total: (
          parseFloat(row.price_per_kw || 0) *
          parseFloat(row.power_required || 0)
        ).toFixed(2),
      }));
      setPowerList(list);
    }
  }, [activePaymentDetailsOverlay, powerServiceRows]);

  // const [rows, setRows] = useState([]);
  // const handleAddRow = (event) => {
  //   const selected = event.target.value;
  //   if (!selected) return;

  //   if (selected === 'Exhibition Services - All') {
  //     const allRows = services.map(service => ({
  //       particular: `**${service.name}**\n${service.description}`,
  //       quantity: service.quantityRange,
  //       price: '',
  //       total: ''
  //     }));
  //     setRows(allRows); // 🔄 Replace existing rows
  //   } else {
  //     const selectedService = services.find(service => service.name === selected);
  //     if (!selectedService) return;

  //     const newRow = {
  //       particular: `**${selectedService.name}**\n${selectedService.description}`,
  //       quantity: selectedService.quantityRange,
  //       price: '',
  //       total: ''
  //     };
  //     setRows([newRow]); // 🔄 Replace with only the new row
  //   }

  //   event.target.value = '';
  // };

  const [currentEditing, setCurrentEditing] = useState(null); // holds which address is being edited

  const [modalForm, setModalForm] = useState({
    address: "",
    state: "",
    pincode: "",
    phone: "",
    email: "",
    gst: "",
  });

  const [faciaText, setFaciaText] = useState("");
  const [stallList, setStallList] = useState([]);

  const [formData, setFormData] = useState({
    state: "",
  });

  const stallSummary = stallList?.reduce(
    (summary, stall) => {
      const total = parseFloat(stall.total || 0);
      const discount = parseFloat(stall.discounted_amount || 0);

      summary.total += total;
      summary.discounted_amount += discount;
      summary.total_after_discount += total - discount;
      summary.sgst += parseFloat(stall.sgst_9_percent || 0);
      summary.cgst += parseFloat(stall.cgst_9_percent || 0);
      summary.igst += parseFloat(stall.igst_18_percent || 0);
      summary.grand_total += parseFloat(stall.grand_total || 0);

      if (!summary.currency) summary.currency = stall.currency || "";

      return summary;
    },
    {
      total: 0,
      discounted_amount: 0,
      total_after_discount: 0, // 👈 NEW FIELD
      sgst: 0,
      cgst: 0,
      igst: 0,
      grand_total: 0,
      currency: "",
    },
  );

  const [activeCommunicationTab, setActiveCommunicationTab] =
    useState("Emails Master");
  const [emailMasterData, setEmailMasterData] = useState([]);
  const [searchEmailQuery, setSearchEmailQuery] = useState("");

  const [emailName, setEmailName] = useState("");
  const [emailContent, setEmailContent] = useState("");
  const [showCcDropdown, setShowCcDropdown] = useState(false);
  const [showBccDropdown, setShowBccDropdown] = useState(false);
  const [appliedPlace, setAppliedPlace] = useState("");

  const [showEmailMasterAddForm, setShowEmailMasterAddForm] = useState(false);
  const [showEmailMasterEditForm, setShowEmailMasterEditForm] = useState(false);
  const [selectedEmailId, setSelectedEmailId] = useState(null);
  const [showEmailSearch, setShowEmailSearch] = useState(false); // ← This is missing

  const handleAppliedPlace = (label) => {
    setAppliedPlace((prev) =>
      prev.includes(label)
        ? prev.filter((item) => item !== label)
        : [...prev, label],
    );
  };

  const [coreFormData, setCoreFormData] = useState([]);
  const [coreFormUpload, setCoreFormUpload] = useState(null);
  const [coreFormCategory, setCoreFormCategory] = useState("");
  const [showCoreFormModal, setShowCoreFormModal] = useState(false);
  const [isCoreFormEditing, setIsCoreFormEditing] = useState(false);
  const [currentCoreFormId, setCurrentCoreFormId] = useState(null);

  // Payment Form States
  const [paymentType, setPaymentType] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [bankName, setBankName] = useState("");
  const [amount, setAmount] = useState("");
  const [tds, setTds] = useState("");
  const [payments, setPayments] = useState([]);

  const [paymentData, setPaymentData] = useState([]);
  const [powerTotalsByCompany, setPowerTotalsByCompany] = useState({});

  const [activeContractorTab, setActiveContractorTab] = useState(
    "Contractors Requirement",
  );

  const [finalListData, setFinalListData] = useState([]);
  const [formsMap, setFormsMap] = useState({}); // { formName: [dataObjects] }

  // Billing Form States
  const [totalAmount, setTotalAmount] = useState("");
  const [paymentReceived, setPaymentReceived] = useState("");
  const [paymentPending, setPaymentPending] = useState("");

  const [showFurnitureList, setShowFurnitureList] = useState(false);
  const [availableFurniture, setAvailableFurniture] = useState([]);
  const [selectedFurniture, setSelectedFurniture] = useState([]);
  const [furnitureBilling, setFurnitureBilling] = useState({
    subTotal: 0,
    discountPercent: "",
    discountAmount: 0,
    amount: 0,
    sgst: 0,
    cgst: 0,
    igst: 0,
    grandTotal: 0,
  });

  const [brandsData, setBrandsData] = useState({
    website: "",
    products: [], // ✅ array
    home_brands: "",
    distributors: "",
    international_brands: "",
  });

  const handleProductSelect = (e) => {
    const selected = e.target.value;
    if (selected && !brandsData.products.includes(selected)) {
      setBrandsData((prev) => ({
        ...prev,
        products: [...prev.products, selected],
      }));
    }
    e.target.value = "";
  };

  const removeProduct = (productToRemove) => {
    setBrandsData((prev) => ({
      ...prev,
      products: prev.products.filter((p) => p !== productToRemove),
    }));
  };

  const [
    searchContractorUndertakingQuery,
    setSearchContractorUndertakingQuery,
  ] = useState("");
  const [
    showContractorUndertakingAddForm,
    setShowContractorUndertakingAddForm,
  ] = useState(false);
  const [
    showContractorUndertakingEditForm,
    setShowContractorUndertakingEditForm,
  ] = useState(false);
  const [authorizedName, setAuthorizedName] = useState("");
  // const [position, setPosition] = useState("");
  const [declarationText, setDeclarationText] = useState("");
  const [contractorUndertakingData, setContractorUndertakingData] = useState(
    [],
  );
  const [uploadedLogo, setUploadedLogo] = useState(null);
  const [undertakingDate, setUndertakingDate] = useState("");
  const [editUndertakingId, setEditUndertakingId] = useState(null);

  const [contractorBoothData, setContractorBoothData] = useState([]);
  const [searchContractorBoothQuery, setSearchContractorBoothQuery] =
    useState("");
  const [showContractorBoothAddForm, setShowContractorBoothAddForm] =
    useState(false);
  const [showContractorBoothEditForm, setShowContractorBoothEditForm] =
    useState(false);
  const [editBoothId, setEditBoothId] = useState(null);
  const [uploadedBoothImage, setUploadedBoothImage] = useState(null);

  const [actionModalType, setActionModalType] = useState(null); // "add" | "edit" | "delete"
  const [selectedItemIndex, setSelectedItemIndex] = useState(null); // index of selected row

  const [showRegistrationOverlay, setShowRegistrationOverlay] = useState(false);

  // Registration Fees States
  const [searchRegistrationFeesQuery, setSearchRegistrationFeesQuery] =
    useState("");
  const [showRegistrationFeesAddForm, setShowRegistrationFeesAddForm] =
    useState(false);
  const [showRegistrationFeesEditForm, setShowRegistrationFeesEditForm] =
    useState(false);
  const [registrationFeesData, setRegistrationFeesData] = useState([]);
  const [registrationFeesText, setRegistrationFeesText] = useState("");
  const [registrationFeesDate, setRegistrationFeesDate] = useState("");
  const [registrationFeesLogo, setRegistrationFeesLogo] = useState(null);
  const [editRegistrationFeesId, setEditRegistrationFeesId] = useState(null);
  const registrationFeesEditableRef = useRef(null);
  const registrationFeesEditableBodyRef = useRef(null);

  const [showFormsMenu, setShowFormsMenu] = useState(false);
  const [showListMenu, setShowListMenu] = useState(false);

  const [showBrandsEditForm, setShowBrandsEditForm] = useState(false);

  const [showBrandingList, setShowBrandingList] = useState(false);
  const [availableBranding, setAvailableBranding] = useState([]);
  const [selectedBranding, setSelectedBranding] = useState([]);
  const [brandingBilling, setBrandingBilling] = useState({
    subTotal: 0,
    amount: 0,
    sgst: 0,
    cgst: 0,
    igst: 0,
    grandTotal: 0,
  });

  const [pendingAmount, setPendingAmount] = useState(null);
  const [powerPendingAmount, setPowerPendingAmount] = useState(null);
  const [selectedStallDetails, setSelectedStallDetails] = useState({});

  const [heading, setHeading] = useState("Exhibitor Declaration & Undertaking");
  const [declarationUndertakingData, setDeclarationUndertakingData] = useState(
    [],
  );
  const [formPoints, setFormPoints] = useState([{ title: "", text: "" }]);
  const [formHeading, setFormHeading] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [showDeclaration, setShowDeclaration] = useState(true);
  const [showDashboardOverlay, setShowDashboardOverlay] = useState(false);
  const [eventScheduleData, setEventScheduleData] = useState([]);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [scheduleFormPoints, setScheduleFormPoints] = useState([
    { title: "", text: "" },
  ]);
  const [scheduleDescription, setScheduleDescription] = useState("");

  const [isEditingSchedule, setIsEditingSchedule] = useState(false);
  const [exhibitorDashboardSchedule, setExhibitorDashboardSchedule] = useState(
    [],
  );
  const [showExhibitorDashboardModal, setShowExhibitorDashboardModal] =
    useState(false);
  const [exhibitorDashboardFormPoints, setExhibitorDashboardFormPoints] =
    useState([{ title: "", text: "" }]);
  const [isEditingExhibitorDashboard, setIsEditingExhibitorDashboard] =
    useState(false);
  const [latestNewsData, setLatestNewsData] = useState([]);
  const [showLatestNewsModal, setShowLatestNewsModal] = useState(false);
  const [latestNewsForm, setLatestNewsForm] = useState([
    { link: "", title: "", text: "" },
  ]);
  const [isEditingLatestNews, setIsEditingLatestNews] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [dashboardView, setDashboardView] = useState("Overview");
  const [importantPage, setImportantPage] = useState(""); // "" | "Instructions" | "Rules"
  const [instructionModalOpen, setInstructionModalOpen] = useState(false);
  const [instructionEditorData, setInstructionEditorData] = useState("");
  const [instructionsList, setInstructionsList] = useState([]);

  const [rulesList, setRulesList] = useState([]);
  const [rulesModalOpen, setRulesModalOpen] = useState(false);
  const [rulesEditorData, setRulesEditorData] = useState("");
  const [rulesEditingIndex, setRulesEditingIndex] = useState(null);
  const [guidelinesList, setGuidelinesList] = useState([]);
  const [guidelinesEditorData, setGuidelinesEditorData] = useState("");
  const [guidelinesEditingIndex, setGuidelinesEditingIndex] = useState(null);
  const [guidelinesModalOpen, setGuidelinesModalOpen] = useState(false);
  const [exhibitionEditorData, setExhibitionEditorData] = useState("");
  const [zoomLevel, setZoomLevel] = useState(1);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const dragFrame = useRef(null);

  const [SMSinstructionEditorData, setSMSinstructionEditorData] = useState("");

  const [smsMessageList, setSmsMessageList] = useState([]);

  const [selectedPlanIndex, setSelectedPlanIndex] = useState(null);

  const [smsTableData, setSmsTableData] = useState([]);
  const [editingCell, setEditingCell] = useState({
    rowIndex: null,
    colKey: null,
  });
  const [editRowId, setEditRowId] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [editedRowData, setEditedRowData] = useState(null);
  const [newRow, setNewRow] = useState({
    plan_name: "",
    delivery_frequency: "",
    description: "",
    price: "",
  });

  const messages = [
    `{BRAND}: Big news, {NAME}! 🚀 {OFFER} starts now at {EVENT}. Visit Booth {BOOTH_NO} today. Details: {SHORT_URL} STOP=opt‑out`,
    `{BRAND}: Last chance! ⏰ {OFFER} ends tomorrow. Drop by Booth {BOOTH_NO} & save. See you! STOP=opt‑out`,
    `Heads‑up, {NAME}! {BRAND} unveils {NEW_PRODUCT} on {EVENT_DATE}. Stay tuned—exclusive perks ahead. STOP=opt‑out`,
    `{BRAND}: It’s live! 🎁 Grab {OFFER} at Booth {BOOTH_NO}. First 100 visitors get a bonus gift. Info: {SHORT_URL} STOP=opt‑out`,
    `{BRAND}: Thanks for the buzz yesterday! Haven’t visited yet? Booth {BOOTH_NO} open till {END_DATE}. Don’t miss {OFFER}. STOP=opt‑out`,
  ];

  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [time, setTime] = useState(new Date());
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const messageTimer = setInterval(() => {
      setCurrentMessageIndex((prev) => (prev + 1) % messages.length);
    }, 3000);

    const timeTimer = setInterval(() => {
      setTime(new Date());
    }, 5000);

    const dateTimer = setInterval(() => {
      setDate(new Date());
    }, 10000);

    return () => {
      clearInterval(messageTimer);
      clearInterval(timeTimer);
      clearInterval(dateTimer);
    };
  }, []);

  const formattedTime = time.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
  const formattedDate = date.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
  });

  const [whatsappInstruction, setWhatsappInstruction] = useState("");
  const [whatsappTableData, setWhatsappTableData] = useState([]);
  const [newWhatsAppRow, setNewWhatsAppRow] = useState({
    plan_name: "",
    delivery_frequency: "",
    description: "",
    price: "",
  });
  const [whatsappMessageList, setWhatsappMessageList] = useState([]);
  const [whatsappInstructionEditorData, setWhatsappInstructionEditorData] =
    useState("");
  const [whatsappEditingIndex, setWhatsappEditingIndex] = useState(null);
  const [whatsappMessage, setWhatsappMessage] = useState("");
  const [selectedWhatsAppPlan, setSelectedWhatsAppPlan] = useState(null);

  const [websiteAdsInstructions, setWebsiteAdsInstructions] = useState([]);
  const [websiteAdsEditorData, setWebsiteAdsEditorData] = useState("");
  const [websiteAdsEditingIndex, setWebsiteAdsEditingIndex] = useState(null);
  const [websiteAdsModalOpen, setWebsiteAdsModalOpen] = useState(false);

  const [websiteAdsTableData, setWebsiteAdsTableData] = useState([]);
  const [newWebsiteAdsRow, setNewWebsiteAdsRow] = useState({
    plan_name: "",
    duration: "",
    description: "",
    price: "",
  });
  const [editWebsiteAdsRowId, setEditWebsiteAdsRowId] = useState(null);
  const [editedWebsiteAdsRow, setEditedWebsiteAdsRow] = useState(null);
  const [websiteAdsEditingCell, setWebsiteAdsEditingCell] = useState({
    rowIndex: null,
    colKey: null,
  });
  const [selectedWebsiteAdsRowId, setSelectedWebsiteAdsRowId] = useState(null);

  const [mediaSets, setMediaSets] = useState({
    media1: [],
    media2: [],
    media3: [],
    media4: [],
    media5: [],
  });

  const [indexes, setIndexes] = useState({
    media1: 0,
    media2: 0,
    media3: 0,
    media4: 0,
    media5: 0,
  });

  const [sponsorImages, setSponsorImages] = useState([]);
  const [showSponsorModal, setShowSponsorModal] = useState(false);
  const [sponsorType, setSponsorType] = useState("");
  const [selectedSponsorFile, setSelectedSponsorFile] = useState(null);
  const [isEditingSponsor, setIsEditingSponsor] = useState(false);
  const [editingSponsorId, setEditingSponsorId] = useState(null);

  const [homeVideos, setHomeVideos] = useState([]);
  const [selectedHomeVideoFile, setSelectedHomeVideoFile] = useState(null);
  const [showHomeVideoModal, setShowHomeVideoModal] = useState(false);
  const [isEditingHomeVideo, setIsEditingHomeVideo] = useState(false);
  const [editingHomeVideoId, setEditingHomeVideoId] = useState(null);
  const [activeHomeNavbarItem, setActiveHomeNavbarItem] =
    useState("Home Page Video");

  const [peopleComments, setPeopleComments] = useState([]);
  const [showPeopleCommentModal, setShowPeopleCommentModal] = useState(false);
  const [selectedPeopleImageFile, setSelectedPeopleImageFile] = useState(null);
  const [peopleComment, setPeopleComment] = useState("");
  const [peopleCommenterName, setPeopleCommenterName] = useState("");
  const [isEditingPeopleComment, setIsEditingPeopleComment] = useState(false);
  const [editingPeopleCommentId, setEditingPeopleCommentId] = useState(null);
  const [peopleCommenterDesignation, setPeopleCommenterDesignation] =
    useState("");

  const [newExhibitors, setNewExhibitors] = useState([]);
  const [loadingNewExhibitors, setLoadingNewExhibitors] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [contactSupport, setContactSupport] = useState([]);
  const [loadingContactSupport, setLoadingContactSupport] = useState(false);

  useEffect(() => {
    if (overlayContent === "New Exhibitor Request") {
      fetchNewExhibitorData();
    }
  }, [overlayContent]);
  const fetchNewExhibitorData = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/get_new_exhibitors.php");
      const data = await res.json();

      if (data.status === "success") {
        setNewExhibitors(data.data || []);
      } else {
        console.error("API error:", data.message);
      }
    } catch (error) {
      console.error("Failed to load exhibitors", error);
    } finally {
      setLoadingNewExhibitors(false);
    }
  };

  const handleMailClick = (exhibitor) => {};

  const handleDeleteClick = async (id) => {
    if (!window.confirm("Are you sure you want to delete this exhibitor?"))
      return;

    try {
      const response = await fetch(
        "https://inoptics.in/api/delete_new_exhibitors.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id }),
        },
      );

      const data = await response.json();

      if (data.status === "success") {
        alert("Exhibitor deleted successfully!");
        // Remove from state without refetching
        setNewExhibitors((prev) =>
          prev.filter((exhibitor) => exhibitor.id !== id),
        );
      } else {
        alert("Failed to delete exhibitor: " + data.message);
      }
    } catch (error) {
      console.error("Error deleting exhibitor:", error);
      alert("An error occurred while deleting the exhibitor.");
    }
  };

  useEffect(() => {
    if (overlayContent === "Contact Support") {
      fetchContactSupportData();
    }
  }, [overlayContent]);

  const fetchContactSupportData = async () => {
    try {
      setLoadingContactSupport(true);
      const res = await fetch(
        "https://inoptics.in/api/get_contact_support.php",
      );
      const data = await res.json();

      if (data.status === "success") {
        setContactSupport(data.data || []);
      } else {
        console.error("API error:", data.message);
      }
    } catch (error) {
      console.error("Failed to load contact support messages", error);
    } finally {
      setLoadingContactSupport(false);
    }
  };

  const handleDeleteContact = async (id) => {
    if (!window.confirm("Are you sure you want to delete this message?"))
      return;

    try {
      const response = await fetch(
        "https://inoptics.in/api/delete_contact_support.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        },
      );

      const data = await response.json();

      if (data.status === "success") {
        alert("Message deleted successfully!");
        setContactSupport((prev) => prev.filter((msg) => msg.id !== id));
      } else {
        alert("Failed to delete message: " + data.message);
      }
    } catch (error) {
      console.error("Error deleting message:", error);
      alert("An error occurred while deleting the message.");
    }
  };

  // const handleConfirmExhibitor = async (id) => {
  //   try {
  //     const res = await fetch("https://inoptics.in/api/confirm_exhibitor.php", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ id }),
  //     });

  //     const result = await res.json();
  //     if (result.success) {
  //       setNewExhibitors((prev) =>
  //         prev.map((item) =>
  //           item.id === id ? { ...item, status: "Confirmed" } : item
  //         )
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Failed to confirm", error);
  //   }
  // };

  const [isCardActive, setIsCardActive] = useState(true);

  const [labelData, setLabelData] = useState([
    "COMPANY NAME",
    "NAME",
    "STALL NO",
    "CITY",
    "STATE",
    "PINCODE",
    "HOME BRANDS",
    "DISTRIBUTORS OF BRANDS",
    "INTERNATIONAL BRANDS",
    "WEBSITE",
  ]);

  const [visibleLabels, setVisibleLabels] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false); // determines Save or Update

  const toggleLabel = (label) => {
    if (visibleLabels.includes(label)) {
      setVisibleLabels(visibleLabels.filter((l) => l !== label));
    } else {
      setVisibleLabels([...visibleLabels, label]);
    }
  };

  useEffect(() => {
    fetch("https://inoptics.in/api/get_exhibitor_card_settings.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setVisibleLabels(data.labels || []);
          setIsCardActive(data.status?.toLowerCase() === "active");
          setIsUpdate(true);
        }
      })
      .catch((err) => console.error("Failed to fetch settings", err));
  }, []);

  const handleSaveOrUpdate = () => {
    fetch("https://inoptics.in/api/save_exhibitor_card_settings.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        labels: visibleLabels,
        card_status: isCardActive ? "Active" : "De-Active",
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          alert(isUpdate ? "Updated successfully" : "Saved successfully");
          setIsUpdate(true);
        } else {
          alert("Failed to save/update");
        }
      })
      .catch(() => alert("Error while saving"));
  };

  useEffect(() => {
    if (activeNavbarItem === "WHATSAPP") {
      const plan = whatsappTableData.find((r) => r.id === selectedRowId);
      setSelectedWhatsAppPlan(plan || null);
    }
  }, [selectedRowId, activeNavbarItem, whatsappTableData]);

  const handleSaveWhatsAppMessage = () => {
    if (whatsappMessage.trim().length === 0) {
      alert("Please enter a message before saving.");
      return;
    }

    alert("WhatsApp message saved successfully!");
  };

  const handlePlanToggle = (index) => {
    if (selectedPlanIndex === index) {
      // Unselect the selected row
      setSelectedPlanIndex(null);
    } else {
      // Select the clicked row
      setSelectedPlanIndex(index);
    }
  };

  const plans = [
    {
      plan: "Lite",
      bestFor: "Just testing the waters?",
      messages: "2,000",
      reach: "Local",
      price: "₹499",
    },
    {
      plan: "Boost",
      bestFor: "Deals & discounts that pop!",
      messages: "10,000",
      reach: "Regional",
      price: "₹1,999",
    },
    {
      plan: "Max Reach",
      bestFor: "Launches, festivals, campaigns!",
      messages: "50,000",
      reach: "Pan India",
      price: "₹6,499",
    },
    {
      plan: "Custom",
      bestFor: "Big goals? We’ll match them!",
      messages: "Flexible",
      reach: "Any",
      price: "Contact Us",
    },
  ];

  const [smsMessages, setSmsMessages] = useState([""]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [calculatedPrice, setCalculatedPrice] = useState(0);
  const [gstAmount, setGstAmount] = useState(0);

  useEffect(() => {
    const plan = smsTableData.find((r) => r.id === selectedRowId);
    setSelectedPlan(plan);

    if (plan) {
      let messageCount = 1;
      switch (plan.plan_name) {
        case "Double Impact":
          messageCount = 2;
          break;
        case "Triple Reach":
          messageCount = 3;
          break;
        case "Weekly Boost":
          messageCount = 5;
          break;
        default:
          messageCount = 1;
      }
      setSmsMessages(Array(messageCount).fill(""));
    }
  }, [selectedRowId, smsTableData]);

  useEffect(() => {
    if (!selectedPlan) return;

    const originalPrice =
      parseFloat(selectedPlan.price?.replace(/[^0-9.]/g, "")) || 0;

    // Total word count from all message boxes
    const totalCharacters = smsMessages.reduce((sum, msg) => {
      return sum + msg.length;
    }, 0);

    const messageMultiplier = totalCharacters > 160 ? 2 : 1;
    const updatedPrice = originalPrice * messageMultiplier;
    const gst = updatedPrice * 0.18;
    const total = updatedPrice + gst;

    setCalculatedPrice(updatedPrice);
    setGstAmount(gst);
    setGrandTotal(total);
  }, [selectedPlan, smsMessages]);

  const handleSaveSMSMessage = () => {
    const emptyFound = smsMessages.some((msg) => msg.trim().length === 0);
    if (emptyFound) {
      alert("Please fill all message boxes before saving.");
      return;
    }

    alert("Messages saved successfully!");
  };

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const filteredStalls = stallData.filter((item) =>
    item.stall_number.toLowerCase().includes(searchStallQuery.toLowerCase()),
  );

  const totalPages = Math.ceil(filteredStalls.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentStalls = filteredStalls.slice(
    startIndex,
    startIndex + rowsPerPage,
  );

  const [videoWallInstructionsList, setVideoWallInstructionsList] = useState(
    [],
  );
  const [videoWallEditorData, setVideoWallEditorData] = useState("");
  const [videoWallEditingIndex, setVideoWallEditingIndex] = useState(null);
  const [videoWallModalOpen, setVideoWallModalOpen] = useState(false);

  useEffect(() => {
    fetchVideoWallInstructions();
  }, []);

  const fetchVideoWallInstructions = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_video_wall_instruction.php",
      );
      const data = await res.json();
      setVideoWallInstructionsList(data || []);
    } catch (err) {
      console.error("Failed to fetch Video Wall instructions", err);
    }
  };

  const saveVideoWallInstruction = async () => {
    if (!videoWallEditorData.trim()) {
      alert("Instruction content cannot be empty.");
      return;
    }

    const endpoint =
      videoWallEditingIndex !== null
        ? "https://inoptics.in/api/update_video_wall_instruction.php"
        : "https://inoptics.in/api/add_video_wall_instruction.php";

    try {
      await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ content: videoWallEditorData }),
      });

      setVideoWallModalOpen(false);
      setVideoWallEditorData("");
      setVideoWallEditingIndex(null);
      fetchVideoWallInstructions(); // refresh
    } catch (err) {
      console.error("Failed to save Video Wall instruction", err);
    }
  };

  const deleteVideoWallInstruction = async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this instruction?",
    );
    if (!confirmDelete) return;

    try {
      await fetch("https://inoptics.in/api/delete_video_wall_instruction.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "delete_latest" }),
      });

      fetchVideoWallInstructions();
    } catch (err) {
      console.error("Failed to delete Video Wall instruction", err);
    }
  };

  const handleImportantClick = (option) => {
    setImportantPage(option);
  };
  // Reset zoom & drag when page changes
  useEffect(() => {
    if (importantPage !== "Exhibition Map") {
      setZoomLevel(1);
      setPosition({ x: 0, y: 0 });
      setIsDragging(false);
    }
  }, [importantPage]);

  const handleMouseDown = (e) => {
    if (zoomLevel <= 1) return;
    setIsDragging(true);
    setDragStart({ x: e.clientX - position.x, y: e.clientY - position.y });
  };

  const handleMouseMove = (e) => {
    if (!isDragging || zoomLevel <= 1) return;

    if (dragFrame.current) cancelAnimationFrame(dragFrame.current);

    dragFrame.current = requestAnimationFrame(() => {
      const newX = e.clientX - dragStart.x;
      const newY = e.clientY - dragStart.y;
      setPosition({ x: newX, y: newY });
    });
  };

  const handleMouseUp = () => setIsDragging(false);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".profile-menu-wrapper")) {
        setShowProfileDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // useEffect(() => {
  //   if (
  //     selectedStallIndex !== null &&
  //     stallList.length > 0 &&
  //     payments.length >= 0 &&
  //     stallList[selectedStallIndex]
  //   ) {
  //     const stall = stallList[selectedStallIndex];
  //     const totalPaidWithTDS = payments.reduce((sum, pay) => {
  //       const amount = parseFloat(pay.amount || pay.amount_paid || 0);
  //       const tds = parseFloat(pay.tds || 0);
  //       return sum + tds + amount;
  //     }, 0);

  //     const pending = parseFloat(stall.grand_total || 0) - totalPaidWithTDS;
  //     setPendingAmount(pending);
  //   } else {
  //     setPendingAmount(null);
  //   }
  // }, [payments, stallList, selectedStallIndex, formData, stallSummary]);

  // ✅ Calculate overall pending amount (for all stalls combined)
  useEffect(() => {
    if (stallList.length > 0 && payments.length >= 0) {
      const totalPaidWithTDS = payments.reduce((sum, pay) => {
        const amount = parseFloat(pay.amount || pay.amount_paid || 0);
        const tds = parseFloat(pay.tds || 0);
        return sum + tds + amount;
      }, 0);

      const totalPending =
        parseFloat(stallSummary.grand_total || 0) - totalPaidWithTDS;
      setPendingAmount(totalPending);
    } else {
      setPendingAmount(null);
    }
  }, [payments, stallList, stallSummary]);

  // ✅ Helper for per-stall pending (used in View Details overlay)
  // const getStallPending = (stallIndex) => {
  //   const stall = stallList[stallIndex];
  //   if (!stall) return 0;

  //   const paidForThisStall = payments
  //     .filter((p) => p.stall_id === stall.id) // adjust if your key is different
  //     .reduce((sum, pay) => {
  //       const amount = parseFloat(pay.amount || pay.amount_paid || 0);
  //       const tds = parseFloat(pay.tds || 0);
  //       return sum + tds + amount;
  //     }, 0);

  //   return parseFloat(stall.grand_total || 0) - paidForThisStall;
  // };

  // ✅ Helper to calculate discount % (for summary)
  const getDiscountPercent = (summary) => {
    if (!summary || !summary.total || summary.total <= 0) return 0;
    return ((summary.discounted_amount / summary.total) * 100).toFixed(0);
  };

  // ✅ Helper for single stall discount % (if needed)
  const getStallDiscountPercent = (stall) => {
    if (!stall || !stall.total || stall.total <= 0) return 0;
    if (stall.discount_percent) return stall.discount_percent; // already stored in DB
    return ((stall.discounted_amount / stall.total) * 100).toFixed(0);
  };

  useEffect(() => {
    if (
      formData?.company_name &&
      powerPayments.length >= 0 &&
      grandTotal !== null &&
      grandTotal !== undefined
    ) {
      const totalPaidWithTDS = powerPayments.reduce((sum, pay) => {
        const amount = parseFloat(pay.amount || pay.amount_paid || 0);
        const tds = parseFloat(pay.tds || 0);
        return sum + tds + amount;
      }, 0);

      const pending = parseFloat(grandTotal || 0) - totalPaidWithTDS;
      setPowerPendingAmount(pending);
    } else {
      setPowerPendingAmount(null);
    }
  }, [powerPayments, grandTotal, formData]);

  useEffect(() => {
    if (selectedStallIndex === null && stallList.length > 0) {
      setSelectedStallIndex(0);
    }
  }, [stallList]);

  const getExhibitorBadgeBilling = () => {
    const count = parseInt(formData.extra_badges, 10) || 0;
    const rate = new Date() > new Date("2026-03-21") ? 200 : 100;
    const total = count * rate;

    const isDelhi = formData?.state?.trim().toLowerCase() === "delhi";
    const cgst = isDelhi ? total * 0.09 : 0;
    const sgst = isDelhi ? total * 0.09 : 0;
    const igst = !isDelhi ? total * 0.18 : 0;
    const grandTotal = total + cgst + sgst + igst;

    return { count, rate, total, cgst, sgst, igst, grandTotal };
  };

  const handleQuantityChange = (index, quantity) => {
    const updated = [...selectedFurniture];
    updated[index].quantity = Number(quantity);
    setSelectedFurniture(updated);
  };

  const handleSendFurnitureEmail = () => {
    // Your logic to send email (e.g., via backend API)
    alert("Furniture order email sent successfully.");
  };

  const addBooth = async () => {
    if (!uploadedBoothImage) return alert("Please upload an image");

    const formData = new FormData();
    formData.append("image", uploadedBoothImage);

    const res = await fetch(
      "https://inoptics.in/api/add_contractor_booth.php",
      {
        method: "POST",
        body: formData,
      },
    );
    const data = await res.json();
    alert(data.message);
    setShowContractorBoothAddForm(false);
    fetchContractorBoothData(); // re-fetch
  };

  const updateBooth = async (id) => {
    if (!id || !uploadedBoothImage) return;

    const formData = new FormData();
    formData.append("id", id);
    formData.append("image", uploadedBoothImage);

    const res = await fetch(
      "https://inoptics.in/api/update_contractor_booth.php",
      {
        method: "POST",
        body: formData,
      },
    );
    const data = await res.json();
    alert(data.message);
    setShowContractorBoothEditForm(false);
    fetchContractorBoothData();
  };

  const deleteBooth = async (id) => {
    const res = await fetch(
      "https://inoptics.in/api/delete_contractor_booth.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      },
    );
    const data = await res.json();
    alert(data.message);
    fetchContractorBoothData();
  };

  useEffect(() => {
    fetchContractorBoothData();
  }, []);

  const fetchContractorBoothData = async () => {
    try {
      const response = await fetch(
        "https://inoptics.in/api/get_contractor_booth.php",
      );
      const data = await response.json();
      setContractorBoothData(data); // store in state
    } catch (error) {
      console.error("Error fetching booth data:", error);
    }
  };

  const resetContractorUndertakingForm = () => {
    setDeclarationText("");
    setUndertakingDate("");
    setUploadedLogo(null);
    setShowContractorUndertakingAddForm(false);
    setShowContractorUndertakingEditForm(false);
    setEditUndertakingId(null);
  };

  // GET: Fetch all contractor undertakings
  const fetchContractorUndertakings = async () => {
    try {
      // Ensure this URL is correct for your deployed PHP file
      // This is the line that initiates the network request to your PHP script
      const res = await fetch(
        "https://inoptics.in/api/get_contractor_undertaking.php",
      );

      // --- CRITICAL ERROR HANDLING ---
      // Always check if the HTTP response itself was successful (status code 200-299)
      if (!res.ok) {
        // If the response is not OK (e.g., 404, 500), read the error body
        const errorBody = await res.text(); // Read as text in case it's not JSON (e.g., an HTML error page)
        console.error("HTTP error during fetch:", res.status, errorBody);
        throw new Error(
          `HTTP error! Status: ${res.status}, Message: ${errorBody}`,
        );
      }
      // --- END CRITICAL ERROR HANDLING ---

      // If the response is OK, parse the JSON data
      const data = await res.json();

      // This is the most important part for displaying: Update your React state
      setContractorUndertakingData(data);
    } catch (error) {
      // Catch any network errors or errors thrown from the 'if (!res.ok)' block
      console.error("Error fetching contractor undertakings:", error); // Log the full error for debugging
      alert(
        "Error fetching contractor undertakings. Check console for details.",
      ); // User-friendly alert
    }
  };

  useEffect(() => {
    if (showContractorOverlay) {
      fetchContractorUndertakings();
    }
  }, [showContractorOverlay]);

  useEffect(() => {
    if (activeContractorTab === "Contractor Undertaking") {
      fetchContractorUndertakings();
    }
  }, [activeContractorTab]);
  // ADD
  const addContractorUndertaking = async () => {
    if (!declarationText) {
      alert("Declaration text is required");
      return;
    }

    try {
      const res = await fetch(
        "https://inoptics.in/api/add_contractor_undertaking.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            declaration_text: declarationText,
            date: undertakingDate,
            // Optionally: Handle uploadedLogo separately if needed
          }),
        },
      );

      const data = await res.json();
      alert(data.message);
      resetContractorUndertakingForm();
      fetchContractorUndertakings();
    } catch (error) {
      alert("Error adding contractor undertaking");
    }
  };

  // DELETE
  const deleteContractorUndertaking = async (id) => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/delete_contractor_undertaking.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        },
      );

      const data = await res.json();
      alert(data.message);
      fetchContractorUndertakings();
    } catch (error) {
      alert("Error deleting contractor undertaking");
    }
  };

  // EDIT (Fill form with selected data)
  const handleContractorUndertakingEdit = (item) => {
    setEditUndertakingId(item.id);
    setDeclarationText(item.declaration_text || "");
    setUndertakingDate(item.date || "");
    setShowContractorUndertakingEditForm(true);
  };

  // UPDATE
  const updateContractorUndertaking = async () => {
    if (!editUndertakingId) return;

    try {
      const res = await fetch(
        "https://inoptics.in/api/update_contractor_undertaking.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: editUndertakingId,
            declaration_text: declarationText,
            date: undertakingDate,
          }),
        },
      );

      const data = await res.json();
      alert(data.message);
      resetContractorUndertakingForm();
      fetchContractorUndertakings();
    } catch (error) {
      alert("Error updating contractor undertaking");
    }
  };

  const editableRef = useRef(null);
  const editableBodyRef = useRef(null);

  useEffect(() => {
    if (editableRef.current) {
      const editableArea = editableRef.current;

      // Try to extract the current editable body content if available
      const currentBody =
        editableArea.querySelector(".editable-body")?.innerHTML ||
        "<p><br/></p>";

      // Rebuild the full HTML using updated logo and date, and preserve body content
      const html = `
      <div class="logo-date-container">
        ${
          uploadedLogo
            ? `<img src="${URL.createObjectURL(
                uploadedLogo,
              )}" class="uploaded-logo-preview" />`
            : ""
        }
        <span class="manual-date">${undertakingDate || "YYYY-MM-DD"}</span>
      </div>
      <div class="editable-body" contenteditable="true">${currentBody}</div>
    `;

      editableArea.innerHTML = html;

      // Optional: reattach editableBodyRef if you're using it elsewhere
      editableBodyRef.current = editableArea.querySelector(".editable-body");

      // Update declarationText
      setDeclarationText(html);
    }
  }, [uploadedLogo, undertakingDate]);

  useEffect(() => {
    if (
      showContractorUndertakingEditForm &&
      editableRef.current &&
      declarationText
    ) {
      editableRef.current.innerHTML = declarationText;

      // Optional: also store reference to editable-body if needed
      editableBodyRef.current =
        editableRef.current.querySelector(".editable-body");
    }
  }, [showContractorUndertakingEditForm, declarationText]);

  const handleSubmitUndertaking = () => {
    alert("Undertaking submitted!"); // Or send data to backend here
    setIsUndertakingRead(false);
    setShowContractorOverlay(false);
  };

  useEffect(() => {
    if (registrationFeesEditableRef.current) {
      const editableArea = registrationFeesEditableRef.current;

      const currentBody =
        editableArea.querySelector(".editable-body")?.innerHTML ||
        "<p><br/></p>";

      const html = `
      <div class="logo-date-container">
        ${
          registrationFeesLogo
            ? `<img src="${URL.createObjectURL(
                registrationFeesLogo,
              )}" class="uploaded-logo-preview" />`
            : ""
        }
        <span class="manual-date">${registrationFeesDate || "YYYY-MM-DD"}</span>
      </div>
      <div class="editable-body" contenteditable="true">${currentBody}</div>
    `;

      editableArea.innerHTML = html;
      registrationFeesEditableBodyRef.current =
        editableArea.querySelector(".editable-body");
      setRegistrationFeesText(html);
    }
  }, [registrationFeesLogo, registrationFeesDate]);

  const resetRegistrationFeesForm = () => {
    setRegistrationFeesText("");
    setRegistrationFeesDate("");
    setRegistrationFeesLogo(null);
    setEditRegistrationFeesId(null);
    setShowRegistrationFeesAddForm(false);
    setShowRegistrationFeesEditForm(false);
  };

  const fetchRegistrationFees = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_registration_fees.php",
      );
      if (!res.ok) {
        const err = await res.text();
        throw new Error(`HTTP Error: ${res.status} - ${err}`);
      }
      const data = await res.json();
      setRegistrationFeesData(data);
    } catch (error) {
      console.error("Error fetching registration fees:", error);
      alert("Error fetching registration fees.");
    }
  };

  useEffect(() => {
    if (showRegistrationOverlay) {
      fetchRegistrationFees();
    }
  }, [showRegistrationOverlay]);

  useEffect(() => {
    if (activeContractorTab === "Registration Fees") {
      fetchRegistrationFees();
    }
  }, [activeContractorTab]);

  const addRegistrationFees = async () => {
    if (!registrationFeesText) {
      alert("Content is required");
      return;
    }

    try {
      const res = await fetch(
        "https://inoptics.in/api/add_registration_fees.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            declaration_text: registrationFeesText,
          }),
        },
      );
      const data = await res.json();
      alert(data.message);
      resetRegistrationFeesForm();
      fetchRegistrationFees();
    } catch (error) {
      alert("Error adding registration fees");
      console.error(error);
    }
  };

  const deleteRegistrationFees = async (id) => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/delete_registration_fees.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        },
      );
      const data = await res.json();
      alert(data.message);
      fetchRegistrationFees();
    } catch (error) {
      alert("Error deleting");
    }
  };

  const handleRegistrationFeesEdit = (item) => {
    setEditRegistrationFeesId(item.id);
    setRegistrationFeesText(item.declaration_text || "");
    setRegistrationFeesDate(item.date || "");
    setShowRegistrationFeesEditForm(true);
  };

  const updateRegistrationFees = async () => {
    if (!editRegistrationFeesId) return;

    try {
      const res = await fetch(
        "https://inoptics.in/api/update_registration_fees.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: editRegistrationFeesId,
            declaration_text: registrationFeesText,
            date: registrationFeesDate,
          }),
        },
      );

      const data = await res.json();
      alert(data.message);
      resetRegistrationFeesForm();
      fetchRegistrationFees();
    } catch (error) {
      alert("Error updating registration fees");
    }
  };

  const handleSendMail = async (emailTemplateName) => {
    if (isSendingMail) return;
    setIsSendingMail(true);

    const emailTemplate = emailMasterData.find(
      (template) => template.email_name === emailTemplateName,
    );

    if (!emailTemplate) {
      alert("Email template not found.");
      setIsSendingMail(false);
      return;
    }

    const { email, company_name, password } = formData;

    if (!email || !company_name) {
      alert("Missing company name or email.");
      setIsSendingMail(false);
      return;
    }

    let parsedContent = emailTemplate.content;

    // -------------------------
    // CASE 1: BASIC LOGIN MAIL
    // -------------------------
    if (emailTemplateName === "Exhibitor Login & Password") {
      parsedContent = parsedContent
        // Replace &n with <br> for HTML emails
        .replace(/&n/g, "<br>")
        // Replace placeholders
        .replace(/Company Name\s*:?\s*/i, `Company Name: ${company_name}<br>`)
        .replace(/Login Id\s*:?\s*/i, `Login Id: ${email}<br>`)
        .replace(/Password\s*:?\s*/i, `Password: ${password}<br>`)
        // Fix login link formatting if present
        .replace(/(https?:\/\/[^\s"<]+)/i, `<a href="$1">$1</a>`);
    }

    // ==============================
    // CASE 2: STALL BOOKING CONFIRMATION
    // ==============================
    else if (
      emailTemplateName === "InOptics 2026 @ Stall Booking Confirmation"
    ) {
      if (!stallList || stallList.length === 0) {
        alert("No stall details available to send in email.");
        setIsSendingMail(false);
        return;
      }

      const getJoined = (key) => stallList.map((s) => s[key] ?? "-").join(", ");
      const getSum = (key) =>
        stallList
          .reduce((sum, s) => sum + (parseFloat(s[key]) || 0), 0)
          .toFixed(2);

      const companyName = formData.company_name;
      const stallNumber = getJoined("stall_number");
      const stallCategory = getJoined("stall_category");
      const stallArea = stallList
        .map((s) => `${parseFloat(s.stall_area || 0)} sq mtr`)
        .join(", ");
      const grandTotal = getSum("grand_total");
      const fortyPercent = (parseFloat(grandTotal) * 0.4).toFixed(2);

      // Keep your CustomEditor HTML clean
      parsedContent = parsedContent
        .trim()
        .replace(/&n\s*/g, "")
        .replace(/&nbsp;/g, " ")
        .replace(/\s{2,}/g, " ");

      // ✅ Replace placeholders inside your template (already having table)
      parsedContent = parsedContent
        .replace(/\[Company Name\]/gi, companyName)
        .replace(/\[stall no\]/gi, stallNumber)
        .replace(/\[stall area\]/gi, stallArea)
        .replace(/\[stall category\]/gi, stallCategory)
        .replace(/\[Grand Total\]/gi, `Rs.${grandTotal}`)
        .replace(/\[40% of Grand Total\]/gi, `Rs.${fortyPercent}`);
    }

    // === CASE 3: POWER REQUIREMENT CONFIRMATION ===
    else if (
      emailTemplateName === "InOptics 2026 @ Power Requirement Confirmation"
    ) {
      if (!exhibitorPreviewList || exhibitorPreviewList.length === 0) {
        alert("No power requirement data available to send in email.");
        setIsSendingMail(false);
        return;
      }

      // Fetch power payments
      let localPowerPayments = [];

      try {
        const res = await fetch(
          `https://inoptics.in/api/get_exhibitor_power_payment.php?company_name=${encodeURIComponent(
            formData.company_name,
          )}`,
        );
        const data = await res.json();

        if (data.success && data.records && data.records.length > 0) {
          localPowerPayments = data.records.map((pay) => ({
            type: pay.payment_type || "",
            date: pay.payment_date || "",
            exhibitorBank: pay.exhibitor_bank_name || "",
            receiverBank: pay.receiver_bank_name || "",
            amount: parseFloat(pay.amount_paid || 0),
            tds: parseFloat(pay.tds || 0),
          }));
          setPowerPayments(localPowerPayments); // Update state for UI
        } else {
          console.log("No payment records found in API response:", data);
        }
      } catch (error) {
        console.error("Error fetching power payments:", error);
      }

      // Log power payments

      // Prepare power requirement details
      const setup = exhibitorPreviewList.find((r) =>
        (r.day || "").toLowerCase().includes("setup"),
      );
      const exhibition = exhibitorPreviewList.find((r) =>
        (r.day || "").toLowerCase().includes("exhibition"),
      );

      const setupText = setup
        ? `Days: ${setup.day || "SETUP DAYS"}<br>Price per KW: ${
            setup.pricePerKw || "-"
          }<br>Power Required: ${setup.powerRequired || "-"} unit<br>Phase: ${
            setup.phase || "-"
          }<br>Total Amount: ${parseFloat(setup.totalAmount || 0).toFixed(
            2,
          )} INR`
        : "";

      const exhibitionText = exhibition
        ? `Days: ${exhibition.day || "EXHIBITION DAYS"}<br>Price per KW: ${
            exhibition.pricePerKw || "-"
          }<br>Power Required: ${
            exhibition.powerRequired || "-"
          } unit<br>Phase: ${
            exhibition.phase || "-"
          }<br>Total Amount: ${parseFloat(exhibition.totalAmount || 0).toFixed(
            2,
          )} INR`
        : "";

      // Calculate totals and taxes (aligned with UI logic)
      const totalPrice = exhibitorPreviewList.reduce(
        (sum, r) => sum + (parseFloat(r.totalAmount) || 0),
        0,
      );
      const sgst =
        formData.state?.toLowerCase() === "delhi" ? totalPrice * 0.09 : 0;
      const cgst =
        formData.state?.toLowerCase() === "delhi" ? totalPrice * 0.09 : 0;
      const igst =
        formData.state?.toLowerCase() !== "delhi" ? totalPrice * 0.18 : 0;
      const grandTotal = totalPrice + (sgst + cgst || igst);

      // Clean the template by removing backslashes and normalizing newlines
      parsedContent = parsedContent
        .replace(/\\+/g, "")
        .replace(/\r\n|\n/g, "<br>");

      // Replace power requirement details
      parsedContent = parsedContent.replace(
        /POWER REQUIREMENT DETAILS[\s\S]*?---------------------------------------------------------[\s\S]*?---------------------------------------------------------/i,
        `POWER REQUIREMENT DETAILS<br>---------------------------------------------------------<br>${setupText}${
          setupText && exhibitionText ? "<br><br>" : ""
        }${exhibitionText}<br>---------------------------------------------------------`,
      );

      // Replace totals and taxes
      parsedContent = parsedContent
        .replace(
          /Total Price\s*:?\s*[^\n<br>]*/i,
          `Total Price: ${totalPrice.toFixed(2)} INR`,
        )
        .replace(
          /SGST\s*\(9%\)\s*:?\s*[^\n<br>]*/i,
          `SGST(9%): ${sgst.toFixed(2)} INR`,
        )
        .replace(
          /CGST\s*\(9%\)\s*:?\s*[^\n<br>]*/i,
          `CGST(9%): ${cgst.toFixed(2)} INR`,
        )
        .replace(
          /IGST\s*\(18%\)\s*:?\s*[^\n<br>]*/i,
          `IGST(18%): ${igst.toFixed(2)} INR`,
        )
        .replace(
          /GRAND TOTAL\s*:?\s*[^\n<br>]*/i,
          `GRAND TOTAL: ${grandTotal.toFixed(2)} INR`,
        );

      // Add payment table and pending status
      if (localPowerPayments.length > 0) {
        const paymentRows = localPowerPayments
          .map(
            (p) => `
          <tr>
            <td>${p.type || "-"}</td>
            <td>${p.date || "-"}</td>
            <td>${p.exhibitorBank || "-"}</td>
            <td>${p.receiverBank || "-"}</td>
            <td>${parseFloat(p.amount || 0).toFixed(2)} INR</td>
            <td>${parseFloat(p.tds || 0).toFixed(2)} INR</td>
          </tr>`,
          )
          .join("");

        const paymentTableHTML = `
        <br><h3 style="margin-top:10px;">Payment Details</h3>
        <table border="1" cellspacing="0" cellpadding="6" style="border-collapse:collapse; width:100%; font-family:Arial; font-size:13px;">
          <thead style="background:#f2f2f2;">
            <tr>
              <th>Payment Type</th>
              <th>Payment Date</th>
              <th>Exhibitor Bank</th>
              <th>Receiver Bank</th>
              <th>Received Payment</th>
              <th>TDS</th>
            </tr>
          </thead>
          <tbody>${paymentRows}</tbody>
        </table>`;

        const totalPaidWithTDS = localPowerPayments.reduce((sum, p) => {
          const amt = parseFloat(p.amount || 0);
          const tds = parseFloat(p.tds || 0);
          return sum + amt + tds;
        }, 0);

        const pendingAmount = grandTotal - totalPaidWithTDS;

        const statusHTML = `
        <div style="margin-top:12px; font-weight:bold; color:${
          pendingAmount <= 0 ? "green" : "red"
        };">
          ${
            pendingAmount <= 0
              ? "PAYMENT CLEARED"
              : `PENDING AMOUNT: ${pendingAmount.toFixed(2)} INR`
          }
        </div>`;

        parsedContent += `${paymentTableHTML}${statusHTML}`;
      } else {
        parsedContent += `<br><div style="margin-top:12px; font-weight:bold; color:red;">No payments recorded yet.</div>`;
      }
    }

    // === CASE 4: EXHIBITOR BADGE REQUEST CONFIRMATION ===
    else if (
      emailTemplateName === "InOptics 2026 @ Badge Request Confirmation"
    ) {
      if (!formData.extra_badges || parseInt(formData.extra_badges, 10) <= 0) {
        alert("No extra badges requested to send in email.");
        setIsSendingMail(false);
        return;
      }

      // Fetch badge payments
      let localBadgePayments = [];

      try {
        const res = await fetch(
          `https://inoptics.in/api/get_exhibitor_badge_payment.php?company_name=${encodeURIComponent(
            formData.company_name,
          )}`,
        );
        const data = await res.json();

        if (data.success && data.records && data.records.length > 0) {
          localBadgePayments = data.records.map((pay) => ({
            type: pay.payment_type || "",
            date: pay.payment_date || "",
            exhibitorBank: pay.exhibitor_bank_name || "",
            receiverBank: pay.receiver_bank_name || "",
            amount: parseFloat(pay.amount_paid || 0),
            tds: parseFloat(pay.tds || 0),
          }));
          setBadgePayments(localBadgePayments); // Update state for UI
        } else {
          console.log("No badge payment records found in API response:", data);
        }
      } catch (error) {
        console.error("Error fetching badge payments:", error);
      }

      // Get billing details
      const { count, total, cgst, sgst, igst, grandTotal } =
        getExhibitorBadgeBilling();
      const rate = new Date() > new Date("2026-03-21") ? 200 : 100;

      // Clean the template by removing backslashes and normalizing newlines
      parsedContent = parsedContent
        .replace(/\\+/g, "")
        .replace(/\r\n|\n/g, "<br>");

      // Replace badge details and totals
      parsedContent = parsedContent
        .replace(
          /Additional Badges\s*:?\s*([^\n<br>]*)?/i,
          `Additional Badges: ${count}`,
        )
        .replace(
          /Rate per Badge\s*:?\s*([^\n<br>]*)?/i,
          `Rate per Badge: ${rate.toFixed(2)}`,
        )
        .replace(
          /Total Price\s*:?\s*([^\n<br>]*)?/i,
          `Total Price: ${total.toFixed(2)}`,
        )
        .replace(
          /SGST\s*\(9%\)\s*:?\s*([^\n<br>]*)?/i,
          `SGST(9%): ${sgst.toFixed(2)}`,
        )
        .replace(
          /CGST\s*\(9%\)\s*:?\s*([^\n<br>]*)?/i,
          `CGST(9%): ${cgst.toFixed(2)}`,
        )
        .replace(
          /IGST\s*\(18%\)\s*:?\s*([^\n<br>]*)?/i,
          `IGST(18%): ${igst.toFixed(2)}`,
        )
        .replace(
          /GRAND TOTAL\s*:?\s*([^\n<br>]*)?/i,
          `GRAND TOTAL: ${grandTotal.toFixed(2)}`,
        );

      // Add payment table and pending status
      if (localBadgePayments.length > 0) {
        const paymentRows = localBadgePayments
          .map(
            (p) => `
          <tr>
            <td>${p.type || "-"}</td>
            <td>${p.date || "-"}</td>
            <td>${p.exhibitorBank || "-"}</td>
            <td>${p.receiverBank || "-"}</td>
            <td>${parseFloat(p.amount || 0).toFixed(2)}</td>
            <td>${parseFloat(p.tds || 0).toFixed(2)}</td>
          </tr>`,
          )
          .join("");

        const paymentTableHTML = `
        <br><h3 style="margin-top:10px;">Payment Details</h3>
        <table border="1" cellspacing="0" cellpadding="6" style="border-collapse:collapse; width:100%; font-family:Arial; font-size:13px;">
          <thead style="background:#f2f2f2;">
            <tr>
              <th>Payment Type</th>
              <th>Payment Date</th>
              <th>Exhibitor Bank</th>
              <th>Receiver Bank</th>
              <th>Received Payment</th>
              <th>TDS</th>
            </tr>
          </thead>
          <tbody>${paymentRows}</tbody>
        </table>`;

        const totalPaidWithTDS = localBadgePayments.reduce((sum, p) => {
          const amt = parseFloat(p.amount || 0);
          const tds = parseFloat(p.tds || 0);
          return sum + amt + tds;
        }, 0);

        const pendingAmount = grandTotal - totalPaidWithTDS;

        const statusHTML = `
        <div style="margin-top:12px; font-weight:bold; color:${
          pendingAmount <= 0 ? "green" : "red"
        };">
          ${
            pendingAmount <= 0
              ? "PAYMENT CLEARED"
              : `PENDING AMOUNT: ${pendingAmount.toFixed(2)}`
          }
        </div>`;

        parsedContent += `${paymentTableHTML}${statusHTML}`;
      } else {
        parsedContent += `<br><div style="margin-top:12px; font-weight:bold; color:red;">No payments recorded yet.</div>`;
      }
    }

    // === CASE 5: EXTRA FURNITURE UNLOCK NOTIFICATION ===
    else if (
      emailTemplateName === "InOptics 2026 @ Extra Furniture Section Unlocked"
    ) {
      const companyName = formData.company_name;
      const emailAddr = formData.email;

      parsedContent = parsedContent
        .replace(/\[Company Name\]/gi, companyName)
        .replace(/\[Email\]/gi, emailAddr)
        .replace(/&n/g, "<br>");
    }

    // Wrap content in HTML structure
    parsedContent = `
    <html>
      <head>
        <meta charset="UTF-8">
      </head>
      <body style="font-family:Arial,sans-serif; font-size:14px; line-height:1.5;">
        ${parsedContent}
      </body>
    </html>`;

    // Final cleanup for stray characters
    parsedContent = parsedContent.replace(/bsp;*/g, "");

    // Log final parsed content and request body for debugging
    // console.log("Final parsed content:", parsedContent);
    // console.log("Sending email with body:", {
    //   email_name: emailTemplateName,
    //   to: email,
    //   html: parsedContent,
    //   secondary_emails: formData.secondary_emails || "",
    // });

    // ---------- SEND MAIL ----------
    try {
      const response = await fetch("https://inoptics.in/api/send_mail.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email_name: emailTemplateName,
          to: email,
          html: parsedContent,
          company_name: formData.company_name,
          secondary_emails: formData.secondary_emails || "",
        }),
      });

      const text = await response.text();
      const result = text ? JSON.parse(text) : {};

      if (response.ok) {
        alert("✅ Mail sent successfully!");
      } else {
        alert("❌ Failed to send mail: " + (result.message || "Unknown error"));
      }
    } catch (err) {
      console.error("Error sending mail:", err);
      alert("❌ Failed to send mail. Check console.");
    }

    setIsSendingMail(false);
  };

  const handleSendFurnitureMail = async (emailTemplateName) => {
    if (isSendingMail) return;
    setIsSendingMail(true);

    try {
      /* ================= TEMPLATE FETCH ================= */

      const vendorTemplate = emailMasterData.find(
        (t) => t.email_name === emailTemplateName,
      );

      const exhibitorTemplate = emailMasterData.find(
        (t) =>
          t.email_name ===
          "InOptics 2026 @ Extra Furniture Request Confirmation Exhibitor",
      );

      if (!vendorTemplate || !exhibitorTemplate) {
        alert("Email template not found");
        return;
      }

      /* ================= EXHIBITOR DETAILS ================= */

      const { company_name, name, mobile, email, stall_no } = formData;

      console.log("Exhibitor rishab furnicuture email details:", {
        company_name,
        name,
        mobile,
        email,
        stall_no,
      });
      if (!company_name || !email) {
        alert("Missing exhibitor data");
        return;
      }

      /* ================= VENDOR DETAILS ================= */

      const vendor = furnitureVendorDetails?.[0] || {};

      const vendorName = vendor.vendor_name || "";
      const vendorEmail =
        vendor.email ||
        vendor.vendor_email ||
        vendor.vendorEmail ||
        vendor.contact_email;

      const vendorCompany = vendor.company_name || "";
      const vendorPhone = vendor.contact_number || vendor.mobile || "";

      if (!vendorEmail) {
        alert("Vendor email missing");
        return;
      }

      /* ================= VALIDATE FURNITURE ================= */

      if (!selectedFurniture || selectedFurniture.length === 0) {
        alert("No furniture selected");
        return;
      }

      /* ================= TABLE CALCULATION ================= */

      let totalAmount = 0;
      let totalSGST = 0;
      let totalCGST = 0;
      let grandTotal = 0;

      const rows = selectedFurniture
        .map((item) => {
          const qty = Number(item.quantity);
          const rate = Number(item.price);

          const amount = qty * rate;
          const sgst = amount * 0.09;
          const cgst = amount * 0.09;
          const total = amount + sgst + cgst;

          totalAmount += amount;
          totalSGST += sgst;
          totalCGST += cgst;
          grandTotal += total;

          return `
        <tr>
          <td>${item.name}</td>
          <td align="center">${qty}</td>
          <td align="right">${rate.toFixed(2)}</td>
          <td align="right">${amount.toFixed(2)}</td>
          <td align="right">${sgst.toFixed(2)}</td>
          <td align="right">${cgst.toFixed(2)}</td>
          <td align="right">${total.toFixed(2)}</td>
        </tr>
        `;
        })
        .join("");

      /* ================= FURNITURE TABLE ================= */

      const furnitureTable = `
      <table border="1" cellpadding="6" cellspacing="0"
      style="border-collapse:collapse;width:100%;font-family:Arial;font-size:13px">

      <thead style="background:#f2f2f2">
      <tr>
        <th>Item Name</th>
        <th>Qty</th>
        <th>Rate</th>
        <th>Amount</th>
        <th>SGST (9%)</th>
        <th>CGST (9%)</th>
        <th>Total</th>
      </tr>
      </thead>

      <tbody>

      ${rows}

      <tr style="font-weight:bold;background:#fafafa">
        <td colspan="3" align="right">TOTAL</td>
        <td align="right">${totalAmount.toFixed(2)}</td>
        <td align="right">${totalSGST.toFixed(2)}</td>
        <td align="right">${totalCGST.toFixed(2)}</td>
        <td align="right">${grandTotal.toFixed(2)}</td>
      </tr>

      </tbody>

      </table>
    `;

      /* ================= PLACEHOLDER DATA ================= */

      const replaceData = {
        "[Company_Name]": company_name,
        "[Contact_Person_Name]": name,
        "[Mobile_Number]": mobile,
        "[Email_Address]": email,
        "[Stall_No]": stall_no,

        "[Vendor_Name]": vendorName,
        "[Vendor_Company]": vendorCompany,
        "[Vendor_Email]": vendorEmail,
        "[Vendor_Phone]": vendorPhone,

        "[Furniture_Table]": furnitureTable,

        "[Exhibitor_Name]": name,
        "[Phone_Number]": mobile,
      };

      /* ================= TEMPLATE REPLACEMENT ================= */

      const replaceTemplate = (template) => {
        let html = template;

        Object.keys(replaceData).forEach((key) => {
          html = html.replaceAll(key, replaceData[key]);
        });

        return html.replace(/&n/g, "<br>");
      };

      const vendorHTML = replaceTemplate(vendorTemplate.content);
      const exhibitorHTML = replaceTemplate(exhibitorTemplate.content);

      /* ================= SEND VENDOR MAIL ================= */

      const vendorRes = await fetch(
        "https://inoptics.in/api/send_furniture_vendor_mail.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email_name: emailTemplateName,
            to: vendorEmail,
            html: vendorHTML,
          }),
        },
      );

      const vendorResult = await vendorRes.json();

      if (!vendorResult.message?.includes("successfully")) {
        alert("Vendor mail failed");
        return;
      }

      /* ================= SEND EXHIBITOR MAIL ================= */

      const exhibitorRes = await fetch(
        "https://inoptics.in/api/send_furniture_vendor_mail.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email_name:
              "InOptics 2026 @ Extra Furniture Request Confirmation Exhibitor",
            to: email,
            html: exhibitorHTML,
          }),
        },
      );

      const exhibitorResult = await exhibitorRes.json();

      if (exhibitorResult.message?.includes("successfully")) {
        alert("✅ Mail sent successfully!");
      } else {
        alert("Vendor mail sent but exhibitor mail failed.");
      }
    } catch (error) {
      console.error("Mail error:", error);
      alert("Error sending mail");
    } finally {
      setIsSendingMail(false);
    }
  };

  const handleSaveRegistrationItem = (item, index) => {
    // console.log("Saving item:", index, item);
    // You can use `fetch` or `axios` here to POST data to your backend
    alert(`Saved item ${index + 1}`);
  };

  const handleContraDelete = (type, item) => {
    if (type === "undertaking") {
      if (item?.id) {
        deleteContractorUndertaking(item.id);
      }
    } else if (type === "registration") {
      if (item?.id) {
        deleteRegistrationFees(item.id);
      }
    }
  };

  const performAction = (actionType, targetType) => {
    const index = selectedItemIndex;

    if (actionType === "view") {
      if (targetType === "undertaking") {
        const item = contractorUndertakingData[index];
        if (item) {
          setViewedUndertaking(
            item.declaration_text || "<p>No content available</p>",
          );
        }
      } else if (targetType === "registration") {
        const item = registrationFeesData[index];
        if (item) {
          setViewedRegistrationFees(
            item.declaration_text || "<p>No content available</p>",
          );
        }
      }
      // Don't reset modal for "view", so the view stays open
      return;
    }

    // --- Undertaking Actions ---
    if (targetType === "undertaking") {
      if (actionType === "add") {
        resetContractorUndertakingForm();
        setShowContractorUndertakingAddForm(true);
      } else if (actionType === "edit") {
        handleContractorUndertakingEdit(contractorUndertakingData[index]);
      } else if (actionType === "delete") {
        deleteContractorUndertaking(contractorUndertakingData[index]?.id);
      }
    }

    // --- Registration Actions ---
    else if (targetType === "registration") {
      if (actionType === "add") {
        resetRegistrationFeesForm();
        setShowRegistrationFeesAddForm(true);
      } else if (actionType === "edit") {
        handleRegistrationFeesEdit(registrationFeesData[index]);
      } else if (actionType === "delete") {
        deleteRegistrationFees(registrationFeesData[index]?.id);
      }
    }

    // Close modal after non-view actions
    setActionModalType(null);
    setSelectedItemIndex(null);
  };

  useEffect(() => {
    if (
      activeContractorTab === "Registration Fees" ||
      activeContractorTab === "Undertaking & Registration Fees"
    ) {
      fetchRegistrationFees();
    }
  }, [activeContractorTab]);

  useEffect(() => {
    if (
      activeContractorTab === "Contractor Undertaking" ||
      activeContractorTab === "Undertaking & Registration Fees"
    ) {
      fetchContractorUndertakings();
    }
  }, [activeContractorTab]);

  const fetchCoreForms = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/get_core_forms.php");
      const data = await res.json();
      setCoreFormData(data);
    } catch (error) {
      alert("Error fetching core forms");
    }
  };
  useEffect(() => {
    if (overlayContent === "Core Required Forms" || showRegistrationModal) {
      fetchCoreForms();
    }
  }, [overlayContent, showRegistrationModal]);

  const resetCoreFormModal = () => {
    setCoreFormUpload(null);
    setCoreFormCategory("");
    setIsCoreFormEditing(false);
    setCurrentCoreFormId(null);
    setShowCoreFormModal(false);
  };
  const addCoreForm = async () => {
    const form = new FormData();
    form.append("file", coreFormUpload);
    form.append("category", coreFormCategory);

    try {
      const res = await fetch("https://inoptics.in/api/add_core_form.php", {
        method: "POST",
        body: form,
      });
      const data = await res.json();
      alert(data.message);
      fetchCoreForms();
      resetCoreFormModal();
    } catch (error) {
      alert("Error adding core form");
    }
  };

  const updateCoreForm = async () => {
    const form = new FormData();
    form.append("id", currentCoreFormId);
    form.append("category", coreFormCategory);
    if (coreFormUpload) form.append("file", coreFormUpload); // Optional file

    try {
      const res = await fetch("https://inoptics.in/api/update_core_form.php", {
        method: "POST",
        body: form,
      });
      const data = await res.json();
      alert(data.message);
      fetchCoreForms();
      resetCoreFormModal();
    } catch (error) {
      alert("Error updating core form");
    }
  };

  const handleCoreFormEdit = (item) => {
    setIsCoreFormEditing(true);
    setCurrentCoreFormId(item.id);
    setCoreFormCategory(item.category);
    setCoreFormUpload(null); // user can choose a new file
    setShowCoreFormModal(true);
  };

  const deleteCoreForm = async (category) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this form?",
    );
    if (!confirmDelete) return;

    try {
      const res = await fetch("https://inoptics.in/api/delete_core_form.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ category }), // 🔥 SEND CATEGORY instead of id
      });

      const data = await res.json();
      alert(data.message);
      fetchCoreForms();
    } catch (error) {
      alert("Error deleting core form");
    }
  };

  const [selectedStallCalculation, setSelectedStallCalculation] =
    useState(null);
  const [stallPayments, setStallPayments] = useState([]);
  const [powerDetails, setPowerDetails] = useState({});
  const [badgeDetails, setBadgeDetails] = useState({ extra_badges: 0 });

  const handleViewPayment = async (payment) => {
    setSelectedCompany(payment);
    setShowPaymentOverlay(true);

    try {
      const res = await fetch(
        "https://inoptics.in/api/fetch_company_stall_details.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ company_name: payment.company_name }),
        },
      );
      const data = await res.json();
      if (data.success) {
        setSelectedStallDetails(data.data);
        setSelectedStallCalculation(data.calculation);
        setStallPayments(data.payments || []);
        setBadgePayments(data.badge_payments || []);
        setPowerDetails({
          ...data.power_details,
          power_payments: data.power_payments || [],
        });
        setBadgeDetails(data.badges || { extra_badges: 0 }); // ✅ new line
      } else {
        setSelectedStallDetails([]);
        setSelectedStallCalculation(null);
        setStallPayments([]);
        setPowerDetails({});
        setBadgeDetails({ extra_badges: 0 });
      }
    } catch (err) {
      console.error(err);
      setSelectedStallDetails([]);
      setSelectedStallCalculation(null);
      setStallPayments([]);
      setPowerDetails({});
    }
  };

  const stallTotalsByCompany = stallList.reduce((acc, stall) => {
    const name = stall.company_name;
    const grandTotal = parseFloat(stall.grand_total) || 0;
    if (!acc[name]) {
      acc[name] = 0;
    }
    acc[name] += grandTotal;
    return acc;
  }, {});

  useEffect(() => {
    const updated = { ...powerTotalsByCompany };
    exhibitorData.forEach((item) => {
      const key = `grandTotal_power_${item.company_name}`;
      const saved = localStorage.getItem(key);
      if (saved !== null) {
        updated[item.company_name] = parseFloat(saved);
      }
    });
    setPowerTotalsByCompany(updated);
  }, [exhibitorData]);

  const getExhibitorBadgesCostForCompany = (company_name) => {
    const item = exhibitorData.find((d) => d.company_name === company_name);
    if (!item) return 0;
    const extraBadgeCount = parseInt(item.extra_badges, 10) || 0;
    return extraBadgeCount * 100;
  };

  const handleSubmitFacia = async () => {
    try {
      const response = await fetch(
        "https://inoptics.in/api/add_exhibitor_facia.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            Company_name: formData.company_name,
            Facia_text: faciaText,
          }),
        },
      );

      const data = await response.json();
      if (data.status === "success") {
        alert("Facia submitted successfully!");
        setShowExhibitorEditForm(true);
      } else if (data.status === "exists") {
        alert("Facia already exists. You can update it.");
        setShowExhibitorEditForm(true);
      } else {
        alert("Error: " + data.message);
      }
    } catch (error) {
      console.error("Submit Facia Error:", error);
      alert("Something went wrong.");
    }
  };

  const handleUpdateFacia = async () => {
    try {
      const response = await fetch(
        "https://inoptics.in/api/update_exhibitor_facia.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            Company_name: formData.company_name,
            Facia_text: faciaText,
          }),
        },
      );

      const data = await response.json();
      if (data.status === "success") {
        alert("Facia updated successfully!");
      } else {
        alert("Update failed: " + data.message);
      }
    } catch (error) {
      console.error("Update Facia Error:", error);
      alert("Something went wrong.");
    }
  };

  useEffect(() => {
    if (activeNavbarItem === "FACIA BOARD" && formData.company_name) {
      fetchFaciaText();
    }
  }, [activeNavbarItem, formData.company_name]);

  const fetchFaciaText = async () => {
    try {
      const response = await fetch(
        `https://inoptics.in/api/get_exhibitor_facia.php?Company_name=${encodeURIComponent(
          formData.company_name,
        )}`,
      );
      const data = await response.json();

      if (data.status === "success") {
        setFaciaText(data.Facia_text);
        setShowExhibitorEditForm(true);
      } else {
        setFaciaText("");
        // setShowExhibitorEditForm(false);
      }
    } catch (error) {
      console.error("Fetch Facia Error:", error);
      alert("Could not fetch facia data.");
    }
  };

  const handleSubmitBrands = async () => {
    const payload = {
      Company_name: formData.company_name,
      website: brandsData.website,
      products: (brandsData.products || []).join(","),
      home_brands: brandsData.home_brands,
      distributors: brandsData.distributors,
      international_brands: brandsData.international_brands,
    };

    // console.log("SUBMIT / UPDATE:", payload);

    try {
      const response = await fetch(
        "https://inoptics.in/api/add_exhibitor_brands.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();
      if (data.status === "success") {
        console.log("brands data submit rishab", data);

        alert("Brands submitted successfully!");
        setShowBrandsEditForm(true);
      } else if (data.status === "exists") {
        alert("Brands data already exists. You can update it.");
        setShowBrandsEditForm(true);
      } else {
        alert("Error: " + data.message);
      }
    } catch (error) {
      console.error("Submit Brands Error:", error);
      alert("Something went wrong.");
    }
  };

  const handleUpdateBrands = async () => {
    const payload = {
      Company_name: formData.company_name,
      website: brandsData.website,
      products: (brandsData.products || []).join(","),
      home_brands: brandsData.home_brands,
      distributors: brandsData.distributors,
      international_brands: brandsData.international_brands,
    };

    // console.log("SUBMIT / UPDATE:", payload);

    try {
      const response = await fetch(
        "https://inoptics.in/api/update_exhibitor_brands.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();
      if (data.status === "success") {
        console.log("brands data rishab", data);

        alert("Brands updated successfully!");
      } else {
        alert("Update failed: " + data.message);
      }
    } catch (error) {
      console.error("Update Brands Error:", error);
      alert("Something went wrong.");
    }
  };

  useEffect(() => {
    if (activeNavbarItem === "BRANDS" && formData.company_name) {
      fetchBrandsData();
    }
  }, [activeNavbarItem, formData.company_name]);

  const fetchBrandsData = async () => {
    try {
      const response = await fetch(
        `https://inoptics.in/api/get_exhibitor_brands.php?Company_name=${encodeURIComponent(
          formData.company_name,
        )}`,
      );

      const data = await response.json();

      if (data.status === "success") {
        console.log("brands data rishab", data);

        setBrandsData({
          website: data.Website || "",

          // 🔥 IMPORTANT FIX
          products: data.Products
            ? data.Products.split(",").map((p) => p.trim())
            : [],

          home_brands: data.Home_brands || "",
          distributors: data.Distributors || "",
          international_brands: data.International_brands || "",
        });

        setShowBrandsEditForm(true);
      } else {
        setBrandsData({
          website: "",
          products: [],
          home_brands: "",
          distributors: "",
          international_brands: "",
        });
      }
    } catch (error) {
      console.error("Fetch Brands Error:", error);
    }
  };

  useEffect(() => {
    if (activeNavbarItem === "BRANDS") {
      fetchProducts();
    }
  }, [activeNavbarItem]);

  useEffect(() => {
    // Ensure the state is checked safely
    const isDelhi = formData?.state?.toLowerCase() === "delhi";

    // Calculate subtotal (Area × Price)
    const subTotal = selectedBranding.reduce(
      (acc, item) => acc + (item.area || 0) * (item.price || 0),
      0,
    );

    const amount = Math.round(subTotal);
    const sgst = isDelhi ? Math.round((amount * 9) / 100) : 0;
    const cgst = isDelhi ? Math.round((amount * 9) / 100) : 0;
    const igst = !isDelhi ? Math.round((amount * 18) / 100) : 0;
    const grandTotal = Math.round(amount + sgst + cgst + igst);

    setBrandingBilling({
      subTotal,
      amount,
      sgst,
      cgst,
      igst,
      grandTotal,
    });
  }, [selectedBranding, formData.state]);

  const addExhibitorSelectedBranding = async (payload) => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/add_selected_branding.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );

      const text = await res.text();
      // console.log("Raw response text:", text);

      let data;
      try {
        data = JSON.parse(text);
      } catch (jsonError) {
        console.error("JSON parsing error:", jsonError);
        throw new Error("Server did not return valid JSON.");
      }

      if (res.ok) {
        alert(data.message || "Branding submitted successfully");
      } else {
        alert(data.message || "Error submitting branding");
      }
    } catch (error) {
      console.error("Add branding error:", error);
      alert("Something went wrong while adding branding.");
    }
  };

  const fetchSelectedBranding = async (companyName) => {
    try {
      const response = await fetch(
        `https://inoptics.in/api/get_selected_branding.php?company_name=${encodeURIComponent(
          companyName,
        )}`,
      );
      const data = await response.json();

      // console.log("Fetched branding data:", data); // For debugging

      const normalizedData = data.map((item) => ({
        ...item,
        name: item.branding_name || item.name || "Unnamed",
        image: item.image_url || item.image || "",
        area: parseFloat(item.area) || 0,
        price: parseFloat(item.price) || 0,
        total:
          parseFloat(item.total) ||
          parseFloat(item.area) * parseFloat(item.price) ||
          0,
      }));

      setSelectedBranding(normalizedData);
    } catch (error) {
      console.error("Error fetching selected branding data:", error);
    }
  };
  useEffect(() => {
    if (formData.company_name) {
      fetchSelectedBranding(formData.company_name);
    }
  }, [formData.company_name]);

  const updateSelectedBranding = async (companyName, selectedBranding) => {
    try {
      const payload = {
        company_name: companyName,
        branding: selectedBranding.map((item) => ({
          image: item.image,
          name: item.name,
          area: item.area,
          price: item.price,
          total: item.area * item.price || 0,
        })),
      };

      const response = await fetch(
        "https://inoptics.in/api/update_selected_branding.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (response.ok && data.status === "success") {
        alert("Branding updated successfully!");
      } else {
        alert(
          "Failed to update branding: " + (data.message || "Unknown error"),
        );
      }
    } catch (error) {
      console.error("Error updating branding:", error);
      alert("Error updating branding. Please try again later.");
    }
  };

  // Fetch payments from DB on load
  useEffect(() => {
    if (!formData.company_name) return;

    // ✅ CLEAN company name before sending to API
    const cleanCompanyName = formData.company_name
      .replace(/\u00A0/g, " ") // remove non-breaking spaces
      .replace(/\s+/g, " ") // normalize multiple spaces
      .trim(); // trim edges

    console.log("Company name sending:", cleanCompanyName);

    fetch(
      `https://inoptics.in/api/get_exhibitor_payment.php?company_name=${encodeURIComponent(
        cleanCompanyName,
      )}`,
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          console.log("exhibitor stall payment", data);

          const normalized = data.records.map((pay) => ({
            type: pay.payment_type || pay.type || "",
            date: pay.payment_date || pay.date || "",
            receiverBank: pay.name_of_receiver_bank || pay.receiverBank || "",
            exhibitorBank:
              pay.name_of_exhibitor_bank || pay.exhibitorBank || "",
            amount: parseFloat(pay.amount_paid || pay.amount || 0),
            tds: parseFloat(pay.tds || 0),
          }));

          setPayments(normalized);
        } else {
          setPayments([]);
        }
      })
      .catch((err) => {
        console.error("Payment fetch error:", err);
        setPayments([]);
      });
  }, [formData.company_name]);

  // Add payment to DB and re-fetch
  const handleAddPayment = async () => {
    if (!formData.company_name) {
      alert("Company name is required.");
      return;
    }

    const newPayment = {
      type: paymentType,
      date: paymentDate,
      receiverBank: receiverBankName,
      exhibitorBank: exhibitorBankName,
      amount: parseFloat(amount) || 0,
      tds: parseFloat(tds) || 0,
    };

    try {
      const response = await fetch(
        "https://inoptics.in/api/add_exhibitor_payment.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            company_name: formData.company_name,
            payments: [newPayment],
          }),
        },
      );

      const result = await response.json();

      if (result.success) {
        alert("Payment added successfully");
        // ✅ FORCE refresh for SAME company
        fetchPayments(formData.company_name);
        setPaymentType("");
        setPaymentDate("");
        setReceiverBankName("");
        setExhibitorBankName("");
        setAmount("");
        setTds("");
      } else {
        alert(result.message || "Failed to add payment");
      }
    } catch (error) {
      console.error("Add payment error:", error);
      alert("An error occurred while adding payment");
    }
  };

  // Delete payment from DB and re-fetch
  const handleDeletePayment = async (index) => {
    const paymentToDelete = payments[index];

    try {
      const response = await fetch(
        "https://inoptics.in/api/delete_exhibitor_payment.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            company_name: formData.company_name,
            payment: paymentToDelete,
          }),
        },
      );

      const result = await response.json();

      if (result.success) {
        alert("Payment deleted successfully");
        // ✅ FORCE refresh for SAME company
        fetchPayments(formData.company_name);
      } else {
        alert(result.message || "Failed to delete payment");
      }
    } catch (error) {
      console.error("Delete payment error:", error);
      alert("An error occurred while deleting payment");
    }
  };

  // Helper to refetch payments from backend
  const fetchPayments = async (companyName) => {
    if (!companyName) return;

    const cleanCompanyName = companyName
      .replace(/\u00A0/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    const res = await fetch(
      `https://inoptics.in/api/get_exhibitor_payment.php?company_name=${encodeURIComponent(
        cleanCompanyName,
      )}`,
    );

    const data = await res.json();

    if (data.success) {
      console.log("exhibitor second methos api fetch data", data);

      const normalized = data.records.map((pay) => ({
        type: pay.payment_type || "",
        date: pay.payment_date || "",
        receiverBank: pay.name_of_receiver_bank || "",
        exhibitorBank: pay.name_of_exhibitor_bank || "",
        amount: parseFloat(pay.amount_paid || 0),
        tds: parseFloat(pay.tds || 0),
      }));

      setPayments(normalized);
    } else {
      setPayments([]);
    }
  };

  // Handle edit click
  const handleEditPayment = (index) => {
    const payment = payments[index];
    setPaymentType(payment.type || "");
    setPaymentDate(payment.date || "");
    setReceiverBankName(payment.receiverBank || "");
    setExhibitorBankName(payment.exhibitorBank || "");
    setAmount(payment.amount || "");
    setTds(payment.tds || "");
    setEditingIndex(index); // 🟢 now we’re in editing mode
  };

  // Handle update payment
  const handleUpdatePayment = async () => {
    if (editingIndex === null) return;

    if (!formData.company_name) {
      alert("Company name is required.");
      return;
    }

    const cleanCompanyName = formData.company_name
      .replace(/\u00A0/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    const updatedPayment = {
      original: payments[editingIndex],
      updated: {
        type: paymentType,
        date: paymentDate,
        receiverBank: receiverBankName,
        exhibitorBank: exhibitorBankName,
        amount: parseFloat(amount) || 0,
        tds: parseFloat(tds) || 0,
      },
    };

    try {
      const response = await fetch(
        "https://inoptics.in/api/update_exhibitor_payment.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            company_name: cleanCompanyName,
            payment: updatedPayment,
          }),
        },
      );

      const result = await response.json();

      if (result.success) {
        alert("Payment updated successfully");

        // ✅ FORCE refetch for SAME company
        fetchPayments(formData.company_name); // refetch fresh data

        setPaymentType("");
        setPaymentDate("");
        setReceiverBankName("");
        setExhibitorBankName("");
        setAmount("");
        setTds("");
        setEditingIndex(null);
      } else {
        alert(result.message || "Failed to update payment");
      }
    } catch (error) {
      console.error("Update payment error:", error);
      alert("An error occurred while updating payment");
    }
  };

  // Recalculate totals when payments change
  useEffect(() => {
    const totalPaid = payments.reduce(
      (sum, p) => sum + (parseFloat(p.amount) || 0),
      0,
    );
    const totalTds = payments.reduce(
      (sum, p) => sum + (parseFloat(p.tds) || 0),
      0,
    );
    const totalReceived = totalPaid + totalTds;

    setPaymentReceived(totalReceived.toFixed(2));

    const grandTotal = stallList.reduce((sum, stall) => {
      const value = parseFloat(stall.grand_total);
      return sum + (isNaN(value) ? 0 : value);
    }, 0);

    setPaymentPending((grandTotal - totalReceived).toFixed(2));
  }, [payments, stallList]);

  // POWER PAYMENT STATES
  const [powerExhibitorBankName, setPowerExhibitorBankName] = useState("");
  const [powerReceiverBankName, setPowerReceiverBankName] = useState("");
  const [editingPowerIndex, setEditingPowerIndex] = useState(null);

  // Fetch Power Payments on load
  useEffect(() => {
    if (activePaymentDetailsOverlay === "power" && formData.company_name) {
      fetchPowerPayments();
    }
  }, [activePaymentDetailsOverlay, formData.company_name]);

  const fetchPowerPayments = async () => {
    try {
      const res = await fetch(
        `https://inoptics.in/api/get_exhibitor_power_payment.php?company_name=${formData.company_name}`,
      );
      const data = await res.json();

      if (data.success) {
        const normalized = data.records.map((pay) => ({
          type: pay.payment_type || "",
          date: pay.payment_date || "",
          exhibitorBank: pay.exhibitor_bank_name || "",
          receiverBank: pay.receiver_bank_name || "",
          amount: parseFloat(pay.amount_paid || 0),
          tds: parseFloat(pay.tds || 0),
        }));
        setPowerPayments(normalized);
      }
    } catch (error) {
      console.error("Error fetching power payments:", error);
    }
  };

  const handleAddPowerPayment = async () => {
    if (!formData.company_name) {
      alert("Company name is required.");
      return;
    }

    const newPayment = {
      type: powerPaymentType,
      date: powerPaymentDate,
      exhibitor_bank_name: powerExhibitorBankName,
      receiver_bank_name: powerReceiverBankName,
      amount: parseFloat(powerAmount) || 0,
      tds: parseFloat(powerTds) || 0,
    };

    try {
      const response = await fetch(
        "https://inoptics.in/api/add_exhibitor_power_payment.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            company_name: formData.company_name,
            payments: [newPayment],
          }),
        },
      );

      const result = await response.json();

      if (result.success) {
        alert("Power payment added successfully");
        fetchPowerPayments();
        setPowerPaymentType("");
        setPowerPaymentDate("");
        setPowerAmount("");
        setPowerTds("");
        setPowerExhibitorBankName("");
        setPowerReceiverBankName("");
      } else {
        alert(result.message || "Failed to add power payment");
      }
    } catch (error) {
      console.error("Add power payment error:", error);
      alert("An error occurred while adding power payment");
    }
  };

  // Delete Power Payment
  const handleDeletePowerPayment = async (index) => {
    const paymentToDelete = powerPayments[index];

    try {
      const response = await fetch(
        "https://inoptics.in/api/delete_exhibitor_power_payment.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            company_name: formData.company_name,
            payment: paymentToDelete,
          }),
        },
      );

      const result = await response.json();

      if (result.success) {
        alert("Power payment deleted successfully");
        fetchPowerPayments();
      } else {
        alert(result.message || "Failed to delete power payment");
      }
    } catch (error) {
      console.error("Delete power payment error:", error);
      alert("An error occurred while deleting power payment");
    }
  };

  // Recalculate totals for power section
  useEffect(() => {
    const totalPaid = powerPayments.reduce(
      (sum, p) => sum + (parseFloat(p.amount) || 0),
      0,
    );
    const totalTds = powerPayments.reduce(
      (sum, p) => sum + (parseFloat(p.tds) || 0),
      0,
    );
    const totalReceived = totalPaid + totalTds;

    setPowerReceived(totalReceived.toFixed(2));

    // You can use a fixed power price or fetch from backend
    const powerTotal = 10000; // Example fixed grand total for power (replace this)
    setPowerPending((powerTotal - totalReceived).toFixed(2));
  }, [powerPayments]);

  // Edit power payment
  const handleEditPowerPayment = (index) => {
    const payment = powerPayments[index];
    setEditingPowerIndex(index);
    setPowerPaymentType(payment.type || "");
    setPowerPaymentDate(payment.date || "");
    setPowerExhibitorBankName(payment.exhibitorBank || "");
    setPowerReceiverBankName(payment.receiverBank || "");
    setPowerAmount(payment.amount || "");
    setPowerTds(payment.tds || "");
  };

  // Update power payment
  const handleUpdatePowerPayment = async () => {
    if (editingPowerIndex === null) return;

    const updatedPayment = {
      type: powerPaymentType,
      date: powerPaymentDate,
      exhibitorBank: powerExhibitorBankName,
      receiverBank: powerReceiverBankName,
      amount: parseFloat(powerAmount) || 0,
      tds: parseFloat(powerTds) || 0,
    };

    try {
      const response = await fetch(
        "https://inoptics.in/api/update_exhibitor_power_payment.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            company_name: formData.company_name,
            oldPayment: powerPayments[editingPowerIndex], // existing payment
            newPayment: updatedPayment, // updated payment
          }),
        },
      );

      const result = await response.json();

      if (result.success) {
        alert("Power payment updated successfully");
        fetchPowerPayments(); // refresh table
        setEditingPowerIndex(null);
        setPowerPaymentType("");
        setPowerPaymentDate("");
        setPowerExhibitorBankName("");
        setPowerReceiverBankName("");
        setPowerAmount("");
        setPowerTds("");
      } else {
        alert(result.message || "Failed to update power payment");
      }
    } catch (error) {
      console.error("Update power payment error:", error);
      alert("An error occurred while updating power payment");
    }
  };

  // State for badge payments
  const [badgePayments, setBadgePayments] = useState([]);
  const [badgePaymentType, setBadgePaymentType] = useState("");
  const [badgePaymentDate, setBadgePaymentDate] = useState("");
  const [badgeExhibitorBankName, setBadgeExhibitorBankName] = useState("");
  const [badgeReceiverBankName, setBadgeReceiverBankName] = useState("");
  const [badgeAmount, setBadgeAmount] = useState("");
  const [badgeTds, setBadgeTds] = useState("");
  const [editingBadgeIndex, setEditingBadgeIndex] = useState(null);
  const [badgePendingAmount, setBadgePendingAmount] = useState(0);
  const [badgeReceived, setBadgeReceived] = useState(0);
  const [badgePending, setBadgePending] = useState(0);

  // ✅ Fetch Badge Payments on load
  useEffect(() => {
    if (activePaymentDetailsOverlay === "badges" && formData.company_name) {
      fetchBadgePayments();
    }
  }, [activePaymentDetailsOverlay, formData.company_name]);

  const fetchBadgePayments = async () => {
    try {
      const res = await fetch(
        `https://inoptics.in/api/get_exhibitor_badge_payment.php?company_name=${formData.company_name}`,
      );
      const data = await res.json();

      if (data.success) {
        const normalized = data.records.map((pay) => ({
          type: pay.payment_type || "",
          date: pay.payment_date || "",
          exhibitorBank: pay.exhibitor_bank_name || "",
          receiverBank: pay.receiver_bank_name || "",
          amount: parseFloat(pay.amount_paid || 0),
          tds: parseFloat(pay.tds || 0),
        }));
        setBadgePayments(normalized);
      }
    } catch (error) {
      console.error("Error fetching badge payments:", error);
    }
  };

  // ✅ Add Badge Payment
  const handleAddBadgePayment = async () => {
    if (!formData.company_name) {
      alert("Company name is required.");
      return;
    }

    const newPayment = {
      type: badgePaymentType,
      date: badgePaymentDate,
      exhibitor_bank_name: badgeExhibitorBankName,
      receiver_bank_name: badgeReceiverBankName,
      amount: parseFloat(badgeAmount) || 0,
      tds: parseFloat(badgeTds) || 0,
    };

    try {
      const response = await fetch(
        "https://inoptics.in/api/add_exhibitor_badge_payment.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            company_name: formData.company_name,
            payments: [newPayment],
          }),
        },
      );

      const result = await response.json();

      if (result.success) {
        alert("Badge payment added successfully");
        fetchBadgePayments();
        setBadgePaymentType("");
        setBadgePaymentDate("");
        setBadgeAmount("");
        setBadgeTds("");
        setBadgeExhibitorBankName("");
        setBadgeReceiverBankName("");
      } else {
        alert(result.message || "Failed to add badge payment");
      }
    } catch (error) {
      console.error("Add badge payment error:", error);
      alert("An error occurred while adding badge payment");
    }
  };

  // ✅ Delete Badge Payment (Instant UI Update)
  const handleDeleteBadgePayment = async (index) => {
    const paymentToDelete = badgePayments[index];

    try {
      const response = await fetch(
        "https://inoptics.in/api/delete_exhibitor_badge_payment.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            company_name: formData.company_name,
            payment: paymentToDelete,
          }),
        },
      );

      const result = await response.json();

      if (result.success) {
        alert("Badge payment deleted successfully");

        // ✅ Instantly update the UI (remove from local state)
        setBadgePayments((prevPayments) =>
          prevPayments.filter((_, i) => i !== index),
        );
      } else {
        alert(result.message || "Failed to delete badge payment");
      }
    } catch (error) {
      console.error("Delete badge payment error:", error);
      alert("An error occurred while deleting badge payment");
    }
  };

  // ✅ Edit Badge Payment
  const handleEditBadgePayment = (index) => {
    const payment = badgePayments[index];
    setEditingBadgeIndex(index);
    setBadgePaymentType(payment.type || "");
    setBadgePaymentDate(payment.date || "");
    setBadgeExhibitorBankName(payment.exhibitorBank || "");
    setBadgeReceiverBankName(payment.receiverBank || "");
    setBadgeAmount(payment.amount || "");
    setBadgeTds(payment.tds || "");
  };

  // ✅ Update Badge Payment
  const handleUpdateBadgePayment = async () => {
    if (editingBadgeIndex === null) return;

    const updatedPayment = {
      type: badgePaymentType,
      date: badgePaymentDate,
      exhibitorBank: badgeExhibitorBankName,
      receiverBank: badgeReceiverBankName,
      amount: parseFloat(badgeAmount) || 0,
      tds: parseFloat(badgeTds) || 0,
    };

    try {
      const response = await fetch(
        "https://inoptics.in/api/update_exhibitor_badge_payment.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            company_name: formData.company_name,
            oldPayment: badgePayments[editingBadgeIndex], // existing payment
            newPayment: updatedPayment, // updated payment
          }),
        },
      );

      const result = await response.json();

      if (result.success) {
        alert("Badge payment updated successfully");
        fetchBadgePayments();
        setEditingBadgeIndex(null);
        setBadgePaymentType("");
        setBadgePaymentDate("");
        setBadgeExhibitorBankName("");
        setBadgeReceiverBankName("");
        setBadgeAmount("");
        setBadgeTds("");
      } else {
        alert(result.message || "Failed to update badge payment");
      }
    } catch (error) {
      console.error("Update badge payment error:", error);
      alert("An error occurred while updating badge payment");
    }
  };

  // ✅ Auto recalculate totals for badge section
  useEffect(() => {
    const totalPaid = badgePayments.reduce(
      (sum, p) => sum + (parseFloat(p.amount) || 0),
      0,
    );
    const totalTds = badgePayments.reduce(
      (sum, p) => sum + (parseFloat(p.tds) || 0),
      0,
    );
    const totalReceived = totalPaid + totalTds;

    setBadgeReceived(totalReceived.toFixed(2));

    // Example calculation for pending amount
    const badgeGrandTotal = getExhibitorBadgeBilling().grandTotal || 0;
    setBadgePending((badgeGrandTotal - totalReceived).toFixed(2));
  }, [badgePayments]);

  // POWER REQUIREMENT CALCULATION

  useEffect(() => {
    const companyState = formData.state?.trim().toLowerCase() || "";
    const isDelhi = companyState === "delhi";

    const totalPrice = exhibitorPreviewList.reduce(
      (acc, item) => acc + Number(item.totalAmount || 0),
      0,
    );

    const calcCgst = isDelhi ? (totalPrice * 9) / 100 : 0;
    const calcSgst = isDelhi ? (totalPrice * 9) / 100 : 0;
    const calcIgst = !isDelhi ? (totalPrice * 18) / 100 : 0;

    const grandTotal = totalPrice + calcCgst + calcSgst + calcIgst;

    setTotalPrice(totalPrice);
    setCgst(calcCgst);
    setSgst(calcSgst);
    setIgst(calcIgst);
    setGrandTotal(grandTotal);

    // ✅ Store GRAND TOTAL in localStorage
    if (formData.company_name) {
      localStorage.setItem(
        `grandTotal_power_${formData.company_name}`,
        grandTotal.toFixed(2),
      );
    }
  }, [exhibitorPreviewList, formData.state]);

  const handleExhibitorPowerSubmit = async () => {
    try {
      // Map each entry to include company name and billing details
      const payload = exhibitorPreviewList.map((item) => ({
        company_name: formData.company_name,
        day: item.day,
        price_per_kw: item.pricePerKw,
        power_required: item.powerRequired,
        phase: item.phase,
        total_amount: item.totalAmount,
        total_price: totalPrice.toFixed(2),
        cgst: cgst.toFixed(2),
        sgst: sgst.toFixed(2),
        igst: igst.toFixed(2),
        grand_total: grandTotal.toFixed(2),
      }));

      const response = await fetch(
        "https://inoptics.in/api/add_Exhibitor_power_requirement.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ entries: payload }),
        },
      );

      const result = await response.json();
      if (response.ok) {
        setPowerTotalsByCompany((prev) => ({
          ...prev,
          [formData.company_name]: parseFloat(grandTotal.toFixed(2)),
        }));

        alert("Data submitted successfully!");
        // console.log(result);
        fetchPowerDataByCompany(formData.company_name); // Refresh data after submission
        setExhibitorPreviewList([]); // clear table after submission
      } else {
        alert("Submission failed: " + result.error);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      alert("An error occurred while submitting.");
    }
  };

  const [isLocked, setIsLocked] = useState(false);
  const [unlockRequested, setUnlockRequested] = useState(false);

  // ====== FETCH POWER DATA FUNCTION ======
  const fetchPowerDataByCompany = async (companyName) => {
    try {
      const response = await fetch(
        `https://inoptics.in/api/get_Exhibitor_power_requirement.php?company_name=${encodeURIComponent(
          companyName,
        )}`,
      );
      const result = await response.json();

      if (response.ok && result.entries && result.entries.length > 0) {
        // console.log("Power data result:", result.entries);

        // Map entries for table display
        const tableData = result.entries.map((item) => ({
          day: item.day,
          pricePerKw: item.price_per_kw,
          powerRequired: item.power_required,
          phase: item.phase,
          totalAmount: item.total_amount,
        }));

        setExhibitorPreviewList(tableData);

        // Billing values
        setTotalPrice(parseFloat(result.entries[0].total_price || 0));
        setCgst(parseFloat(result.entries[0].cgst || 0));
        setSgst(parseFloat(result.entries[0].sgst || 0));
        setIgst(parseFloat(result.entries[0].igst || 0));
        setGrandTotal(parseFloat(result.entries[0].grand_total || 0));

        // 🔹 Capture lock and unlock state
        // console.log(
        //   "Lock status:",
        //   result.entries[0].is_locked,
        //   "Type:",
        //   typeof result.entries[0].is_locked
        // );
        setIsLocked(result.entries[0].is_locked == 1); // flexible check
        setUnlockRequested(result.entries[0].unlock_requested == 1);
      } else {
        setExhibitorPreviewList([]);
        setTotalPrice(0);
        setCgst(0);
        setSgst(0);
        setIgst(0);
        setGrandTotal(0);
        setIsLocked(false);
        setUnlockRequested(false);
      }
    } catch (error) {
      console.error("Error fetching power data:", error);
      alert("Failed to fetch data.");
    }
  };

  useEffect(() => {
    if (formData.company_name) {
      fetchPowerDataByCompany(formData.company_name);
    }
  }, [formData.company_name]);

  const handleUnlockPowerRequirement = async (companyName) => {
    if (!companyName) return alert("Company name missing!");

    try {
      // 1️⃣ First unlock the panel in the database
      const res = await fetch(
        "https://inoptics.in/api/update_unlock_power_requirement.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ company_name: companyName }),
        },
      );

      const data = await res.json();

      if (res.ok && data.success) {
        alert("✅ Power Requirement unlocked successfully!");
        setIsLocked(false);
        setUnlockRequested(false);

        // 2️⃣ Send unlock confirmation mail using the saved template name
        await fetch("https://inoptics.in/api/send_power_unlocked_mail.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            company_name: companyName,
            template_name:
              "InOptics 2026 @ Successfully Unlocked Power Requirement",
          }),
        });

        // 3️⃣ Refresh exhibitor data in dashboard
        fetchPowerDataByCompany(companyName);
      } else {
        alert(data.message || "Failed to unlock the panel.");
      }
    } catch (error) {
      console.error("Error unlocking power requirement:", error);
      alert("An error occurred while unlocking.");
    }
  };

  const handleResetRow = async (item, companyName) => {
    // console.log("Item to delete:", item);
    // console.log("Company name from formData:", companyName);

    if (!companyName) {
      alert("Invalid row data: missing company_name");
      return;
    }

    // Prepare the full payload matching backend requirements:
    const payload = {
      company_name: companyName,
      price_per_kw: parseFloat(item.pricePerKw),
      power_required: parseFloat(item.powerRequired),
      phase: item.phase,
      total_amount: parseFloat(item.totalAmount),
    };

    try {
      const response = await fetch(
        "https://inoptics.in/api/delete_Exhibitor_power_requirement.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );

      const result = await response.json();

      if (response.ok) {
        alert(result.message || "Row deleted successfully!");
        setExhibitorPreviewList((prev) =>
          prev.filter((entry) => entry !== item),
        );
      } else {
        alert("Delete failed: " + (result.error || "Unknown error"));
      }
    } catch (error) {
      console.error("Error deleting row:", error);
      alert("Error deleting row");
    }
  };

  const handleExhibitorDayChange = (e) => {
    const selectedDay = e.target.value;
    setExhibitorSelectedDay(selectedDay);

    // Find the price for the selected power_type
    const selectedItem = powerData.find(
      (item) => item.power_type === selectedDay,
    );
    if (selectedItem) {
      setExhibitorPricePerKw(selectedItem.price);
    } else {
      setExhibitorPricePerKw(""); // reset if not found
    }
  };

  const handleExhibitorPowerChange = (e) => {
    const power = e.target.value;
    setExhibitorPowerRequired(power);

    if (exhibitorPricePerKw && power) {
      const total = parseFloat(exhibitorPricePerKw) * parseFloat(power);
      setExhibitorTotalAmount(total.toFixed(2));
    } else {
      setExhibitorTotalAmount("");
    }
  };

  const handleExhibitorPhaseChange = (e) => {
    setExhibitorPhase(e.target.value);
  };

  const handleExhibitorAdd = () => {
    if (!exhibitorSelectedDay || !exhibitorPowerRequired || !exhibitorPhase) {
      alert("Please fill in all required fields.");
      return;
    }

    const totalAmount = (
      parseFloat(exhibitorPowerRequired || 0) *
      parseFloat(exhibitorPricePerKw || 0)
    ).toFixed(2);

    const newRow = {
      day: exhibitorSelectedDay,
      pricePerKw: exhibitorPricePerKw,
      powerRequired: exhibitorPowerRequired,
      phase: exhibitorPhase,
      totalAmount: totalAmount,
    };

    setExhibitorPreviewList([...exhibitorPreviewList, newRow]);

    // Clear current fields
    setExhibitorSelectedDay("");
    setExhibitorPricePerKw("");
    setExhibitorPowerRequired("");
    setExhibitorPhase("");
  };

  const handleNext = () => {
    if (!exhibitorPowerRequired || !exhibitorPhase) {
      alert("Please fill all required fields before continuing.");
      return;
    }

    const totalAmount = (
      parseFloat(exhibitorPowerRequired || 0) *
      parseFloat(exhibitorPricePerKw || 0)
    ).toFixed(2);

    const newRow = {
      day: exhibitorSelectedDay,
      pricePerKw: exhibitorPricePerKw,
      powerRequired: exhibitorPowerRequired,
      phase: exhibitorPhase,
      totalAmount: totalAmount,
    };

    // ✅ Add row to preview list
    setExhibitorPreviewList((prev) => [...prev, newRow]);

    // ✅ Reset fields before next step
    setExhibitorPowerRequired("");
    setExhibitorPhase("");
    setExhibitorTotalAmount("");

    if (currentStep < powerTypes.length - 1) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  useEffect(() => {
    if (powerData.length && currentStep < powerData.length) {
      const selectedType = powerTypes[currentStep];
      setExhibitorSelectedDay(selectedType);

      const matchedItem = powerData.find(
        (item) => item.power_type.trim() === selectedType,
      );

      if (matchedItem) {
        setExhibitorPricePerKw(matchedItem.price);
      } else {
        setExhibitorPricePerKw("");
      }
    }
  }, [currentStep, powerData]);

  useEffect(() => {
    const isDelhi = (formData.state?.trim().toLowerCase() || "") === "delhi";

    // Calculate subtotal from selectedFurniture items
    const subTotal = selectedFurniture.reduce(
      (acc, item) => acc + (item.quantity || 0) * item.price,
      0,
    );

    const discountPercent = furnitureBilling.discountPercent || 0;
    const discountAmount = Math.round((subTotal * discountPercent) / 100);
    const amount = Math.round(subTotal - discountAmount);

    const sgst = isDelhi ? Math.round((amount * 9) / 100) : 0;
    const cgst = isDelhi ? Math.round((amount * 9) / 100) : 0;
    const igst = !isDelhi ? Math.round((amount * 18) / 100) : 0;

    const grandTotal = Math.round(amount + sgst + cgst + igst);

    setFurnitureBilling((prev) => ({
      ...prev,
      subTotal: Math.round(subTotal),
      discountAmount,
      amount,
      sgst,
      cgst,
      igst,
      grandTotal,
    }));
  }, [selectedFurniture, furnitureBilling.discountPercent, formData.state]);

  // ✅ Save Stall pending amount
  useEffect(() => {
    if (pendingAmount !== null && formData?.company_name) {
      localStorage.setItem(
        `pending_stall_${formData.company_name}`,
        pendingAmount.toFixed(2),
      );
    }
  }, [pendingAmount, formData?.company_name]);

  // ✅ Save Power pending amount
  useEffect(() => {
    if (powerPendingAmount !== null && formData?.company_name) {
      localStorage.setItem(
        `pending_power_${formData.company_name}`,
        powerPendingAmount.toFixed(2),
      );
    }
  }, [powerPendingAmount, formData?.company_name]);

  // ✅ Save Badge pending (from getExhibitorBadgeBilling)
  useEffect(() => {
    const { grandTotal } = getExhibitorBadgeBilling();
    if (formData?.company_name && grandTotal !== undefined) {
      localStorage.setItem(
        `pending_badge_${formData.company_name}`,
        grandTotal.toFixed(2),
      );
    }
  }, [formData?.company_name]);

  // Full list of exhibitors (fetch from backend or initialize)
  const [allExhibitors, setAllExhibitors] = useState([]);

  // List currently displayed in UI
  const [exhibitorList, setExhibitorList] = useState([]);

  const handleExhibitorSearch = (query) => {
    // Example: filter exhibitor list based on company_name
    if (!query) return; // if empty, do nothing or reset list

    const filteredExhibitors = allExhibitors.filter((exhibitor) =>
      exhibitor.company_name.toLowerCase().includes(query.toLowerCase()),
    );

    // Update your state to show the filtered list
    setExhibitorList(filteredExhibitors);
  };

  const [paymentsData, setPaymentsData] = useState([]);

  const fetchAllPayments = async () => {
    const apiUrl = "https://inoptics.in/api/fetch_all_payments.php";

    try {
      const res = await fetch(apiUrl);
      console.log("rishab all payment inoptics", res);

      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

      const data = await res.json();

      if (data.success) {
        console.log("fetch all payment", data);
        // Map the backend data to frontend structure
        const safeNum = (val) => Number(val) || 0;

        const normalized = data.records.map((r, idx) => ({
          id: idx + 1,
          company_name: r.company_name || "N/A",
          state: r.state || "",

          stall: safeNum(r.stall_total),
          power: safeNum(r.power_total),
          exhibitorBadgesTotal: safeNum(r.badges_total),

          // ✅ Paid
          stallPaid: safeNum(r.paid_exhibitor),
          powerPaid: safeNum(r.paid_power),
          badgePaid: safeNum(r.paid_badge),

          paid_total: safeNum(r.paid_total),
          total: safeNum(r.total),
          pending: safeNum(r.pending),

          // ✅ TDS
          stall_tds: safeNum(r.stall_tds_total),
          power_tds: safeNum(r.power_tds_total),
          badge_tds: safeNum(r.badge_tds_total),
          total_tds: safeNum(r.total_tds),

          stall_payments: r.stall_payments || "-",
          power_payments: r.power_payments || "-",
          badge_payments: r.badge_payments || "-",
        }));

        setPaymentsData(normalized);
      } else {
        console.error("API returned error:", data.message);
        setPaymentsData([]);
      }
    } catch (err) {
      console.error("Error fetching payments:", err);
      setPaymentsData([]);
    }
  };

  useEffect(() => {
    if (overlayContent === "Payments") {
      fetchAllPayments();
    }
  }, [overlayContent]);

  const [paymentSearchQuery, setPaymentSearchQuery] = useState("");
  const [filteredPaymentsData, setFilteredPaymentsData] = useState([]);

  const handlePaymentSearch = (query) => {
    if (!query) {
      // If search is empty, show all payments again
      setFilteredPaymentsData(paymentsData);
      return;
    }

    const filtered = paymentsData.filter((item) =>
      item.company_name.toLowerCase().includes(query.toLowerCase()),
    );
    setFilteredPaymentsData(filtered);
  };

  useEffect(() => {
    setFilteredPaymentsData(paymentsData);
  }, [paymentsData]);

  // ===== RESET FORM =====
  const resetContractorForm = () => {
    setCompanyName("");
    setName("");
    setEmail("");
    setAddress("");
    setCity("");
    setCountry("");
    setPincode("");
    setPhoneNumber("");
    setMobileNumber("");
    setEditId(null); // ✅ RESET EDIT ID
    setShowContractorRequirementAddForm(false);
    setShowContractorRequirementEditForm(false);
  };

  const fetchContractorRequirements = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_contractor_requirement.php",
      );
      const data = await res.json();
      setContractorRequirementData(data);
    } catch (error) {
      console.error("Error fetching contractor requirements:", error);
    }
  };

  // ===== useEffect - LOAD DATA =====
  useEffect(() => {
    fetchContractorRequirements();
  }, []);

  // ===== ADD CONTRACTOR =====
  const addContractorRequirement = async () => {
    if (!companyName || !name) {
      alert("Please enter all required fields.");
      return;
    }

    try {
      const res = await fetch(
        "https://inoptics.in/api/add_contractor_requirement.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            company_name: companyName,
            name,
            email,
            address,
            city,
            country,
            pincode,
            phone_numbers: phoneNumber,
            mobile_numbers: mobileNumber,
          }),
        },
      );

      const data = await res.json();
      alert(data.message);
      resetContractorForm();
      fetchContractorRequirements();
    } catch (error) {
      console.error("Error adding contractor:", error);
      alert("Error adding contractor requirement");
    }
  };

  // ===== DELETE CONTRACTOR =====
  const deleteContractor = async (id) => {
    if (!window.confirm("Are you sure you want to delete this contractor?")) {
      return;
    }

    try {
      const res = await fetch(
        "https://inoptics.in/api/delete_contractor_requirement.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        },
      );

      const data = await res.json();
      alert(data.message);
      fetchContractorRequirements();
    } catch (error) {
      console.error("Error deleting contractor:", error);
      alert("Error deleting contractor");
    }
  };

  // ===== HANDLE EDIT (Already Correct) =====
  const handleContractorEdit = (item) => {
    console.log("🔍 Edit item:", item); // Debug

    setCompanyName(item.company_name || "");
    setName(item.name || "");
    setEmail(item.email || "");
    setAddress(item.address || "");
    setCity(item.city || "");
    setCountry(item.country || "");
    setPincode(item.pincode || "");
    setPhoneNumber(item.phone_numbers || "");
    setMobileNumber(item.mobile_numbers || "");
    setEditId(item.id);

    setShowContractorRequirementEditForm(true);
    setShowContractorRequirementAddForm(false);
  };

  // ===== 🔥 UPDATE CONTRACTOR (FIXED) =====
  const updateContractorRequirement = async () => {
    if (!editId) {
      alert("No contractor selected for editing");
      return;
    }

    if (!companyName || !name) {
      alert("Please enter all required fields.");
      return;
    }

    try {
      const res = await fetch(
        "https://inoptics.in/api/update_contractor_requirement.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: editId,
            company_name: companyName, // ✅ Match database column
            name: name,
            email: email,
            address: address,
            city: city,
            country: country,
            pincode: pincode,
            phone_numbers: phoneNumber, // ✅ Match database column
            mobile_numbers: mobileNumber, // ✅ Match database column
          }),
        },
      );

      const data = await res.json();
      alert(data.message);
      resetContractorForm();
      fetchContractorRequirements();
    } catch (error) {
      console.error("Error updating contractor:", error);
      alert("Error updating contractor requirement");
    }
  };

  const requiredStallFields = [
    "stall_number",
    "hall_number",
    "stall_category",
    "stall_price",
    "currency",
    "stall_area",
    "total",
    "discount",
    "discounted_amount",
    "total_after_discount",
    "sgst9",
    "cgst9",
    "igst18",
    "grand_total",
  ];

  const requiredFields = [
    "company_name",
    "name",
    "email",
    "address",
    "city",
    "state",
    "pin",
    "mobile",
  ];

  const handleAddExhibitorStall = () => {
    const missingFields = requiredStallFields.filter(
      (field) => !formData[field],
    );
    if (missingFields.length > 0) {
      const newErrors = {};
      missingFields.forEach((field) => {
        newErrors[field] = true;
      });
      setErrors(newErrors);
      return;
    }

    setStallList((prevList) => [...prevList, { ...formData }]);
    setFormData({});
    setErrors({});
  };

  // STALL REQUIREMENT CALCULATION
  const handleStallChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updated = { ...prev, [name]: value };

      // ✅ Auto-set stall_price if stall_category changes
      if (name === "stall_category") {
        const selectedCategory = stallCategories.find(
          (cat) => cat.category === value,
        );
        if (selectedCategory) {
          updated.stall_price = selectedCategory.price;
        }
      }

      // Read stall price and area from the updated formData
      const stallPrice = parseFloat(updated.stall_price) || 0;
      const stallArea = parseFloat(updated.stall_area) || 0;

      // Calculate total amount
      const total = stallPrice * stallArea;

      const discount = parseFloat(updated.discount) || 0;
      const discountedAmount = (total * discount) / 100;
      const totalAfterDiscount = total - discountedAmount;

      // Read user state from BASIC DETAILS
      const userState = (updated.state || "").trim().toLowerCase();

      // Initialize tax variables
      let sgst = 0,
        cgst = 0,
        igst = 0;

      // Tax logic based on userState
      if (userState === "delhi") {
        // Delhi: SGST + CGST (each 9%)
        sgst = totalAfterDiscount * 0.09;
        cgst = totalAfterDiscount * 0.09;
        igst = 0;
      } else {
        // Other states: IGST 18%
        sgst = 0;
        cgst = 0;
        igst = totalAfterDiscount * 0.18;
      }

      const grandTotal = totalAfterDiscount + sgst + cgst + igst;

      // Return updated formData with calculated fields formatted to 2 decimals
      return {
        ...updated,
        total: total.toFixed(2),
        discounted_amount: discountedAmount.toFixed(2),
        total_after_discount: totalAfterDiscount.toFixed(2),
        sgst9: sgst.toFixed(2),
        cgst9: cgst.toFixed(2),
        igst18: igst.toFixed(2),
        grand_total: grandTotal.toFixed(2),
      };
    });

    // Clear error if any on this field
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: false }));
    }
  };

  const fetchAvailableStalls = async () => {
    try {
      const response = await fetch(
        `https://inoptics.in/api/get_available_stalls.php?ts=${Date.now()}`,
      ); // timestamp to avoid caching
      const data = await response.json();
      setStallData(data); // set state for dropdown
    } catch (error) {
      console.error("Failed to fetch available stalls", error);
    }
  };

  useEffect(() => {
    if (activeNavbarItem === "STALLS") {
      fetchAvailableStalls();
    }
  }, [activeNavbarItem]);

  const renderLabeledField = (label) => {
    const name = label.toLowerCase().replace(/[%()]/g, "").replace(/\s+/g, "_");
    const isRequired = requiredFields.includes(name);

    const readOnlyFields = [
      "total",
      "discounted_amount",
      "total_after_discount",
      "sgst9",
      "cgst9",
      "igst18",
      "grand_total",
    ];
    const isReadOnly = readOnlyFields.includes(name) || isViewOnly;

    const renderDropdown = () => {
      switch (name) {
        case "stall_number":
          return (
            <select
              name={name}
              value={formData[name] || ""}
              onChange={handleStallChange}
            >
              <option value="">Select Stall Number</option>
              {stallData.map((stall, i) => (
                <option key={i} value={stall.stall_number}>
                  {stall.stall_number}
                </option>
              ))}
            </select>
          );
        case "hall_number":
          return (
            <select
              name={name}
              value={formData[name] || ""}
              onChange={handleStallChange}
            >
              <option value="">Select Hall</option>
              {hallsData.map((hall, i) => (
                <option key={i} value={hall.hall_number}>
                  {hall.hall_number}
                </option>
              ))}
            </select>
          );
        case "stall_category":
          return (
            <select
              name={name}
              value={formData[name] || ""}
              onChange={handleStallChange}
            >
              <option value="">Select Stall Category</option>
              {stallCategories.map((cat, i) => (
                <option key={i} value={cat.category}>
                  {cat.category}
                </option>
              ))}
            </select>
          );
        case "currency":
          return (
            <select
              name={name}
              value={formData[name] || ""}
              onChange={handleStallChange}
            >
              <option value="">Select Currency</option>
              {currencyData.map((currency, i) => (
                <option
                  key={i}
                  value={
                    currency.currency_code ||
                    currency.code ||
                    currency.currency ||
                    currency.name
                  }
                >
                  {currency.currency_code ||
                    currency.code ||
                    currency.currency ||
                    currency.name}
                </option>
              ))}
            </select>
          );
        case "stall_area":
          return (
            <select
              name={name}
              value={formData[name] || ""}
              onChange={handleStallChange}
            >
              <option value="">Select Stall Area</option>
              {stallAreas.map((area, i) => (
                <option key={i} value={area.area}>
                  {area.area}
                </option>
              ))}
            </select>
          );
        default:
          return (
            <input
              type="text"
              name={name}
              placeholder={label}
              value={formData[name] || ""}
              onChange={handleStallChange}
              className={errors[name] ? "input-error" : ""}
              readOnly={isReadOnly}
            />
          );
      }
    };

    return (
      <>
        <label>
          {label} {isRequired && <span style={{ color: "red" }}>*</span>}
        </label>
        {renderDropdown()}
        {errors[name] && (
          <span className="error-text">This field is required</span>
        )}
      </>
    );
  };

  const handleDashboardClick = () => {
    // Clear all overlays and forms
    setOverlayContent(null);
    setShowAddForm(false);
    setShowBusinessForm(false);
    setShowEditForm(false);
    setShowEditBusinessForm(false);

    // Optionally collapse submenus too
    setShowStallsMenu(false);
    setShowMastersMenu(false);
    setShowWebsiteMenu(false);
  };

  const generatePassword = () => {
    const firstDigit = "123456789";
    const otherDigits = "0123456789";

    let password = firstDigit.charAt(
      Math.floor(Math.random() * firstDigit.length),
    );
    for (let i = 0; i < 3; i++) {
      password += otherDigits.charAt(
        Math.floor(Math.random() * otherDigits.length),
      );
    }

    return password;
  };

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: false }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};
    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field].trim() === "") {
        newErrors[field] = true;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    if (showExhibitorEditForm) {
      // console.log("Updating exhibitor:", formData);

      updateExhibitor(formData);
    }
    // Add mode
    else if (showExhibitorAddForm) {
      // console.log("Adding new exhibitor:", formData);

      addExhibitor(formData);
    }

    setShowExhibitorAddForm(false);
    setShowExhibitorEditForm(false);
    setFormData({});
    setErrors({});
  };

  const handlePowerRequirementUpdate = async () => {
    try {
      // Send the entire list of rows currently in state (exhibitorPreviewList)
      const response = await fetch(
        "https://inoptics.in/api/update_power_requirements.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            company_name: formData.company_name,
            rows: exhibitorPreviewList,
          }),
        },
      );

      const result = await response.json();

      if (response.ok) {
        alert("Update successful");
        // Optionally refetch or update state
      } else {
        alert("Update failed: " + (result.error || "Unknown error"));
      }
    } catch (error) {
      console.error(error);
      alert("Error during update");
    }
  };

  const fetchExhibitorData = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/get_exhibitors.php");
      const data = await res.json();
      console.log("exhibitor data working api", data);
      setExhibitorData(data);
    } catch (error) {
      console.error("Failed to fetch exhibitors:", error);
    }
  };

  const groupedData = Object.values(
    exhibitorData.reduce((acc, item) => {
      if (!acc[item.company_name]) {
        acc[item.company_name] = {
          ...item,
          stall_no: [],
          category: [],
          stall_area: [],
        };
      }
      if (item.stall_no) acc[item.company_name].stall_no.push(item.stall_no);
      if (item.category) acc[item.company_name].category.push(item.category);
      if (item.stall_area)
        acc[item.company_name].stall_area.push(item.stall_area); // ✅ add this
      return acc;
    }, {}),
  );

  const addExhibitor = async (newExhibitor) => {
    try {
      const res = await fetch("https://inoptics.in/api/add_exhibitor.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newExhibitor),
      });
      const data = await res.json();
      alert(data.message);
      fetchExhibitorData();
    } catch (error) {
      console.error("Add exhibitor error:", error);
    }
  };

  const updateExhibitor = async (updatedExhibitor) => {
    try {
      const res = await fetch("https://inoptics.in/api/update_exhibitor.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatedExhibitor),
      });
      const data = await res.json();
      alert(data.message);
      fetchExhibitorData();
    } catch (error) {
      console.error("Update exhibitor error:", error);
    }
  };

  const deleteExhibitor = async (company_name) => {
    if (!window.confirm("Are you sure you want to delete this exhibitor?"))
      return;

    try {
      const res = await fetch(
        "https://inoptics.in/api/delete_company_details_everywhere.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            company_name: company_name.trim(),
          }),
        },
      );
      const data = await res.json();
      console.log("delete exhibitor data", data);

      alert(data.message);
      fetchExhibitorData();
    } catch (error) {
      console.error("Delete exhibitor error:", error);
    }
  };
  // const deleteExhibitor = async (id) => {
  //   if (!window.confirm("Are you sure you want to delete this exhibitor?"))
  //     return;

  //   try {
  //     const res = await fetch("https://inoptics.in/api/delete_exhibitor.php", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ id }),
  //     });
  //     const data = await res.json();
  //     alert(data.message);
  //     fetchExhibitorData();
  //   } catch (error) {
  //     console.error("Delete exhibitor error:", error);
  //   }
  // };

  const addExhibitorSelectedFurniture = async (payload) => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/add_selected_furniture.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );

      const text = await res.text(); // get raw response body
      // console.log("Raw response text:", text);

      let data;
      try {
        data = JSON.parse(text);
      } catch (jsonError) {
        console.error("JSON parsing error:", jsonError);
        throw new Error("Server did not return valid JSON.");
      }

      if (res.ok) {
        alert(data.message || "Furniture submitted successfully");
        fetchSelectedFurniture(payload.company_name); // Refresh furniture list after adding
      } else {
        alert(data.message || "Error submitting furniture");
      }
    } catch (error) {
      console.error("Add furniture error:", error);
      alert("Something went wrong while adding furniture.");
    }
  };

  // Add this state near the top of your component
  const [lockState, setLockState] = useState({
    is_locked: 0,
    unlock_requested: 0,
  });

  const fetchSelectedFurniture = async (companyName) => {
    try {
      const response = await fetch(
        `https://inoptics.in/api/get_selected_furniture.php?company_name=${encodeURIComponent(
          companyName,
        )}`,
      );
      const data = await response.json();

      // ✅ Handle both furniture list and lock state
      const furnitureList = Array.isArray(data.furniture) ? data.furniture : [];

      const normalizedData = furnitureList.map((item) => ({
        ...item,
        id: item.id || Math.random(),
        name: item.furniture_name || item.name || "Unnamed",
        image: item.image_url || item.image || "",
        price: parseFloat(item.price) || 0,
        quantity: parseInt(item.quantity) || 1,
      }));

      setSelectedFurniture(normalizedData);
      setLockState(data.lockState || { is_locked: 0, unlock_requested: 0 });

      // console.log("Fetched furniture:", normalizedData);
      // console.log("Lock state:", data.lockState);
    } catch (error) {
      console.error("Error fetching selected furniture data:", error);
    }
  };

  const handleAdminUnlock = async (companyName) => {
    if (!companyName) return alert("Missing company name!");

    if (!window.confirm(`Unlock furniture for ${companyName}?`)) return;

    try {
      const response = await fetch(
        "https://inoptics.in/api/admin_unlock_furniture.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ company_name: companyName }),
        },
      );

      const result = await response.json();
      if (result.status === "success" || result.status === "unlocked") {
        alert("Furniture unlocked successfully!");
        setLockState({ is_locked: 0, unlock_requested: 0 });

        // 🟢 Trigger the unlock email
        await handleSendMail(
          "InOptics 2026 @ Extra Furniture Section Unlocked",
        );
      } else {
        alert(result.message || "Unlock failed");
      }
    } catch (error) {
      console.error("Unlock error:", error);
      alert("Something went wrong while unlocking furniture.");
    }
  };

  const updateSelectedFurniture = async (companyName, selectedFurniture) => {
    try {
      const payload = {
        company_name: companyName,
        furniture: selectedFurniture.map((item) => ({
          image: item.image,
          name: item.name,
          price: item.price,
          quantity: item.quantity,
          total: item.price * item.quantity || 0,
        })),
      };

      const response = await fetch(
        "https://inoptics.in/api/Update_selected_furniture.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (response.ok && data.status === "success") {
        alert("Furniture updated successfully!");
        fetchSelectedFurniture(payload.company_name);
        // optionally refetch the data or update state here
      } else {
        alert(
          "Failed to update furniture: " + (data.message || "Unknown error"),
        );
      }
    } catch (error) {
      console.error("Error updating furniture:", error);
      alert("Error updating furniture. Please try again later.");
    }
  };

  // Fetch all available contractors
  const fetchExhibitorContractors = async () => {
    try {
      const response = await fetch(
        "https://inoptics.in/api/get_exhibitor_contractors_requirements.php",
      );
      const data = await response.json();
      setContractorData(data);
    } catch (error) {
      console.error("Error fetching contractor data:", error);
    }
  };

  // Fetch selected contractor for the current exhibitor
  const fetchSelectedContractor = async (companyName) => {
    try {
      const response = await fetch(
        `https://inoptics.in/api/get_selected_exhibitors_contractors.php?exhibitor_company_name=${companyName}`,
      );
      const data = await response.json();

      if (data && data.contractor_company_name) {
        const selectedContractor = contractorData.find(
          (c) => c.company_name === data.contractor_company_name,
        );
        if (selectedContractor) {
          setSelectedContractorId(selectedContractor.id);
        }
      } else {
        setSelectedContractorId(null);
      }
    } catch (error) {
      console.error("Error fetching selected contractor:", error);
    }
  };

  // Select contractor
  const selectContractor = async (contractorId) => {
    const contractor = contractorData.find((c) => c.id === contractorId);
    const exhibitorCompany = formData.company_name;

    const contactNumbers = [
      contractor.phone_numbers || "",
      contractor.mobile_numbers || "",
    ]
      .filter(Boolean)
      .join(" / ");

    try {
      const response = await fetch(
        "https://inoptics.in/api/selected_exhibitors_contractors.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            exhibitor_company_name: exhibitorCompany,
            contractor_name: contractor.name,
            contractor_company_name: contractor.company_name,
            address: contractor.address,
            city: contractor.city,
            pincode: contractor.pincode,
            country: contractor.country,
            contact_numbers: contactNumbers,
            email: contractor.email,
          }),
        },
      );

      const result = await response.json();

      if (response.ok) {
        setSelectedContractorId(contractorId);
        alert("Contractor selected successfully.");
      } else {
        console.error(result.error);
      }
    } catch (error) {
      console.error("Error selecting contractor:", error);
    }
  };

  // Unselect contractor
  const unselectContractor = async () => {
    const exhibitorCompany = formData.company_name;

    try {
      const response = await fetch(
        "https://inoptics.in/api/unselect_exhibitors_contractors.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ exhibitor_company_name: exhibitorCompany }),
        },
      );

      const result = await response.json();

      if (response.ok) {
        setSelectedContractorId(null);

        // Clear local storage and reset fields
        localStorage.removeItem("undertakingDetails");
        setUserName("");
        setUserDesignation("");
        setIsUndertakingRead(false);
        setIsSaved(false);

        alert("Contractor unselected successfully.");
      } else {
        console.error(result.error);
        alert("Failed to unselect contractor.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Fetch contractors on initial render
  useEffect(() => {
    fetchExhibitorContractors();
  }, []);

  // Fetch selected contractor when the active tab changes and company name is available
  useEffect(() => {
    if (activeNavbarItem === "APPOINTED CONTRACTOR" && formData.company_name) {
      fetchSelectedContractor(formData.company_name);
    }
  }, [activeNavbarItem, formData.company_name, contractorData]);

  useEffect(() => {
    if (activeContractorTab === "Booth Design") {
      fetchAllFinalSelections();
    }
  }, [activeContractorTab]);

  const fetchAllFinalSelections = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_all_selected_exhibitors_contractors.php",
      );
      if (!res.ok) throw new Error("Failed to fetch final list");
      const data = await res.json();
      setFinalListData(data);
    } catch (error) {
      console.error("Error fetching final contractor list:", error);
    }
  };

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("undertakingDetails"));
    if (stored) {
      setUserName(stored.name);
      setUserDesignation(stored.designation);
      setIsUndertakingRead(stored.checked);
      setIsSaved(true);
    }
  }, []);

  const handleSaveToLocal = () => {
    if (!userName || !userDesignation || !isUndertakingRead) {
      alert("Please fill all fields and agree to the terms.");
      return;
    }

    localStorage.setItem(
      "undertakingDetails",
      JSON.stringify({
        name: userName,
        designation: userDesignation,
        checked: isUndertakingRead,
        company: formData.company_name, // optional if needed
      }),
    );

    setIsSaved(true);
  };

  const handleEditMode = () => {
    setIsSaved(false);
  };

  const fetchStallsByCompany = async (companyName) => {
    try {
      const response = await fetch("https://inoptics.in/api/get_stalls.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ company_name: companyName }),
      });

      if (!response.ok) {
        console.error("Failed to fetch stall data");
        return;
      }

      const data = await response.json();
      // console.log("Raw stalls from API:", data);

      // ✅ Your custom rounding rule
      const customRound = (value) => {
        const num = parseFloat(String(value).trim());
        if (isNaN(num)) return value;
        const intPart = Math.floor(Math.abs(num));
        const decimal = Math.abs(num) - intPart;
        const rounded = decimal <= 0.5 ? intPart : intPart + 1;
        const signed = num < 0 ? -rounded : rounded;
        return signed.toFixed(2);
      };

      // ✅ Updated rounding logic
      const roundedData = Array.isArray(data)
        ? data.map((stall) => {
            return {
              ...stall,

              // ✅ Force number + rounding
              stall_price: customRound(stall.stall_price),
              total: customRound(stall.total),

              discount: isNaN(parseFloat(stall.discount))
                ? 0
                : parseFloat(stall.discount),
              discounted_amount: customRound(stall.discounted_amount),
              total_after_discount: customRound(stall.total_after_discount),

              cgst9: customRound(stall.cgst9),
              sgst9: customRound(stall.sgst9),
              igst18: customRound(stall.igst18),

              grand_total: customRound(stall.grand_total),
            };
            // console.log("Raw discount from API:", stall.discount);
          })
        : data;
      setStallList(roundedData);
    } catch (error) {
      console.error("Error fetching stall data:", error);
    }
  };

  useEffect(() => {
    if (formData.company_name && (showExhibitorEditForm || isViewOnly)) {
      fetchStallsByCompany(formData.company_name);
    }
  }, [formData.company_name, showExhibitorEditForm, isViewOnly]);
  const handleDeleteExhibitorStall = async (index) => {
    const stallToDelete = stallList[index];
    if (!stallToDelete) {
      alert("Stall not found");
      return;
    }

    if (
      !window.confirm(
        `Are you sure you want to delete stall number ${stallToDelete.stall_number}?`,
      )
    ) {
      return;
    }

    try {
      const response = await fetch(
        "https://inoptics.in/api/delete_exhibitor_stall.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            stall_number: stallToDelete.stall_number,
            company_name: formData.company_name, // ✅ include company name
          }),
        },
      );

      if (response.ok) {
        const result = await response.json();
        alert(result.message);

        // Remove stall from local state so UI updates immediately
        const updatedStalls = [...stallList];
        updatedStalls.splice(index, 1);
        setStallList(updatedStalls);

        // Refetch available stalls to update dropdown
        await fetchAvailableStalls(); // ✅ Refreshes dropdown with available stalls

        // Refetch exhibitor data to update the exhibitor table (groupedData)
        await fetchExhibitorData(); // ✅ Add this - replace with your actual function name
      } else {
        const errorData = await response.json();
        alert("Failed to delete stall: " + errorData.message);
      }
    } catch (error) {
      console.error("Deletion error:", error);
      alert("An error occurred while deleting the stall.");
    }
  };
  // const [stalls, setStalls] = useState([]);

  const extractNumber = (str) => {
    if (!str) return 0;
    const match = str.match(/[\d.]+/); // extract numbers and decimals
    return match ? parseFloat(match[0]) : 0;
  };
  const handleExhibitorStallsSubmit = async (e) => {
    e.preventDefault();

    const stallData = {
      company_name: formData.company_name || "",
      stall_number: formData.stall_number || "",
      hall_number: formData.hall_number || "",
      stall_category: formData.stall_category || "",
      stall_price: parseFloat(customRound(formData.stall_price)) || 0,
      currency: formData.currency || "",
      stall_area: extractNumber(formData.stall_area),
      total: parseFloat(customRound(formData.total)) || 0,
      discount: parseFloat(formData.discount) || 0,
      discounted_amount:
        parseFloat(customRound(formData.discounted_amount)) || 0,
      total_after_discount:
        parseFloat(customRound(formData.total_after_discount)) || 0,
      sgst9: parseFloat(customRound(formData.sgst9)) || 0,
      cgst9: parseFloat(customRound(formData.cgst9)) || 0,
      igst18: parseFloat(customRound(formData.igst18)) || 0,
      grand_total: parseFloat(customRound(formData.grand_total)) || 0,
    };

    try {
      const response = await fetch(
        "https://inoptics.in/api/submit_stalls.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(stallData),
        },
      );

      if (!response.ok) {
        alert("Failed to submit stall data");
        return;
      }

      const result = await response.json();
      alert("Stall data submitted successfully!");

      // 🔥 STEP 2 — Recalculate FREE badges after stall add
      const badgeRes = await fetch(
        "https://inoptics.in/api/update_free_badges.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            company_name: formData.company_name,
          }),
        },
      );

      const badgeData = await badgeRes.json();

      if (!badgeData.success) {
        console.warn("Free badge update failed:", badgeData.error);
      } else {
        console.log("✅ Free badges recalculated:", badgeData.free_badges);
      }

      // 🔄 Refresh exhibitor + stalls UI
      fetchExhibitorData(); // updates free_badges & free_remaining
      fetchStallsByCompany(formData.company_name);

      // 🧹 Reset form
      setStallCategory("");
      setFormData((prev) => ({
        ...prev,
        stall_number: "",
        hall_number: "",
        stall_category: "",
        stall_price: "",
        currency: "",
        stall_area: "",
        total: "",
        discount: "",
        discounted_amount: "",
        total_after_discount: "",
        sgst9: "",
        cgst9: "",
        igst18: "",
        grand_total: "",
      }));
    } catch (error) {
      console.error("Submission error:", error);
      alert("An error occurred while submitting stall data.");
    }
  };

  const handleEditExhibitorStall = (stall, index) => {
    const stallToEdit = stallList[index];
    setEditingIndex(index);

    setFormData((prev) => ({
      ...prev,
      id: stall.id,
      company_name: stallToEdit.company_name || "",
      stall_number: stallToEdit.stall_number || "",
      hall_number: stallToEdit.hall_number || "",
      stall_category: stallToEdit.stall_category || "",
      stall_area: stallToEdit.stall_area || "",
      currency: stallToEdit.currency || "",
      discount: stallToEdit.discount_percent || "",
      stall_price: stallToEdit.stall_price || "",
      total: stallToEdit.total || "",
      discounted_amount: stallToEdit.discounted_amount || "",
      total_after_discount: stallToEdit.total_after_discount || "",
      sgst9: stallToEdit.sgst_9_percent || "",
      cgst9: stallToEdit.cgst_9_percent || "",
      igst18: stallToEdit.igst_18_percent || "",
      grand_total: stallToEdit.grand_total || "",
    }));

    setStallCategory(stallToEdit.stall_category);
  };

  const handleUpdateExhibitorStall = async (e) => {
    e.preventDefault();

    if (!formData.id) {
      alert("Invalid stall ID");
      return;
    }

    const stallData = {
      id: Number(formData.id),
      company_name: formData.company_name || "",
      stall_number: formData.stall_number || "",
      hall_number: formData.hall_number || "",
      stall_category: formData.stall_category || "",
      stall_price: parseFloat(formData.stall_price) || 0,
      currency: formData.currency || "",
      stall_area: parseFloat(formData.stall_area) || 0,
      total: parseFloat(formData.total) || 0,
      discount: parseFloat(formData.discount) || 0,
      discounted_amount: parseFloat(formData.discounted_amount) || 0,
      total_after_discount: parseFloat(formData.total_after_discount) || 0,
      sgst9: parseFloat(formData.sgst9) || 0,
      cgst9: parseFloat(formData.cgst9) || 0,
      igst18: parseFloat(formData.igst18) || 0,
      grand_total: parseFloat(formData.grand_total) || 0,
    };

    try {
      const response = await fetch(
        "https://inoptics.in/api/edit_exhibitor_stall.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(stallData),
        },
      );

      const result = await response.json();

      if (response.ok && result.message) {
        alert(result.message);

        // 🔄 refresh stalls list
        await fetchStallsByCompany(formData.company_name);

        // reset form
        setFormData({
          id: "",
          company_name: "",
          stall_number: "",
          hall_number: "",
          stall_category: "",
          stall_price: "",
          currency: "",
          stall_area: "",
          total: "",
          discount: "",
          discounted_amount: "",
          total_after_discount: "",
          sgst9: "",
          cgst9: "",
          igst18: "",
          grand_total: "",
        });

        setEditingIndex(null);
      } else {
        alert(result.message || "Failed to update stall");
      }
    } catch (error) {
      console.error("Update error:", error);
      alert("Server error while updating stall");
    }
  };

  // mapping labels to backend keys (define once at top level)
  const labelToBackendKey = {
    "STALL NUMBER": "stall_number",
    "HALL NUMBER": "hall_number",
    "STALL CATEGORY": "stall_category",
    "STALL PRICE": "stall_price",
    CURRENCY: "currency",
    "STALL AREA": "stall_area",
    TOTAL: "total",
    "DISCOUNT(%)": "discount_percent",
    "DISCOUNTED AMOUNT": "discounted_amount",
    "TOTAL AFTER DISCOUNT": "total_after_discount",
    "SGST(9%)": "sgst_9_percent",
    "CGST(9%)": "cgst_9_percent",
    "IGST(18%)": "igst_18_percent",
    "GRAND TOTAL": "grand_total",
  };

  // figure out which columns actually have data
  const visibleColumns = Object.keys(labelToBackendKey).filter((label) => {
    const key = labelToBackendKey[label];
    return stallList.some(
      (stall) =>
        stall[key] !== null && stall[key] !== undefined && stall[key] !== "",
    );
  });

  // Custom rounding function
  const customRound = (value) => {
    if (!value || isNaN(value)) return "0.00";
    const num = parseFloat(value);
    const decimal = num % 1;
    const intPart = Math.floor(num);
    if (decimal <= 0.5) {
      return intPart.toFixed(2);
    } else {
      return (intPart + 1).toFixed(2);
    }
  };

  useEffect(() => {
    if (
      (activeNavbarItem === "EXHIBITOR BADGES" ||
        activeNavbarItem === "PAYMENT DETAILS") &&
      formData.company_name
    ) {
      // Check localStorage first to avoid unnecessary API calls
      const cachedData = localStorage.getItem(
        `badges_${formData.company_name}`,
      );
      if (cachedData) {
        const { free_badges, extra_badges } = JSON.parse(cachedData);
        setFormData((prev) => ({
          ...prev,
          free_badges: parseInt(free_badges, 10) || 0,
          extra_badges: parseInt(extra_badges, 10) || 0,
        }));
      }

      // Fetch badges info from API
      fetch(
        `https://inoptics.in/api/get_Exhibitor_badges.php?company_name=${encodeURIComponent(
          formData.company_name,
        )}`,
      )
        .then((res) => res.json())
        .then((data) => {
          // Make sure data is valid
          if (
            data.free_badges !== undefined &&
            data.extra_badges !== undefined
          ) {
            setFormData((prev) => ({
              ...prev,
              free_badges: parseInt(data.free_badges, 10) || 0,
              extra_badges: parseInt(data.extra_badges, 10) || 0,
            }));
            // Store in localStorage
            localStorage.setItem(
              `badges_${formData.company_name}`,
              JSON.stringify({
                free_badges: parseInt(data.free_badges, 10) || 0,
                extra_badges: parseInt(data.extra_badges, 10) || 0,
              }),
            );
            setIsLocked(data.is_locked === "1" || data.is_locked === 1);
          }
        })
        .catch(() => alert("Failed to fetch exhibitor badges."));
    }
  }, [activeNavbarItem, formData.company_name]);

  const handleUnlockBadges = () => {
    if (!formData.company_name) {
      alert("⚠️ No company selected!");
      return;
    }

    if (
      !window.confirm(
        `Are you sure you want to unlock badges for ${formData.company_name}?`,
      )
    ) {
      return;
    }

    // 1️⃣ First: Unlock the badges panel
    fetch("https://inoptics.in/api/unlock_exhibitor_badges.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ company_name: formData.company_name }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success" || data.success) {
          // 2️⃣ If unlock is successful, send the mail
          alert("✅ Exhibitor badges panel unlocked successfully!");
          setIsLocked(false);

          // Now send the mail automatically
          return fetch(
            "https://inoptics.in/api/unlocked_exhibitor_badges_mail.php",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                company_name: formData.company_name,
                template_name:
                  "InOptics 2026 @ Successfully Unlocked Badges Requirement",
              }),
            },
          );
        } else {
          throw new Error(data.message || "Failed to unlock badges.");
        }
      })
      .then((res) => res?.json())
      .then((mailResponse) => {
        if (mailResponse?.success) {
          alert("📧 Unlock mail sent successfully to Exhibitor!");
        } else if (mailResponse) {
          alert(`⚠️ Mail not sent: ${mailResponse.message}`);
        }
      })
      .catch((error) => {
        console.error("Unlock/Mail Error:", error);
        alert("❌ Error unlocking exhibitor badges or sending mail.");
      });
  };

  const handleExhibitorBadgesSubmit = async (e) => {
    e.preventDefault();

    const extraValue = Number(formData.extra_badges);

    // ❌ Block negative only
    if (extraValue < 0) {
      alert("Extra badges cannot be negative");
      return;
    }

    // Optional: block NaN
    if (isNaN(extraValue)) {
      alert("Enter valid extra badge count");
      return;
    }

    try {
      const res = await fetch(
        "https://inoptics.in/api/update_Exhibitor_badges.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            company_name: formData.company_name,
            extra_badges: extraValue, // 0 allowed now
          }),
        },
      );

      const data = await res.json();

      if (data.success) {
        alert("Extra badges updated successfully");
      } else {
        alert(data.error || "Failed to update extra badges.");
      }
    } catch (error) {
      alert("Error updating exhibitor badges.");
    }
  };

  const handleUpdateFreeExhibitorBadgesSubmit = async () => {
    if (!formData.free_badges || formData.free_badges <= 0) {
      alert("Enter valid free badge count");
      return;
    }

    try {
      const res = await fetch(
        "https://inoptics.in/api/update_Exhibitor_Free_badges.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            company_name: formData.company_name,
            free_badges: Number(formData.free_badges),
          }),
        },
      );

      const data = await res.json();

      if (data.success) {
        alert("Free badges updated successfully");
      } else {
        alert(data.error || "Failed to update badges.");
      }
    } catch (error) {
      alert("Error updating exhibitor badges.");
    }
  };

  const getCurrencySymbol = (name) => {
    switch (name.toUpperCase().trim()) {
      case "RUPEE":
      case "RUPEES":
      case "INR":
        return "(₹)";
      case "DOLLAR":
      case "DOLLARS":
      case "USD":
        return "($)";
      case "EURO":
      case "EUROS":
      case "EUR":
        return "(€)";
      default:
        return "";
    }
  };

  const fetchCurrencyData = async () => {
    try {
      const response = await fetch("https://inoptics.in/api/get_currency.php");
      const data = await response.json();
      setCurrencyData(data);
    } catch (error) {
      alert("Error fetching currency data");
    }
  };

  const addCurrency = async () => {
    if (!currencyName) {
      alert("Please enter a currency name.");
      return;
    }

    try {
      const res = await fetch("https://inoptics.in/api/add_currency.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: currencyName }),
      });

      const data = await res.json();
      alert(data.message);
      setCurrencyName("");
      setShowCurrencyAddForm(false);
      fetchCurrencyData();
    } catch (err) {
      alert("Error adding currency");
    }
  };

  const deleteCurrency = async (id) => {
    try {
      const res = await fetch("https://inoptics.in/api/delete_currency.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      const data = await res.json();
      alert(data.message);
      fetchCurrencyData();
    } catch (err) {
      alert("Error deleting currency");
    }
  };

  const handleCurrencyEdit = (item) => {
    setEditCurrencyId(item.id);
    setEditCurrencyName(item.name);
    setShowCurrencyEditForm(true);
  };

  const updateCurrency = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/update_currency.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: editCurrencyId,
          name: editCurrencyName,
        }),
      });

      const data = await res.json();
      alert(data.message);
      setShowCurrencyEditForm(false);
      fetchCurrencyData();
    } catch (err) {
      alert("Error updating currency");
    }
  };

  const handleEditAddress = (idx) => {
    setCurrentEditing(idx);
    const existingData = addresses[idx].data;

    if (existingData) {
      setModalForm({ ...existingData });
    } else {
      setModalForm({
        address: "",
        state: "",
        pincode: "",
        phone: "",
        email: "",
        gst: "",
      });
    }

    setShowModal(true);
  };

  const handleSaveAddress = async () => {
    const updatedAddresses = [...addresses];
    const currentAddress = updatedAddresses[currentEditing];
    const label = currentAddress.label;

    // Merge updated form data
    currentAddress.data = { ...modalForm };

    try {
      const res = await fetch(
        "https://inoptics.in/api/update_invoice_address.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            label, // used for identifying which record to update
            address: modalForm.address || "",
            state: modalForm.state || "",
            pincode: modalForm.pincode || "",
            phone: modalForm.phone || "",
            email: modalForm.email || "",
            gst: modalForm.gst || "",
            is_active: currentAddress.isActive ? 1 : 0, // include if needed
          }),
        },
      );

      const result = await res.json();
      // console.log("Save address result:", result);

      if (result.success) {
        alert("Address updated successfully!");
        setAddresses(updatedAddresses);
      } else {
        alert("Failed to update address: " + result.message);
      }
    } catch (err) {
      console.error("Error updating address:", err);
      alert("Network or server error occurred.");
    }

    setShowModal(false);
  };

  const handleDeleteAddress = async (idx) => {
    const updatedAddresses = [...addresses];
    const label = updatedAddresses[idx].label;

    await fetch("https://inoptics.in/api/delete_invoice_address.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ label }),
    });

    updatedAddresses[idx].data = null;
    setAddresses(updatedAddresses);
  };

  const handleSetActive = async (id) => {
    const updated = addresses.map((addr) =>
      addr.id === id
        ? { ...addr, isActive: true }
        : { ...addr, isActive: false },
    );

    setAddresses(updated);

    // Send active address update to server
    await fetch("https://inoptics.in/api/set_active_invoice_address.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });
  };
  const handleFetchAddress = async () => {
    const res = await fetch(
      "https://inoptics.in/api/get_invoice_addresses.php",
    );
    const data = await res.json();

    const updated = addresses.map((addr) => {
      const found = data.find((d) => d.label === addr.label);
      return found
        ? {
            ...addr,
            data: {
              address: found.address,
              state: found.state,
              pincode: found.pincode,
              phone: found.phone,
              email: found.email,
              gst: found.gst,
            },
            isActive: found.is_active == 1, // convert from int to boolean
          }
        : addr;
    });

    setAddresses(updated);
  };

  useEffect(() => {
    handleFetchAddress();
  }, []);

  const activeAddress = addresses.find((addr) => addr.isActive);

  useEffect(() => {
    fetchBadgeLimits();
  }, []);

  const fetchBadgeLimits = async () => {
    try {
      const response = await fetch(
        "https://inoptics.in/api/get_badge_limit.php",
      );
      const data = await response.json();
      setBadgeLimitsData(data);
    } catch (error) {
      alert("Error fetching badge limits");
    }
  };

  const addBadgeLimit = async () => {
    if (!minSqFt || !maxSqFt || !noOfBadges) {
      alert("All fields are required.");
      return;
    }

    try {
      const res = await fetch("https://inoptics.in/api/add_badge_limit.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          min_sq_ft: minSqFt,
          max_sq_ft: maxSqFt,
          no_of_badges: noOfBadges,
        }),
      });

      const data = await res.json();
      alert(data.message);
      setMinSqFt("");
      setMaxSqFt("");
      setNoOfBadges("");
      setShowBadgeLimitsAddForm(false);
      fetchBadgeLimits();
    } catch (err) {
      alert("Error adding badge limit");
    }
  };

  const deleteBadgeLimit = async (id) => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/delete_badge_limit.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        },
      );

      const data = await res.json();
      alert(data.message);
      fetchBadgeLimits();
    } catch (err) {
      alert("Error deleting badge limit");
    }
  };

  const handleBadgeLimitsEdit = (item) => {
    setEditMinSqFt(item.min_sq_ft);
    setEditMaxSqFt(item.max_sq_ft);
    setEditNoOfBadges(item.no_of_badges);
    setEditingId(item.id);
    setShowBadgeLimitsEditForm(true);
  };

  const updateBadgeLimit = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/edit_badge_limit.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: editingId,
          min_sq_ft: editMinSqFt,
          max_sq_ft: editMaxSqFt,
          no_of_badges: editNoOfBadges,
        }),
      });

      const data = await res.json();
      alert(data.message);
      setShowBadgeLimitsEditForm(false);
      fetchBadgeLimits();
    } catch (err) {
      alert("Error updating badge limit");
    }
  };

  // Fetch Products
  const fetchProducts = async () => {
    try {
      const res = await axios.get("https://inoptics.in/api/get_product.php");
      setProducts(res.data);
    } catch (err) {
      alert("Error fetching products");
    }
  };

  useEffect(() => {
    if (overlayContent === "Products") {
      fetchProducts();
    }
  }, [overlayContent]);

  const addProduct = async () => {
    if (!newProductName.trim()) {
      alert("Please enter product name.");
      return;
    }
    try {
      const res = await axios.post("https://inoptics.in/api/add_product.php", {
        name: newProductName.trim(),
      });
      alert(res.data.message);
      setNewProductName("");
      setShowAddProductForm(false);
      fetchProducts();
    } catch {
      alert("Error adding product");
    }
  };

  const openEditProductForm = (product) => {
    setEditProductId(product.id);
    setEditProductName(product.name);
    setShowEditProductForm(true);
  };

  const updateProduct = async () => {
    if (!editProductName.trim()) {
      alert("Please enter product name.");
      return;
    }
    try {
      const res = await axios.post(
        "https://inoptics.in/api/update_product.php",
        {
          id: editProductId,
          name: editProductName.trim(),
        },
      );
      alert(res.data.message);
      setShowEditProductForm(false);
      fetchProducts();
    } catch {
      alert("Error updating product");
    }
  };

  const deleteProduct = async (id) => {
    if (!window.confirm("Are you sure you want to delete this product?"))
      return;
    try {
      const res = await axios.post(
        "https://inoptics.in/api/delete_product.php",
        { id },
      );
      alert(res.data.message);
      fetchProducts();
    } catch {
      alert("Error deleting product");
    }
  };

  const fetchTaxesData = async () => {
    try {
      const response = await fetch("https://inoptics.in/api/get_taxes.php");
      const text = await response.text();
      const data = JSON.parse(text);
      setTaxesData(data);
    } catch (error) {
      console.error("Error fetching taxes:", error);
    }
  };

  const addTax = async () => {
    if (!taxName || !taxValue) {
      alert("Please fill all fields.");
      return;
    }

    try {
      const res = await fetch("https://inoptics.in/api/add_taxes.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: taxName, value: `${taxValue}%` }),
      });

      const data = await res.json();
      alert(data.message);
      setTaxName("");
      setTaxValue("");
      setShowAddForm(false);
      fetchTaxesData();
    } catch (err) {
      alert("Error adding tax");
    }
  };

  const deleteTax = async (id) => {
    try {
      const res = await fetch("https://inoptics.in/api/delete_taxes.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      const data = await res.json();
      alert(data.message);
      fetchTaxesData();
    } catch (err) {
      alert("Error deleting tax");
    }
  };

  const handleTaxEdit = (item) => {
    setEditTaxId(item.id);
    setEditTaxName(item.name);
    setEditTaxValue(item.value.replace("%", ""));
    setShowEditForm(true);
  };

  const updateTax = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/update_taxes.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: editTaxId,
          name: editTaxName,
          value: `${editTaxValue}%`,
        }),
      });

      const data = await res.json();
      alert(data.message);
      fetchTaxesData();
      setShowEditForm(false);
    } catch (err) {
      alert("Error updating tax");
    }
  };

  useEffect(() => {
    const { stall_area, stall_price, discount, currency, state } = formData;

    const area = parseFloat(stall_area) || 0;
    const price = parseFloat(stall_price) || 0;
    const discountValue = parseFloat(discount) || 0;

    const total = area * price;
    const discountedAmount = (discountValue / 100) * total;
    const totalAfterDiscount = total - discountedAmount;

    // Apply tax logic based on currency and state
    let sgst9 = 0,
      cgst9 = 0,
      igst18 = 0;

    if (currency === "Rupees") {
      if (state?.toLowerCase() === "delhi") {
        sgst9 = (9 / 100) * totalAfterDiscount;
        cgst9 = (9 / 100) * totalAfterDiscount;
      } else {
        igst18 = (18 / 100) * totalAfterDiscount;
      }
    } else if (currency === "Dollar" || currency === "Euro") {
      igst18 = (18 / 100) * totalAfterDiscount;
    }

    const grandTotal = totalAfterDiscount + sgst9 + cgst9 + igst18;

    setFormData((prev) => ({
      ...prev,
      total: total.toFixed(2),
      discounted_amount: discountedAmount.toFixed(2),
      total_after_discount: totalAfterDiscount.toFixed(2),
      sgst9: sgst9.toFixed(2),
      cgst9: cgst9.toFixed(2),
      igst18: igst18.toFixed(2),
      grand_total: grandTotal.toFixed(2),
    }));
  }, [
    formData.stall_area,
    formData.stall_price,
    formData.discount,
    formData.currency,
    formData.state,
  ]);

  const fetchStallAreas = async () => {
    try {
      const response = await fetch(
        "https://inoptics.in/api/get_stall_areas.php",
      );
      const text = await response.text();
      try {
        const data = JSON.parse(text);
        setStallAreas(data);
      } catch {
        console.error("Error parsing Stall Areas JSON");
      }
    } catch (error) {
      console.error("Error fetching Stall Areas:", error);
    }
  };

  const addStallArea = async () => {
    if (!newStallArea) {
      alert("Please enter stall area");
      return;
    }
    try {
      const res = await fetch("https://inoptics.in/api/add_stall_area.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ area: newStallArea }),
      });
      const data = await res.json();
      alert(data.message);
      setNewStallArea("");
      setShowAddStallAreaForm(false);
      fetchStallAreas();
    } catch {
      alert("Error adding stall area");
    }
  };

  const deleteStallArea = async (id) => {
    try {
      const res = await fetch("https://inoptics.in/api/delete_stall_area.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });
      const data = await res.json();
      alert(data.message);
      fetchStallAreas();
    } catch {
      alert("Error deleting stall area");
    }
  };

  const handleEditStallArea = (item) => {
    setEditStallAreaId(item.id);
    setEditStallArea(item.area);
    setShowEditStallAreaForm(true);
  };

  const updateStallArea = async () => {
    if (!editStallArea) {
      alert("Please enter stall area");
      return;
    }
    try {
      const res = await fetch("https://inoptics.in/api/update_stall_area.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: editStallAreaId, area: editStallArea }),
      });
      const data = await res.json();
      alert(data.message);
      setShowEditStallAreaForm(false);
      fetchStallAreas();
    } catch {
      alert("Error updating stall area");
    }
  };

  const fetchStallCategories = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/get_stall_category.php");
      const data = await res.json();
      setStallCategories(data);
    } catch (err) {
      console.error("Error fetching Stall Categories", err);
    }
  };

  const addStallCategory = async () => {
    if (!stallCategory || !stallCategoryType || !stallCategoryPrice) {
      alert("Please fill all fields.");
      return;
    }

    try {
      const res = await fetch(
        "https://inoptics.in/api/add_stall_category.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            category: stallCategory,
            type: stallCategoryType,
            rupees: parseFloat(stallCategoryPrice),
            dollar: parseFloat(stallCategoryDollar),
            euro: parseFloat(stallCategoryEuro),
          }),
        },
      );

      const data = await res.json();
      alert(data.message);

      // Reset form state
      setStallCategory("");
      setStallCategoryType("Bare Space");
      setStallCategoryPrice("");
      setShowStallCategoriesAddForm(false);
      fetchStallCategories();
    } catch (err) {
      alert("Error adding Stall Category");
    }
  };

  const deleteStallCategory = async (id) => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/delete_stall_category.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        },
      );
      const data = await res.json();
      alert(data.message);
      fetchStallCategories();
    } catch (err) {
      alert("Error deleting Stall Category");
    }
  };

  const handleStallCategoriesEdit = (item) => {
    setEditStallCategoriesId(item.id);
    setEditStallCategory(item.category);
    setEditStallCategoryType(item.type);
    setEditStallCategoryPrice(item.rupees);
    setEditStallCategoryDollar(item.dollar);
    setEditStallCategoryEuro(item.euro);
    setShowStallCategoriesEditForm(true);
  };

  const updateStallCategory = async () => {
    if (
      !editStallCategory ||
      !editStallCategoryType ||
      !editStallCategoryPrice
    ) {
      alert("Please fill all fields.");
      return;
    }

    try {
      const res = await fetch(
        "https://inoptics.in/api/update_stall_category.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: editStallCategoriesId,
            category: editStallCategory,
            type: editStallCategoryType,
            rupees: parseFloat(editStallCategoryPrice),
            dollar: parseFloat(editStallCategoryDollar),
            euro: parseFloat(editStallCategoryEuro),
          }),
        },
      );

      const data = await res.json();
      alert(data.message);
      fetchStallCategories();
      setShowStallCategoriesEditForm(false);
    } catch (err) {
      alert("Error updating Stall Category");
    }
  };

  const fetchHallsData = async () => {
    try {
      const response = await fetch(
        "https://inoptics.in/api/get_hall_numbers.php",
      );
      const data = await response.json();
      setHallsData(data);
    } catch (error) {
      console.error("Error fetching hall data", error);
    }
  };

  const addHalls = async () => {
    if (!hallsNumber) return alert("Please enter a hall number.");
    try {
      const res = await fetch("https://inoptics.in/api/add_hall_number.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ hall_number: hallsNumber }),
      });
      const data = await res.json();
      alert(data.message);
      setHallsNumber("");
      setShowAddHallsForm(false);
      fetchHallsData();
    } catch (error) {
      alert("Error adding hall number.");
    }
  };
  const deleteHalls = async (id) => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/delete_hall_number.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        },
      );
      const data = await res.json();
      alert(data.message);
      fetchHallsData();
    } catch (error) {
      alert("Error deleting hall.");
    }
  };

  const startEditHalls = (item) => {
    setEditHallsId(item.id);
    setEditHallsNumber(item.hall_number);
    setShowEditHallsForm(true);
  };

  const updateHalls = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/update_hall_number.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: editHallsId,
            hall_number: editHallsNumber,
          }),
        },
      );
      const data = await res.json();
      alert(data.message);
      setShowEditHallsForm(false);
      fetchHallsData();
    } catch (error) {
      alert("Error updating hall.");
    }
  };

  const stallInputRef = useRef(null);
  const editStallInputRef = useRef(null);

  useEffect(() => {
    if (showStallAddForm && stallInputRef.current) {
      stallInputRef.current.focus();
    }
    if (showStallEditForm && editStallInputRef.current) {
      editStallInputRef.current.focus();
    }
  }, [showStallAddForm, showStallEditForm]);

  const filteredPowerData = powerData.filter((item) =>
    item.power_type.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const filteredBusinessData = businessData.filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const filteredFurnitureData = furnitureData.filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const filteredHalls = hallsData.filter((item) =>
    item.hall_number.toLowerCase().includes(searchHallsQuery.toLowerCase()),
  );

  const filteredStallAreas = stallAreas.filter((item) =>
    item.area.toLowerCase().includes(searchQueryStallAreas.toLowerCase()),
  );

  const filteredTaxesData = taxesData.filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const filteredProducts = products.filter((product) =>
    product.name.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const addFurnitureRequirement = async () => {
    if (!furnitureImage || !furniturePrice || !furnitureName) {
      alert("Please fill all fields.");
      return;
    }

    const formData = new FormData();
    formData.append("image", furnitureImage);
    formData.append("price", furniturePrice);
    formData.append("name", furnitureName);

    try {
      const res = await fetch(
        "https://inoptics.in/api/add_furniture_requirement.php",
        {
          method: "POST",
          body: formData,
        },
      );

      const data = await res.json();
      alert(data.message);
      setFurniturePrice("");
      setFurnitureImage(null);
      setFurnitureName("");
      setShowAddFurnitureForm(false);
      fetchFurnitureData();
    } catch (err) {
      alert("Error adding furniture");
    }
  };
  const fetchFurnitureData = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_furniture_requirement.php",
      );
      const data = await res.json();
      setFurnitureData(data);
    } catch (err) {
      console.error("Error fetching furniture data", err);
    }
  };

  const handleEditFurniture = (item) => {
    setEditFurnitureId(item.id);
    setEditFurnitureName(item.name); // <-- Add this line
    setEditFurnitureImage(null);
    setEditFurniturePrice(item.price);
    setShowEditFurnitureForm(true);
  };

  const handleDeleteFurniture = async (id) => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/delete_furniture_requirement.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        },
      );

      const data = await res.json();
      alert(data.message);
      fetchFurnitureData(); // refresh the table
    } catch (err) {
      alert("Error deleting furniture requirement");
    }
  };

  useEffect(() => {
    if (overlayContent === "Additional Requirement") {
      setActiveNavbarItem("FURNITURE REQUIREMENT");
    }
  }, [overlayContent]);

  const handleUpdateFurniture = async () => {
    if (!editFurnitureName || !editFurniturePrice) {
      alert("Please fill all fields.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("id", editFurnitureId);
      formData.append("name", editFurnitureName);
      if (editFurnitureImage) {
        formData.append("image", editFurnitureImage);
      }
      formData.append("price", editFurniturePrice);

      const res = await fetch(
        "https://inoptics.in/api/update_furniture_requirement.php",
        {
          method: "POST",
          body: formData,
        },
      );

      const data = await res.json();
      alert(data.message);
      setShowEditFurnitureForm(false);
      fetchFurnitureData();
    } catch (err) {
      alert("Error updating furniture requirement");
    }
  };

  // Fetch branding data
  const fetchBrandingData = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_branding_requirement.php",
      );
      const data = await res.json();
      setBrandingData(data);
    } catch (err) {
      console.error("Error fetching branding data", err);
    }
  };

  useEffect(() => {
    fetchBrandingData();
  }, []);

  const handleAddBranding = async () => {
    const formData = new FormData();
    formData.append("image", brandingImage);
    formData.append("name", brandingName);

    // Combine height and width into one dimension string
    const dimension = `${brandingHeight}*${brandingWidth}`;
    formData.append("dimension", dimension);

    formData.append("area", brandingArea);
    formData.append("fixed_price", brandingFixedPrice);
    formData.append("total_price", brandingTotalPrice);

    const res = await fetch(
      "https://inoptics.in/api/add_branding_requirement.php",
      {
        method: "POST",
        body: formData,
      },
    );

    const data = await res.json();
    alert(data.message);
    setShowAddBrandingForm(false);
    fetchBrandingData();
  };

  const handleEditBranding = (item) => {
    setEditBrandingItem(item);

    // Parse height and width from existing dimension string
    const [height, width] =
      item.height && item.width
        ? [item.height, item.width]
        : (item.dimension || "").split("*");
    setBrandingHeight(height || "");
    setBrandingWidth(width || "");

    setBrandingName(item.name || "");
    setBrandingArea(item.area || "");
    setBrandingFixedPrice(item.fixed_price || "");
    setBrandingTotalPrice(item.total_price || "");
    setShowEditBrandingForm(true);
  };

  const handleUpdateBranding = async () => {
    const formData = new FormData();
    formData.append("id", editBrandingItem.id);
    if (brandingImage) {
      formData.append("image", brandingImage);
    }

    formData.append("name", brandingName);

    // Combine height and width into one dimension string
    const dimension = `${brandingHeight}*${brandingWidth}`;
    formData.append("dimension", dimension);

    formData.append("area", brandingArea);
    formData.append("fixed_price", brandingFixedPrice);
    formData.append("total_price", brandingTotalPrice);

    const res = await fetch(
      "https://inoptics.in/api/update_branding_requirement.php",
      {
        method: "POST",
        body: formData,
      },
    );

    const data = await res.json();
    alert(data.message);
    setShowEditBrandingForm(false);
    fetchBrandingData();
  };

  const handleDeleteBranding = async (id) => {
    const res = await fetch(
      "https://inoptics.in/api/delete_branding_requirement.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      },
    );
    const data = await res.json();
    alert(data.message);
    fetchBrandingData();
  };

  const fetchBusinessData = async () => {
    try {
      const response = await fetch(
        "https://inoptics.in/api/get_business_requirement.php",
      );
      const text = await response.text();
      const data = JSON.parse(text);
      setBusinessData(data);
    } catch (error) {
      console.error("Error fetching business data", error);
    }
  };

  const addBusinessRequirement = async () => {
    if (!businessName) {
      alert("Please enter Business Name.");
      return;
    }

    try {
      const res = await fetch(
        "https://inoptics.in/api/add_business_requirement.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ name: businessName }),
        },
      );

      const data = await res.json();
      alert(data.message);
      setBusinessName("");
      setShowBusinessForm(false);
      fetchBusinessData();
    } catch (err) {
      alert("Error adding business requirement");
    }
  };

  const deleteBusinessRequirement = async (id) => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/delete_business_requirement.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        },
      );

      const data = await res.json();
      alert(data.message);
      fetchBusinessData();
    } catch (err) {
      alert("Error deleting business item");
    }
  };

  const editBusinessRequirement = (item) => {
    setEditBusinessId(item.id);
    setEditBusinessName(item.name);
    setShowEditBusinessForm(true);
  };

  const updateBusinessRequirement = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/update_business_requirement.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: editBusinessId, name: editBusinessName }),
        },
      );

      const data = await res.json();
      alert(data.message);
      setShowEditBusinessForm(false);
      fetchBusinessData();
    } catch (err) {
      alert("Error updating business item");
    }
  };

  const fetchExhibitionData = async () => {
    try {
      const response = await fetch(
        "https://inoptics.in/api/get_exhibition_map.php",
      );
      const text = await response.text();
      const data = JSON.parse(text);
      setExhibitionData(data);
    } catch (error) {
      console.error("Error fetching exhibition data", error);
    }
  };

  useEffect(() => {
    fetchExhibitionData();
  }, []);

  const addExhibitionImage = async () => {
    if (!exhibitionImage) {
      alert("Please select an image");
      return;
    }

    const formData = new FormData();
    formData.append("image", exhibitionImage);

    try {
      const res = await fetch(
        "https://inoptics.in/api/add_exhibition_map.php",
        {
          method: "POST",
          body: formData,
        },
      );

      const data = await res.json();
      alert(data.message);
      setExhibitionImage(null);
      setShowExhibitionMapForm(false);
      fetchExhibitionData();
    } catch (err) {
      console.error("Error uploading exhibition image", err);
      alert("Upload failed");
    }
  };

  const deleteExhibitionMap = async (id) => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/delete_exhibition_map.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        },
      );

      const data = await res.json();
      alert(data.message);
      fetchExhibitionData();
    } catch (err) {
      console.error("Error deleting image", err);
      alert("Failed to delete");
    }
  };

  const editExhibitionMap = (item) => {
    setEditItemId(item.id);
    setShowEditExhibitionMapForm(true);
  };

  const updateExhibitionImage = async () => {
    if (!editExhibitionImage || !editItemId) {
      alert("Please select a new image");
      return;
    }

    const formData = new FormData();
    formData.append("image", editExhibitionImage);
    formData.append("id", editItemId);

    try {
      const res = await fetch(
        "https://inoptics.in/api/update_exhibition_map.php",
        {
          method: "POST",
          body: formData,
        },
      );

      const data = await res.json();
      alert(data.message);
      setShowEditExhibitionMapForm(false);
      setEditExhibitionImage(null);
      fetchExhibitionData();
    } catch (err) {
      console.error("Error updating exhibition image", err);
      alert("Update failed");
    }
  };

  const fetchInstructions = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_exhibitor_dashboard_instructions.php",
      );

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();
      // console.log("Fetched instructions:", data);
      setInstructionData(data);
    } catch (error) {
      console.error("Error fetching instructions:", error);
    }
  };
  useEffect(() => {
    fetchInstructions();
  }, []);

  // Add
  const addExhibitorInstruction = async () => {
    if (!instructionEditorData.trim()) return;

    const formattedContent = instructionEditorData.replace(/\n/g, "<br>");
    await fetch(
      "https://inoptics.in/api/add_exhibitor_dashboard_instructions.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ content: formattedContent }),
      },
    );

    fetchInstructions();
    setInstructionEditorData("");
    setInstructionModalOpen(false);
  };

  const updateExhibitorInstruction = async () => {
    if (!instructionEditorData.trim()) return;

    const formattedContent = instructionEditorData.replace(/\n/g, "<br>");
    await fetch(
      "https://inoptics.in/api/update_exhibitor_dashboard_instructions.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: editInstructionId,
          content: formattedContent,
        }),
      },
    );

    fetchInstructions();
    setInstructionModalOpen(false);
  };

  // Delete
  const deleteInstruction = async (id) => {
    await fetch(
      "https://inoptics.in/api/delete_exhibitor_dashboard_instructions.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      },
    );
    fetchInstructions();
  };

  // ✅ Save handler with new name
  const saveExhibitorDashboardInstruction = async () => {
    if (editingIndex !== null) {
      await updateExhibitorInstruction();
    } else {
      await addExhibitorInstruction();
    }
  };

  // 🚀 Fetch declaration data
  const fetchExhibitorDeclaration = async () => {
    const res = await fetch(
      "https://inoptics.in/api/get_exhibitor_declaration_undertaking.php",
    );
    const data = await res.json();
    setDeclarationUndertakingData(data);
  };

  useEffect(() => {
    fetchExhibitorDeclaration();
  }, []);

  // 🟢 Add or update declaration
  const saveExhibitorDeclaration = async () => {
    const cleanedPoints = formPoints.filter(
      (item) => item.title.trim() && item.text.trim(),
    );

    const endpoint = isEditing
      ? "https://inoptics.in/api/update_exhibitor_declaration_undertaking.php"
      : "https://inoptics.in/api/add_exhibitor_declaration_undertaking.php";

    await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ points: cleanedPoints }),
    });

    setShowModal(false);
    fetchExhibitorDeclaration();
  };

  // 🟥 Delete declaration
  const deleteExhibitorDeclaration = async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete the declaration?",
    );
    if (!confirmDelete) return;

    await fetch(
      "https://inoptics.in/api/delete_exhibitor_declaration_undertaking.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      },
    );

    setDeclarationUndertakingData([]);
  };

  useEffect(() => {
    fetchEventSchedule();
  }, []);

  const fetchEventSchedule = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_exhibitor_event_schedule.php",
      );
      const data = await res.json();

      if (data.length > 0) {
        setScheduleDescription(data[0].description || "");
      } else {
        setScheduleDescription("");
      }

      setEventScheduleData(data);
    } catch (err) {
      console.error("Failed to fetch event schedule", err);
    }
  };

  const saveEventSchedule = async () => {
    const endpoint = isEditingSchedule
      ? "https://inoptics.in/api/update_exhibitor_event_schedule.php"
      : "https://inoptics.in/api/add_exhibitor_event_schedule.php";

    try {
      await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          description: scheduleDescription,
        }),
      });

      setShowScheduleModal(false);
      fetchEventSchedule();
    } catch (err) {
      console.error("Failed to save event schedule", err);
    }
  };

  const deleteEventSchedule = async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete the Event Schedule?",
    );
    if (!confirmDelete) return;

    try {
      await fetch(
        "https://inoptics.in/api/delete_exhibitor_event_schedule.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        },
      );

      setEventScheduleData([]);
    } catch (err) {
      console.error("Failed to delete event schedule", err);
    }
  };

  useEffect(() => {
    fetchExhibitorDashboardSchedule();
  }, []);

  const fetchExhibitorDashboardSchedule = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_exhibitor_dashboard_schedule.php",
      );
      const data = await res.json();
      setExhibitorDashboardSchedule(data);
    } catch (err) {
      console.error("Failed to fetch exhibitor dashboard schedule", err);
    }
  };
  const saveExhibitorDashboardSchedule = async () => {
    const cleanedPoints = exhibitorDashboardFormPoints.filter(
      (item) => item.title.trim() && item.text.trim(),
    );

    const endpoint = isEditingExhibitorDashboard
      ? "https://inoptics.in/api/update_exhibitor_dashboard_schedule.php"
      : "https://inoptics.in/api/add_exhibitor_dashboard_schedule.php";

    try {
      await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ points: cleanedPoints }),
      });

      setShowExhibitorDashboardModal(false);
      fetchExhibitorDashboardSchedule();
    } catch (err) {
      console.error("Failed to save exhibitor dashboard schedule", err);
    }
  };
  const deleteExhibitorDashboardSchedule = async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete the Exhibitor Dashboard Schedule?",
    );
    if (!confirmDelete) return;

    try {
      await fetch(
        "https://inoptics.in/api/delete_exhibitor_dashboard_schedule.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        },
      );

      setExhibitorDashboardSchedule([]);
    } catch (err) {
      console.error("Failed to delete exhibitor dashboard schedule", err);
    }
  };

  // const normalizeYouTubeLink = (url) => {
  //   if (!url) return '';
  //   try {
  //     const urlObj = new URL(url);

  //     if (url.includes("/embed/")) {
  //       const videoId = url.split("/embed/")[1];
  //       return `https://www.youtube.com/watch?v=${videoId}`;
  //     }

  //     if (urlObj.hostname.includes("youtube.com") && urlObj.searchParams.get("v")) {
  //       return `https://www.youtube.com/watch?v=${urlObj.searchParams.get("v")}`;
  //     }

  //     if (urlObj.hostname === "youtu.be") {
  //       return `https://www.youtube.com/watch?v=${urlObj.pathname.slice(1)}`;
  //     }
  //   } catch (err) {
  //     console.error("Invalid video URL:", err);
  //   }

  //   return '';
  // };

  const saveLatestNews = async () => {
    const cleanedNews = latestNewsForm
      .filter((item) => item.title?.trim() && item.text?.trim())
      .map((item) => ({
        title: item.title.trim(),
        text: item.text.trim(),
        news_link: item.news_link?.trim() || "",
      }));

    if (cleanedNews.length === 0) {
      alert("Please add at least one news item with title and description.");
      return;
    }

    const endpoint = isEditingLatestNews
      ? "https://inoptics.in/api/update_latest_news.php"
      : "https://inoptics.in/api/add_latest_news.php";

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ news: cleanedNews }),
      });

      if (!response.ok) throw new Error("Failed to save news");

      const result = await response.json();
      // console.log("Success:", result.message);

      setShowLatestNewsModal(false);
      fetchLatestNews();
    } catch (err) {
      console.error("Error saving latest news:", err);
      alert("Failed to save latest news.");
    }
  };

  const deleteLatestNews = async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete all latest news?",
    );
    if (!confirmDelete) return;

    try {
      await fetch("https://inoptics.in/api/delete_latest_news.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      setLatestNewsData([]);
    } catch (err) {
      console.error("Failed to delete latest news", err);
    }
  };

  const fetchLatestNews = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/get_latest_news.php");
      const data = await res.json();
      // console.log("Fetched news from API:", data);
      setLatestNewsData(data);
    } catch (err) {
      console.error("Failed to fetch latest news", err);
    }
  };

  useEffect(() => {
    fetchLatestNews();
  }, []);

  useEffect(() => {
    fetchExhibitorInstructions();
  }, []);

  const fetchExhibitorInstructions = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_exhibitor_instructions.php",
      );
      const data = await res.json();

      // Ensure we always have an array
      if (Array.isArray(data) && data.length > 0) {
        setInstructionsList(data);
      } else {
        setInstructionsList([]);
      }
    } catch (err) {
      console.error("Failed to fetch instructions", err);
    }
  };

  const saveExhibitorInstruction = async () => {
    if (!instructionEditorData.trim()) {
      alert("Instruction content cannot be empty.");
      return;
    }

    const isEditing = editInstructionId !== null;

    const endpoint = isEditing
      ? "https://inoptics.in/api/update_exhibitor_instruction.php"
      : "https://inoptics.in/api/add_exhibitor_instruction.php";

    const payload = isEditing
      ? { id: editInstructionId, content: instructionEditorData }
      : { content: instructionEditorData };

    try {
      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      console.log("API Response:", data);

      if (!data.success && isEditing) {
        alert(data.message || "Update failed");
        return;
      }

      setInstructionModalOpen(false);
      setInstructionEditorData("");
      setEditingIndex(null);
      setEditInstructionId(null);
      fetchExhibitorInstructions();
    } catch (err) {
      console.error("Failed to save instruction", err);
    }
  };

  const deleteExhibitorInstruction = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this instruction?",
    );
    if (!confirmDelete) return;

    try {
      const res = await fetch(
        "https://inoptics.in/api/delete_exhibitor_instruction.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }), // ✅ correct
        },
      );

      const data = await res.json();
      console.log("Delete Response:", data);

      if (!data.success) {
        alert(data.message || "Delete failed");
        return;
      }

      fetchExhibitorInstructions();
    } catch (err) {
      console.error("Failed to delete instruction", err);
    }
  };

  useEffect(() => {
    fetchExhibitorRules();
  }, []);

  const fetchExhibitorRules = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_exhibitor_rules.php",
      );
      const data = await res.json();
      setRulesList(data || []);
    } catch (err) {
      console.error("Failed to fetch rules", err);
    }
  };

  const saveExhibitorRule = async () => {
    if (!rulesEditorData.trim()) {
      alert("Rules content cannot be empty.");
      return;
    }

    const endpoint =
      rulesEditingIndex !== null
        ? "https://inoptics.in/api/update_exhibitor_rule.php"
        : "https://inoptics.in/api/add_exhibitor_rule.php";

    try {
      await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ content: rulesEditorData }),
      });

      setRulesModalOpen(false);
      setRulesEditorData("");
      setRulesEditingIndex(null);
      fetchExhibitorRules();
    } catch (err) {
      console.error("Failed to save rule", err);
    }
  };

  const deleteExhibitorRule = async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this rule?",
    );
    if (!confirmDelete) return;

    try {
      await fetch("https://inoptics.in/api/delete_exhibitor_rule.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "delete_latest" }), // ✅ Required for safety
      });

      fetchExhibitorRules(); // Refresh the rule list
    } catch (err) {
      console.error("Failed to delete rule", err);
    }
  };

  useEffect(() => {
    fetchExhibitorGuidelines();
  }, []);

  const fetchExhibitorGuidelines = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_exhibitor_guidelines.php",
      );
      const data = await res.json();
      setGuidelinesList(data || []);
    } catch (err) {
      console.error("Failed to fetch guidelines", err);
    }
  };
  const saveExhibitorGuideline = async () => {
    if (!guidelinesEditorData.trim()) {
      alert("Guideline content cannot be empty.");
      return;
    }

    const endpoint =
      guidelinesEditingIndex !== null
        ? "https://inoptics.in/api/update_exhibitor_guideline.php"
        : "https://inoptics.in/api/add_exhibitor_guideline.php";

    try {
      await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ content: guidelinesEditorData }),
      });

      setGuidelinesModalOpen(false);
      setGuidelinesEditorData("");
      setGuidelinesEditingIndex(null);
      fetchExhibitorGuidelines(); // refresh list
    } catch (err) {
      console.error("Failed to save guideline", err);
    }
  };

  const deleteExhibitorGuideline = async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this guideline?",
    );
    if (!confirmDelete) return;

    try {
      await fetch("https://inoptics.in/api/delete_exhibitor_guideline.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "delete_latest" }), // ✅ Add this line
      });

      fetchExhibitorGuidelines(); // refresh list
    } catch (err) {
      console.error("Failed to delete guideline", err);
    }
  };

  // Fetch Declarations
  const fetchDeclarations = async () => {
    const res = await fetch(
      "https://inoptics.in/api/get_exhibitor_declaration.php",
    );
    const data = await res.json();
    setDeclarationData(data);
  };

  useEffect(() => {
    if (overlayContent === "Exhibitor Declaration") {
      fetchDeclarations();
    }
  }, [overlayContent]);

  // Add Declaration
  const addDeclaration = async () => {
    if (!newDeclarationContent.trim()) return;
    const formatted = newDeclarationContent.replace(/\n/g, "<br>");
    await fetch("https://inoptics.in/api/add_exhibitor_declaration.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ content: formatted }),
    });
    fetchDeclarations();
    setNewDeclarationContent("");
    setShowAddDeclarationForm(false);
  };

  // Edit Declaration
  const editDeclaration = (item) => {
    setEditDeclarationId(item.id);
    setEditDeclarationContent(item.content.replace(/<br\s*\/?>/gi, "\n"));
    setShowEditDeclarationForm(true);
  };

  // Update Declaration
  const updateDeclaration = async () => {
    if (!editDeclarationContent.trim()) return;
    const formatted = editDeclarationContent.replace(/\n/g, "<br>");
    await fetch("https://inoptics.in/api/update_exhibitor_declaration.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: editDeclarationId, content: formatted }),
    });
    fetchDeclarations();
    setShowEditDeclarationForm(false);
  };

  // Delete Declaration
  const deleteDeclaration = async (id) => {
    await fetch("https://inoptics.in/api/delete_exhibitor_declaration.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });
    fetchDeclarations();
  };

  const fetchSchedules = async () => {
    const res = await fetch(
      "https://inoptics.in/api/get_exhibitor_schedule.php",
    );
    const data = await res.json();
    setExhibitorScheduleData(data);
  };

  const addExhibitorSchedule = async () => {
    if (!exhibitorScheduleContent.trim()) return;

    const formattedContent = exhibitorScheduleContent.replace(/\n/g, "<br>");

    await fetch("https://inoptics.in/api/add_exhibitor_schedule.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ content: formattedContent }),
    });
    fetchSchedules();
    setExhibitorScheduleContent("");
    setShowExhibitorScheduleForm(false);
  };

  const editExhibitorSchedule = (item) => {
    setEditingExhibitorScheduleId(item.id);
    setEditExhibitorScheduleContent(item.content.replace(/<br\s*\/?>/gi, "\n"));
    setShowEditExhibitorScheduleForm(true);
  };

  const updateExhibitorSchedule = async () => {
    if (!editExhibitorScheduleContent.trim()) return;

    const formattedContent = editExhibitorScheduleContent.replace(
      /\n/g,
      "<br>",
    );

    await fetch("https://inoptics.in/api/update_exhibitor_schedule.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: editingExhibitorScheduleId,
        content: formattedContent,
      }),
    });
    fetchSchedules();
    setShowEditExhibitorScheduleForm(false);
  };

  const deleteExhibitorSchedule = async (id) => {
    await fetch("https://inoptics.in/api/delete_exhibitor_schedule.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });
    fetchSchedules();
  };

  const fetchGuidelines = async () => {
    const res = await fetch(
      "https://inoptics.in/api/get_guidelines_for_construction.php",
    );
    const data = await res.json();
    setGuidelineData(data);
  };

  const addGuideline = async () => {
    if (!newGuidelineContent.trim()) return;
    const formatted = newGuidelineContent.replace(/\n/g, "<br>");
    await fetch("https://inoptics.in/api/add_guidelines_for_construction.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ content: formatted }),
    });
    fetchGuidelines();
    setNewGuidelineContent("");
    setShowGuidelineForm(false);
  };

  const editGuideline = (item) => {
    setEditGuidelineId(item.id);
    setEditGuidelineContent(item.content.replace(/<br\s*\/?>/gi, "\n")); // Convert <br> to \n
    setShowEditGuidelineForm(true);
  };

  const updateGuideline = async () => {
    if (!editGuidelineContent.trim()) return;
    const formatted = editGuidelineContent.replace(/\n/g, "<br>");
    await fetch(
      "https://inoptics.in/api/update_guidelines_for_construction.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: editGuidelineId, content: formatted }),
      },
    );
    fetchGuidelines();
    setShowEditGuidelineForm(false);
  };

  const deleteGuideline = async (id) => {
    await fetch(
      "https://inoptics.in/api/delete_guidelines_for_construction.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      },
    );
    fetchGuidelines();
  };

  useEffect(() => {
    if (
      overlayContent === "Contractor" &&
      activeContractorTab === "Guidelines For Construction"
    ) {
      fetchGuidelines();
    }
  }, [activeContractorTab]);

  const addPowerRequirement = async () => {
    if (!powerType || !price) {
      alert("Please fill all fields.");
      return;
    }

    try {
      const res = await fetch(
        "https://inoptics.in/api/add_power_requirement.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            power_type: powerType,
            price: parseFloat(price),
          }),
        },
      );

      const data = await res.json();
      alert(data.message);
      setPowerType("");
      setPrice("");
      setShowAddForm(false);
      fetchPowerData();
    } catch (err) {
      alert("Error adding power requirement");
    }
  };

  const fetchPowerData = async () => {
    try {
      const response = await fetch(
        "https://www.inoptics.in/api/get_power_requirement.php",
      );
      const text = await response.text();
      // console.log("Raw response text:", text);

      const data = JSON.parse(text);
      // console.log("Parsed powerData:", data); // ⬅️ Add this

      setPowerData(data);
    } catch (error) {
      console.error("Fetch error", error);
    }
  };

  const powerTypes = [
    ...new Set(powerData.map((item) => item.power_type.trim())),
  ];

  useEffect(() => {
    fetchPowerData();
    fetchBusinessData();
    fetchFurnitureData();
    fetchStallData();
    fetchHallsData();
    fetchStallCategories();
    fetchStallAreas();
    fetchTaxesData();
    fetchCurrencyData();
    fetchExhibitorData();
    fetchContractorRequirements();
  }, []);

  useEffect(() => {
    fetchSMSInstructions();
  }, []);

  const fetchSMSInstructions = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_sms_instruction.php",
      );
      const data = await res.json();
      setSmsMessageList(data || []);
    } catch (err) {
      console.error("Failed to fetch SMS instructions", err);
    }
  };

  const saveSMSInstructions = async () => {
    if (!SMSinstructionEditorData.trim()) {
      alert("Message content cannot be empty.");
      return;
    }

    const endpoint =
      editingIndex !== null
        ? "https://inoptics.in/api/update_sms_instruction.php"
        : "https://inoptics.in/api/add_sms_instruction.php";

    try {
      await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ content: SMSinstructionEditorData }),
      });

      setInstructionModalOpen(false);
      setSMSinstructionEditorData("");
      setEditingIndex(null);
      fetchSMSInstructions();
    } catch (err) {
      console.error("Failed to save SMS message", err);
    }
  };

  const deleteSMSInstructions = async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete the SMS message?",
    );
    if (!confirmDelete) return;

    try {
      await fetch("https://inoptics.in/api/delete_sms_instruction.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "delete_latest" }), // ✅ This line is crucial
      });

      setEditingIndex(null);
      setSMSinstructionEditorData("");
      fetchSMSInstructions();
    } catch (err) {
      console.error("Failed to delete SMS message", err);
    }
  };

  useEffect(() => {
    fetchSMSTable();
  }, []);

  const fetchSMSTable = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/get_sms_table.php");
      const data = await res.json();
      setSmsTableData(data || []);
    } catch (err) {
      console.error("Failed to fetch SMS table", err);
    }
  };

  const saveSMSTableRow = async (row) => {
    try {
      await fetch("https://inoptics.in/api/add_sms_table.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          plan_name: row.plan_name,
          delivery_frequency: row.delivery_frequency,
          description: row.description,
          price: row.price,
        }),
      });

      setNewRow({
        plan_name: "",
        delivery_frequency: "",
        description: "",
        price: "",
      });

      fetchSMSTable();
    } catch (err) {
      console.error("Failed to add row", err);
    }
  };

  const deleteSMSTableRow = async (id) => {
    const confirmDelete = window.confirm("Delete this row?");
    if (!confirmDelete) return;

    try {
      await fetch("https://inoptics.in/api/delete_sms_table.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      fetchSMSTable();
    } catch (err) {
      console.error("Failed to delete row", err);
    }
  };

  const updateSMSTableCell = async (id, key, value) => {
    try {
      await fetch("https://inoptics.in/api/update_sms_table.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, key, value }),
      });

      fetchSMSTable();
    } catch (err) {
      console.error("Failed to update cell", err);
    }
  };

  useEffect(() => {
    fetchWhatsAppTable();
  }, []);

  // Fetch WhatsApp Table Data
  const fetchWhatsAppTable = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/get_whatsapp_table.php");
      const data = await res.json();
      setWhatsappTableData(data || []);
    } catch (err) {
      console.error("Failed to fetch WhatsApp table", err);
    }
  };

  // Add new WhatsApp row
  const saveWhatsAppTableRow = async (row) => {
    try {
      await fetch("https://inoptics.in/api/add_whatsapp_table.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          plan_name: row.plan_name,
          delivery_frequency: row.delivery_frequency,
          description: row.description,
          price: row.price,
        }),
      });

      setNewWhatsAppRow({
        plan_name: "",
        delivery_frequency: "",
        description: "",
        price: "",
      });
      fetchWhatsAppTable();
    } catch (err) {
      console.error("Failed to add WhatsApp row", err);
    }
  };

  // Delete WhatsApp row
  const deleteWhatsAppTableRow = async (id) => {
    const confirmDelete = window.confirm("Delete this WhatsApp row?");
    if (!confirmDelete) return;

    try {
      await fetch("https://inoptics.in/api/delete_whatsapp_table.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      fetchWhatsAppTable();
    } catch (err) {
      console.error("Failed to delete WhatsApp row", err);
    }
  };

  // Update WhatsApp cell
  const updateWhatsAppTableCell = async (id, key, value) => {
    try {
      await fetch("https://inoptics.in/api/update_whatsapp_table.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, key, value }),
      });

      fetchWhatsAppTable();
    } catch (err) {
      console.error("Failed to update WhatsApp cell", err);
    }
  };

  useEffect(() => {
    fetchWhatsAppInstructions();
  }, []);

  const fetchWhatsAppInstructions = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_whatsapp_instruction.php",
      );
      const data = await res.json();
      if (data.success) {
        setWhatsappInstruction(data.content || "");
      }
    } catch (err) {
      console.error("Failed to fetch WhatsApp instructions", err);
    }
  };
  const saveWhatsAppInstructions = async () => {
    if (!whatsappInstructionEditorData.trim()) {
      alert("Message content cannot be empty.");
      return;
    }

    const endpoint =
      whatsappEditingIndex !== null
        ? "https://inoptics.in/api/update_whatsapp_instruction.php"
        : "https://inoptics.in/api/add_whatsapp_instruction.php";

    try {
      await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ content: whatsappInstructionEditorData }),
      });

      setInstructionModalOpen(false);
      setWhatsappInstructionEditorData("");
      setWhatsappEditingIndex(null);
      fetchWhatsAppInstructions();
    } catch (err) {
      console.error("Failed to save WhatsApp instruction", err);
    }
  };
  const deleteWhatsAppInstructions = async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete the WhatsApp message?",
    );
    if (!confirmDelete) return;

    try {
      await fetch("https://inoptics.in/api/delete_whatsapp_instruction.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "delete_latest" }),
      });

      setWhatsappEditingIndex(null);
      setWhatsappInstructionEditorData("");
      fetchWhatsAppInstructions();
    } catch (err) {
      console.error("Failed to delete WhatsApp message", err);
    }
  };

  // useEffect(() => {
  //   fetchWebsiteAdsInstructions();
  // }, []);

  // const fetchWebsiteAdsInstructions = async () => {
  //   try {
  //     const res = await fetch('https://inoptics.in/api/get_website_ads_instruction.php');
  //     const data = await res.json();
  //     setWebsiteAdsInstructions(data || []);
  //   } catch (err) {
  //     console.error("Failed to fetch website ads instructions", err);
  //   }
  // };
  // const saveWebsiteAdsInstructions = async () => {
  //   if (!websiteAdsEditorData.trim()) {
  //     alert("Instruction content cannot be empty.");
  //     return;
  //   }

  //   const endpoint = websiteAdsEditingIndex !== null
  //     ? 'https://inoptics.in/api/update_website_ads_instruction.php'
  //     : 'https://inoptics.in/api/add_website_ads_instruction.php';

  //   try {
  //     await fetch(endpoint, {
  //       method: 'POST',
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ content: websiteAdsEditorData }),
  //     });

  //     setWebsiteAdsModalOpen(false);
  //     setWebsiteAdsEditorData('');
  //     setWebsiteAdsEditingIndex(null);
  //     fetchWebsiteAdsInstructions();
  //   } catch (err) {
  //     console.error("Failed to save Website Ads instruction", err);
  //   }
  // };
  // const deleteWebsiteAdsInstructions = async () => {
  //   const confirmDelete = window.confirm("Are you sure you want to delete this instruction?");
  //   if (!confirmDelete) return;

  //   try {
  //     await fetch('https://inoptics.in/api/delete_website_ads_instruction.php', {
  //       method: 'POST',
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ action: "delete_latest" })
  //     });

  //     setWebsiteAdsEditingIndex(null);
  //     setWebsiteAdsEditorData('');
  //     fetchWebsiteAdsInstructions();
  //   } catch (err) {
  //     console.error("Failed to delete Website Ads instruction", err);
  //   }
  // };
  // useEffect(() => {
  //   fetchWebsiteAdsTable();
  // }, []);

  // const fetchWebsiteAdsTable = async () => {
  //   try {
  //     const res = await fetch('https://inoptics.in/api/get_website_ads_table.php');
  //     const data = await res.json();
  //     setWebsiteAdsTableData(data || []);
  //   } catch (err) {
  //     console.error("Failed to fetch Website Ads table", err);
  //   }
  // };

  // const saveWebsiteAdsTableRow = async (row) => {
  //   try {
  //     await fetch('https://inoptics.in/api/add_website_ads_table.php', {
  //       method: 'POST',
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(row)
  //     });

  //     setNewWebsiteAdsRow({
  //       plan_name: '',
  //       duration: '',
  //       description: '',
  //       price: ''
  //     });

  //     fetchWebsiteAdsTable();
  //   } catch (err) {
  //     console.error("Failed to add Website Ads row", err);
  //   }
  // };
  // const deleteWebsiteAdsTableRow = async (id) => {
  //   const confirmDelete = window.confirm("Delete this row?");
  //   if (!confirmDelete) return;

  //   try {
  //     await fetch('https://inoptics.in/api/delete_website_ads_table.php', {
  //       method: 'POST',
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ id })
  //     });

  //     fetchWebsiteAdsTable();
  //   } catch (err) {
  //     console.error("Failed to delete Website Ads row", err);
  //   }
  // };

  // const updateWebsiteAdsTableCell = async (id, key, value) => {
  //   try {
  //     await fetch('https://inoptics.in/api/update_website_ads_table.php', {
  //       method: 'POST',
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ id, key, value })
  //     });

  //     fetchWebsiteAdsTable();
  //   } catch (err) {
  //     console.error("Failed to update Website Ads cell", err);
  //   }
  // };

  const handleDelete = async (id) => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/delete_power_requirement.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        },
      );

      const data = await res.json();
      alert(data.message);
      fetchPowerData();
    } catch (err) {
      alert("Error deleting item");
    }
  };

  const handleEdit = (item) => {
    setEditItemId(item.id);
    setEditPowerType(item.power_type);
    setEditPrice(item.price);
    setShowEditForm(true);
  };
  const handleUpdate = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/update_power_requirement.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: editItemId,
            power_type: editPowerType,
            price: parseFloat(editPrice),
          }),
        },
      );

      const data = await res.json();
      alert(data.message);
      fetchPowerData(); // Refresh data
      setShowEditForm(false); // Close modal
    } catch (err) {
      alert("Error updating item");
    }
  };

  const fetchStallData = async () => {
    try {
      const response = await fetch(
        `https://inoptics.in/api/get_stall_data.php?ts=${Date.now()}`,
      ); // always unique
      const data = await response.json();
      setStallData(data);
    } catch (error) {
      console.error("Failed to fetch stall data", error);
    }
  };

  const addStall = async () => {
    if (!stallNumber) {
      alert("Please enter the Stall Number.");
      return;
    }

    try {
      const res = await fetch("https://inoptics.in/api/add_stall.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          stall_number: stallNumber,
          hall_number: hallNumber || null, // Send null if empty
        }),
      });

      const data = await res.json();
      alert(data.message);
      setStallNumber("");
      setHallNumber("");
      setShowStallAddForm(false);
      fetchStallData();
    } catch (err) {
      alert("Error adding stall");
      console.error(err);
    }
  };

  const handleStallDelete = async (id) => {
    try {
      const res = await fetch("https://inoptics.in/api/delete_stall.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });
      const data = await res.json();
      alert(data.message);
      fetchStallData();
    } catch (err) {
      alert("Error deleting stall");
      console.error(err);
    }
  };

  const handleStallEdit = (item) => {
    setEditStallId(item.id);
    setEditStallNumber(item.stall_number);
    setEditHallNumber(item.hall_number || ""); // Avoid setting "null" string
    setShowStallEditForm(true);
  };

  const handleStallUpdate = async () => {
    if (!editStallNumber) {
      alert("Stall number is required.");
      return;
    }

    try {
      const res = await fetch("https://inoptics.in/api/update_stall.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: editStallId,
          stall_number: editStallNumber,
          hall_number: editHallNumber || null, // Optional
        }),
      });

      const data = await res.json();
      alert(data.message);
      setShowStallEditForm(false);
      fetchStallData();
    } catch (err) {
      alert("Error updating stall");
      console.error(err);
    }
  };

  useEffect(() => {
    fetchSponsorImages();
  }, []);

  const fetchSponsorImages = async () => {
    const res = await fetch(
      "https://inoptics.in/api/get_sponsor_images_list.php",
    );
    const data = await res.json();
    setSponsorImages(data);
  };

  const uploadSponsorImage = async () => {
    const formData = new FormData();
    formData.append("image", selectedSponsorFile);
    formData.append("sponsor_type", sponsorType);
    formData.append("name", sponsorName);

    const res = await fetch(
      "https://inoptics.in/api/upload_sponsor_image.php",
      {
        method: "POST",
        body: formData,
      },
    );
    const result = await res.json();
    alert(result.message || result.error);
    fetchSponsorImages();
    resetSponsorModal();
  };

  const updateSponsorImage = async () => {
    const formData = new FormData();
    formData.append("id", editingSponsorId);
    formData.append("image", selectedSponsorFile);
    formData.append("sponsor_type", sponsorType);
    formData.append("name", sponsorName);

    const res = await fetch(
      "https://inoptics.in/api/update_sponsor_image.php",
      {
        method: "POST",
        body: formData,
      },
    );
    const result = await res.json();
    alert(result.message || result.error);
    fetchSponsorImages();
    resetSponsorModal();
  };

  const deleteSponsorImage = async (id) => {
    if (!window.confirm("Are you sure you want to delete this sponsor image?"))
      return;

    const res = await fetch(
      "https://inoptics.in/api/delete_sponsor_image.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      },
    );
    const result = await res.json();
    alert(result.message || result.error);
    fetchSponsorImages();
  };

  const handleEditSponsor = (item) => {
    setIsEditingSponsor(true);
    setEditingSponsorId(item.id);
    setSponsorType(item.sponsor_type);
    setSponsorName(item.name || "");
    setShowSponsorModal(true);
  };

  const resetSponsorModal = () => {
    setShowSponsorModal(false);
    setSponsorType("");
    setSponsorName("");
    setSelectedSponsorFile(null);
    setIsEditingSponsor(false);
    setEditingSponsorId(null);
  };

  useEffect(() => {
    fetchHomeVideos();
  }, []);

  const fetchHomeVideos = async () => {
    const res = await fetch("https://inoptics.in/api/get_home_videos.php");
    const data = await res.json();
    setHomeVideos(data);
  };

  const uploadHomeVideo = async () => {
    const formData = new FormData();
    formData.append("video", selectedHomeVideoFile); // must be a File object

    const res = await fetch("https://inoptics.in/api/upload_home_video.php", {
      method: "POST",
      body: formData,
    });

    const result = await res.json();
    alert(result.message || result.error);
    fetchHomeVideos();
    resetHomeVideoModal();
  };

  const updateHomeVideo = async () => {
    const formData = new FormData();
    formData.append("id", editingHomeVideoId);
    formData.append("video", selectedHomeVideoFile);

    const res = await fetch("https://inoptics.in/api/update_home_video.php", {
      method: "POST",
      body: formData,
    });

    const result = await res.json();
    alert(result.message || result.error);
    fetchHomeVideos();
    resetHomeVideoModal();
  };

  const deleteHomeVideo = async (id) => {
    if (
      !window.confirm("Are you sure you want to delete this home page video?")
    )
      return;

    const res = await fetch("https://inoptics.in/api/delete_home_video.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    const result = await res.json();
    alert(result.message || result.error);
    fetchHomeVideos();
  };

  const handleEditHomeVideo = (item) => {
    setIsEditingHomeVideo(true);
    setEditingHomeVideoId(item.id);
    setShowHomeVideoModal(true);
  };

  const resetHomeVideoModal = () => {
    setShowHomeVideoModal(false);
    setSelectedHomeVideoFile(null);
    setIsEditingHomeVideo(false);
    setEditingHomeVideoId(null);
  };

  useEffect(() => {
    fetchPeopleComments();
  }, []);

  const fetchPeopleComments = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_people_comments.php",
      );
      const data = await res.json();
      setPeopleComments(data);
    } catch (err) {
      console.error("Error fetching people comments:", err);
    }
  };

  const uploadPeopleComment = async () => {
    const formData = new FormData();
    formData.append("image", selectedPeopleImageFile);
    formData.append("comment", peopleComment);
    formData.append("name", peopleCommenterName);
    formData.append("designation", peopleCommenterDesignation);

    const res = await fetch(
      "https://inoptics.in/api/upload_people_comment.php",
      {
        method: "POST",
        body: formData,
      },
    );

    const result = await res.json();
    alert(result.message || result.error);
    fetchPeopleComments();
    resetPeopleCommentModal();
  };

  const updatePeopleComment = async () => {
    const formData = new FormData();
    formData.append("id", editingPeopleCommentId);
    formData.append("image", selectedPeopleImageFile);
    formData.append("comment", peopleComment);
    formData.append("name", peopleCommenterName);
    formData.append("designation", peopleCommenterDesignation);

    const res = await fetch(
      "https://inoptics.in/api/update_people_comment.php",
      {
        method: "POST",
        body: formData,
      },
    );

    const result = await res.json();
    alert(result.message || result.error);
    fetchPeopleComments();
    resetPeopleCommentModal();
  };

  const deletePeopleComment = async (id) => {
    if (!window.confirm("Are you sure you want to delete this comment?"))
      return;

    const res = await fetch(
      "https://inoptics.in/api/delete_people_comment.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      },
    );

    const result = await res.json();
    alert(result.message || result.error);
    fetchPeopleComments();
  };

  const handleEditPeopleComment = (item) => {
    setIsEditingPeopleComment(true);
    setEditingPeopleCommentId(item.id);
    setSelectedPeopleImageFile(null); // optional: you can skip setting old image
    setPeopleComment(item.comment);
    setPeopleCommenterName(item.name);
    setPeopleCommenterDesignation(item.designation);
    setShowPeopleCommentModal(true);
  };

  const resetPeopleCommentModal = () => {
    setShowPeopleCommentModal(false);
    setSelectedPeopleImageFile(null);
    setPeopleComment("");
    setPeopleCommenterName("");
    setPeopleCommenterDesignation("");
    setIsEditingPeopleComment(false);
    setEditingPeopleCommentId(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    navigate("/admin-login");
  };

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
    setOverlayContent(null);
  };

  const toggleWebsiteMenu = () => {
    setShowWebsiteMenu(!showWebsiteMenu);
  };

  const openOverlay = (content) => {
    setOverlayContent(content);
  };

  const closeOverlay = () => {
    setOverlayContent(null);
  };

  const selectedStall = stallList.length > 0 ? stallList[0] : null;

  const cardItems = [
    { title: "Visitors Counts", count: 120, bgImage: visitorsImg },
    { title: "Exhibitors Counts", count: 85, bgImage: exhibitorsImg },
    { title: "Forms", count: 42, bgImage: formsImg },
    { title: "Payment Details", count: 19, bgImage: paymentsImg },
    { title: "Reminders", count: 10, bgImage: remaindersImg },
    { title: "Inquiries", count: 5, bgImage: inquery },
  ];

  // const websitePages = [
  //   "Navbar", "Footer", "Landing page", "Home page", "About Us",
  //   "Why Exhibit", "Press Release", "Media Gallery",
  //   "Floating Card","Home Exhibitor List"
  // ];

  const masterPages = [
    "Business Requirement",
    "Products",
    "Taxes",
    "Currency",
    "Proforma",
    "Badges Limit",
    "Power Requirement",
    "Message Rules",
    "Exhibitor Series Edit",
    "Furniture Requirement",
    // "Furniture Vendor",
  ];

  const stallsManagementPages = [
    "Stall Numbers",
    "Hall Numbers",
    "Stall Categories",
    "Stall Areas",
  ];

  const formsPages = ["Core Required Forms", "Additional Required"];

  useEffect(() => {
    console.log("showBusinessForm:", showBusinessForm);
  }, [showBusinessForm]);

  const resetEmailForm = () => {
    setEmailName("");
    setEmailContent("");
    setAppliedPlace("");
    setShowEmailMasterAddForm(false);
    setShowEmailMasterEditForm(false);
    setSelectedEmailId(null);
  };

  const handleEmailMasterEdit = (item) => {
    setEmailName(item.email_name);
    setEmailContent(item.content);
    setAppliedPlace(item.applied_place);
    setSelectedEmailId(item.id);
    setShowEmailMasterEditForm(true);
  };

  useEffect(() => {
    fetchEmailMessages();
  }, []);

  const fetchEmailMessages = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/get_email_messages.php");
      const json = await res.json();
      setEmailMasterData(json.data || []); // ✅ Use json.data, not json
    } catch (err) {
      console.error("Failed to fetch email messages", err);
    }
  };

  const addEmailMaster = async () => {
    if (!emailName.trim() || !emailContent.trim()) {
      alert("Email name and content are required.");
      return;
    }

    try {
      await fetch("https://inoptics.in/api/add_email_message.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email_name: emailName,
          content: emailContent,
          applied_place: appliedPlace,
          set_from_email: fromEmail,
          attach_pdf: attachPdf,
          admin_copy_email: adminCopyEmail,
        }),
      });

      resetEmailForm();
      fetchEmailMessages(); // 🔄 Refresh list
    } catch (err) {
      console.error("Failed to add email message", err);
    }
  };

  const updateEmailMaster = async () => {
    if (!emailName.trim() || !emailContent.trim()) {
      alert("Email name and content are required.");
      return;
    }

    try {
      await fetch("https://inoptics.in/api/update_email_message.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: selectedEmailId,
          email_name: emailName,
          content: emailContent,
          applied_place: appliedPlace,
          set_from_email: fromEmail, // ✅ from your state
          attach_pdf: attachPdf, // ✅ "Yes" or "No"
          admin_copy_email: adminCopyEmail,
        }),
      });

      resetEmailForm();
      fetchEmailMessages();
    } catch (err) {
      console.error("Failed to update email message", err);
    }
  };

  const deleteEmailMaster = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this email template?",
    );
    if (!confirmDelete) return;

    try {
      await fetch("https://inoptics.in/api/delete_email_message.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      fetchEmailMessages(); // 🔄 Refresh list
    } catch (err) {
      console.error("Failed to delete email message", err);
    }
  };

  const invoiceRows = [
    {
      particular: `**EXHIBITION SERVICES - STALLS**\nTo charges for your booth at \nInoptics 2026 @ New Delhi,\nMarch 28th–30th, 2026\nCategory: ${
        selectedStall?.stall_category || "-"
      }\nStall No.: ${selectedStall?.stall_number || "-"}`,
      quantity: selectedStall?.stall_area || 1,
      price: selectedStall?.stall_price || 0,
      total: selectedStall?.total || 0,
    },
  ];

  const numberToWords = (num) => {
    const a = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const b = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const numberToWordsIndian = (n) => {
      if ((n = n.toString()).length > 9) return "Overflow";
      const nStr = ("000000000" + n)
        .substr(-9)
        .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
      if (!nStr) return;

      let str = "";
      str +=
        nStr[1] != 0
          ? (a[Number(nStr[1])] || b[nStr[1][0]] + " " + a[nStr[1][1]]) +
            " Crore "
          : "";
      str +=
        nStr[2] != 0
          ? (a[Number(nStr[2])] || b[nStr[2][0]] + " " + a[nStr[2][1]]) +
            " Lakh "
          : "";
      str +=
        nStr[3] != 0
          ? (a[Number(nStr[3])] || b[nStr[3][0]] + " " + a[nStr[3][1]]) +
            " Thousand "
          : "";
      str +=
        nStr[4] != 0
          ? (a[Number(nStr[4])] || b[nStr[4][0]] + " " + a[nStr[4][1]]) +
            " Hundred "
          : "";
      str +=
        nStr[5] != 0
          ? (str != "" ? "and " : "") +
            (a[Number(nStr[5])] || b[nStr[5][0]] + " " + a[nStr[5][1]]) +
            " "
          : "";
      return str.trim();
    };

    const rounded = Math.round(num);
    return numberToWordsIndian(rounded) + " Only";
  };

  // Normalize common state names (like New Delhi → Delhi)
  const normalizeState = (state) => {
    if (!state) return "";
    const cleaned = state.toLowerCase().trim().replace(/\s+/g, "");
    // Handle known aliases
    if (cleaned.includes("newdelhi") || cleaned.includes("delhi"))
      return "delhi";
    if (cleaned.includes("mumbai") || cleaned.includes("maharashtra"))
      return "maharashtra";
    if (cleaned.includes("bangalore")) return "karnataka";
    return cleaned;
  };

  // Extract normalized sender and recipient state
  const fromState2 = normalizeState(formTemplateData.senderState);
  const toState2 = normalizeState(formTemplateData.stateCity?.split(",")[0]);

  // Subtotal & Discount
  const subTotal2 = invoiceRows.reduce(
    (sum, row) => sum + Number(row.total || 0),
    0,
  );
  const discount2 = Number(formTemplateData.discount || 0);
  const discountPercent2 =
    subTotal2 > 0 ? ((discount2 / subTotal2) * 100).toFixed(2) : 0;

  // Tax rates
  const taxRate2 = 0.18;
  const sgstRate2 = 0.09;
  const cgstRate2 = 0.09;

  let sgst2 = 0;
  let cgst2 = 0;
  let igst2 = 0;
  let taxAmount2 = 0;

  // ✅ Apply correct GST logic
  const isSameState2 = fromState2 === toState2;

  if (isSameState2) {
    sgst2 = subTotal2 * sgstRate2;
    cgst2 = subTotal2 * cgstRate2;
    taxAmount2 = sgst2 + cgst2;
  } else {
    igst2 = subTotal2 * taxRate2;
    taxAmount2 = igst2;
  }

  // Final total and words
  const grandTotal2 = subTotal2 - discount2 + taxAmount2;
  const amountInWords2 = numberToWords(grandTotal2);

  // --- Fetch Data on Mount ---
  useEffect(() => {
    fetchVisitorGuideMain();
    fetchVisitorGuideCards();
    fetchReachMain();
    fetchReachCards();
    fetchMetroMaps();
  }, []);

  // --- Fetch Main ---
  const fetchVisitorGuideMain = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_visitor_guide_main.php",
      );
      const data = await res.json();
      setVisitorMain(data || {});
    } catch (err) {
      console.error("Failed to fetch Visitor Guide Main", err);
    }
  };

  // --- Fetch Cards ---
  const fetchVisitorGuideCards = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_visitor_guide_cards.php",
      );
      const data = await res.json();
      setVisitorCards(data || []);
    } catch (err) {
      console.error("Failed to fetch Visitor Guide Cards", err);
    }
  };

  // --- Save Main (Add/Update) ---
  const saveVisitorGuideMain = async () => {
    try {
      const endpoint = visitorMain.id
        ? "https://inoptics.in/api/update_visitor_guide_main.php"
        : "https://inoptics.in/api/add_visitor_guide_main.php";

      await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: visitorMain.id,
          header: mainHeader,
          text: mainText,
        }),
      });

      fetchVisitorGuideMain();
      setShowMainModal(false);
      setEditModeMain(false);
    } catch (err) {
      console.error("Failed to save Visitor Guide Main", err);
    }
  };

  // --- Delete Main ---
  const deleteVisitorGuideMain = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete Visitor Guide Main?",
    );
    if (!confirmDelete) return;

    try {
      await fetch("https://inoptics.in/api/delete_visitor_guide_main.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      setVisitorMain({});
    } catch (err) {
      console.error("Failed to delete Visitor Guide Main", err);
    }
  };

  // --- Save Card (Add/Update) ---
  const saveVisitorGuideCard = async () => {
    try {
      const endpoint = editModeCard
        ? "https://inoptics.in/api/update_visitor_guide_card.php"
        : "https://inoptics.in/api/add_visitor_guide_card.php";

      await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: editModeCard ? editingCardId : undefined,
          title: cardTitle,
          description: cardDescription,
        }),
      });

      fetchVisitorGuideCards();
      setShowCardModal(false);
      setEditModeCard(false);
      setCardTitle("");
      setCardDescription("");
    } catch (err) {
      console.error("Failed to save Visitor Guide Card", err);
    }
  };

  // --- Delete Card ---
  const deleteVisitorGuideCard = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this card?",
    );
    if (!confirmDelete) return;

    try {
      await fetch("https://inoptics.in/api/delete_visitor_guide_card.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      setVisitorCards(visitorCards.filter((c) => c.id !== id));
    } catch (err) {
      console.error("Failed to delete Visitor Guide Card", err);
    }
  };

  // --- Handle Edit Main ---
  const handleEditMain = (main) => {
    setEditModeMain(true);
    setMainHeader(main.header);
    setMainText(main.text);
    setShowMainModal(true);
  };

  // --- Handle Edit Card ---
  const [editingCardId, setEditingCardId] = useState(null);

  const handleEditCard = (card) => {
    setEditModeCard(true);
    setEditingCardId(card.id);
    setCardTitle(card.title);
    setCardDescription(card.description);
    setShowCardModal(true);
  };

  // --- Fetch Reach Main ---
  const fetchReachMain = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/get_reach_main.php");
      const data = await res.json();
      setReachMain(data || {});
    } catch (err) {
      console.error("Failed to fetch Reach Main", err);
    }
  };

  // --- Fetch Reach Cards ---
  const fetchReachCards = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/get_reach_cards.php");
      const data = await res.json();
      setReachCards(data || []);
    } catch (err) {
      console.error("Failed to fetch Reach Cards", err);
    }
  };

  // --- Save Reach Main (Add/Update) ---
  const saveReachMain = async () => {
    try {
      const endpoint = reachMain.id
        ? "https://inoptics.in/api/update_reach_main.php"
        : "https://inoptics.in/api/add_reach_main.php";

      await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: reachMain.id,
          title: reachTitle,
          text: reachText,
        }),
      });

      fetchReachMain();
      setShowReachMainModal(false);
      setEditModeReachMain(false);
    } catch (err) {
      console.error("Failed to save Reach Main", err);
    }
  };

  // --- Delete Reach Main ---
  const deleteReachMain = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete Reach Main?",
    );
    if (!confirmDelete) return;

    try {
      await fetch("https://inoptics.in/api/delete_reach_main.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      setReachMain({});
    } catch (err) {
      console.error("Failed to delete Reach Main", err);
    }
  };

  // --- Save Reach Card (Add/Update) ---
  const saveReachCard = async () => {
    try {
      const endpoint = editModeReachCard
        ? "https://inoptics.in/api/update_reach_card.php"
        : "https://inoptics.in/api/add_reach_card.php";

      const formData = new FormData();
      formData.append("description", reachDescription);
      formData.append("position", reachPosition); // ✅ add position

      if (selectedFile) {
        formData.append("image", selectedFile);
      }

      if (editModeReachCard && editingReachCardId) {
        formData.append("id", editingReachCardId);
      }

      await fetch(endpoint, {
        method: "POST",
        body: formData,
      });

      fetchReachCards();
      setShowReachCardModal(false);
      setEditModeReachCard(false);
      setReachDescription("");
      setReachImage("");
      setSelectedFile(null);
      setReachPosition("Right"); // reset
    } catch (err) {
      console.error("Failed to save Reach Card", err);
    }
  };

  // --- Delete Reach Card ---
  const deleteReachCard = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this Reach Card?",
    );
    if (!confirmDelete) return;

    try {
      await fetch("https://inoptics.in/api/delete_reach_card.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      setReachCards(reachCards.filter((c) => c.id !== id));
    } catch (err) {
      console.error("Failed to delete Reach Card", err);
    }
  };

  // --- Handle Edit Reach Main ---
  const handleEditReachMain = (main) => {
    setEditModeReachMain(true);
    setReachTitle(main.title);
    setReachText(main.text);
    setShowReachMainModal(true);
  };

  // --- Handle Edit Reach Card ---
  const [editingReachCardId, setEditingReachCardId] = useState(null);

  const handleEditReachCard = (card) => {
    setEditModeReachCard(true);
    setEditingReachCardId(card.id);
    setReachDescription(card.description);
    setReachImage(card.image);
    setReachPosition(card.position || "Right"); // ✅ load position if exists
    setShowReachCardModal(true);
  };

  const fetchMetroMaps = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_visitor_metro_map.php",
      );
      const data = await res.json();
      setMetroMaps(data || []);
    } catch (err) {
      console.error("Failed to fetch Visitor Metro Map", err);
    }
  };

  const saveMetroMap = async () => {
    try {
      const endpoint = editModeMetro
        ? "https://inoptics.in/api/update_visitor_metro_map.php"
        : "https://inoptics.in/api/add_visitor_metro_map.php";

      const formData = new FormData();
      formData.append("description", metroDescription);

      if (selectedFile) {
        formData.append("image", selectedFile);
      }

      if (editModeMetro && editingMetroId) {
        formData.append("id", editingMetroId);
      }

      await fetch(endpoint, {
        method: "POST",
        body: formData,
      });

      fetchMetroMaps();
      setShowMetroModal(false);
      setEditModeMetro(false);
      setMetroDescription("");
      setMetroImage("");
      setSelectedFile(null);
    } catch (err) {
      console.error("Failed to save Metro Map", err);
    }
  };

  const deleteMetroMap = async (id) => {
    if (!window.confirm("Are you sure you want to delete this Metro Map?"))
      return;

    try {
      await fetch("https://inoptics.in/api/delete_visitor_metro_map.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      setMetroMaps(metroMaps.filter((m) => m.id !== id));
    } catch (err) {
      console.error("Failed to delete Metro Map", err);
    }
  };

  const handleEditMetro = (map) => {
    setEditModeMetro(true);
    setEditingMetroId(map.id);
    setMetroDescription(map.description);
    setMetroImage(map.image);
    setShowMetroModal(true);
  };

  // --- Fetch Data on Mount ---
  useEffect(() => {
    if (activeWebsiteNavbarItem === "For Exhibitors") {
      fetchExhibitorsMain();
      fetchExhibitorsCards();
    }
  }, [activeWebsiteNavbarItem]);

  // --- Fetch Main ---
  const fetchExhibitorsMain = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_exhibitors_main.php",
      );
      const data = await res.json();
      setExhibitorsMain(data || {});
    } catch (err) {
      console.error("Failed to fetch Exhibitors Main", err);
    }
  };

  // --- Fetch Cards ---
  const fetchExhibitorsCards = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_exhibitors_cards.php",
      );
      const data = await res.json();
      setExhibitorsCards(data || []);
    } catch (err) {
      console.error("Failed to fetch Exhibitors Cards", err);
    }
  };

  // --- Save Main (Add/Update) ---
  const saveExhibitorsMain = async () => {
    try {
      const endpoint = exhibitorsMain.id
        ? "https://inoptics.in/api/update_exhibitors_main.php"
        : "https://inoptics.in/api/add_exhibitors_main.php";

      await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: exhibitorsMain.id,
          header: exhibitorsHeader,
          text: exhibitorsText,
        }),
      });

      fetchExhibitorsMain();
      setShowMainModal(false);
      setEditModeExhibitorsMain(false);
    } catch (err) {
      console.error("Failed to save Exhibitors Main", err);
    }
  };

  // --- Delete Main ---
  const deleteExhibitorsMain = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete Exhibitors Main?",
    );
    if (!confirmDelete) return;

    try {
      await fetch("https://inoptics.in/api/delete_exhibitors_main.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      setExhibitorsMain({});
    } catch (err) {
      console.error("Failed to delete Exhibitors Main", err);
    }
  };

  // --- Save Card (Add/Update) ---
  const saveExhibitorsCard = async () => {
    try {
      const endpoint = editModeExhibitorsCard
        ? "https://inoptics.in/api/update_exhibitors_card.php"
        : "https://inoptics.in/api/add_exhibitors_card.php";

      await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: editModeExhibitorsCard ? editingExhibitorsCardId : undefined,
          title: exhibitorsCardTitle,
          description: exhibitorsCardDescription,
        }),
      });

      fetchExhibitorsCards();
      setShowCardModal(false);
      setEditModeExhibitorsCard(false);
      setExhibitorsCardTitle("");
      setExhibitorsCardDescription("");
    } catch (err) {
      console.error("Failed to save Exhibitors Card", err);
    }
  };

  // --- Delete Card ---
  const deleteExhibitorsCard = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this Exhibitors card?",
    );
    if (!confirmDelete) return;

    try {
      await fetch("https://inoptics.in/api/delete_exhibitors_card.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      setExhibitorsCards(exhibitorsCards.filter((c) => c.id !== id));
    } catch (err) {
      console.error("Failed to delete Exhibitors Card", err);
    }
  };

  // --- Handle Edit Main ---
  const handleEditExhibitorsMain = (main) => {
    setEditModeExhibitorsMain(true);
    setExhibitorsHeader(main.header);
    setExhibitorsText(main.text);
    setShowMainModal(true);
  };

  // --- Handle Edit Card ---
  const handleEditExhibitorsCard = (card) => {
    setEditModeExhibitorsCard(true);
    setEditingExhibitorsCardId(card.id);
    setExhibitorsCardTitle(card.title);
    setExhibitorsCardDescription(card.description);
    setShowCardModal(true);
  };

  useEffect(() => {
    fetchAboutUsData();
    fetchOurVisionData();
  }, []);

  const fetchAboutUsData = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/get_about_us.php");
      const data = await res.json();
      setAboutUsData(data || []);
    } catch (err) {
      console.error("Failed to fetch About Us data", err);
    }
  };

  const fetchOurVisionData = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/get_our_vision.php");
      const data = await res.json();
      setOurVisionData(data || []);
    } catch (err) {
      console.error("Failed to fetch Our Vision data", err);
    }
  };

  const handleEditItem = (item, type) => {
    setEditMode(true);
    setEditingId(item.id);
    setTitle(item.title);
    setDescription(item.description);

    if (type === "about") setShowAboutModal(true);
    else setShowVisionModal(true);
  };

  const saveItem = async (type) => {
    const endpoint = editMode
      ? type === "about"
        ? "https://inoptics.in/api/update_about_us.php"
        : "https://inoptics.in/api/update_our_vision.php"
      : type === "about"
        ? "https://inoptics.in/api/add_about_us.php"
        : "https://inoptics.in/api/add_our_vision.php";

    await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: editingId,
        title,
        description,
      }),
    });

    type === "about" ? fetchAboutUsData() : fetchOurVisionData();
    setShowAboutModal(false);
    setShowVisionModal(false);
    setEditMode(false);
    setTitle("");
    setDescription("");
  };

  const deleteItem = async (id, type) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;

    const endpoint =
      type === "about"
        ? "https://inoptics.in/api/delete_about_us.php"
        : "https://inoptics.in/api/delete_our_vision.php";

    await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    type === "about"
      ? setAboutUsData(aboutUsData.filter((i) => i.id !== id))
      : setOurVisionData(ourVisionData.filter((i) => i.id !== id));
  };

  // --- Fetch data on mount ---
  useEffect(() => {
    fetchPoweringFutureBecomeAnExhibitor();
    fetchWhyExhibitBecomeAnExhibitor();
  }, []);

  // --- Fetch Powering Future data ---
  const fetchPoweringFutureBecomeAnExhibitor = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_powering_future_become_an_exhibitor.php",
      );
      const data = await res.json();
      setPoweringFutureBecomeAnExhibitor(data || []);
    } catch (err) {
      console.error("Failed to fetch Powering Future data", err);
    }
  };

  // --- Fetch Why Exhibit data ---
  const fetchWhyExhibitBecomeAnExhibitor = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_why_exhibit_become_an_exhibitor.php",
      );
      const data = await res.json();
      setWhyExhibitBecomeAnExhibitor(data || []);
    } catch (err) {
      console.error("Failed to fetch Why Exhibit data", err);
    }
  };

  // --- Handle Edit ---
  const handleEditBecomeAnExhibitorItem = (item, type) => {
    setEditMode(true);
    setEditingId(item.id);
    setTitle(item.title);
    setDescription(item.description);

    if (type === "poweringFuture")
      setShowPoweringFutureBecomeAnExhibitorModal(true);
    else setShowWhyExhibitBecomeAnExhibitorModal(true);
  };

  // --- Save Item ---
  const saveBecomeAnExhibitorItem = async (type) => {
    const endpoint = editMode
      ? type === "poweringFuture"
        ? "https://inoptics.in/api/update_powering_future_become_an_exhibitor.php"
        : "https://inoptics.in/api/update_why_exhibit_become_an_exhibitor.php"
      : type === "poweringFuture"
        ? "https://inoptics.in/api/add_powering_future_become_an_exhibitor.php"
        : "https://inoptics.in/api/add_why_exhibit_become_an_exhibitor.php";

    await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: editingId, title, description }),
    });

    type === "poweringFuture"
      ? fetchPoweringFutureBecomeAnExhibitor()
      : fetchWhyExhibitBecomeAnExhibitor();

    setShowPoweringFutureBecomeAnExhibitorModal(false);
    setShowWhyExhibitBecomeAnExhibitorModal(false);
    setEditMode(false);
    setTitle("");
    setDescription("");
  };

  // --- Delete Item ---
  const deleteBecomeAnExhibitorItem = async (id, type) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;

    const endpoint =
      type === "poweringFuture"
        ? "https://inoptics.in/api/delete_powering_future_become_an_exhibitor.php"
        : "https://inoptics.in/api/delete_why_exhibit_become_an_exhibitor.php";

    await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    type === "poweringFuture"
      ? setPoweringFutureBecomeAnExhibitor(
          PoweringFutureBecomeAnExhibitor.filter((i) => i.id !== id),
        )
      : setWhyExhibitBecomeAnExhibitor(
          WhyExhibitBecomeAnExhibitor.filter((i) => i.id !== id),
        );
  };

  // ================= Exhibitor Login API Calls =================
  useEffect(() => {
    fetchExhibitorLoginDetails();
  }, []);

  const fetchExhibitorLoginDetails = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_exhibitor_login.php",
      );
      const data = await res.json();
      setExhibitorLoginDetails(data || []);
    } catch (err) {
      console.error("Failed to fetch Exhibitor Login details", err);
    }
  };

  const addExhibitorLoginDetail = async () => {
    await fetch("https://inoptics.in/api/add_exhibitor_login.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        description: exhibitorLoginDescription,
      }),
    });
    fetchExhibitorLoginDetails();
  };

  const updateExhibitorLoginDetail = async () => {
    await fetch("https://inoptics.in/api/update_exhibitor_login.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: editingExhibitorLoginId,
        description: exhibitorLoginDescription,
      }),
    });
    fetchExhibitorLoginDetails();
  };

  const deleteExhibitorLogin = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;

    await fetch("https://inoptics.in/api/delete_exhibitor_login.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    setExhibitorLoginDetails(exhibitorLoginDetails.filter((i) => i.id !== id));
  };

  // ===== Handlers =====
  const handleAddExhibitorLogin = () => {
    setExhibitorLoginEditMode(false);
    setEditingExhibitorLoginId(null);
    setExhibitorLoginDescription("");
    setShowExhibitorLoginModal(true);
  };

  const handleEditExhibitorLogin = (item) => {
    setExhibitorLoginEditMode(true);
    setEditingExhibitorLoginId(item.id);
    setExhibitorLoginDescription(item.description);
    setShowExhibitorLoginModal(true);
  };

  const saveExhibitorLoginDetails = async () => {
    if (exhibitorLoginEditMode) {
      await updateExhibitorLoginDetail();
    } else {
      await addExhibitorLoginDetail();
    }

    setExhibitorLoginEditMode(false);
    setEditingExhibitorLoginId(null);
    setExhibitorLoginDescription("");
    setShowExhibitorLoginModal(false);
  };

  // ================= Furniture Vendor API Calls =================
  useEffect(() => {
    fetchFurnitureVendorDetails();
  }, []);

  const fetchFurnitureVendorDetails = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_furniture_vendor.php",
      );

      const data = await res.json();
      console.log("Admin Furniture API Response:", data);

      if (data.success && Array.isArray(data.data)) {
        setFurnitureVendorDetails(data.data); // ✅ only array
      } else {
        setFurnitureVendorDetails([]); // fallback
      }
    } catch (err) {
      console.error("Failed to fetch Furniture Vendor details", err);
      setFurnitureVendorDetails([]);
    }
  };

  const addFurnitureVendorDetail = async () => {
    await fetch("https://inoptics.in/api/add_furniture_vendor.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        description: furnitureVendorDescription,
      }),
    });
    fetchFurnitureVendorDetails();
  };

  const updateFurnitureVendorDetail = async () => {
    await fetch("https://inoptics.in/api/update_furniture_vendor.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: editingFurnitureVendorId,
        description: furnitureVendorDescription,
      }),
    });
    fetchFurnitureVendorDetails();
  };

  const deleteFurnitureVendor = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;

    await fetch("https://inoptics.in/api/delete_furniture_vendor.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    setFurnitureVendorDetails(
      furnitureVendorDetails.filter((i) => i.id !== id),
    );
  };

  // ===== Handlers =====
  const handleAddFurnitureVendor = () => {
    setFurnitureVendorEditMode(false);
    setEditingFurnitureVendorId(null);
    setFurnitureVendorDescription("");
    setShowFurnitureVendorModal(true);
  };

  const handleEditFurnitureVendor = (item) => {
    setFurnitureVendorEditMode(true);
    setEditingFurnitureVendorId(item.id);
    setFurnitureVendorDescription(item.description);
    setShowFurnitureVendorModal(true);
  };

  const saveFurnitureVendorDetails = async () => {
    if (!furnitureVendorDescription.trim()) {
      alert("Please enter a description");
      return;
    }

    if (furnitureVendorEditMode) {
      await updateFurnitureVendorDetail();
    } else {
      await addFurnitureVendorDetail();
    }

    setFurnitureVendorEditMode(false);
    setEditingFurnitureVendorId(null);
    setFurnitureVendorDescription("");
    setShowFurnitureVendorModal(false);
  };

  useEffect(() => {
    fetchWhyExhibitData();
    fetchWhyExhibitImageData();
  }, []);

  const fetchWhyExhibitData = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/get_why_exhibit.php");
      const data = await res.json();
      setWhyExhibitData(data || []);
    } catch (err) {
      console.error("Failed to fetch Why Exhibit data", err);
    }
  };

  const fetchWhyExhibitImageData = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_why_exhibit_image.php",
      );
      const data = await res.json();
      setWhyExhibitImageData(data || []);
    } catch (err) {
      console.error("Failed to fetch Why Exhibit image data", err);
    }
  };

  const saveWhyExhibitItem = async () => {
    const endpoint = editModeWhyExhibit
      ? "https://inoptics.in/api/update_why_exhibit.php"
      : "https://inoptics.in/api/add_why_exhibit.php";

    await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: editingWhyExhibitId,
        title: exhibitTitle,
        text: exhibitText,
      }),
    });

    fetchWhyExhibitData();
    setShowWhyExhibitModal(false);
    setEditModeWhyExhibit(false);
    setExhibitTitle("");
    setExhibitText("");
  };

  const saveWhyExhibitImage = async () => {
    const formData = new FormData();
    formData.append("id", editingWhyExhibitId);
    formData.append("image", exhibitImage);

    const endpoint = editModeWhyExhibit
      ? "https://inoptics.in/api/update_why_exhibit_image.php"
      : "https://inoptics.in/api/add_why_exhibit_image.php";

    await fetch(endpoint, {
      method: "POST",
      body: formData,
    });

    fetchWhyExhibitImageData();
    setShowWhyExhibitImageModal(false);
    setExhibitImage(null);
  };

  const deleteWhyExhibit = async (id) => {
    if (
      !window.confirm("Are you sure you want to delete this Why Exhibit item?")
    )
      return;

    await fetch("https://inoptics.in/api/delete_why_exhibit.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    setWhyExhibitData(whyExhibitData.filter((i) => i.id !== id));
  };

  const deleteWhyExhibitImage = async (id) => {
    if (!window.confirm("Are you sure you want to delete this image?")) return;

    await fetch("https://inoptics.in/api/delete_why_exhibit_image.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    setWhyExhibitImageData(whyExhibitImageData.filter((i) => i.id !== id));
  };

  // Fetch PDFs
  const fetchWhyExhibitPdfs = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/get_whyexhibit_pdf.php");
      const data = await res.json();
      setWhyExhibitPdfData(data || []);
    } catch (err) {
      console.error("Failed to fetch PDFs", err);
    }
  };

  // Save/Add PDF
  const saveWhyExhibitPdf = async () => {
    const formData = new FormData();
    formData.append("title", exhibitPdfTitle);
    if (exhibitPdfFile) formData.append("pdf_file", exhibitPdfFile);
    if (editModeWhyExhibitPdf) formData.append("id", editingWhyExhibitPdfId);

    await fetch(
      `https://inoptics.in/api/${
        editModeWhyExhibitPdf
          ? "update_whyexhibit_pdf.php"
          : "add_whyexhibit_pdf.php"
      }`,
      {
        method: "POST",
        body: formData,
      },
    );

    setShowWhyExhibitPdfModal(false);
    fetchWhyExhibitPdfs();
  };

  // Delete PDF
  const deleteWhyExhibitPdf = async (id) => {
    if (!window.confirm("Are you sure you want to delete this PDF?")) return;

    await fetch("https://inoptics.in/api/delete_whyexhibit_pdf.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    setWhyExhibitPdfData(whyExhibitPdfData.filter((i) => i.id !== id));
  };

  useEffect(() => {
    fetchFounderSectionData();
  }, []);

  // ==== Fetch Founder Section ====
  const fetchFounderSectionData = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_founder_section.php",
      );
      const data = await res.json();
      setFounderSectionData(data || []);
    } catch (err) {
      console.error("Failed to fetch Founder Section data", err);
    }
  };

  // ==== Edit Founder Section ====
  const handleEditFounder = (item) => {
    setFounderEditMode(true);
    setEditingFounderId(item.id);
    setFounderHeading(item.heading);
    setFounderDescription(item.description);
    setFounderImagePreview(item.image_url); // show current image
    setShowFounderSectionModal(true);
  };

  // ==== Save Founder Section ====
  const saveFounderSection = async () => {
    const formData = new FormData();
    formData.append("heading", founderHeading);
    formData.append("description", founderDescription);
    if (founderImage) formData.append("image", founderImage);
    if (founderEditMode) formData.append("id", editingFounderId);

    const endpoint = founderEditMode
      ? "https://inoptics.in/api/update_founder_section.php"
      : "https://inoptics.in/api/add_founder_section.php";

    await fetch(endpoint, {
      method: "POST",
      body: formData,
    });

    fetchFounderSectionData();
    setShowFounderSectionModal(false);
    setFounderEditMode(false);
    setFounderHeading("");
    setFounderDescription("");
    setFounderImage(null);
    setFounderImagePreview(null);
  };

  // ==== Delete Founder Section ====
  const deleteFounder = async (id) => {
    if (
      !window.confirm("Are you sure you want to delete this founder section?")
    )
      return;

    await fetch("https://inoptics.in/api/delete_founder_section.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    setFounderSectionData(founderSectionData.filter((i) => i.id !== id));
  };

  useEffect(() => {
    fetchOurStoryData();
  }, []);

  // ==== Fetch Our Story ====
  const fetchOurStoryData = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/get_our_story.php");
      const data = await res.json();
      setOurStoryData(data || []);
    } catch (err) {
      console.error("Failed to fetch Our Story data", err);
    }
  };

  // ==== Edit Story ====
  const handleEditStory = (item) => {
    setStoryEditMode(true);
    setEditingStoryId(item.id);
    setStoryTitle(item.title);
    setStoryDescription(item.description);
    setShowOurStoryModal(true);
  };

  // ==== Save Story ====
  const saveStory = async () => {
    const endpoint = storyEditMode
      ? "https://inoptics.in/api/update_our_story.php"
      : "https://inoptics.in/api/add_our_story.php";

    await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: editingStoryId,
        title: storyTitle,
        description: storyDescription,
      }),
    });

    fetchOurStoryData();
    setShowOurStoryModal(false);
    setStoryEditMode(false);
    setStoryTitle("");
    setStoryDescription("");
  };

  // ==== Delete Story ====
  const deleteStory = async (id) => {
    if (!window.confirm("Are you sure you want to delete this story?")) return;

    await fetch("https://inoptics.in/api/delete_our_story.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    setOurStoryData(ourStoryData.filter((i) => i.id !== id));
  };

  // ==== Fetch Footer Data ====
  useEffect(() => {
    fetchFooterDetails1();
    fetchFooterDetails2();
    fetchFooterDetails3();
    fetchFooterDetails4();
  }, []);

  // ====== FOOTER DETAILS 1 API CALLS ======
  const fetchFooterDetails1 = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_footer_details1.php",
      );
      const data = await res.json();
      setFooterDetails1(data || []);
    } catch (err) {
      console.error("Failed to fetch Footer Details 1", err);
    }
  };

  const addFooterDetails1 = async () => {
    const formData = new FormData();
    if (selectedFile) {
      formData.append("image", selectedFile); // actual file
    }
    formData.append("description", footerDescription);

    await fetch("https://inoptics.in/api/add_footer_details1.php", {
      method: "POST",
      body: formData, // 🚀 don't set Content-Type, browser will set automatically
    });

    fetchFooterDetails1();
  };

  const updateFooterDetails1 = async () => {
    const formData = new FormData();
    formData.append("id", editingFooterId);
    if (selectedFile) {
      formData.append("image", selectedFile); // only append if new file chosen
    }
    formData.append("description", footerDescription);

    await fetch("https://inoptics.in/api/update_footer_details1.php", {
      method: "POST",
      body: formData,
    });

    fetchFooterDetails1();
  };

  const deleteFooterDetails1 = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;

    await fetch("https://inoptics.in/api/delete_footer_details1.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    setFooterDetails1(footerDetails1.filter((i) => i.id !== id));
  };

  // ====== HANDLERS ======
  const handleAddFooter1 = () => {
    setFooterEditMode(false);
    setEditingFooterId(null);
    setFooterImage("");
    setFooterDescription("");
    setShowFooterDetails1Modal(true);
  };

  const handleEditFooter1 = (item) => {
    setFooterEditMode(true);
    setEditingFooterId(item.id);
    setFooterImage(item.image);
    setFooterDescription(item.description);
    setShowFooterDetails1Modal(true);
  };

  const saveFooterDetails1 = async () => {
    if (footerEditMode) {
      await updateFooterDetails1();
    } else {
      await addFooterDetails1();
    }

    // reset modal + states
    setFooterEditMode(false);
    setEditingFooterId(null);
    setFooterImage("");
    setFooterDescription("");
    setShowFooterDetails1Modal(false);
  };
  // ====== FETCH FOOTER DETAILS 2 ======
  const fetchFooterDetails2 = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_footer_details2.php",
      );
      const data = await res.json();
      setFooterDetails2(data || []);
    } catch (err) {
      console.error("Failed to fetch Footer Details 2", err);
    }
  };

  // ====== ADD / UPDATE / DELETE FOOTER DETAILS 2 ======
  const addFooterDetails2 = async () => {
    await fetch("https://inoptics.in/api/add_footer_details2.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        title: footerTitle,
        description: footerDescription2,
      }),
    });
    fetchFooterDetails2();
  };

  const updateFooterDetails2 = async () => {
    await fetch("https://inoptics.in/api/update_footer_details2.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: editingFooter2Id,
        title: footerTitle,
        description: footerDescription2,
      }),
    });
    fetchFooterDetails2();
  };

  const deleteFooterDetails2 = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;

    await fetch("https://inoptics.in/api/delete_footer_details2.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    setFooterDetails2(footerDetails2.filter((i) => i.id !== id));
  };

  // ====== HANDLERS ======
  const handleAddFooter2 = () => {
    setFooterEditMode2(false);
    setEditingFooter2Id(null);
    setFooterTitle("");
    setFooterDescription2("");
    setShowFooterDetails2Modal(true);
  };

  const handleEditFooter2 = (item) => {
    setFooterEditMode2(true);
    setEditingFooter2Id(item.id);
    setFooterTitle(item.title);
    setFooterDescription2(item.description);
    setShowFooterDetails2Modal(true);
  };

  const saveFooterDetails2 = async () => {
    if (footerEditMode2) {
      await updateFooterDetails2();
    } else {
      await addFooterDetails2();
    }

    // reset modal + states
    setFooterEditMode2(false);
    setEditingFooter2Id(null);
    setFooterTitle("");
    setFooterDescription2("");
    setShowFooterDetails2Modal(false);
  };

  // ====== FOOTER DETAILS 3 API CALLS ======
  const fetchFooterDetails3 = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_footer_details3.php",
      );
      const data = await res.json();
      setFooterDetails3(data || []);
    } catch (err) {
      console.error("Failed to fetch Footer Details 3", err);
    }
  };

  // ====== FOOTER DETAILS 4 API CALLS ======
  const fetchFooterDetails4 = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_footer_details4.php",
      );
      const data = await res.json();
      setFooterDetails4(data || []);
    } catch (err) {
      console.error("Failed to fetch Footer Details 4", err);
    }
  };

  // ----- Footer Details 3 -----
  const addFooterDetails3 = async () => {
    await fetch("https://inoptics.in/api/add_footer_details3.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ description: footerDescription3 }),
    });
    fetchFooterDetails3();
  };

  const updateFooterDetails3 = async () => {
    await fetch("https://inoptics.in/api/update_footer_details3.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: editingFooter3Id,
        description: footerDescription3,
      }),
    });
    fetchFooterDetails3();
  };

  const deleteFooterDetails3 = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;

    await fetch("https://inoptics.in/api/delete_footer_details3.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });
    setFooterDetails3(footerDetails3.filter((i) => i.id !== id));
  };

  // ----- Footer Details 4 -----
  const addFooterDetails4 = async () => {
    const formData = new FormData();
    if (selectedFile) formData.append("image", selectedFile);
    formData.append("title", footerTitle4);

    await fetch("https://inoptics.in/api/add_footer_details4.php", {
      method: "POST",
      body: formData,
    });
    fetchFooterDetails4();
  };

  const updateFooterDetails4 = async () => {
    const formData = new FormData();
    formData.append("id", editingFooter4Id);
    formData.append("title", footerTitle4);
    if (selectedFile) formData.append("image", selectedFile);

    await fetch("https://inoptics.in/api/update_footer_details4.php", {
      method: "POST",
      body: formData,
    });
    fetchFooterDetails4();
  };

  const deleteFooterDetails4 = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;

    await fetch("https://inoptics.in/api/delete_footer_details4.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });
    setFooterDetails4(footerDetails4.filter((i) => i.id !== id));
  };
  // Footer 3
  const handleAddFooter3 = () => {
    setFooterEditMode3(false);
    setEditingFooter3Id(null);
    setFooterDescription3("");
    setShowFooterDetails3Modal(true);
  };

  const handleEditFooter3 = (item) => {
    setFooterEditMode3(true);
    setEditingFooter3Id(item.id);
    setFooterDescription3(item.description);
    setShowFooterDetails3Modal(true);
  };

  const saveFooterDetails3 = async () => {
    if (footerEditMode3) await updateFooterDetails3();
    else await addFooterDetails3();

    setFooterEditMode3(false);
    setEditingFooter3Id(null);
    setFooterDescription3("");
    setShowFooterDetails3Modal(false);
  };

  // Footer 4
  const handleAddFooter4 = () => {
    setFooterEditMode4(false);
    setEditingFooter4Id(null);
    setFooterTitle4("");
    setFooterImage4("");
    setShowFooterDetails4Modal(true);
  };

  const handleEditFooter4 = (item) => {
    setFooterEditMode4(true);
    setEditingFooter4Id(item.id);
    setFooterTitle4(item.title);
    setFooterImage4(item.image);
    setShowFooterDetails4Modal(true);
  };

  const saveFooterDetails4 = async () => {
    if (footerEditMode4) await updateFooterDetails4();
    else await addFooterDetails4();

    setFooterEditMode4(false);
    setEditingFooter4Id(null);
    setFooterTitle4("");
    setFooterImage4("");
    setShowFooterDetails4Modal(false);
  };

  useEffect(() => {
    fetchPrivacyDetails();
    fetchTermsDetails();
  }, []);

  // ================= PRIVACY POLICY API CALLS =================
  // ================= PRIVACY POLICY API CALLS =================
  const fetchPrivacyDetails = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_privacy_details.php",
      );
      const data = await res.json();
      setPrivacyDetails(data || []);
    } catch (err) {
      console.error("Failed to fetch Privacy Policy Details", err);
    }
  };

  const addPrivacyDetail = async () => {
    await fetch("https://inoptics.in/api/add_privacy_details.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        description: privacyDescription, // ✅ only description
      }),
    });
    fetchPrivacyDetails();
  };

  const updatePrivacyDetail = async () => {
    await fetch("https://inoptics.in/api/update_privacy_details.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: editingPrivacyId,
        description: privacyDescription, // ✅ only description
      }),
    });
    fetchPrivacyDetails();
  };

  const deletePrivacyDetail = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;

    await fetch("https://inoptics.in/api/delete_privacy_details.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    setPrivacyDetails(privacyDetails.filter((i) => i.id !== id));
  };

  // ===== HANDLERS =====
  const handleAddPrivacy = () => {
    setPrivacyEditMode(false);
    setEditingPrivacyId(null);
    setPrivacyDescription(""); // ✅ no title anymore
    setShowPrivacyModal(true);
  };

  const handleEditPrivacy = (item) => {
    setPrivacyEditMode(true);
    setEditingPrivacyId(item.id);
    setPrivacyDescription(item.description); // ✅ only description
    setShowPrivacyModal(true);
  };

  const savePrivacyDetails = async () => {
    if (privacyEditMode) {
      await updatePrivacyDetail();
    } else {
      await addPrivacyDetail();
    }

    // reset modal + states
    setPrivacyEditMode(false);
    setEditingPrivacyId(null);
    setPrivacyDescription(""); // ✅ clear only description
    setShowPrivacyModal(false);
  };
  // ================= TERMS & CONDITIONS API CALLS =================
  const fetchTermsDetails = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/get_terms_details.php");
      const data = await res.json();
      setTermsDetails(data || []);
    } catch (err) {
      console.error("Failed to fetch Terms & Conditions Details", err);
    }
  };

  const addTermsDetail = async () => {
    await fetch("https://inoptics.in/api/add_terms_details.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        description: termsDescription, // Only description
      }),
    });
    fetchTermsDetails();
  };

  const updateTermsDetail = async () => {
    await fetch("https://inoptics.in/api/update_terms_details.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: editingTermsId,
        description: termsDescription, // Only description
      }),
    });
    fetchTermsDetails();
  };

  const deleteTermsDetail = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;

    await fetch("https://inoptics.in/api/delete_terms_details.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    setTermsDetails(termsDetails.filter((i) => i.id !== id));
  };

  // ===== HANDLERS =====
  const handleAddTerms = () => {
    setTermsEditMode(false);
    setEditingTermsId(null);
    setTermsDescription(""); // Clear only description
    setShowTermsModal(true);
  };

  const handleEditTerms = (item) => {
    setTermsEditMode(true);
    setEditingTermsId(item.id);
    setTermsDescription(item.description); // Only description
    setShowTermsModal(true);
  };

  const saveTermsDetails = async () => {
    if (termsEditMode) {
      await updateTermsDetail();
    } else {
      await addTermsDetail();
    }

    // reset modal + states
    setTermsEditMode(false);
    setEditingTermsId(null);
    setTermsDescription(""); // Reset only description
    setShowTermsModal(false);
  };

  // ================= RULES & POLICY API CALLS =================
  useEffect(() => {
    fetchRulesDetails();
  }, []);

  const fetchRulesDetails = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/get_rules_details.php");
      const data = await res.json();
      setRulesDetails(data || []);
    } catch (err) {
      console.error("Failed to fetch Rules & Policy Details", err);
    }
  };

  const addRulesDetail = async () => {
    await fetch("https://inoptics.in/api/add_rules_details.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        description: rulesDescription, // removed title
      }),
    });
    fetchRulesDetails();
  };

  const updateRulesDetail = async () => {
    await fetch("https://inoptics.in/api/update_rules_details.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: editingRulesId,
        description: rulesDescription, // removed title
      }),
    });
    fetchRulesDetails();
  };

  const deleteRulesDetail = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;

    await fetch("https://inoptics.in/api/delete_rules_details.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    setRulesDetails(rulesDetails.filter((i) => i.id !== id));
  };

  // ===== HANDLERS =====
  const handleAddRules = () => {
    setRulesEditMode(false);
    setEditingRulesId(null);
    setRulesDescription(""); // removed rulesTitle
    setShowRulesModal(true);
  };

  const handleEditRules = (item) => {
    setRulesEditMode(true);
    setEditingRulesId(item.id);
    setRulesDescription(item.description); // removed rulesTitle
    setShowRulesModal(true);
  };

  const saveRulesDetails = async () => {
    if (rulesEditMode) {
      await updateRulesDetail();
    } else {
      await addRulesDetail();
    }

    // reset modal + states
    setRulesEditMode(false);
    setEditingRulesId(null);
    setRulesDescription(""); // removed rulesTitle
    setShowRulesModal(false);
  };

  // ================= PRESS RELEASE API CALLS =================
  useEffect(() => {
    fetchPressReleaseDetails();
  }, []);

  const fetchPressReleaseDetails = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_pressrelease_details.php",
      );
      const data = await res.json();
      setPressReleaseDetails(data || []);
    } catch (err) {
      console.error("Failed to fetch Press Release Details", err);
    }
  };

  const addPressReleaseDetail = async () => {
    await fetch("https://inoptics.in/api/add_pressrelease_details.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        description: pressReleaseDescription, // removed title
      }),
    });
    fetchPressReleaseDetails();
  };

  const updatePressReleaseDetail = async () => {
    await fetch("https://inoptics.in/api/update_pressrelease_details.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: editingPressReleaseId,
        description: pressReleaseDescription, // removed title
      }),
    });
    fetchPressReleaseDetails();
  };

  const deletePressReleaseDetail = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;

    await fetch("https://inoptics.in/api/delete_pressrelease_details.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    setPressReleaseDetails(pressReleaseDetails.filter((i) => i.id !== id));
  };

  // ===== HANDLERS =====
  const handleAddPressRelease = () => {
    setPressReleaseEditMode(false);
    setEditingPressReleaseId(null);
    setPressReleaseDescription(""); // removed pressReleaseTitle
    setShowPressReleaseModal(true);
  };

  const handleEditPressRelease = (item) => {
    setPressReleaseEditMode(true);
    setEditingPressReleaseId(item.id);
    setPressReleaseDescription(item.description); // removed pressReleaseTitle
    setShowPressReleaseModal(true);
  };

  const savePressReleaseDetails = async () => {
    if (pressReleaseEditMode) {
      await updatePressReleaseDetail();
    } else {
      await addPressReleaseDetail();
    }

    // reset modal + states
    setPressReleaseEditMode(false);
    setEditingPressReleaseId(null);
    setPressReleaseDescription(""); // removed pressReleaseTitle
    setShowPressReleaseModal(false);
  };

  // ================= MEDIA GALLERY API CALLS =================
  useEffect(() => {
    fetchMediaGalleryDetails();
  }, []);

  useEffect(() => {
    if (overlayContent === "Exhibitor Badges") {
      setActiveNavbarItem("EXHIBITOR BADGES");
    }
  }, [overlayContent]);

  // Fetch all Media Gallery entries
  const fetchMediaGalleryDetails = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_mediagallery_details.php",
      );
      const data = await res.json();
      setMediaGalleryDetails(data || []);
    } catch (err) {
      console.error("Failed to fetch Media Gallery Details", err);
    }
  };

  // Add a new Media Gallery entry
  const addMediaGalleryDetail = async () => {
    const formData = new FormData();
    formData.append("heading", mediaGalleryHeading);
    mediaGalleryImages.forEach((img) => {
      formData.append("images[]", img);
    });

    await fetch("https://inoptics.in/api/add_mediagallery_details.php", {
      method: "POST",
      body: formData,
    });

    fetchMediaGalleryDetails();
  };

  // Update existing Media Gallery entry
  const updateMediaGalleryDetail = async () => {
    const formData = new FormData();
    formData.append("id", editingMediaGalleryId);
    formData.append("heading", mediaGalleryHeading);
    mediaGalleryImages.forEach((img) => {
      formData.append("images[]", img);
    });

    await fetch("https://inoptics.in/api/update_mediagallery_details.php", {
      method: "POST",
      body: formData,
    });

    fetchMediaGalleryDetails();
  };

  // Delete Media Gallery entry
  const deleteMediaGalleryDetail = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;

    await fetch("https://inoptics.in/api/delete_mediagallery_details.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    setMediaGalleryDetails(mediaGalleryDetails.filter((i) => i.id !== id));
  };

  // ===== HANDLERS =====
  const handleAddMediaGallery = () => {
    setMediaGalleryEditMode(false);
    setEditingMediaGalleryId(null);
    setMediaGalleryHeading("");
    setMediaGalleryImages([]);
    setShowMediaGalleryModal(true);
  };

  const handleEditMediaGallery = (item) => {
    setMediaGalleryEditMode(true);
    setEditingMediaGalleryId(item.id);
    setMediaGalleryHeading(item.heading);

    // For existing images, create a placeholder object with URL
    const existingImages = [
      {
        name: item.image,
        url: `https://inoptics.in/api/uploads/${item.image}`,
        existing: true,
      },
    ];
    setMediaGalleryImages(existingImages);

    setShowMediaGalleryModal(true);
  };

  // Handle image uploads
  const handleMediaGalleryImageUpload = (e) => {
    const files = Array.from(e.target.files);
    setMediaGalleryImages((prev) => [...prev, ...files]);
  };

  // Remove uploaded image
  const removeMediaGalleryImage = (index) => {
    setMediaGalleryImages((prev) => prev.filter((_, i) => i !== index));
  };

  // Save Media Gallery Details (add or update)
  const saveMediaGalleryDetails = async () => {
    if (mediaGalleryEditMode) {
      await updateMediaGalleryDetail();
    } else {
      await addMediaGalleryDetail();
    }

    // Reset modal + states
    setMediaGalleryEditMode(false);
    setEditingMediaGalleryId(null);
    setMediaGalleryHeading("");
    setMediaGalleryImages([]);
    setShowMediaGalleryModal(false);
  };

  const handleSendRegistrationMail = (email) => {
    if (!email) {
      alert("Please enter contractor email address!");
      return;
    }

    // Replace with your backend API endpoint to send mail
    fetch("https://inoptics.in/api/send-contractor-mail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email,
        file: coreFormData.find((form) =>
          form.category
            ?.toLowerCase()
            .includes("contractor undertaking-declaration & registration"),
        )?.filename,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        alert("Mail sent successfully!");
      })
      .catch((err) => {
        console.error("Error sending mail:", err);
        alert("Failed to send mail.");
      });
  };

  // ================= FLOATING CARD API CALLS =================
  useEffect(() => {
    fetchFloatingCards();
  }, []);

  const fetchFloatingCards = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_floatingcard_details.php",
      );
      const data = await res.json();
      setFloatingCards(data || []);
    } catch (err) {
      console.error("Failed to fetch Floating Card Details", err);
    }
  };

  const addFloatingCard = async () => {
    await fetch("https://inoptics.in/api/add_floatingcard_details.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        description: floatingCardText,
      }),
    });
    fetchFloatingCards();
  };

  const updateFloatingCard = async () => {
    await fetch("https://inoptics.in/api/update_floatingcard_details.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: editingFloatingCardId,
        description: floatingCardText,
      }),
    });
    fetchFloatingCards();
  };

  const deleteFloatingCard = async (id) => {
    if (!window.confirm("Are you sure you want to delete this Floating Card?"))
      return;

    await fetch("https://inoptics.in/api/delete_floatingcard_details.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    setFloatingCards(floatingCards.filter((i) => i.id !== id));
  };

  // ===== HANDLERS =====
  const handleAddFloatingCard = () => {
    setIsEditingFloatingCard(false);
    setEditingFloatingCardId(null);
    setFloatingCardText("");
    setShowFloatingCardModal(true);
  };

  const handleEditFloatingCard = (item) => {
    setIsEditingFloatingCard(true);
    setEditingFloatingCardId(item.id);
    setFloatingCardText(item.description);
    setShowFloatingCardModal(true);
  };

  const saveFloatingCard = async () => {
    if (isEditingFloatingCard) {
      await updateFloatingCard();
    } else {
      await addFloatingCard();
    }

    // reset modal + states
    setIsEditingFloatingCard(false);
    setEditingFloatingCardId(null);
    setFloatingCardText("");
    setShowFloatingCardModal(false);
  };

  const resetFloatingCardModal = () => {
    setIsEditingFloatingCard(false);
    setEditingFloatingCardId(null);
    setFloatingCardText("");
    setShowFloatingCardModal(false);
  };

  // ==== Fetch Data on Mount ====
  useEffect(() => {
    fetchUnsubscribeImages();
    // fetchUnsubscribeTexts();
  }, []);

  // ===== API CALLS: Unsubscribe Images =====
  const fetchUnsubscribeImages = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_unsubscribe_images.php",
      );
      const data = await res.json();
      setUnsubscribeImages(data || []);
    } catch (err) {
      console.error("Failed to fetch Unsubscribe Images", err);
    }
  };

  const addUnsubscribeImage = async () => {
    const formData = new FormData();
    if (selectedUnsubFile) {
      formData.append("image", selectedUnsubFile);
    }

    await fetch("https://inoptics.in/api/add_unsubscribe_image.php", {
      method: "POST",
      body: formData,
    });

    fetchUnsubscribeImages();
  };

  const updateUnsubscribeImage = async () => {
    const formData = new FormData();
    formData.append("id", editingUnsubImageId);
    if (selectedUnsubFile) {
      formData.append("image", selectedUnsubFile);
    }

    await fetch("https://inoptics.in/api/update_unsubscribe_image.php", {
      method: "POST",
      body: formData,
    });

    fetchUnsubscribeImages();
  };

  const deleteUnsubscribeImage = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;

    await fetch("https://inoptics.in/api/delete_unsubscribe_image.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    setUnsubscribeImages(unsubscribeImages.filter((i) => i.id !== id));
  };

  // ===== API CALLS: Unsubscribe Text =====
  // const fetchUnsubscribeTexts = async () => {
  //   try {
  //     const res = await fetch("https://inoptics.in/api/get_unsubscribe_texts.php");
  //     const data = await res.json();
  //     setUnsubscribeTexts(data || []);
  //   } catch (err) {
  //     console.error("Failed to fetch Unsubscribe Texts", err);
  //   }
  // };

  // const addUnsubscribeText = async () => {
  //   await fetch("https://inoptics.in/api/add_unsubscribe_text.php", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({
  //       text: unsubText,
  //       form: unsubForm,
  //     }),
  //   });

  //   fetchUnsubscribeTexts();
  // };

  // const updateUnsubscribeText = async () => {
  //   await fetch("https://inoptics.in/api/update_unsubscribe_text.php", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({
  //       id: editingUnsubTextId,
  //       text: unsubText,
  //       form: unsubForm,
  //     }),
  //   });

  //   fetchUnsubscribeTexts();
  // };

  // const deleteUnsubscribeText = async (id) => {
  //   if (!window.confirm("Are you sure you want to delete this item?")) return;

  //   await fetch("https://inoptics.in/api/delete_unsubscribe_text.php", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({ id }),
  //   });

  //   setUnsubscribeTexts(unsubscribeTexts.filter((i) => i.id !== id));
  // };

  // ==== Handlers for Modals ====
  const handleAddUnsubImage = () => {
    setUnsubEditMode(false);
    setEditingUnsubImageId(null);
    setUnsubImage("");
    setShowUnsubImageModal(true);
  };

  const handleEditUnsubImage = (item) => {
    setUnsubEditMode(true);
    setEditingUnsubImageId(item.id);
    setUnsubImage(item.image);
    setShowUnsubImageModal(true);
  };

  const saveUnsubImage = async () => {
    if (unsubEditMode) {
      await updateUnsubscribeImage();
    } else {
      await addUnsubscribeImage();
    }
    setShowUnsubImageModal(false);
  };

  // const handleAddUnsubText = () => {
  //   setUnsubEditMode2(false);
  //   setEditingUnsubTextId(null);
  //   setUnsubText("");
  //   setUnsubForm("");
  //   setShowUnsubTextModal(true);
  // };

  // const handleEditUnsubText = (item) => {
  //   setUnsubEditMode2(true);
  //   setEditingUnsubTextId(item.id);
  //   setUnsubText(item.text);
  //   setUnsubForm(item.form);
  //   setShowUnsubTextModal(true);
  // };

  // const saveUnsubText = async () => {
  //   if (unsubEditMode2) {
  //     await updateUnsubscribeText();
  //   } else {
  //     await addUnsubscribeText();
  //   }
  //   setShowUnsubTextModal(false);
  // };

  // --- STATES ---
  const [showBasicExport, setShowBasicExport] = useState(false);
  const [showStallExport, setShowStallExport] = useState(false);
  const [showStallPaymentExport, setShowStallPaymentExport] = useState(false);
  const [showPowerPaymentExport, setShowPowerPaymentExport] = useState(false);

  const [showAllExport, setShowAllExport] = useState(false);
  const [selectedFields, setSelectedFields] = useState([]);
  const [currentLabelIndex, setCurrentLabelIndex] = useState(0);

  // --- HANDLE FIELD SELECT ---
  const handleFieldSelect = (field) => {
    setSelectedFields((prev) =>
      prev.includes(field) ? prev.filter((f) => f !== field) : [...prev, field],
    );
  };

  // --- HELPER: DOWNLOAD BLOB AS CSV ---
  const downloadCSV = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  // --- EXPORT BASIC DETAILS ---
  const handleExportSelected = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/fetch_excel_basic_details.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ fields: selectedFields }),
        },
      );

      const text = await res.text();

      // console.log("API RESPONSE:", text);

      if (!text) {
        alert("Server returned empty response.");
        return;
      }

      const result = JSON.parse(text);

      if (!result.success) {
        alert(result.error);
        return;
      }

      const data = result.data;

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Exhibitors");

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

      const blob = new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "Exhibitors_Basic_Details.xlsx");
    } catch (err) {
      console.error(err);
      alert("Export failed. Check console.");
    }
  };

  const handleExportStallSelected = async () => {
    if (!selectedFields.length) return alert("Select at least one field");
    try {
      const res = await fetch(
        "https://inoptics.in/api/fetch_excel_stall_details.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ fields: selectedFields }),
        },
      );
      const data = await res.json();
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Stalls");
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(
        new Blob([wbout], { type: "application/octet-stream" }),
        "Exhibitors_Stall_Details.xlsx",
      );
    } catch (err) {
      console.error(err);
    }
  };

  const handleExportAllSelected = async () => {
    if (!selectedFields.length) return alert("Select at least one field");
    try {
      const res = await fetch(
        "https://inoptics.in/api/fetch_excel_all_details.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ fields: selectedFields }),
        },
      );
      const data = await res.json();
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "AllDetails");
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(
        new Blob([wbout], { type: "application/octet-stream" }),
        "Exhibitors_All_Details.xlsx",
      );
    } catch (err) {
      console.error(err);
    }
  };

  // --- EXPORT STALL PAYMENT DETAILS ---
  const handleExportStallPaymentSelected = async () => {
    if (!selectedFields.length) return alert("Select at least one field");
    try {
      const res = await fetch(
        "https://inoptics.in/api/fetch_excel_stall_payment.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ fields: selectedFields }),
        },
      );
      const data = await res.json();
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "StallPayment");
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(
        new Blob([wbout], { type: "application/octet-stream" }),
        "Exhibitors_Stall_Payment.xlsx",
      );
    } catch (err) {
      console.error("Export failed:", err);
    }
  };

  // --- EXPORT POWER PAYMENT DETAILS ---
  const handleExportPowerPaymentSelected = async () => {
    if (!selectedFields.length) return alert("Select at least one field");
    try {
      const res = await fetch(
        "https://inoptics.in/api/fetch_excel_power_payment.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ fields: selectedFields }),
        },
      );
      const data = await res.json();
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "PowerPayment");
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(
        new Blob([wbout], { type: "application/octet-stream" }),
        "Exhibitors_Power_Payment.xlsx",
      );
    } catch (err) {
      console.error("Export failed:", err);
    }
  };

  const handleLabelPrint = async () => {
    try {
      const res = await fetch("https://inoptics.in/api/fetch_label_data.php", {
        method: "GET",
        headers: { Accept: "application/json" },
      });

      const raw = await res.text();
      if (!raw) {
        alert("Empty response from server.");
        return;
      }

      let data;
      try {
        data = JSON.parse(raw);
      } catch (e) {
        console.error("Non-JSON response:", raw);
        alert("API response JSON nahi hai. Console me response dekho.");
        return;
      }

      // If API returns {success:true,data:[...]} convert to array
      if (data && !Array.isArray(data) && Array.isArray(data.data)) {
        data = data.data;
      }

      if (!Array.isArray(data) || data.length === 0) {
        alert("No label data found.");
        return;
      }

      // Normalize keys (pin/mobile naming issues)
      const normalized = data.map((item) => ({
        name: item.name ?? item.Name ?? "",
        company_name: item.company_name ?? item["Company Name"] ?? "",
        address: item.address ?? item.Address ?? "",
        city: item.city ?? item.City ?? "",
        state: item.state ?? item.State ?? "",
        pincode: item.pincode ?? item.pin ?? item.Pincode ?? "",
        mobile_no: item.mobile_no ?? item.mobile ?? item["Mobile No"] ?? "",
      }));

      const sortedData = [...normalized].sort((a, b) =>
        (a.company_name || "")
          .toLowerCase()
          .localeCompare((b.company_name || "").toLowerCase()),
      );

      const printWindow = window.open("", "_blank");
      if (!printWindow) {
        alert("Popup blocked. Please allow popups for this site.");
        return;
      }

      printWindow.document.write(`
      <html>
        <head>
          <title>Label Print</title>
          <style>
            @page { size: A4; margin: 0; }
            body { margin: 0; padding: 0; font-family: "Segoe UI", Arial, sans-serif; background: white; }
            .page-container {
              width: 20.0cm;
              height: 27.12cm;
              margin: 1.29cm auto;
              display: grid;
              grid-template-columns: repeat(2, 9.91cm);
              grid-auto-rows: 3.39cm;
              column-gap: 0.3cm;
              row-gap: 0;
              box-sizing: border-box;
              justify-content: center;
            }
            .page-container:not(:first-child) { page-break-before: always; padding-top: 1.3cm; }
            .label {
              width: 9.91cm;
              height: 3.39cm;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              font-size: 9pt;
              line-height: 1.1;
              padding: 0.4cm 0.3cm 0cm 0.3cm;
              overflow: hidden;
              page-break-inside: avoid;
            }
            .label-id { font-weight: bold; font-size: 9.4pt; margin-bottom: 2px; text-align: left; text-transform: uppercase; letter-spacing: 0.3px; }
            .kind-attention { font-weight: bold; font-size: 9.4pt; text-transform: uppercase; margin-left: 5px; letter-spacing: 0.3px; }
            .company-name { font-weight: bold; text-transform: uppercase; font-size: 9.4pt; margin-bottom: 2px; text-align: left; }
            .address, .state, .phone { font-weight: bold; text-transform: uppercase; font-size: 9.4pt; letter-spacing: -0.5px; }
            .city-pincode { display: flex; gap: 5px; font-weight: bold; text-transform: uppercase; }
            @media print {
              body { -webkit-print-color-adjust: exact; print-color-adjust: exact; margin: 0 !important; }
              .page-container { margin: 1.29cm auto !important; }
              .page-container:not(:first-child) { padding-top: 1.29cm !important; }
            }
          </style>
        </head>
        <body>
          ${Array.from(
            { length: Math.ceil(sortedData.length / 16) },
            (_, pageIndex) =>
              sortedData.slice(pageIndex * 16, (pageIndex + 1) * 16),
          )
            .map(
              (pageData, pageIndex) => `
            <div class="page-container">
              ${pageData
                .map((item, i) => {
                  const labelId = (pageIndex * 16 + i + 1)
                    .toString()
                    .padStart(3, "0");
                  return `
                  <div class="label">
                    <div class="label-id">
                      (${labelId})
                      <span class="kind-attention">ATTN: ${item.name || ""}</span>
                    </div>
                    <div class="company-name">M/S ${item.company_name || ""}</div>
                    <div class="address">${item.address || ""}</div>
                    <div class="city-pincode">
                      <span>${item.city || ""}</span>
                      <span>${item.pincode || ""}</span>
                    </div>
                    <div class="state">${item.state || ""}</div>
                    <div class="phone">MOBILE : ${item.mobile_no || ""}</div>
                  </div>
                `;
                })
                .join("")}
            </div>
          `,
            )
            .join("")}
        </body>
      </html>
    `);

      printWindow.document.close();

      // Ensure content is rendered before print (important)
      printWindow.onload = () => {
        printWindow.focus();
        printWindow.print();
      };
    } catch (error) {
      console.error("Label print failed:", error);
      alert("Label print failed. Console check karo.");
    }
  };

  const labelBoxRef = useRef(null);

  useEffect(() => {
    if (!showBasicExport) return;

    let cancelled = false;

    (async () => {
      try {
        const res = await fetch(
          "https://inoptics.in/api/fetch_label_data.php",
          {
            method: "GET",
            headers: { Accept: "application/json" },
          },
        );

        const result = await res.json();

        // handle both shapes:
        const arr = Array.isArray(result)
          ? result
          : Array.isArray(result?.data)
            ? result.data
            : [];

        const sortedData = [...arr].sort((a, b) =>
          (a?.company_name || "")
            .toLowerCase()
            .localeCompare((b?.company_name || "").toLowerCase()),
        );

        if (!cancelled) {
          setLabelData(sortedData);
          setCurrentLabelIndex(0); // important for preview navigation
        }
      } catch (err) {
        console.error("Failed to fetch label data:", err);
        if (!cancelled) setLabelData([]);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [showBasicExport]);

  const handleNextLabel = () => {
    setCurrentLabelIndex((prev) =>
      prev < labelData.length - 1 ? prev + 1 : prev,
    );
  };

  const handlePrevLabel = () => {
    setCurrentLabelIndex((prev) => (prev > 0 ? prev - 1 : prev));
  };

  // 🔹 Automatically adjust font size to fit inside the label
  useEffect(() => {
    const box = labelBoxRef.current;
    if (!box) return;

    // Reset to normal font size first
    box.style.fontSize = "13px";

    // Shrink only if overflow occurs
    while (box.scrollHeight > box.clientHeight) {
      const currentSize = parseFloat(window.getComputedStyle(box).fontSize);
      if (currentSize <= 8) break; // don’t go smaller than 8px
      box.style.fontSize = `${currentSize - 0.5}px`;
    }
  }, [currentLabelIndex, labelData]);

  // exhibitor unlock request contractor from
  const [unlockRequests, setUnlockRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(null);

  useEffect(() => {
    fetchUnlockRequests();
  }, []);

  const fetchUnlockRequests = async () => {
    setLoading(true);
    try {
      const res = await fetch(
        "https://inoptics.in/api/admin_unlock_requests.php",
      );
      const data = await res.json();

      if (Array.isArray(data)) {
        setUnlockRequests(data);
      } else {
        setUnlockRequests(data.data || []);
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const handleUnlock = async (company) => {
    const confirm = window.confirm(`Unlock contractor form for ${company}?`);

    if (!confirm) return;

    setProcessing(company);

    try {
      const res = await fetch(
        "https://inoptics.in/api/admin_unlock_contractor.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ exhibitor_company: company }),
        },
      );

      const text = await res.text();
      const data = JSON.parse(text);

      if (data.success) {
        toast.success("Contractor form unlocked successfully!");

        // 🔥 Remove request from admin list immediately
        setUnlockRequests((prev) =>
          prev.filter((item) => item.exhibitor_company !== company),
        );
      } else {
        toast.error("Unlock failed");
      }
    } catch (err) {
      console.error(err);
      toast.error("Server error while unlocking");
    }

    setProcessing(null);
  };

  const fetchUploadedForms = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_all_uploaded_exhibitor_forms.php",
      );
      const json = await res.json();

      console.log("Forms API raw:", json);

      if (!json.success || !Array.isArray(json.data)) {
        console.warn("No forms data");
        return;
      }

      const map = {};

      json.data.forEach((row) => {
        const company = row.exhibitor_company_name;

        if (!map[company]) {
          map[company] = [];
        }

        // ⭐⭐⭐ MAIN FIX HERE
        map[company].push({
          file_name: row.file_name,
          file_path: row.file_path,
          booth_design: row.booth_design || "", // ✅ ADD THIS
        });
      });

      console.log("Forms Map:", map); // now booth_design must appear

      setFormsMap(map);
    } catch (error) {
      console.error("Forms fetch failed", error);
    }
  };

  useEffect(() => {
    fetchUploadedForms();
  }, []);

  useEffect(() => {
    fetchAllFinalSelections();
    fetchUploadedForms();
  }, []);

  const approveBooth = async (company) => {
    if (!company) {
      alert("Company name missing");
      return;
    }

    console.log("APPROVE CLICKED FOR:", company);

    try {
      const res = await fetch(
        "https://inoptics.in/api/approve_booth_design.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ company }),
        },
      );

      const text = await res.text();
      console.log("RAW RESPONSE:", text);

      if (!text) {
        alert("Empty response from server");
        return;
      }

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        alert("Invalid JSON from server:\n" + text);
        return;
      }

      if (data.success) {
        alert("✅ Booth Design Approved");
      } else {
        alert("❌ Not updated: " + (data.message || "No row matched"));
      }
    } catch (err) {
      console.error("Approve error:", err);
      alert("Network / server error");
    }
  };

  const rejectBooth = async (company) => {
    if (!company) {
      alert("Company name missing");
      return;
    }

    console.log("REJECT CLICKED FOR:", company);

    try {
      const res = await fetch(
        "https://inoptics.in/api/reject_booth_design.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ company }),
        },
      );

      const text = await res.text();
      console.log("RAW RESPONSE:", text);

      if (!text) {
        alert("Empty response from server");
        return;
      }

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        alert("Invalid JSON from server:\n" + text);
        return;
      }

      if (data.success) {
        alert("❌ Booth Design Rejected");
      } else {
        alert("Failed: " + (data.message || "No row matched"));
      }
    } catch (err) {
      console.error("Reject error:", err);
      alert("Network / server error");
    }
  };

  const buildCompanyRows = (data) => {
    const map = {};

    data.forEach((row) => {
      const name = row.company_name;

      if (!map[name]) {
        map[name] = {
          ...row,
          stall: Number(row.stall || 0),
          power: Number(row.power || 0),
          exhibitorBadgesTotal: Number(row.exhibitorBadgesTotal || 0),
          stallPaid: 0,
          powerPaid: 0,
          badgePaid: 0,
          paid_total: 0,
          stallPaymentsSeen: false,
          powerPaymentsSeen: false,
          badgePaymentsSeen: false,
        };
      }

      // ✅ Add each payment type only once
      if (row.stall_payments && !map[name].stallPaymentsSeen) {
        row.stall_payments.split(",").forEach((v) => {
          map[name].stallPaid += Number(v || 0);
        });
        map[name].stallPaymentsSeen = true;
      }

      if (row.power_payments && !map[name].powerPaymentsSeen) {
        row.power_payments.split(",").forEach((v) => {
          map[name].powerPaid += Number(v || 0);
        });
        map[name].powerPaymentsSeen = true;
      }

      if (row.badge_payments && !map[name].badgePaymentsSeen) {
        row.badge_payments.split(",").forEach((v) => {
          map[name].badgePaid += Number(v || 0);
        });
        map[name].badgePaymentsSeen = true;
      }

      map[name].paid_total += Number(row.paid_total || 0);
    });

    return Object.values(map);
  };

  // 👇👇 YAHAN PASTE KARO
  const displayData = buildCompanyRows(
    filteredPaymentsData.length > 0 ? filteredPaymentsData : paymentsData,
  );

  const paymentSummary = stallPayments?.reduce(
    (sum, p) => {
      sum.totalPayment += parseFloat(p.amount_paid || 0);
      sum.totalTDS += parseFloat(p.tds || 0);
      return sum;
    },
    {
      totalPayment: 0,
      totalTDS: 0,
    },
  );

  const paymentAfterTDS =
    (paymentSummary?.totalPayment || 0) + (paymentSummary?.totalTDS || 0);

  const totalPaidAmount =
    (paymentSummary?.totalPayment || 0) + (paymentSummary?.totalTDS || 0);

  const calculatedPendingAmount = Math.max(
    0,
    Math.round(selectedStallCalculation?.grand_total || 0) -
      Math.round(totalPaidAmount),
  );

  const paymentTotals = payments.reduce(
    (sum, pay) => {
      const amount = parseFloat(pay.amount || pay.amount_paid || 0);
      const tds = parseFloat(pay.tds || 0);

      sum.totalPayment += amount;
      sum.totalTDS += tds;

      return sum;
    },
    {
      totalPayment: 0,
      totalTDS: 0,
    },
  );

  const totalPaymentWithTDS =
    paymentTotals.totalPayment + paymentTotals.totalTDS;

  const fetchBoothDesignStatus = async () => {
    if (!formData.company_name) return;

    try {
      const res = await fetch(
        `https://inoptics.in/api/get_booth_design_status.php?company=${encodeURIComponent(
          formData.company_name,
        )}`,
      );

      const data = await res.json();

      const rawStatus =
        typeof data.status === "string"
          ? data.status.toLowerCase().trim()
          : "pending";

      const status = ["pending", "approved", "rejected"].includes(rawStatus)
        ? rawStatus
        : "pending";

      setBoothDesignStatus(status);
      setBoothRejectReason(
        status === "rejected" ? data.reject_reason || "" : "",
      );

      // 🔥 STORE BOOTH ID FOR REJECT / APPROVE
      setSelectedBoothId(data.booth_id || null);

      console.log("Booth Status:", {
        status,
        booth_id: data.booth_id,
        reason: data.reject_reason,
      });
    } catch (err) {
      console.error("Failed to fetch booth status", err);
      setBoothDesignStatus("pending");
      setBoothRejectReason("");
      setSelectedBoothId(null);
    }
  };

  const [boothIdMap, setBoothIdMap] = useState({});

  const fetchAllBoothIds = async () => {
    const map = {};

    for (const item of finalListData) {
      try {
        const res = await fetch(
          `https://inoptics.in/api/get_booth_design_status.php?company=${encodeURIComponent(
            item.exhibitor_company_name,
          )}`,
        );

        const data = await res.json();

        if (data.booth_id) {
          map[item.exhibitor_company_name] = data.booth_id;
        }
      } catch (err) {
        console.error(
          "Booth status fetch failed for",
          item.exhibitor_company_name,
          err,
        );
      }
    }

    setBoothIdMap(map);
  };

  useEffect(() => {
    if (finalListData.length > 0) {
      fetchAllBoothIds();
    }
  }, [finalListData]);

  const handleRejectBoothDesign = async () => {
    // 🔒 SAFETY CHECKS
    if (!selectedCompany || typeof selectedCompany !== "string") {
      alert("Company name missing");
      return;
    }

    if (!rejectReason || !rejectReason.trim()) {
      alert("Please enter reject reason");
      return;
    }

    const payload = {
      company: selectedCompany.trim(),
      reason: rejectReason.trim(),
    };

    console.log("❌ Reject payload:", payload); // 🔥 DEBUG

    try {
      setRejecting(true);

      const res = await fetch(
        "https://inoptics.in/api/reject_booth_design.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const text = await res.text();
      console.log("Reject API raw response:", text);

      if (!text) {
        throw new Error("Empty response from server");
      }

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        throw new Error("Invalid JSON from server");
      }

      if (!res.ok || !data.success) {
        throw new Error(data.message || "Reject failed");
      }

      // ✅ SUCCESS
      alert("❌ Booth design rejected successfully");

      // 🔄 RESET UI STATE
      setShowRejectPopup(false);
      setRejectReason("");
      setSelectedCompany(null);

      // 🔄 OPTIONAL: refresh list / status
      fetchBoothDesignStatus?.();
    } catch (err) {
      console.error("Reject error:", err);
      alert(err.message || "Server error");
    } finally {
      setRejecting(false);
    }
  };

  const fetchUndertakingStatus = async (companyName) => {
    try {
      const res = await fetch(
        `https://inoptics.in/api/get_undertaking_status.php?company_name=${encodeURIComponent(companyName)}`,
      );

      const data = await res.json();

      if (data.success) {
        setUndertakingStatus(Number(data.undertaking_accepted));
      } else {
        setUndertakingStatus(0);
      }
    } catch (error) {
      console.error(error);
      setUndertakingStatus(0);
    }
  };

  useEffect(() => {
    if (showTermsDeclaration && selectedCompanyName) {
      fetchUndertakingStatus(selectedCompanyName);
    }
  }, [showTermsDeclaration, selectedCompanyName]);

  const handleUnlockUndertaking = async (companyName) => {
    if (!companyName) {
      alert("Company name missing");
      return;
    }

    try {
      const response = await fetch(
        "https://inoptics.in/api/unlock_undertaking.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            company_name: companyName,
          }),
        },
      );

      const result = await response.json();

      if (response.ok && result.success) {
        alert("Undertaking unlocked successfully");

        // 🔥 Important — Update UI state
        setUndertakingStatus(0); // 🔥 correct state update
      } else {
        alert(result.message || "Failed to unlock");
      }
    } catch (error) {
      console.error("Unlock error:", error);
      alert("Server error while unlocking");
    }
  };

  // ================= FETCH IMAGES =================

  const fetchMediaImages = async () => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/get_email_media_images.php",
      );

      const data = await res.json();

      console.log("Fetched Images:", data); // 🔥 Debug

      if (Array.isArray(data)) {
        setMediaImages(data);
      } else if (data.success) {
        setMediaImages(data.data || []);
      } else {
        setMediaImages([]);
      }
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  useEffect(() => {
    fetchMediaImages();
  }, []);

  // ================= COPY URL =================

  const handleCopyUrl = async (url) => {
    try {
      await navigator.clipboard.writeText(url);
      alert("URL copied successfully!");
    } catch (err) {
      console.error("Copy failed:", err);
      alert("Failed to copy URL");
    }
  };

  // ================= DELETE IMAGE =================

  const handleDeleteImage = async (id) => {
    if (!window.confirm("Delete this image?")) return;

    try {
      const res = await fetch(
        "https://inoptics.in/api/delete_email_media_image.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        },
      );

      const data = await res.json();

      if (data.success) {
        setMediaImages((prev) => prev.filter((img) => img.id !== id));
        alert("Image deleted successfully");
      } else {
        alert(data.message || "Delete failed");
      }
    } catch (error) {
      console.error("Delete error:", error);
      alert("Server error while deleting");
    }
  };

  // ================= UPLOAD IMAGE =================

  const handleUploadImage = async () => {
    if (!selectedImage) {
      alert("Select image first");
      return;
    }

    const formData = new FormData();
    formData.append("image", selectedImage);

    try {
      const res = await fetch(
        "https://inoptics.in/api/upload_email_media_image.php",
        {
          method: "POST",
          body: formData,
        },
      );

      const data = await res.json();

      if (data.success) {
        alert("Image uploaded successfully");

        setSelectedImage(null);
        setSelectedImagePreview(null);

        await fetchMediaImages(); // 🔥 IMPORTANT
      } else {
        alert("Upload failed");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const sendPowerRevisedMail = async (companyName, email) => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/send_power_revised_mail.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            company_name: companyName,
            template_name: "POWER LOAD INCREASED",
            email: email,
          }),
        },
      );

      const data = await res.json();
      console.log(data);
    } catch (error) {
      console.error("Failed to send power revised mail:", error);
    }
  };

  const sendPowerVendorMail = async (companyName) => {
    try {
      const res = await fetch(
        "https://inoptics.in/api/send_power_vendor_mail.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            template_name: "Revised Power Load Vendor",
            company_name: companyName,
          }),
        },
      );

      const data = await res.json();
      console.log(data);
    } catch (error) {
      console.error("Failed to send vendor mail:", error);
    }
  };

  const sendPowerMailToAdmin = async (companyName) => {
    try {
      await fetch("https://inoptics.in/api/send_power_mail_to_admin.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          template_name:
            "InOptics 2026 @ Exhibitor Power Requirement Confirmation",
          company_name: companyName,
        }),
      });
    } catch (error) {
      console.error("Failed to send power mail to admin:", error);
    }
  };

  const handleSendPowerDetailsMail = async (companyName) => {
    if (!companyName) {
      alert("Company name missing");
      return;
    }

    try {
      const response = await fetch(
        "https://inoptics.in/api/send_power_mail_to_vendor.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            company_name: companyName,
            template_name: "Power Requirement by Exhibitor",
          }),
        },
      );

      const result = await response.json();

      console.log("API RESPONSE:", result);

      if (response.ok && result.success) {
      } else {
        alert("❌ ERROR:\n" + JSON.stringify(result, null, 2));
      }
    } catch (error) {
      console.error("Mail API Error:", error);
      alert("🚨 Network / Server Crash:\n" + error.message);
    }
  };

  const handleDeleteCompanyRemark = async (id) => {
    if (!window.confirm("Delete this remark?")) return;

    try {
      const res = await fetch(
        "https://inoptics.in/api/delete_exhibitor_remark.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        },
      );

      const data = await res.json();

      if (data.success) {
        fetchCompanyRemarks();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleUpdateCompanyRemark = async () => {
    if (!editingRemarkId || !remarkText.trim()) return;

    try {
      const res = await fetch(
        "https://inoptics.in/api/update_exhibitor_remark.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: editingRemarkId,
            remark: remarkText,
          }),
        },
      );

      const data = await res.json();

      if (data.success) {
        fetchCompanyRemarks();

        // 🔥 RESET AFTER UPDATE
        setRemarkText("");
        setEditingRemarkId(null);
        setRemarkSaved(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSaveRemark = async () => {
    if (!remarkText.trim()) return;

    try {
      const res = await fetch(
        "https://inoptics.in/api/add_exhibitor_remark.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            company_name: formData.company_name,
            remark: remarkText,
          }),
        },
      );

      const data = await res.json();

      if (data.success) {
        setRemarkSaved(true);
        setRemarkText("");
        fetchCompanyRemarks();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSendEmail = () => {
    alert("Send Email logic here");
  };

  const handleEditCompanyRemark = (item) => {
    setRemarkText(item.remark); // textarea me remark
    setEditingRemarkId(item.id); // kis id ko update karna hai
    setRemarkSaved(true); // update button show karega
  };

  useEffect(() => {
    if (!formData.company_name) return;

    fetchCompanyRemarks();
    setRemarkText("");
    setRemarkSaved(false);
    setEditingRemarkId(null);
  }, [formData.company_name]);

  const fetchCompanyRemarks = async () => {
    try {
      const res = await fetch(
        `https://inoptics.in/api/get_exhibitor_remarks.php?company_name=${formData.company_name}`,
      );

      const data = await res.json();

      if (data.success) {
        setCompanyRemarks(data.records);
      } else {
        setCompanyRemarks([]);
      }
    } catch (err) {
      console.error(err);
      setCompanyRemarks([]);
    }
  };

  const exportTableData = () => {
    const dataArray = Object.values(groupedData); // object → array convert

    const exportData = dataArray
      .sort((a, b) =>
        a.company_name.localeCompare(b.company_name, undefined, {
          sensitivity: "base",
        }),
      )
      .map((item, index) => {
        const stallWithCat = (item.stall_no || []).map((stall, i) => {
          const cat = (item.category?.[i] || "").toLowerCase();

          let suffix = "";

          if (cat.includes("bare")) suffix = "B";
          else if (cat.includes("shell")) suffix = "S";

          return `${stall}(${suffix})`;
        });

        const stallAreas = item.stall_area || [];

        const bsValues = [
          ...new Set(
            (item.category || []).map((cat) => {
              const c = (cat || "").toLowerCase();

              if (c.includes("bare")) return "B";
              if (c.includes("shell")) return "S";

              return "";
            }),
          ),
        ].filter(Boolean);

        const mobileNumbers = item.mobile
          ? item.mobile.split(",").map((m) => m.trim())
          : [];

        return {
          ID: index + 1,
          "Company Name": item.company_name,
          "Stall No": stallWithCat.join(", "),
          "Stall Area": stallAreas.map((area) => `${area} sq mtr`).join(", "),
          "B/S": bsValues.join(", "),
          Email: item.email,
          Mobile: mobileNumbers.join(", "),
        };
      });

    if (exportData.length === 0) {
      toast.error("No data to export");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Exhibitors");

    XLSX.writeFile(workbook, "Exhibitor_List.xlsx");
  };

  return (
    <div>
      <div className="top-search-bar">
        <input
          type="text"
          placeholder="Search by Company Name..."
          value={companySearch}
          onChange={(e) => setCompanySearch(e.target.value)}
        />
      </div>
      <>
        <div className="exhibitor-table-wrapper">
          <div className="exhibitor-table-container">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>COMPANY NAME</th>
                  <th>STALL NO</th>
                  <th>STALL AREA</th>
                  <th>(B/S)</th>
                  <th>EMAIL</th>
                  <th>MOBILE</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {groupedData
                  // First, sort alphabetically
                  .sort((a, b) =>
                    a.company_name.localeCompare(b.company_name, undefined, {
                      sensitivity: "base",
                    }),
                  )
                  // Then, assign a fixed row number to each item
                  .map((item, index) => ({
                    ...item,
                    rowNumber: index + 1,
                  }))
                  // Now filter after assigning row numbers
                  .filter((item) => {
                    // B / S values
                    const bsValues = [
                      ...new Set(
                        item.category.map((cat) => {
                          const c = (cat || "").toLowerCase().trim();

                          if (c.includes("bare")) return "B";
                          if (c.includes("shell")) return "S";

                          return "";
                        }),
                      ),
                    ].filter(Boolean);

                    const companyMatch = item.company_name
                      .toLowerCase()
                      .includes(companySearch.toLowerCase());

                    const bsMatch =
                      bsSearch === "" || bsValues.includes(bsSearch);

                    return companyMatch && bsMatch;
                  })
                  .map((item) => {
                    const stallWithCat = item.stall_no.map((stall, i) => {
                      const cat = (item.category[i] || "").toLowerCase();

                      let suffix = "";

                      if (cat.includes("bare")) suffix = "B";
                      else if (cat.includes("shell")) suffix = "S";

                      return `${stall}(${suffix})`;
                    });

                    const stallAreas = item.stall_area || [];

                    // Chunk array function (2 per line)
                    const chunkArray = (arr, size) => {
                      const chunks = [];
                      for (let i = 0; i < arr.length; i += size) {
                        chunks.push(arr.slice(i, i + size));
                      }
                      return chunks;
                    };

                    const stallChunks = chunkArray(stallWithCat, 2);
                    const areaChunks = chunkArray(stallAreas, 2);

                    // B/S values
                    const bsValues = [
                      ...new Set(
                        item.category.map((cat) => {
                          const c = (cat || "").toLowerCase().trim();

                          if (c.includes("bare")) return "B";
                          if (c.includes("shell")) return "S";

                          return "";
                        }),
                      ),
                    ].filter(Boolean);

                    // Mobile numbers split by comma
                    const mobileNumbers = item.mobile
                      ? item.mobile.split(",")
                      : [];

                    return (
                      <tr key={item.rowNumber}>
                        <td>{item.rowNumber}</td>
                        <td>{item.company_name}</td>

                        {/* Stall No */}
                        <td>
                          {stallChunks.map((chunk, i) => (
                            <div key={i}>
                              {chunk.join(", ")}
                              {i < stallChunks.length - 1 && ","}
                            </div>
                          ))}
                        </td>

                        {/* Stall Area */}
                        <td>
                          {areaChunks.map((chunk, i) => (
                            <div key={i}>
                              {chunk
                                .map((area) => {
                                  const num = parseFloat(area);
                                  const formatted = Number.isInteger(num)
                                    ? num.toString()
                                    : num.toFixed(2);
                                  return `${formatted} sq mtr`;
                                })
                                .join(", ")}
                              {i < areaChunks.length - 1 && ","}
                            </div>
                          ))}
                        </td>

                        <td>{bsValues.join(", ")}</td>
                        <td>{item.email}</td>

                        {/* Mobile */}
                        <td>
                          {mobileNumbers.map((num, i) => (
                            <div key={i}>
                              {num.trim()}
                              {i < mobileNumbers.length - 1 && ","}
                            </div>
                          ))}
                        </td>

                        {/* Action Buttons */}
                        <td className="stall-action-buttons">
                          <button
                            className="action-btn edit-btn"
                            title="Edit"
                            onClick={() => {
                              setEditExhibitor(item);
                              setFormData({
                                id: item.id,
                                company_name: item.company_name || "",
                                name: item.name || "",
                                email: item.email || "",
                                address: item.address || "",
                                city: item.city || "",
                                state: item.state || "",
                                pin: item.pin || "",
                                mobile: item.mobile || "",
                                telephone: item.telephone || "",
                                fax: item.fax || "",
                                gst: item.gst || "",
                                secondary_emails: item.secondary_emails || "",
                                password: item.password || "",
                                stall_no: item.stall_no || "",
                                category: item.category || "",

                                // stall fields
                              });
                              fetchSelectedFurniture(item.company_name || "");
                              setActiveNavbarItem("BASIC DETAILS");
                              setShowExhibitorEditForm(true);
                              setIsViewOnly(false);
                              setTimeout(() => setModalVisible(true), 10);
                            }}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>

                          <button
                            className="action-btn delete-btn"
                            title="Delete"
                            // onClick={() => deleteExhibitor(item.id)}
                            onClick={() => deleteExhibitor(item.company_name)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                          <button
                            onClick={() => {
                              setSelectedCompanyName(item.company_name);
                              setShowTermsDeclaration(true);
                              setHideMainDashboard(true);
                            }}
                            title="Terms"
                            style={{
                              backgroundColor:
                                Number(item.undertaking_accepted) === 1
                                  ? "#fbc02d" // Yellow (Accepted)
                                  : "#1976d2", // Blue (Not Accepted)
                              color:
                                Number(item.undertaking_accepted) === 1
                                  ? "#000"
                                  : "#fff",
                              padding: "6px 12px",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                              transition: "all 0.3s ease",
                            }}
                          >
                            <FontAwesomeIcon icon={faFileAlt} />
                          </button>

                          <button
                            className="action-btn view-btn"
                            title="View"
                            onClick={() => {
                              setEditExhibitor(item);
                              setFormData({
                                id: item.id,
                                company_name: item.company_name || "",
                                name: item.name || "",
                                email: item.email || "",
                                address: item.address || "",
                                city: item.city || "",
                                state: item.state || "",
                                pin: item.pin || "",
                                mobile: item.mobile || "",
                                telephone: item.telephone || "",
                                fax: item.fax || "",
                                gst: item.gst || "",
                                secondary_emails: item.secondary_emails || "",
                                password: item.password || "",
                                stall_no: item.stall_no || "",
                                category: item.category || "",
                              });
                              setActiveNavbarItem("BASIC DETAILS");
                              setShowExhibitorEditForm(true);
                              setIsViewOnly(true);
                              setTimeout(() => setModalVisible(true), 10);
                            }}
                          >
                            <FontAwesomeIcon icon={faEye} />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>

        {(showTermsDeclaration || showTermsDeclaration) && (
          <div className={`full-modal-overlay ${modalVisible ? "show" : ""}`}>
            <div
              className="modal-container"
              style={{ flexDirection: "column" }}
            >
              {/* Top Header */}
              <div className="form-overlay-header">
                <span>
                  {showTermsDeclaration
                    ? ` ${selectedCompanyName}`
                    : isViewOnly
                      ? `View: ${formData.company_name}${
                          formData.state ? `, ${formData.state}` : ""
                        }`
                      : showExhibitorEditForm
                        ? `${formData.company_name}${
                            formData.state ? `, ${formData.state}` : ""
                          }`
                        : "New Exhibitor Request"}
                </span>
                <button
                  className="cancel-button-top"
                  onClick={() => {
                    setModalVisible(false);
                    setTimeout(() => {
                      setShowExhibitorAddForm(false);
                      setShowTermsDeclaration(false);
                    }, 300); // wait for animation to finish
                  }}
                >
                  ← Back
                </button>
              </div>

              {/* View Mode (READ-ONLY) */}

              <div className="declaration-overlay">
                <div className="declaration-container">
                  <div className="declaration-header-flex">
                    <h3 className="declaration-heading">Terms & Declaration</h3>

                    <button
                      onClick={() => setShowTermsDeclaration(false)}
                      className="close-btn"
                    >
                      ×
                    </button>
                  </div>

                  {/* ================= STATUS BASED RENDER ================= */}

                  {undertakingStatus === null ? (
                    <div>Loading...</div>
                  ) : undertakingStatus === 0 ? (
                    <div className="not-accepted-box">
                      ❗ {selectedCompanyName} has NOT accepted Undertaking.
                    </div>
                  ) : (
                    <>
                      <ol className="declaration-list">
                        {declarationUndertakingData.map((point, index) => (
                          <li key={index}>
                            <strong>{point.title}:</strong> {point.text}
                          </li>
                        ))}
                      </ol>

                      <div style={{ marginTop: "20px", textAlign: "right" }}>
                        <button
                          type="button"
                          onClick={() =>
                            handleUnlockUndertaking(selectedCompanyName)
                          }
                          className="unlock-btn"
                        >
                          Unlock Undertaking
                        </button>
                      </div>
                    </>
                  )}

                  {/* ================= END ================= */}
                </div>
              </div>
            </div>
          </div>
        )}

        {(showExhibitorAddForm || showExhibitorEditForm) && (
          <div className={`full-modal-overlay ${modalVisible ? "show" : ""}`}>
            <div
              className="modal-container"
              style={{ flexDirection: "column" }}
            >
              {/* Top Header */}
              <div className="form-overlay-header">
                <span>
                  {isViewOnly
                    ? `View: ${formData.company_name}${
                        formData.state ? `, ${formData.state}` : ""
                      }`
                    : showExhibitorEditForm
                      ? `${formData.company_name}${
                          formData.state ? `, ${formData.state}` : ""
                        }`
                      : "New Exhibitor Request"}
                </span>
                <button
                  className="cancel-button-top"
                  onClick={() => {
                    setModalVisible(false);
                    setTimeout(() => {
                      setShowExhibitorAddForm(false);
                      setShowExhibitorEditForm(false);
                    }, 300); // wait for animation to finish
                  }}
                >
                  ← Back
                </button>
              </div>

              {/* View Mode (READ-ONLY) */}
              {isViewOnly ? (
                <div className="view-only-details">
                  <h3 style={{ marginBottom: "10px" }}>BASIC DETAILS</h3>
                  <div className="details-grid">
                    <p>
                      <strong>COMPANY NAME:</strong>{" "}
                      <span>{formData.company_name}</span>
                    </p>
                    <p>
                      <strong>NAME:</strong> <span>{formData.name}</span>
                    </p>
                    <p>
                      <strong>EMAIL:</strong> <span>{formData.email}</span>
                    </p>
                    <p>
                      <strong>ADDRESS:</strong> <span>{formData.address}</span>
                    </p>
                    <p>
                      <strong>CITY:</strong> <span>{formData.city}</span>
                    </p>
                    <p>
                      <strong>STATE:</strong> <span>{formData.state}</span>
                    </p>
                    <p>
                      <strong>PIN:</strong> <span>{formData.pin}</span>
                    </p>
                    <p>
                      <strong>MOBILE:</strong> <span>{formData.mobile}</span>
                    </p>
                    <p>
                      <strong>GST:</strong> <span>{formData.gst}</span>
                    </p>
                    <p>
                      <strong>SECONDARY EMAILS:</strong>{" "}
                      <span>{formData.secondary_emails}</span>
                    </p>
                  </div>

                  <h3 style={{ margin: "20px 0 10px" }}>STALLS</h3>

                  {stallList.length === 0 && <p>No stalls added</p>}

                  {stallList.map((stall, i) => (
                    <div
                      key={i}
                      className="stall-card"
                      style={{ marginBottom: "15px" }}
                    >
                      <p>
                        <strong>STALL NUMBER:</strong> {stall.stall_number}
                      </p>
                      <p>
                        <strong>STALL CATEGORY:</strong> {stall.stall_category}
                      </p>
                      <p>
                        <strong>STALL PRICE:</strong> ₹{stall.stall_price}
                      </p>
                      <p>
                        <strong>CURRENCY:</strong> ₹{stall.currency}
                      </p>
                      <p>
                        <strong>STALL AREA:</strong> {stall.stall_area}
                      </p>
                      <p>
                        <strong>TOTAL:</strong> {stall.total}
                      </p>
                      <p>
                        <strong>DISCOUNT:</strong> {stall.discount_percent}%
                      </p>
                      <p>
                        <strong>DISCOUNT AMOUNT:</strong>{" "}
                        {stall.discounted_amount}%
                      </p>
                      <p>
                        <strong>TOTAL AFTER DISCOUNT :</strong>{" "}
                        {stall.total_after_discount}%
                      </p>
                      <p>
                        <strong>CGST:</strong> {stall.sgst_9_percent}%
                      </p>
                      <p>
                        <strong>SGST:</strong> {stall.cgst_9_percent}%
                      </p>
                      <p>
                        <strong>IGST:</strong> {stall.igst_18_percent}%
                      </p>
                      <p>
                        <strong>GRAND TOTAL:</strong> ₹{stall.grand_total}
                      </p>
                      <hr />
                    </div>
                  ))}

                  <div className="payment-cards-container">
                    <h2 className="payment-details-form-heading">
                      PAYMENT DETAILS
                    </h2>

                    <div className="payment-card-grid">
                      {/* First Card: Stall Charges Summary */}
                      <div className="payment-card">
                        <h4>Stall Particulars</h4>

                        <div className="billing-summary">
                          <div className="billing-row">
                            <span>Total:</span>
                            <strong>
                              {stallSummary.total.toFixed(2)}{" "}
                              {stallSummary.currency}
                            </strong>
                          </div>

                          {stallSummary.discounted_amount > 0 && (
                            <div className="billing-row">
                              <span>
                                Discount ({getDiscountPercent(stallSummary)}
                                %):
                              </span>
                              <strong>
                                {stallSummary.discounted_amount.toFixed(2)}{" "}
                                {stallSummary.currency}
                              </strong>
                            </div>
                          )}

                          {formData?.state?.toLowerCase() === "delhi" ? (
                            <>
                              <div className="billing-row">
                                <span>SGST (9%):</span>
                                <strong>
                                  {stallSummary.sgst.toFixed(2)}{" "}
                                  {stallSummary.currency}
                                </strong>
                              </div>
                              <div className="billing-row">
                                <span>CGST (9%):</span>
                                <strong>
                                  {stallSummary.cgst.toFixed(2)}{" "}
                                  {stallSummary.currency}
                                </strong>
                              </div>
                            </>
                          ) : (
                            <div className="billing-row">
                              <span>IGST (18%):</span>
                              <strong>
                                {stallSummary.igst.toFixed(2)}{" "}
                                {stallSummary.currency}
                              </strong>
                            </div>
                          )}

                          <div className="billing-row total">
                            <span>Grand Total:</span>
                            <strong>
                              {stallSummary.grand_total.toFixed(2)}{" "}
                              {stallSummary.currency}
                            </strong>
                          </div>

                          {/* ✅ Overall Pending Amount Row */}
                          {pendingAmount !== null && (
                            <div
                              className="billing-row"
                              style={{
                                color: pendingAmount <= 0 ? "green" : "red",
                                fontWeight: "bold",
                                marginTop: "10px",
                              }}
                            >
                              <span>
                                {pendingAmount <= 0
                                  ? "PAYMENT CLEARED"
                                  : "PENDING AMOUNT"}
                              </span>
                              <strong>
                                {pendingAmount.toFixed(2)}{" "}
                                {stallSummary.currency}
                              </strong>
                            </div>
                          )}
                        </div>

                        <div
                          style={{
                            alignSelf: "flex-end",
                            marginTop: "auto",
                          }}
                        ></div>
                      </div>

                      {/* === Card 2: Power Requirement Billing === */}
                      <div className="payment-card">
                        <h4>Power Requirement</h4>

                        <div className="billing-summary">
                          <div className="billing-row">
                            <span>Total:</span>
                            <strong>{totalPrice.toFixed(2)} ₹</strong>
                          </div>

                          {formData?.state?.toLowerCase() === "delhi" ? (
                            <>
                              <div className="billing-row">
                                <span>CGST (9%):</span>
                                <strong>{cgst.toFixed(2)} ₹</strong>
                              </div>
                              <div className="billing-row">
                                <span>SGST (9%):</span>
                                <strong>{sgst.toFixed(2)} ₹</strong>
                              </div>
                            </>
                          ) : (
                            <div className="billing-row">
                              <span>IGST (18%):</span>
                              <strong>{igst.toFixed(2)} ₹</strong>
                            </div>
                          )}

                          <div className="billing-row total">
                            <span>Grand Total:</span>
                            <strong>{grandTotal.toFixed(2)} ₹</strong>
                          </div>

                          {/* ✅ Pending Amount for Power */}
                          {powerPendingAmount !== null && (
                            <div
                              className="billing-row"
                              style={{
                                color:
                                  powerPendingAmount <= 0 ? "green" : "red",
                                fontWeight: "bold",
                                marginTop: "10px",
                              }}
                            >
                              <span>
                                {powerPendingAmount <= 0
                                  ? "PAYMENT CLEARED"
                                  : "PENDING AMOUNT"}
                              </span>
                              <strong>{powerPendingAmount.toFixed(2)} ₹</strong>
                            </div>
                          )}
                        </div>

                        <div
                          style={{
                            alignSelf: "flex-end",
                            marginTop: "auto",
                          }}
                        ></div>
                      </div>

                      {/* === Card 3: Exhibitor Badges Billing === */}
                      {(() => {
                        const { count, total, cgst, sgst, igst, grandTotal } =
                          getExhibitorBadgeBilling();

                        return (
                          <div className="payment-card">
                            <h4>Exhibitor Badges</h4>

                            <div className="billing-summary">
                              <div className="billing-row">
                                <span>Extra Badges:</span>
                                <strong>{count || 0}</strong>
                              </div>
                              <div className="billing-row">
                                <span>Total Amount:</span>
                                <strong>₹{total?.toFixed(2) || "0.00"}</strong>
                              </div>

                              {formData?.state?.toLowerCase() === "delhi" ? (
                                <>
                                  <div className="billing-row">
                                    <span>CGST (9%):</span>
                                    <strong>
                                      ₹{cgst?.toFixed(2) || "0.00"}
                                    </strong>
                                  </div>
                                  <div className="billing-row">
                                    <span>SGST (9%):</span>
                                    <strong>
                                      ₹{sgst?.toFixed(2) || "0.00"}
                                    </strong>
                                  </div>
                                </>
                              ) : (
                                <div className="billing-row">
                                  <span>IGST (18%):</span>
                                  <strong>₹{igst?.toFixed(2) || "0.00"}</strong>
                                </div>
                              )}

                              <div className="billing-row total">
                                <span>Grand Total:</span>
                                <strong>
                                  ₹{grandTotal?.toFixed(2) || "0.00"}
                                </strong>
                              </div>
                            </div>

                            <div
                              style={{
                                alignSelf: "flex-end",
                                marginTop: "auto",
                              }}
                            ></div>
                          </div>
                        );
                      })()}
                    </div>
                  </div>

                  <div className="selected-furniture-table-wrapper">
                    <table className="selected-furniture-table">
                      <colgroup>
                        <col style={{ width: "40px" }} />
                        <col style={{ width: "120px" }} />
                        <col style={{ width: "180px" }} />
                        <col style={{ width: "100px" }} />
                        <col style={{ width: "100px" }} />
                        <col style={{ width: "100px" }} />
                        <col style={{ width: "100px" }} />
                      </colgroup>
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Image</th>
                          <th>Name</th>
                          <th>Price</th>
                          <th>Quantity</th>
                          <th>Total</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedFurniture.length > 0 ? (
                          selectedFurniture.map((item, index) => (
                            <tr key={item.id}>
                              <td>{index + 1}</td>
                              <td>
                                <img
                                  src={`https://www.inoptics.in/api/uploads/${item.image}`}
                                  alt={item.name}
                                  width="100"
                                  height="100"
                                  style={{ objectFit: "cover" }}
                                />
                              </td>
                              <td>{item.name}</td>
                              <td>₹{item.price}</td>
                              <td>
                                <input
                                  type="number"
                                  min="1"
                                  value={item.quantity || ""}
                                  onChange={(e) =>
                                    handleQuantityChange(index, e.target.value)
                                  }
                                  style={{ width: "60px" }}
                                />
                              </td>
                              <td>
                                ₹
                                {item.quantity
                                  ? (item.quantity * item.price).toFixed(2)
                                  : "0.00"}
                              </td>
                              <td>
                                <button
                                  onClick={() =>
                                    setSelectedFurniture(
                                      selectedFurniture.filter(
                                        (_, i) => i !== index,
                                      ),
                                    )
                                  }
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan="7"
                              style={{
                                textAlign: "center",
                                padding: "10px",
                              }}
                            >
                              No furniture selected yet.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* furniture payments details */}

                  <h3>Particulars</h3>

                  <div
                    style={{
                      fontSize: "15px",
                      lineHeight: "1.8",
                      fontFamily: "Segoe UI",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>Total</span>
                      <span>
                        ₹{furnitureBilling.amount?.toFixed(2) || "0.00"}
                      </span>
                    </div>

                    {/* Taxes */}
                    {formData.state?.toLowerCase() === "delhi" ? (
                      <>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>CGST (9%)</span>
                          <span>
                            ₹{furnitureBilling.cgst?.toFixed(2) || "0.00"}
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>SGST (9%)</span>
                          <span>
                            ₹{furnitureBilling.sgst?.toFixed(2) || "0.00"}
                          </span>
                        </div>
                      </>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span>IGST (18%)</span>
                        <span>
                          ₹{furnitureBilling.igst?.toFixed(2) || "0.00"}
                        </span>
                      </div>
                    )}

                    <hr style={{ margin: "15px 0" }} />

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontWeight: "bold",
                      }}
                    >
                      <span>GRAND TOTAL</span>
                      <span>
                        ₹{furnitureBilling.grandTotal?.toFixed(2) || "0.00"}
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  {/* Top Navbar */}
                  <div className="modal-navbar">
                    <ul className="navbar-list">
                      {(() => {
                        // Define navbar items
                        const navbarItems = [
                          "BASIC DETAILS",
                          "STALLS",
                          "POWER REQUIREMENT",
                          "EXHIBITOR BADGES",
                          "APPOINTED CONTRACTOR",
                          "EXTRA FURNITURE REQUIREMENT",
                          "PAYMENT DETAILS",
                          "BRANDS",
                        ];

                        // Conditionally insert FACIA BOARD before BRANDS
                        if (showFaciaBoardTab) {
                          navbarItems.splice(7, 0, "FACIA BOARD");
                        }

                        // Render the list
                        return navbarItems.map((item) => (
                          <li
                            key={item}
                            className={`navbar-item ${
                              activeNavbarItem === item ? "active" : ""
                            }`}
                            onClick={() => setActiveNavbarItem(item)}
                          >
                            {item}
                          </li>
                        ));
                      })()}
                    </ul>
                  </div>

                  <div className="modal-content">
                    {activeNavbarItem === "BASIC DETAILS" && (
                      <>
                        <div className="basic-details-form-with-chnage-company-name">
                          <div className="basic-details-form slide-up-form">
                            <form className="form-grid" onSubmit={handleSubmit}>
                              {/* COMPANY NAME */}
                              <div className="form-group full-width">
                                <label>
                                  COMPANY NAME{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="text"
                                  name="company_name"
                                  value={formData.company_name || ""}
                                  onChange={handleChange}
                                  className={
                                    errors.company_name ? "input-error" : ""
                                  }
                                />
                                {errors.company_name && (
                                  <span className="error-text">
                                    This field is required
                                  </span>
                                )}
                              </div>

                              {/* NAME */}
                              <div className="form-group full-width">
                                <label>
                                  NAME <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="text"
                                  name="name"
                                  value={formData.name || ""}
                                  onChange={handleChange}
                                  className={errors.name ? "input-error" : ""}
                                />
                                {errors.name && (
                                  <span className="error-text">
                                    This field is required
                                  </span>
                                )}
                              </div>

                              {/* ADDRESS */}
                              <div className="form-group full-width">
                                <label>
                                  ADDRESS{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="text"
                                  name="address"
                                  value={formData.address || ""}
                                  onChange={handleChange}
                                  className={
                                    errors.address ? "input-error" : ""
                                  }
                                />
                                {errors.address && (
                                  <span className="error-text">
                                    This field is required
                                  </span>
                                )}
                              </div>

                              {/* CITY / STATE / PIN */}
                              <div className="row-group">
                                <div className="form-subgroup">
                                  <label>
                                    CITY <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="city"
                                    value={formData.city || ""}
                                    onChange={handleChange}
                                    className={errors.city ? "input-error" : ""}
                                  />
                                  {errors.city && (
                                    <span className="error-text">
                                      This field is required
                                    </span>
                                  )}
                                </div>
                                <div className="form-subgroup">
                                  <label>
                                    STATE{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="state"
                                    value={formData.state || ""}
                                    onChange={handleChange}
                                    className={
                                      errors.state ? "input-error" : ""
                                    }
                                  />
                                  {errors.state && (
                                    <span className="error-text">
                                      This field is required
                                    </span>
                                  )}
                                </div>
                                <div className="form-subgroup">
                                  <label>
                                    PINCODE{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="pin"
                                    value={formData.pin || ""}
                                    onChange={handleChange}
                                    className={errors.pin ? "input-error" : ""}
                                  />
                                  {errors.pin && (
                                    <span className="error-text">
                                      This field is required
                                    </span>
                                  )}
                                </div>
                              </div>

                              {/* MOBILE / TELEPHONE */}
                              {/* MOBILE / TELEPHONE */}
                              <div className="row-group">
                                <div className="form-subgroup">
                                  <label>
                                    MOBILE{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="mobile"
                                    placeholder="9876543210, 8765432109" // ✅ allow comma-separated mobiles
                                    value={formData.mobile || ""}
                                    onChange={handleChange}
                                    className={
                                      errors.mobile ? "input-error" : ""
                                    }
                                  />
                                  {errors.mobile && (
                                    <span className="error-text">
                                      This field is required
                                    </span>
                                  )}
                                </div>
                                <div className="form-subgroup">
                                  <label>TELEPHONE</label>
                                  <input
                                    type="text"
                                    name="telephone"
                                    value={formData.telephone || ""}
                                    onChange={handleChange}
                                  />
                                </div>
                              </div>

                              {/* EMAIL / SECONDARY EMAILS */}
                              <div className="row-group">
                                <div className="form-subgroup">
                                  <label>
                                    EMAIL{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="email"
                                    value={formData.email || ""}
                                    onChange={handleChange}
                                    className={
                                      errors.email ? "input-error" : ""
                                    }
                                  />
                                  {errors.email && (
                                    <span className="error-text">
                                      This field is required
                                    </span>
                                  )}
                                </div>
                                <div className="form-subgroup">
                                  <label>SECONDARY EMAILS</label>
                                  <input
                                    type="text"
                                    name="secondary_emails"
                                    placeholder="email1@example.com, email2@example.com"
                                    value={formData.secondary_emails || ""}
                                    onChange={handleChange}
                                  />
                                </div>
                              </div>

                              {/* GST & Submit Button in same row */}
                              <div className="row-group gst-row">
                                {/* GST Input */}
                                <div className="form-subgroup">
                                  <label>GST</label>
                                  <input
                                    type="text"
                                    name="gst"
                                    value={formData.gst || ""}
                                    onChange={handleChange}
                                  />
                                </div>

                                {/* Buttons group */}
                                <div className="form-subgroup button-group">
                                  {showExhibitorEditForm && (
                                    <button
                                      type="button"
                                      className="send-mail-btn"
                                      onClick={() =>
                                        handleSendMail(
                                          "Exhibitor Login & Password",
                                        )
                                      }
                                    >
                                      Send Mail
                                    </button>
                                  )}
                                  <button type="submit" className="update-btn">
                                    {showExhibitorEditForm
                                      ? "Update"
                                      : "Submit"}
                                  </button>
                                </div>
                              </div>

                              {/* Password display */}
                              {showExhibitorEditForm && (
                                <div className="form-row">
                                  <div className="form-group password-label">
                                    <p
                                      style={{
                                        fontWeight: "600",
                                        fontFamily: "montserrat",
                                      }}
                                    >
                                      Password:{" "}
                                      <span>{formData.password || "N/A"}</span>
                                    </p>
                                  </div>
                                </div>
                              )}
                            </form>
                            {isSendingMail && (
                              <div className="waiting-overlay">
                                <div className="waiting-loader"></div>
                                <p>Sending mail, please wait...</p>
                              </div>
                            )}
                          </div>
                          <div>
                            <UpdateCompanyName
                              fetchExhibitorData={fetchExhibitorData}
                            />
                          </div>
                        </div>
                      </>
                    )}

                    {activeNavbarItem === "STALLS" && (
                      <div className="stalls-form-wrapper">
                        <div className="stalls-form-row">
                          {/* Left Column - Form */}
                          <div className="stalls-form">
                            <form
                              className="stalls-form-structured"
                              onSubmit={
                                editingIndex !== null
                                  ? handleUpdateExhibitorStall
                                  : handleExhibitorStallsSubmit
                              }
                            >
                              {/* Row 1 */}
                              <div className="row">
                                <div className="field-box">
                                  <div className="field">
                                    {renderLabeledField("HALL NUMBER")}
                                  </div>
                                </div>
                                <div className="field-box">
                                  <div className="field">
                                    {renderLabeledField("STALL NUMBER")}
                                  </div>
                                </div>
                              </div>

                              {/* Row 2 */}
                              <div className="row">
                                <div className="field-box">
                                  <div className="field">
                                    <label>STALL CATEGORY</label>
                                    <select
                                      value={stallCategory}
                                      onChange={(e) => {
                                        const selected = e.target.value;
                                        setStallCategory(selected);

                                        if (
                                          selected.startsWith("Shell Scheme")
                                        ) {
                                          setShowFaciaBoardTab(true);
                                        } else {
                                          setShowFaciaBoardTab(false);
                                          if (
                                            activeNavbarItem === "FACIA BOARD"
                                          ) {
                                            setActiveNavbarItem("STALLS");
                                          }
                                        }

                                        // Auto-fill price based on category + currency
                                        const matchedCategory =
                                          stallCategories.find(
                                            (cat) => cat.category === selected,
                                          );
                                        if (
                                          matchedCategory &&
                                          formData.currency
                                        ) {
                                          let price = 0;
                                          if (formData.currency === "Rupees")
                                            price = matchedCategory.rupees;
                                          else if (
                                            formData.currency === "Dollar"
                                          )
                                            price = matchedCategory.dollar;
                                          else if (formData.currency === "Euro")
                                            price = matchedCategory.euro;

                                          setFormData((prev) => ({
                                            ...prev,
                                            stall_category: selected,
                                            stall_price: parseFloat(price) || 0,
                                          }));
                                        } else {
                                          setFormData((prev) => ({
                                            ...prev,
                                            stall_category: selected,
                                          }));
                                        }
                                      }}
                                    >
                                      <option value="">
                                        -- Select Category --
                                      </option>
                                      {stallCategories.map((cat) => (
                                        <option
                                          key={cat.id}
                                          value={cat.category}
                                        >
                                          {cat.category}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                                <div className="field-box">
                                  <div className="field">
                                    {renderLabeledField("STALL AREA")}
                                  </div>
                                </div>
                              </div>

                              {/* Row 3 */}
                              <div className="row">
                                <div className="field-box">
                                  <div className="field">
                                    <label>CURRENCY</label>
                                    <select
                                      value={formData.currency}
                                      onChange={(e) => {
                                        const selectedCurrency = e.target.value;
                                        setFormData((prev) => ({
                                          ...prev,
                                          currency: selectedCurrency,
                                        }));

                                        // Auto-fill price if stallCategory is already selected
                                        const matchedCategory =
                                          stallCategories.find(
                                            (cat) =>
                                              cat.category === stallCategory,
                                          );
                                        if (matchedCategory) {
                                          let price = 0;
                                          if (selectedCurrency === "Rupees")
                                            price = matchedCategory.rupees;
                                          else if (
                                            selectedCurrency === "Dollar"
                                          )
                                            price = matchedCategory.dollar;
                                          else if (selectedCurrency === "Euro")
                                            price = matchedCategory.euro;

                                          setFormData((prev) => ({
                                            ...prev,
                                            stall_price: parseFloat(price) || 0,
                                          }));
                                        }
                                      }}
                                    >
                                      <option value="">
                                        -- Select Currency --
                                      </option>
                                      <option value="Rupees">Rupees</option>
                                      <option value="Dollar">Dollar</option>
                                      <option value="Euro">Euro</option>
                                    </select>
                                  </div>
                                </div>
                                <div className="field-box">
                                  <div className="field">
                                    {renderLabeledField("DISCOUNT(%)")}
                                  </div>
                                </div>
                              </div>

                              {/* Submit Button */}
                              {!isViewOnly && (
                                <div className="stall-form-button-group">
                                  {stallList.length > 0 && (
                                    <button
                                      type="button"
                                      className="send-mail-btn"
                                      disabled={isSendingMail}
                                      onClick={async () => {
                                        try {
                                          setIsSendingMail(true);
                                          await handleSendMail(
                                            "InOptics 2026 @ Stall Booking Confirmation",
                                          );
                                          alert("Mail sent successfully!");
                                        } catch (error) {
                                          console.error(
                                            "Error sending mail:",
                                            error,
                                          );
                                          alert(
                                            "Something went wrong while sending the mail.",
                                          );
                                        } finally {
                                          setIsSendingMail(false);
                                        }
                                      }}
                                    >
                                      {isSendingMail
                                        ? "Sending..."
                                        : "Send Mail"}
                                    </button>
                                  )}

                                  {editingIndex !== null ? (
                                    <button
                                      type="submit"
                                      className="edit-stall-btn"
                                    >
                                      Edit Stall
                                    </button>
                                  ) : (
                                    <button
                                      type="submit"
                                      className="add-stall-btn"
                                    >
                                      Add Stall
                                    </button>
                                  )}
                                </div>
                              )}
                            </form>
                          </div>

                          {/* Right Column - Billing Details */}
                          <div className="billing-details">
                            <h3>Particulars</h3>
                            <div className="billing-row">
                              <span>Stall Number:</span>
                              <strong>{formData.stall_number || "-"}</strong>
                            </div>
                            <div className="billing-row">
                              <span>Hall Number:</span>
                              <strong>{formData.hall_number || "-"}</strong>
                            </div>
                            <div className="billing-row">
                              <span>Stall Category:</span>
                              <strong>{formData.stall_category || "-"}</strong>
                            </div>
                            <div className="billing-row">
                              <span>Stall Area:</span>
                              <strong>{formData.stall_area || "-"}</strong>
                            </div>
                            <div className="billing-row">
                              <span>Stall Price(per sq mtrs):</span>
                              <strong>
                                {formData.stall_price || "-"}{" "}
                                {formData.currency || ""}
                              </strong>
                            </div>

                            <h3>Billing Details</h3>
                            <div className="billing-row">
                              <span>Total:</span>
                              <strong>
                                {customRound(formData.total)}{" "}
                                {formData.currency}
                              </strong>
                            </div>

                            {formData.discount &&
                              parseFloat(formData.discount) > 0 && (
                                <>
                                  <div className="billing-row">
                                    <span>
                                      Discount ({formData.discount}%):
                                    </span>
                                    <strong>
                                      {customRound(formData.discounted_amount)}{" "}
                                      {formData.currency}
                                    </strong>
                                  </div>
                                  <hr />
                                  <div className="billing-row">
                                    <span>Amount After Discount:</span>
                                    <strong>
                                      {customRound(
                                        formData.total_after_discount,
                                      )}{" "}
                                      {formData.currency}
                                    </strong>
                                  </div>
                                </>
                              )}

                            {formData.state?.toLowerCase() === "delhi" &&
                            formData.currency === "Rupees" ? (
                              <>
                                <div className="billing-row">
                                  <span>SGST (9%):</span>
                                  <strong>
                                    {customRound(formData.sgst9)}{" "}
                                    {formData.currency}
                                  </strong>
                                </div>
                                <div className="billing-row">
                                  <span>CGST (9%):</span>
                                  <strong>
                                    {customRound(formData.cgst9)}{" "}
                                    {formData.currency}
                                  </strong>
                                </div>
                              </>
                            ) : (
                              <div className="billing-row">
                                <span>IGST (18%):</span>
                                <strong>
                                  {customRound(formData.igst18)}{" "}
                                  {formData.currency}
                                </strong>
                              </div>
                            )}

                            <div className="billing-row total">
                              <span>Grand Total:</span>
                              <strong>
                                {customRound(formData.grand_total)}{" "}
                                {formData.currency}
                              </strong>
                            </div>
                          </div>
                        </div>

                        {/* Table Section */}
                        <div className="Exhibitor-stall-table-scroll-wrapper">
                          <div className="Exhibitor-stall-table-container">
                            <table>
                              <thead>
                                <tr>
                                  {[
                                    "STALL NUMBER",
                                    "HALL NUMBER",
                                    "STALL CATEGORY",
                                    "STALL PRICE",
                                    "CURRENCY",
                                    "STALL AREA",
                                    "TOTAL",
                                    "DISCOUNT(%)",
                                    "DISCOUNTED AMOUNT",
                                    "TOTAL AFTER DISCOUNT",
                                    "SGST(9%)",
                                    "CGST(9%)",
                                    "IGST(18%)",
                                    "GRAND TOTAL",
                                  ]
                                    .filter((label) => {
                                      const key = labelToBackendKey[label];
                                      return stallList.some(
                                        (stall) =>
                                          stall[key] !== null &&
                                          stall[key] !== undefined &&
                                          stall[key] !== "",
                                      );
                                    })
                                    .map((label, index) => (
                                      <th key={index}>{label}</th>
                                    ))}
                                  <th>ACTION</th>
                                </tr>
                              </thead>

                              <tbody>
                                {stallList.map((stall, rowIndex) => {
                                  const visibleColumns = Object.keys(
                                    labelToBackendKey,
                                  ).filter((label) => {
                                    const key = labelToBackendKey[label];
                                    return stallList.some(
                                      (s) =>
                                        s[key] !== null &&
                                        s[key] !== undefined &&
                                        s[key] !== "",
                                    );
                                  });

                                  return (
                                    <tr key={rowIndex}>
                                      {visibleColumns.map((label, colIndex) => {
                                        const backendKey =
                                          labelToBackendKey[label];
                                        let cellValue = stall[backendKey];

                                        // ✅ Format "STALL AREA" to show like "12 sq mtr"
                                        if (
                                          label === "STALL AREA" &&
                                          cellValue !== null &&
                                          cellValue !== undefined &&
                                          cellValue !== ""
                                        ) {
                                          const num = parseFloat(cellValue);
                                          if (!isNaN(num)) {
                                            const formatted = Number.isInteger(
                                              num,
                                            )
                                              ? num.toString()
                                              : num.toFixed(2);
                                            cellValue = `${formatted} sq mtr`;
                                          }
                                        }

                                        return (
                                          <td key={colIndex}>{cellValue}</td>
                                        );
                                      })}
                                      <td className="stall-action-buttons">
                                        <button
                                          className="edit-btn"
                                          onClick={() =>
                                            handleEditExhibitorStall(
                                              stall,
                                              rowIndex,
                                            )
                                          }
                                        >
                                          <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        <button
                                          className="power-reset-btn"
                                          onClick={() =>
                                            handleDeleteExhibitorStall(rowIndex)
                                          }
                                        >
                                          <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                      </td>
                                    </tr>
                                  );
                                })}

                                {/* ➕ Grand Total Row */}
                                {stallList.length >= 2 && (
                                  <tr
                                    className="grand-total-row"
                                    style={{
                                      fontWeight: "bold",
                                      background: "#f1f1f1",
                                    }}
                                  >
                                    {visibleColumns.map((label) => {
                                      const key = labelToBackendKey[label];

                                      switch (label) {
                                        case "STALL NUMBER":
                                          return (
                                            <td key={key}>
                                              {stallList
                                                .map((s) => s.stall_number)
                                                .join(", ")}
                                            </td>
                                          );
                                        case "TOTAL":
                                          return (
                                            <td key={key}>
                                              {Math.round(
                                                stallList.reduce(
                                                  (sum, s) =>
                                                    sum +
                                                    (parseFloat(s.total) || 0),
                                                  0,
                                                ),
                                              )}
                                            </td>
                                          );
                                        case "DISCOUNT(%)":
                                          return (
                                            <td key={key}>
                                              {stallList[0]?.discount_percent ||
                                                0}
                                            </td>
                                          );
                                        case "DISCOUNTED AMOUNT":
                                          return (
                                            <td key={key}>
                                              {Math.round(
                                                stallList.reduce(
                                                  (sum, s) =>
                                                    sum +
                                                    (parseFloat(
                                                      s.discounted_amount,
                                                    ) || 0),
                                                  0,
                                                ),
                                              )}
                                            </td>
                                          );
                                        case "TOTAL AFTER DISCOUNT":
                                          return (
                                            <td key={key}>
                                              {Math.round(
                                                stallList.reduce(
                                                  (sum, s) =>
                                                    sum +
                                                    (parseFloat(
                                                      s.total_after_discount,
                                                    ) || 0),
                                                  0,
                                                ),
                                              )}
                                            </td>
                                          );
                                        case "SGST(9%)":
                                          return (
                                            <td key={key}>
                                              {Math.round(
                                                stallList.reduce(
                                                  (sum, s) =>
                                                    sum +
                                                    (parseFloat(
                                                      s.sgst_9_percent,
                                                    ) || 0),
                                                  0,
                                                ),
                                              )}
                                            </td>
                                          );
                                        case "CGST(9%)":
                                          return (
                                            <td key={key}>
                                              {Math.round(
                                                stallList.reduce(
                                                  (sum, s) =>
                                                    sum +
                                                    (parseFloat(
                                                      s.cgst_9_percent,
                                                    ) || 0),
                                                  0,
                                                ),
                                              )}
                                            </td>
                                          );
                                        case "IGST(18%)":
                                          return (
                                            <td key={key}>
                                              {Math.round(
                                                stallList.reduce(
                                                  (sum, s) =>
                                                    sum +
                                                    (parseFloat(
                                                      s.igst_18_percent,
                                                    ) || 0),
                                                  0,
                                                ),
                                              )}
                                            </td>
                                          );
                                        case "GRAND TOTAL":
                                          return (
                                            <td key={key}>
                                              {Math.round(
                                                stallList.reduce(
                                                  (sum, s) =>
                                                    sum +
                                                    (parseFloat(
                                                      s.grand_total,
                                                    ) || 0),
                                                  0,
                                                ),
                                              )}
                                            </td>
                                          );
                                        default:
                                          return <td key={key}></td>;
                                      }
                                    })}
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        {isSendingMail && (
                          <div className="waiting-overlay">
                            <div className="waiting-loader"></div>
                            <p>Sending mail, please wait...</p>
                          </div>
                        )}
                      </div>
                    )}

                    {activeNavbarItem === "POWER REQUIREMENT" && (
                      <>
                        {/* Wrapper for Progress + Form */}
                        <div className="power-requirement-wrapper">
                          {/* Left Side Form Section */}
                          <div className="power-requirement-form-left">
                            {/* Progress Bar */}
                            <ul id="progressbar">
                              {powerTypes.map((type, index) => (
                                <li
                                  key={type}
                                  className={
                                    index <= currentStep ? "active" : ""
                                  }
                                >
                                  {type}
                                </li>
                              ))}
                            </ul>

                            {/* Sliding Forms Container */}
                            <form className="power-requirement-stalls-form-wrapper">
                              {powerTypes.map((type, index) => (
                                <div
                                  key={type}
                                  className={`power-requirement-stalls-form-grid ${
                                    index === currentStep
                                      ? "slide-active"
                                      : index < currentStep
                                        ? "slide-left"
                                        : "slide-right"
                                  }`}
                                >
                                  {/* Row 1 */}
                                  <div className="power-requirement-stalls-form-row">
                                    <div className="power-requirement-stalls-form-group">
                                      <label>TYPE:</label>
                                      <input
                                        type="text"
                                        value={exhibitorSelectedDay}
                                        readOnly
                                      />
                                    </div>

                                    <div className="power-requirement-stalls-form-group">
                                      <label>PRICE PER KW:</label>
                                      <input
                                        type="text"
                                        value={exhibitorPricePerKw}
                                        readOnly
                                      />
                                    </div>
                                  </div>

                                  {/* Row 2 */}
                                  <div className="power-requirement-stalls-form-row">
                                    <div className="power-requirement-stalls-form-group">
                                      <label>POWER REQUIRED:</label>
                                      <input
                                        type="number"
                                        name="power_required"
                                        value={exhibitorPowerRequired}
                                        onChange={handleExhibitorPowerChange}
                                      />
                                    </div>

                                    <div className="power-requirement-stalls-form-group">
                                      <label>PHASE:</label>
                                      <div className="phase-options">
                                        <label>
                                          <input
                                            type="radio"
                                            name={`phase-${index}`}
                                            value="Single Phase"
                                            checked={
                                              exhibitorPhase === "Single Phase"
                                            }
                                            onChange={
                                              handleExhibitorPhaseChange
                                            }
                                          />
                                          Single
                                        </label>
                                        <label>
                                          <input
                                            type="radio"
                                            name={`phase-${index}`}
                                            value="Three Phase"
                                            checked={
                                              exhibitorPhase === "Three Phase"
                                            }
                                            onChange={
                                              handleExhibitorPhaseChange
                                            }
                                          />
                                          Three
                                        </label>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Row 3 */}
                                  <div className="power-requirement-stalls-form-row">
                                    <div className="power-requirement-stalls-form-group">
                                      <label>TOTAL AMOUNT:</label>
                                      <input
                                        type="text"
                                        name="total_amount"
                                        value={exhibitorTotalAmount}
                                        readOnly
                                      />
                                    </div>

                                    {/* Buttons */}
                                    <div className="power-requirement-add-button-inline">
                                      {currentStep > 0 && (
                                        <button
                                          type="button"
                                          onClick={handlePrevious}
                                        >
                                          Previous
                                        </button>
                                      )}
                                      {currentStep < powerTypes.length - 1 ? (
                                        <button
                                          type="button"
                                          onClick={handleNext}
                                        >
                                          Next
                                        </button>
                                      ) : (
                                        <button
                                          type="button"
                                          onClick={handleExhibitorAdd}
                                        >
                                          Add
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </form>
                          </div>

                          {/* Right Side Instructions */}
                          <div className="power-requirement-instruction-box">
                            {/* Top-Centered Buttons */}

                            <h3>Power Requirement Guidelines</h3>
                            <ul>
                              <li>
                                Power requirements for setup days and exhibition
                                days must be submitted separately.
                              </li>
                              <li>
                                Power will be arranged as per the requirement
                                form. Requests made after 28th February 2026 may
                                incur additional charges.
                              </li>
                              <li>
                                If unsure of your needs, please consult your
                                fabricator for accurate details.
                              </li>
                              <li>
                                Kindly ensure your contractor uses quality,
                                thick wiring. Additional charges may apply if
                                power usage exceeds the amount ordered.
                              </li>
                              <li>Thank you for your cooperation.</li>
                            </ul>

                            <div className="power-requirement-top-buttons-inside-box">
                              {/* Send Mail button always visible */}
                              {showExhibitorEditForm && (
                                <button
                                  className="power-btn send-mail-btn"
                                  onClick={() =>
                                    toast.promise(
                                      (async () => {
                                        await sendPowerRevisedMail(
                                          formData.company_name,
                                          formData.email,
                                        );
                                        await sendPowerVendorMail(
                                          formData.company_name,
                                        );
                                      })(),
                                      {
                                        loading: "Sending update mail...",
                                        success:
                                          "Updated power mail sent successfully",
                                        error: "Failed to send mail",
                                      },
                                    )
                                  }
                                >
                                  Send Update Power Mail
                                </button>
                              )}
                              <button
                                className="power-btn send-mail-btn"
                                onClick={() =>
                                  toast.promise(
                                    (async () => {
                                      await sendPowerMailToAdmin(
                                        formData.company_name,
                                      );
                                      await handleSendPowerDetailsMail(
                                        formData.company_name,
                                      );
                                    })(),
                                    {
                                      loading: "Sending mail...",
                                      success: "Mail sent successfully",
                                      error: "Failed to send mail",
                                    },
                                  )
                                }
                              >
                                Send Mail
                              </button>

                              {!isViewOnly && (
                                <>
                                  <button
                                    className="power-btn submit-btn"
                                    onClick={handleExhibitorPowerSubmit}
                                  >
                                    {showExhibitorEditForm
                                      ? "Update"
                                      : "Submit"}
                                  </button>

                                  {/* 🔹 Show Unlock button only if locked */}
                                  {isLocked && (
                                    <button
                                      className="power-btn unlock-btn"
                                      style={{
                                        backgroundColor: unlockRequested
                                          ? "#888"
                                          : "#ff9800",
                                        cursor: unlockRequested
                                          ? "not-allowed"
                                          : "pointer",
                                      }}
                                      disabled={unlockRequested}
                                      onClick={() =>
                                        handleUnlockPowerRequirement(
                                          formData.company_name,
                                        )
                                      }
                                    >
                                      {unlockRequested
                                        ? "Unlock Requested"
                                        : "Unlock"}
                                    </button>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Table + Billing Layout */}
                        <div className="power-requirement-below-section">
                          {/* Table */}
                          <div className="power-requirement-table-container">
                            <table>
                              <thead>
                                <tr>
                                  <th>Days</th>
                                  <th>Price per KW</th>
                                  <th>Power Required</th>
                                  <th>Phase</th>
                                  <th>Total Amount</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {exhibitorPreviewList.length === 0 ? (
                                  <tr>
                                    <td
                                      colSpan="6"
                                      style={{
                                        textAlign: "center",
                                        padding: "10px",
                                        color: "#e5e9ee",
                                      }}
                                    >
                                      No data to display
                                    </td>
                                  </tr>
                                ) : (
                                  exhibitorPreviewList.map((item, i) => (
                                    <tr key={i}>
                                      <td>{item.day}</td>
                                      <td>{item.pricePerKw}</td>
                                      <td>{item.powerRequired}</td>
                                      <td>{item.phase}</td>
                                      <td>{item.totalAmount}</td>
                                      <td>
                                        <button
                                          className="power-reset-btn"
                                          onClick={() =>
                                            handleResetRow(
                                              item,
                                              formData.company_name,
                                            )
                                          }
                                        >
                                          Remove
                                        </button>
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                          </div>

                          {/* Billing Section */}
                          <div className="power-requirement-billing">
                            <h3>Power Requirement Billing</h3>

                            <div className="power-requirement-stalls-forms-group">
                              <span className="power-label">Total Price:</span>
                              <strong>{totalPrice.toFixed(2)} ₹</strong>
                            </div>

                            {formData.state?.toLowerCase() === "delhi" ? (
                              <>
                                <div className="power-requirement-stalls-forms-group">
                                  <span className="power-label">
                                    CGST (9%):
                                  </span>
                                  <strong>{cgst.toFixed(2)} ₹</strong>
                                </div>
                                <div className="power-requirement-stalls-forms-group">
                                  <span className="power-label">
                                    SGST (9%):
                                  </span>
                                  <strong>{sgst.toFixed(2)} ₹</strong>
                                </div>
                              </>
                            ) : (
                              <div className="power-requirement-stalls-forms-group">
                                <span className="power-label">IGST (18%):</span>
                                <strong>{igst.toFixed(2)} ₹</strong>
                              </div>
                            )}

                            <div className="power-requirement-stalls-forms-group total">
                              <span className="power-label">Grand Total:</span>
                              <strong>{grandTotal.toFixed(2)} ₹</strong>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {activeNavbarItem === "EXHIBITOR BADGES" && (
                      <div className="exhibitor-badges-form slide-up-form">
                        <div className="badge-flex-container">
                          {/* Left Side */}
                          <div className="badge-left">
                            <div className="badges-instruction-box">
                              <h3 className="instruction-heading">
                                Exhibitor Badge Policy
                              </h3>
                              <div className="instruction-text">
                                <br />
                                <br />
                                As per your stall size, you will receive{" "}
                                <strong>
                                  {formData.free_badges || 0}
                                </strong>{" "}
                                complimentary badge
                                {formData.free_badges === 1 ? "" : "s"} for the
                                exhibition.
                                <br />
                                <br />
                                Additional badges can be requested at a cost of
                                ₹100 per badge. However, any badge requests made
                                after <strong>20th March 2026</strong> will be
                                charged at ₹200 per badge.
                                <br />
                                <br />
                                We kindly request you to order only the number
                                of badges you truly need, as issuing excess
                                badges poses a potential security risk.
                                <br />
                                <br />
                                Thank you for your cooperation.
                              </div>
                            </div>

                            <div className="extra-badges-form-grid">
                              <h3>Additional Badge Request</h3>

                              <div className="badge-fields-row">
                                {/* ───────── FREE BADGES ───────── */}
                                <div className="badge-box">
                                  <div className="field-row">
                                    <label htmlFor="free_badges">
                                      Free Badges:
                                    </label>
                                    <input
                                      type="number"
                                      id="free_badges"
                                      value={formData.free_badges || ""}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          free_badges: e.target.value,
                                        })
                                      }
                                    />
                                  </div>

                                  {!isViewOnly && (
                                    <button
                                      type="button"
                                      className="badge-update-btn"
                                      onClick={
                                        handleUpdateFreeExhibitorBadgesSubmit
                                      }
                                    >
                                      Update Free Badges
                                    </button>
                                  )}
                                </div>

                                {/* ───────── EXTRA BADGES ───────── */}
                                <div className="badge-box">
                                  <div className="field-row">
                                    <label htmlFor="extra_badges">
                                      Extra Badges:
                                    </label>
                                    <input
                                      type="number"
                                      id="extra_badges"
                                      value={formData.extra_badges || ""}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          extra_badges: e.target.value,
                                        })
                                      }
                                    />
                                  </div>

                                  {!isViewOnly && (
                                    <button
                                      type="button"
                                      className="badge-update-btn"
                                      onClick={handleExhibitorBadgesSubmit} // old function
                                    >
                                      Update Extra Badges
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Right Side: Billing */}
                          {parseInt(formData.extra_badges, 10) > 0 &&
                            (() => {
                              const count = parseInt(formData.extra_badges, 10);
                              const rate =
                                new Date() > new Date("2026-03-21") ? 200 : 100; // Corrected date to '2026-03-20'
                              const total = count * rate;

                              const companyState =
                                formData.state?.trim().toLowerCase() || "";
                              const isDelhi = companyState === "delhi";

                              const cgst = isDelhi ? total * 0.09 : 0;
                              const sgst = isDelhi ? total * 0.09 : 0;
                              const igst = !isDelhi ? total * 0.18 : 0;
                              const grandTotal = total + cgst + sgst + igst;

                              return (
                                <div className="badge-right exhibitor-billing-section">
                                  <div className="billing-summary-wrapper">
                                    <h3>Particulars</h3>

                                    <div className="billing-summary-container">
                                      <div className="billing-line">
                                        <span>Extra Badges</span>
                                        <span>{count}</span>
                                      </div>
                                      <div className="billing-line">
                                        <span>Total Amount</span>
                                        <span>₹{total.toFixed(2)}</span>
                                      </div>
                                      {isDelhi ? (
                                        <>
                                          <div className="billing-line">
                                            <span>CGST (9%)</span>
                                            <span>₹{cgst.toFixed(2)}</span>
                                          </div>
                                          <div className="billing-line">
                                            <span>SGST (9%)</span>
                                            <span>₹{sgst.toFixed(2)}</span>
                                          </div>
                                        </>
                                      ) : (
                                        <div className="billing-line">
                                          <span>IGST (18%)</span>
                                          <span>₹{igst.toFixed(2)}</span>
                                        </div>
                                      )}
                                      <div className="billing-line grand-total">
                                        <span>GRAND TOTAL</span>
                                        <span>₹{grandTotal.toFixed(2)}</span>
                                      </div>
                                    </div>

                                    <div className="billing-button-container">
                                      {isLocked && (
                                        <button
                                          type="button"
                                          className="unlock-btn"
                                          onClick={handleUnlockBadges}
                                          style={{
                                            backgroundColor: "#2ecc71",
                                            color: "white",
                                            padding: "8px 16px",
                                            border: "none",
                                            borderRadius: "5px",
                                            marginRight: "10px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          🔓 Unlock
                                        </button>
                                      )}

                                      <button
                                        type="button"
                                        className="send-mail-btn"
                                        onClick={() =>
                                          handleSendMail(
                                            "InOptics 2026 @ Badge Request Confirmation",
                                          )
                                        }
                                        disabled={isSendingMail}
                                      >
                                        {isSendingMail
                                          ? "Sending..."
                                          : "Send Mail"}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              );
                            })()}
                        </div>
                      </div>
                    )}

                    {activeNavbarItem === "APPOINTED CONTRACTOR" && (
                      <>
                        <div className="appointed-contractor-section">
                          <div className="left-column">
                            <div className="contractor-instruction-box">
                              <h3>CONTRACTORS INSTRUCTIONS</h3>
                              <p>
                                All contractors must be registered before the
                                deadline. ID badges must be collected prior to
                                exhibition day. Ensure proper documentation is
                                uploaded in the portal. Contractor undertaking
                                form is mandatory. Follow the venue safety and
                                conduct guidelines strictly.
                              </p>

                              {/* 🔥 New "Not Listed? Registration Form" Section */}
                              <div className="contractor-registration-line">
                                <span>Your contractor not listed? </span>
                                <button
                                  className="registration-form-btn"
                                  onClick={() => setShowRegistrationModal(true)}
                                >
                                  Click Here
                                </button>
                              </div>
                            </div>

                            {/* Contractor Table */}
                            <div className="appointed-contractor-wrapper">
                              <div className="exhibitor-cont-table-container">
                                <table className="appointed-contractor-table">
                                  <thead>
                                    <tr>
                                      <th>ID</th>
                                      <th>Name</th>
                                      <th>Company Name</th>
                                      <th>City</th>
                                      <th>Phn/Mob No</th>
                                      <th>Email</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {contractorData.map((contractor, index) => (
                                      <tr key={contractor.id}>
                                        <td>{index + 1}</td>
                                        <td>{contractor.name}</td>
                                        <td>{contractor.company_name}</td>
                                        <td>{contractor.city}</td>
                                        <td>
                                          {contractor.mobile_numbers || ""},{" "}
                                          {contractor.phone_numbers || ""}
                                        </td>
                                        <td>{contractor.email}</td>
                                        <td>
                                          {selectedContractorId ===
                                          contractor.id ? (
                                            <button
                                              className="unselect-btn"
                                              onClick={unselectContractor}
                                            >
                                              Unselect
                                            </button>
                                          ) : (
                                            <button
                                              className="select-btn"
                                              onClick={() => {
                                                selectContractor(contractor.id);
                                                setShowContractorOverlay(true);
                                              }}
                                              disabled={!!selectedContractorId}
                                            >
                                              Select
                                            </button>
                                          )}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>

                          {/* Right Column (Only Booth Design + Submit now) */}
                          <div className="contractor-actions">
                            <h4>Booth Design</h4>
                            <p className="booth-design-instruction">
                              Please upload a high-quality image of your booth
                              design. The image should clearly show the layout
                              and structural details.
                              <br />
                              <strong>
                                Recommended dimensions:
                              </strong> Width: <code>1200px</code>, Height:{" "}
                              <code>800px</code>.
                              <br />
                              Accepted formats: <code>.jpg</code>,{" "}
                              <code>.png</code>, <code>.pdf</code>. Maximum file
                              size: <code>5MB</code>.
                            </p>

                            <div className="booth-design-upload-section">
                              <label htmlFor="boothDesignUpload">
                                Upload Booth Design
                              </label>
                              <input
                                type="file"
                                id="boothDesignUpload"
                                name="boothDesignUpload"
                                disabled={!selectedContractorId}
                              />
                            </div>

                            <div className="form-submit align-bottom">
                              <button type="submit">
                                {showExhibitorEditForm ? "Update" : "Submit"}
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* ✅ New Registration Form Modal */}
                        {showRegistrationModal && (
                          <div
                            className="appointedcontractor-overlay-backdrop"
                            onClick={() => setShowRegistrationModal(false)}
                          >
                            <div
                              className="appointedcontractor-overlay"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <div className="appointedcontractor-overlay-header">
                                <h2>Contractor Registration Form</h2>
                                <button
                                  className="appointedcontractor-close-btn"
                                  onClick={() =>
                                    setShowRegistrationModal(false)
                                  }
                                >
                                  Close
                                </button>
                              </div>

                              <div className="appointedcontractor-modal-content">
                                <p className="appointedcontractor-instruction-text">
                                  FOR SMOOTH AND QUICK FUNCTIONALITY PLEASE
                                  FORWARD THIS REGISTRATION FORM TO YOUR
                                  CONTRACTOR AND ASK THEM TO FILL THE FORM AND
                                  THEN SEND THE FORM TO{" "}
                                  <strong>INOPTICS@GMAIL.COM</strong>
                                </p>

                                <div className="appointedcontractor-form-line">
                                  <label className="appointedcontractor-form-label">
                                    Please enter your contractor email address:
                                  </label>
                                  <input
                                    type="email"
                                    className="appointedcontractor-line-input"
                                    placeholder="Enter contractor email"
                                    value={contractorEmail}
                                    onChange={(e) =>
                                      setContractorEmail(e.target.value)
                                    }
                                  />
                                </div>

                                <div className="appointedcontractor-mail-preview">
                                  <h4>📧 Mail Preview</h4>
                                  <p>
                                    <strong>To:</strong> INOPTICS@GMAIL.COM
                                  </p>
                                  <p>
                                    <strong>Subject:</strong> Contractor
                                    Registration Form Submission
                                  </p>
                                  <p>
                                    <strong>Body:</strong> Dear Team, <br />{" "}
                                    Please find attached the contractor
                                    registration form for approval.
                                  </p>
                                </div>

                                <div className="appointedcontractor-action-buttons">
                                  {coreFormData.length > 0 && (
                                    <a
                                      href={`https://inoptics.in/api/uploads/${encodeURIComponent(
                                        coreFormData.find((form) =>
                                          form.category
                                            ?.toLowerCase()
                                            .includes(
                                              "contractor undertaking-declaration & registration",
                                            ),
                                        )?.filename || "",
                                      )}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="appointedcontractor-view-btn"
                                    >
                                      View Form
                                    </a>
                                  )}

                                  <button
                                    className="appointedcontractor-send-btn"
                                    onClick={() =>
                                      handleSendRegistrationMail(
                                        contractorEmail,
                                      )
                                    }
                                  >
                                    Send Mail
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {showContractorOverlay && (
                          <div
                            className="contractor-overlay-backdrop"
                            onClick={() => setShowContractorOverlay(false)}
                          >
                            <div
                              className="contractor-overlay"
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* Header */}
                              <div className="contractor-overlay-header">
                                <h2>Mandatory Required Information</h2>
                                <button
                                  className="contractor-close-btn"
                                  onClick={() =>
                                    setShowContractorOverlay(false)
                                  }
                                >
                                  Close
                                </button>
                              </div>

                              {/* Subheading */}
                              <h3 className="contractor-subheading">
                                Please follow it carefully
                              </h3>

                              {/* Instruction Box */}
                              <div className="contractor-instruction-box-modal">
                                <h4>Instruction</h4>
                                <ol>
                                  <li>
                                    Click here to{" "}
                                    <strong>Send the Undertaking Form</strong>{" "}
                                    to your selected contractor.
                                  </li>
                                  <li>
                                    FOR SMOOTH AND QUICK FUNCTIONALITY PLEASE
                                    FORWARD THIS UNDERTAKING FORM TO YOUR
                                    CONTRACTOR AND ASK THEM TO FILL THE FORM AND
                                    THEN SEND THE FORM TO{" "}
                                    <strong>INOPTICS@GMAIL.COM</strong>
                                  </li>
                                  <li>
                                    <strong>
                                      Set-Up & dismantling timetable
                                    </strong>
                                    <br />
                                    <br />
                                    <strong>Set up:</strong>
                                    <br /> ➤ Bare space: from 25/03/2026, 4:00
                                    PM to 27/03/2026, 4:00 PM
                                    <br /> ➤ Shell scheme: from 26/03/2026, 4:00
                                    PM to 27/03/2026, 4:00 PM
                                    <br />
                                    <br />
                                    <strong>Dismantling:</strong>
                                    <br /> ➤ Bare space: from 30/03/2026, 4:30
                                    PM to 30/03/2026, 12:00 MIDNIGHT
                                    <br /> ➤ Shell scheme: from 30/03/2026, 4:30
                                    PM to 30/03/2026, 9:00 PM
                                  </li>
                                  <li>
                                    Booth Design is also mandatory to be
                                    uploaded for approval with proper
                                    instruction given in the Booth Design space.
                                  </li>
                                  <li>
                                    After receiving the form, read it carefully.
                                    It should be filled by the contractor and
                                    then e-mail that form like this:
                                  </li>
                                </ol>

                                {/* Email Input + Preview */}
                                {/* <div className="appointedcontractor-form-line">
                                        <label className="appointedcontractor-form-label">
                                          Please enter your contractor email address:
                                        </label>
                                        <input
                                          type="email"
                                          className="appointedcontractor-line-input"
                                          placeholder="Enter contractor email"
                                          value={contractorEmail}
                                          onChange={(e) => setContractorEmail(e.target.value)}
                                        />
                                      </div> */}

                                <div className="appointedcontractor-mail-preview">
                                  <h4>📧 Mail Preview</h4>
                                  <p>
                                    <strong>To:</strong> INOPTICS@GMAIL.COM
                                  </p>
                                  <p>
                                    <strong>Subject:</strong> Contractor
                                    Registration Form Submission
                                  </p>
                                  <p>
                                    <strong>Body:</strong> Dear Team, <br />{" "}
                                    Please find attached the contractor
                                    registration form for approval.
                                  </p>
                                </div>

                                {/* View / Send Buttons */}
                                <div className="appointedcontractor-action-buttons">
                                  {coreFormData.length > 0 && (
                                    <a
                                      href={`https://inoptics.in/api/uploads/${encodeURIComponent(
                                        coreFormData.find((form) =>
                                          form.category
                                            ?.toLowerCase()
                                            .includes(
                                              "contractor undertaking-declaration & registration",
                                            ),
                                        )?.filename || "",
                                      )}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="appointedcontractor-view-btn"
                                    >
                                      View Form
                                    </a>
                                  )}

                                  <button
                                    className="appointedcontractor-send-btn"
                                    onClick={() =>
                                      handleSendRegistrationMail(
                                        contractorEmail,
                                      )
                                    }
                                  >
                                    Send Mail
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}

                    {activeNavbarItem === "EXTRA FURNITURE REQUIREMENT" && (
                      <>
                        {/* Available Furniture List */}
                        {showFurnitureList && (
                          <div className="exhibitor-extra-furniture-modal-overlay">
                            <div className="exhibitor-extra-furniture-modal-content-table">
                              {/* Header with Close Button */}
                              <div className="exhibitor-extra-furniture-modal-header">
                                <h2>Furniture List</h2>
                                <button
                                  className="exhibitor-extra-furniture-close-btn"
                                  onClick={() => setShowFurnitureList(false)}
                                >
                                  ×
                                </button>
                              </div>

                              {/* Furniture Cards Grid */}
                              <div className="exhibitor-extra-furniture-scrollable-body">
                                <div className="exhibitor-extra-furniture-grid">
                                  {furnitureData.map((item) => (
                                    <div
                                      key={item.id}
                                      className="furniture-card"
                                    >
                                      <img
                                        src={`https://www.inoptics.in/api/uploads/${item.image}`}
                                        alt={item.name}
                                        className="furniture-card-img"
                                      />
                                      <div className="furniture-card-name">
                                        {item.name}
                                      </div>
                                      <div className="furniture-card-price">
                                        ₹{item.price}
                                      </div>
                                      {selectedFurniture.find(
                                        (f) => f.id === item.id,
                                      ) ? (
                                        <button
                                          style={{
                                            backgroundColor: "#4caf50",
                                            cursor: "default",
                                          }}
                                          disabled
                                        >
                                          Selected
                                        </button>
                                      ) : (
                                        <button
                                          onClick={() => {
                                            setSelectedFurniture([
                                              ...selectedFurniture,
                                              {
                                                ...item,
                                                quantity: 1,
                                              },
                                            ]);
                                          }}
                                        >
                                          Select
                                        </button>
                                      )}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        <div
                          style={{
                            display: "flex",
                            gap: "60px",
                            alignItems: "flex-start",
                          }}
                        >
                          <div className="selected-furniture-table-wrapper">
                            <table className="selected-furniture-table">
                              <colgroup>
                                <col style={{ width: "40px" }} />
                                <col style={{ width: "120px" }} />
                                <col style={{ width: "180px" }} />
                                <col style={{ width: "100px" }} />
                                <col style={{ width: "100px" }} />
                                <col style={{ width: "100px" }} />
                                <col style={{ width: "100px" }} />
                              </colgroup>
                              <thead>
                                <tr>
                                  <th>ID</th>
                                  <th>Image</th>
                                  <th>Name</th>
                                  <th>Price</th>
                                  <th>Quantity</th>
                                  <th>Total</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {selectedFurniture.length > 0 ? (
                                  selectedFurniture.map((item, index) => (
                                    <tr key={item.id}>
                                      <td>{index + 1}</td>
                                      <td>
                                        <img
                                          src={`https://www.inoptics.in/api/uploads/${item.image}`}
                                          alt={item.name}
                                          width="100"
                                          height="100"
                                          style={{ objectFit: "cover" }}
                                        />
                                      </td>
                                      <td>{item.name}</td>
                                      <td>₹{item.price}</td>
                                      <td>
                                        <input
                                          type="number"
                                          min="1"
                                          value={item.quantity || ""}
                                          onChange={(e) =>
                                            handleQuantityChange(
                                              index,
                                              e.target.value,
                                            )
                                          }
                                          style={{ width: "60px" }}
                                        />
                                      </td>
                                      <td>
                                        ₹
                                        {item.quantity
                                          ? (
                                              item.quantity * item.price
                                            ).toFixed(2)
                                          : "0.00"}
                                      </td>
                                      <td>
                                        <button
                                          onClick={() =>
                                            setSelectedFurniture(
                                              selectedFurniture.filter(
                                                (_, i) => i !== index,
                                              ),
                                            )
                                          }
                                        >
                                          Delete
                                        </button>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="7"
                                      style={{
                                        textAlign: "center",
                                        padding: "10px",
                                      }}
                                    >
                                      No furniture selected yet.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                          {/* Extra Furniture Billing Section */}
                          <div
                            className="extra-furniture-billing-section"
                            style={{ width: "27%" }}
                          >
                            <div className="furniture-extra-action-button">
                              <div className="extra-furniture-add-button">
                                <button
                                  onClick={() =>
                                    setShowFurnitureList(!showFurnitureList)
                                  }
                                >
                                  Add Extra Furniture
                                </button>
                              </div>
                              <div
                                className="extra-furniture-billing-submit"
                                style={{ display: "flex", gap: "10px" }}
                              >
                                <button
                                  onClick={() => {
                                    // if (selectedFurniture.length === 0) {
                                    //   alert(
                                    //     "Please select at least one furniture item.",
                                    //   );
                                    //   return;
                                    // }

                                    const companyName =
                                      formData.company_name ||
                                      "Unknown Company";

                                    const payload = {
                                      company_name: companyName,
                                      furniture: selectedFurniture.map(
                                        (item) => ({
                                          image: item.image,
                                          name: item.name,
                                          price: item.price,
                                          quantity: item.quantity,
                                          total: item.quantity * item.price,
                                        }),
                                      ),
                                    };

                                    addExhibitorSelectedFurniture(payload);
                                    updateSelectedFurniture(
                                      companyName,
                                      selectedFurniture,
                                    )
                                      .then(() => {
                                        setSelectedFurniture([]);
                                      })
                                      .catch((err) => {
                                        console.error("Update failed:", err);
                                      });
                                  }}
                                >
                                  {showExhibitorEditForm ? "Update" : "Submit"}
                                </button>

                                {/* 🔓 Unlock Button (only when locked) */}
                                {lockState.is_locked === 1 && (
                                  <button
                                    style={{
                                      backgroundColor: "#f44336",
                                      color: "#fff",
                                    }}
                                    onClick={() =>
                                      handleAdminUnlock(formData.company_name)
                                    }
                                  >
                                    Unlock
                                  </button>
                                )}
                              </div>
                            </div>

                            <h3>Particulars</h3>

                            <div
                              style={{
                                fontSize: "15px",
                                lineHeight: "1.8",
                                fontFamily: "Segoe UI",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span>Total</span>
                                <span>
                                  ₹
                                  {furnitureBilling.amount?.toFixed(2) ||
                                    "0.00"}
                                </span>
                              </div>

                              {/* Taxes */}
                              {formData.state?.toLowerCase() === "delhi" ? (
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <span>CGST (9%)</span>
                                    <span>
                                      ₹
                                      {furnitureBilling.cgst?.toFixed(2) ||
                                        "0.00"}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <span>SGST (9%)</span>
                                    <span>
                                      ₹
                                      {furnitureBilling.sgst?.toFixed(2) ||
                                        "0.00"}
                                    </span>
                                  </div>
                                </>
                              ) : (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <span>IGST (18%)</span>
                                  <span>
                                    ₹
                                    {furnitureBilling.igst?.toFixed(2) ||
                                      "0.00"}
                                  </span>
                                </div>
                              )}

                              <hr style={{ margin: "15px 0" }} />

                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  fontWeight: "bold",
                                }}
                              >
                                <span>GRAND TOTAL</span>
                                <span>
                                  ₹
                                  {furnitureBilling.grandTotal?.toFixed(2) ||
                                    "0.00"}
                                </span>
                              </div>
                            </div>

                            <div className="Extra-Furniture-Instruction">
                              {/* === Dynamically fetched Furniture Vendor Description === */}
                              <div className="admin-vendor-wrapper">
                                {furnitureVendorDetails.length > 0 ? (
                                  furnitureVendorDetails.map((vendor) => (
                                    <div
                                      key={vendor.id}
                                      className="admin-vendor-card"
                                    >
                                      <div className="admin-vendor-row">
                                        <div className="admin-vendor-label">
                                          Vendor Name :
                                        </div>
                                        <div className="admin-vendor-value">
                                          {vendor.vendor_name}
                                        </div>
                                      </div>

                                      <div className="admin-vendor-row">
                                        <div className="admin-vendor-label">
                                          Company Name :
                                        </div>
                                        <div className="admin-vendor-value">
                                          {vendor.company_name}
                                        </div>
                                      </div>

                                      <div className="admin-vendor-row">
                                        <div className="admin-vendor-label">
                                          Email :
                                        </div>
                                        <div className="admin-vendor-value">
                                          {vendor.email}
                                        </div>
                                      </div>

                                      <div className="admin-vendor-row">
                                        <div className="admin-vendor-label">
                                          Contact No :
                                        </div>
                                        <div className="admin-vendor-value">
                                          {vendor.contact_number}
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <p className="admin-vendor-empty">
                                    No vendors found
                                  </p>
                                )}
                              </div>

                              {/* === Send Email Button === */}
                              <div className="billing-button-container">
                                <button
                                  type="button"
                                  className="send-mail-btn"
                                  onClick={() =>
                                    handleSendFurnitureMail(
                                      "InOptics 2026 @ Extra Furniture Request Confirmation",
                                    )
                                  }
                                  disabled={isSendingMail}
                                >
                                  {isSendingMail ? "Sending..." : "Send Mail"}
                                </button>

                                {/* 👇 Show loader overlay while sending */}
                                {isSendingMail && (
                                  <div className="waiting-overlay">
                                    <div className="waiting-loader"></div>
                                    <p>Sending mail, please wait...</p>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {activeNavbarItem === "PAYMENT DETAILS" && (
                      <div className="payment-details-form slide-up-form">
                        <div className="details-container">
                          {/* Company Details (Left) */}
                          <div className="company-details-box">
                            <h2 className="payment-details-form-heading">
                              Company Details
                            </h2>
                            <div className="company-details-grid">
                              <div className="row">
                                <label>
                                  <strong>Company Name:</strong>{" "}
                                  {formData.company_name}
                                </label>
                                <label>
                                  <strong>Address:</strong> {formData.address}
                                </label>
                              </div>
                              <div className="row">
                                <label>
                                  <strong>City:</strong> {formData.city}
                                </label>
                                <label>
                                  <strong>State:</strong> {formData.state}
                                </label>
                              </div>
                              <div className="row">
                                <label>
                                  <strong>Pincode:</strong> {formData.pin}
                                </label>
                                <label>
                                  <strong>Mobile:</strong> {formData.mobile}
                                </label>
                              </div>
                              <div className="row">
                                <label>
                                  <strong>Email:</strong> {formData.email}
                                </label>
                                <label>
                                  <strong>GST:</strong> {formData.gst}
                                </label>
                              </div>
                            </div>
                          </div>

                          {/* Booth Details (Right) */}
                          <div className="booth-details-box">
                            <h2 className="payment-details-form-heading">
                              Booth Details
                            </h2>

                            {stallList.length > 1 ? (
                              // 🔹 Show table if multiple stalls
                              <table className="booth-details-table">
                                <thead>
                                  <tr>
                                    <th>Stall No</th>
                                    <th>Category</th>
                                    <th>Area</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {stallList.map((stall, idx) => {
                                    // ✅ Format Stall Area (e.g., 12.00 → 12 sq mtr)
                                    let areaValue = stall.stall_area;
                                    if (
                                      areaValue !== null &&
                                      areaValue !== undefined &&
                                      areaValue !== ""
                                    ) {
                                      const num = parseFloat(areaValue);
                                      if (!isNaN(num)) {
                                        const formatted = Number.isInteger(num)
                                          ? num.toString()
                                          : num.toFixed(2);
                                        areaValue = `${formatted} sq mtr`;
                                      }
                                    } else {
                                      areaValue = "N/A";
                                    }

                                    return (
                                      <tr key={idx}>
                                        <td>{stall.stall_number}</td>
                                        <td>{stall.stall_category}</td>
                                        <td>{areaValue}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            ) : (
                              // 🔹 Show labels if single stall
                              <div className="payment-details-label-group">
                                <label>
                                  <strong>Stall No:</strong>{" "}
                                  {stallList[0]?.stall_number || "N/A"}
                                </label>
                                <label>
                                  <strong>Stall Category:</strong>{" "}
                                  {stallList[0]?.stall_category || "N/A"}
                                </label>
                                <label>
                                  <strong>Stall Area:</strong>{" "}
                                  {(() => {
                                    const areaValue = stallList[0]?.stall_area;
                                    if (
                                      areaValue !== null &&
                                      areaValue !== undefined &&
                                      areaValue !== ""
                                    ) {
                                      const num = parseFloat(areaValue);
                                      if (!isNaN(num)) {
                                        const formatted = Number.isInteger(num)
                                          ? num.toString()
                                          : num.toFixed(2);
                                        return `${formatted} sq mtr`;
                                      }
                                    }
                                    return "N/A";
                                  })()}
                                </label>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* ======= PAYMENT DETAILS CARDS SECTION ======= */}
                        <div className="payment-cards-container">
                          <h2 className="payment-details-form-heading">
                            PAYMENT DETAILS
                          </h2>

                          <div className="payment-card-grid">
                            {/* First Card: Stall Charges Summary */}
                            <div className="payment-card">
                              <h4>Stall Particulars</h4>

                              <div className="billing-summary">
                                <div className="billing-row">
                                  <span>Total:</span>
                                  <strong>
                                    {stallSummary.total.toFixed(2)}{" "}
                                    {stallSummary.currency}
                                  </strong>
                                </div>

                                {stallSummary.discounted_amount > 0 && (
                                  <div className="billing-row">
                                    <span>
                                      Discount (
                                      {getDiscountPercent(stallSummary)}
                                      %):
                                    </span>
                                    <strong>
                                      {stallSummary.discounted_amount.toFixed(
                                        2,
                                      )}{" "}
                                      {stallSummary.currency}
                                    </strong>
                                  </div>
                                )}

                                {formData?.state?.toLowerCase() === "delhi" ? (
                                  <>
                                    <div className="billing-row">
                                      <span>SGST (9%):</span>
                                      <strong>
                                        {stallSummary.sgst.toFixed(2)}{" "}
                                        {stallSummary.currency}
                                      </strong>
                                    </div>
                                    <div className="billing-row">
                                      <span>CGST (9%):</span>
                                      <strong>
                                        {stallSummary.cgst.toFixed(2)}{" "}
                                        {stallSummary.currency}
                                      </strong>
                                    </div>
                                  </>
                                ) : (
                                  <div className="billing-row">
                                    <span>IGST (18%):</span>
                                    <strong>
                                      {stallSummary.igst.toFixed(2)}{" "}
                                      {stallSummary.currency}
                                    </strong>
                                  </div>
                                )}

                                <div className="billing-row total">
                                  <span>Grand Total:</span>
                                  <strong>
                                    {stallSummary.grand_total.toFixed(2)}{" "}
                                    {stallSummary.currency}
                                  </strong>
                                </div>

                                {/* ✅ Overall Pending Amount Row */}
                                {pendingAmount !== null && (
                                  <div
                                    className="billing-row"
                                    style={{
                                      color:
                                        pendingAmount <= 0 ? "green" : "red",
                                      fontWeight: "bold",
                                      marginTop: "10px",
                                    }}
                                  >
                                    <span>
                                      {pendingAmount <= 0
                                        ? "PAYMENT CLEARED"
                                        : "PENDING AMOUNT"}
                                    </span>
                                    <strong>
                                      {pendingAmount.toFixed(2)}{" "}
                                      {stallSummary.currency}
                                    </strong>
                                  </div>
                                )}
                              </div>

                              <div
                                style={{
                                  alignSelf: "flex-end",
                                  marginTop: "auto",
                                }}
                              >
                                <button
                                  className="card-pay-now-btn"
                                  onClick={() => {
                                    setSelectedStallIndex(0); // select first stall (or change logic)
                                    setActiveOverlay("stall");
                                  }}
                                >
                                  Add Payment
                                </button>
                              </div>
                            </div>

                            {/* === Card 2: Power Requirement Billing === */}
                            <div className="payment-card">
                              <h4>Power Requirement</h4>

                              <div className="billing-summary">
                                <div className="billing-row">
                                  <span>Total:</span>
                                  <strong>{totalPrice.toFixed(2)} ₹</strong>
                                </div>

                                {formData?.state?.toLowerCase() === "delhi" ? (
                                  <>
                                    <div className="billing-row">
                                      <span>CGST (9%):</span>
                                      <strong>{cgst.toFixed(2)} ₹</strong>
                                    </div>
                                    <div className="billing-row">
                                      <span>SGST (9%):</span>
                                      <strong>{sgst.toFixed(2)} ₹</strong>
                                    </div>
                                  </>
                                ) : (
                                  <div className="billing-row">
                                    <span>IGST (18%):</span>
                                    <strong>{igst.toFixed(2)} ₹</strong>
                                  </div>
                                )}

                                <div className="billing-row total">
                                  <span>Grand Total:</span>
                                  <strong>{grandTotal.toFixed(2)} ₹</strong>
                                </div>

                                {/* ✅ Pending Amount for Power */}
                                {powerPendingAmount !== null && (
                                  <div
                                    className="billing-row"
                                    style={{
                                      color:
                                        powerPendingAmount <= 0
                                          ? "green"
                                          : "red",
                                      fontWeight: "bold",
                                      marginTop: "10px",
                                    }}
                                  >
                                    <span>
                                      {powerPendingAmount <= 0
                                        ? "PAYMENT CLEARED"
                                        : "PENDING AMOUNT"}
                                    </span>
                                    <strong>
                                      {powerPendingAmount.toFixed(2)} ₹
                                    </strong>
                                  </div>
                                )}
                              </div>

                              <div
                                style={{
                                  alignSelf: "flex-end",
                                  marginTop: "auto",
                                }}
                              >
                                <button
                                  className="card-pay-now-btn"
                                  onClick={() => setActiveOverlay("power")}
                                >
                                  Add Payment
                                </button>
                              </div>
                            </div>

                            {/* === Card 3: Exhibitor Badges Billing === */}
                            {(() => {
                              const {
                                count,
                                total,
                                cgst,
                                sgst,
                                igst,
                                grandTotal,
                              } = getExhibitorBadgeBilling();

                              return (
                                <div className="payment-card">
                                  <h4>Exhibitor Badges</h4>

                                  <div className="billing-summary">
                                    <div className="billing-row">
                                      <span>Extra Badges:</span>
                                      <strong>{count || 0}</strong>
                                    </div>
                                    <div className="billing-row">
                                      <span>Total Amount:</span>
                                      <strong>
                                        ₹{total?.toFixed(2) || "0.00"}
                                      </strong>
                                    </div>

                                    {formData?.state?.toLowerCase() ===
                                    "delhi" ? (
                                      <>
                                        <div className="billing-row">
                                          <span>CGST (9%):</span>
                                          <strong>
                                            ₹{cgst?.toFixed(2) || "0.00"}
                                          </strong>
                                        </div>
                                        <div className="billing-row">
                                          <span>SGST (9%):</span>
                                          <strong>
                                            ₹{sgst?.toFixed(2) || "0.00"}
                                          </strong>
                                        </div>
                                      </>
                                    ) : (
                                      <div className="billing-row">
                                        <span>IGST (18%):</span>
                                        <strong>
                                          ₹{igst?.toFixed(2) || "0.00"}
                                        </strong>
                                      </div>
                                    )}

                                    <div className="billing-row total">
                                      <span>Grand Total:</span>
                                      <strong>
                                        ₹{grandTotal?.toFixed(2) || "0.00"}
                                      </strong>
                                    </div>
                                  </div>

                                  <div
                                    style={{
                                      alignSelf: "flex-end",
                                      marginTop: "auto",
                                    }}
                                  >
                                    <button
                                      className="card-pay-now-btn"
                                      onClick={() => setActiveOverlay("badges")}
                                    >
                                      Add Payment
                                    </button>
                                  </div>
                                </div>
                              );
                            })()}

                            {/* === Remaining Placeholder Cards (4–8) === */}
                            {[...Array(5)].map((_, index) => (
                              <div key={index} className="payment-card">
                                <h4>Card Title {index + 4}</h4>
                                <p>Some detail or data here</p>
                              </div>
                            ))}
                          </div>
                        </div>

                        {activePaymentDetailsOverlay && (
                          <div className="payment-overlay-backdrop">
                            <div className="PaymentDetails-overlay-panel">
                              <div className="PaymentDetails-overlay-header">
                                <h3>
                                  {activePaymentDetailsOverlay === "stall"
                                    ? "Stall Payment"
                                    : activePaymentDetailsOverlay === "power"
                                      ? "Power Payment"
                                      : "Exhibitor Badges Payment"}
                                </h3>
                                <div className="payment-header-actions">
                                  <button
                                    className="payment-details-add-payment-btn small"
                                    onClick={() => {
                                      if (
                                        activePaymentDetailsOverlay === "stall"
                                      ) {
                                        const stall =
                                          stallList[selectedStallIndex];

                                        setFormTemplateData({
                                          recipient: formData.company_name,
                                          address1: formData.address,
                                          receiverEmail: formData.email,
                                          stateCity: `${formData.state}, ${formData.city}`,
                                          pincode: stall?.pin || formData.pin,
                                          senderState:
                                            activeAddress.data?.state,
                                          discount:
                                            stall?.discounted_amount || 0,
                                          discountPercent:
                                            stall?.discount_percent || 0,
                                        });

                                        setInvoiceOverlayVisible(true);
                                      } else if (
                                        activePaymentDetailsOverlay === "power"
                                      ) {
                                        // For power payment
                                        setFormTemplateData({
                                          recipient: formData.company_name,
                                          address1: formData.address,
                                          receiverEmail: formData.email,
                                          stateCity: `${formData.state}, ${formData.city}`,
                                          pincode: formData.pin,
                                          senderState:
                                            activeAddress.data?.state,
                                          discount: 0, // Power payments might not have discount
                                          discountPercent: 0,
                                        });

                                        setInvoiceOverlayVisible(true);
                                      }
                                    }}
                                  >
                                    Proforma Invoice
                                  </button>
                                  <button
                                    className="payment-header-close-btn"
                                    onClick={() => setActiveOverlay(null)}
                                  >
                                    Close
                                  </button>
                                </div>
                              </div>

                              {/* Entire scrollable content inside this panel */}
                              {activePaymentDetailsOverlay === "stall" &&
                                selectedStallIndex !== null &&
                                (() => {
                                  const stall = stallList[selectedStallIndex];
                                  if (!stall)
                                    return <p>No stall data found.</p>;

                                  const totalPaidWithTDS = payments.reduce(
                                    (sum, pay) => {
                                      const amount = parseFloat(
                                        pay.amount || pay.amount_paid || 0,
                                      );
                                      const tds = parseFloat(pay.tds || 0);
                                      return sum + amount + tds;
                                    },
                                    0,
                                  );

                                  const grandTotal =
                                    stallList.length > 1
                                      ? parseFloat(
                                          stallSummary.grand_total || 0,
                                        )
                                      : parseFloat(stall.grand_total || 0);

                                  const pendingAmount =
                                    grandTotal - totalPaidWithTDS;

                                  return (
                                    <>
                                      <div className="payment-billing-flex-wrapper">
                                        {/* 🔹 Billing Details */}
                                        <div className="stallpayment-billing-details">
                                          <h3>Particulars</h3>

                                          {stallList.length > 1 ? (
                                            <table className="stall-booth-details-table">
                                              <thead>
                                                <tr>
                                                  <th>Stall No</th>
                                                  <th>Category</th>
                                                  <th>Area</th>
                                                  <th>Price (per sq.mtrs)</th>
                                                  <th>Total</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {stallList.map((s, idx) => (
                                                  <tr key={idx}>
                                                    <td>
                                                      {s.stall_number || "-"}
                                                    </td>
                                                    <td>
                                                      {s.stall_category || "-"}
                                                    </td>
                                                    <td>
                                                      {s.stall_area
                                                        ? `${parseFloat(
                                                            s.stall_area,
                                                          ).toFixed(0)} sq mtr`
                                                        : "-"}
                                                    </td>
                                                    <td>
                                                      {s.stall_price || "-"}{" "}
                                                      {s.currency || ""}
                                                    </td>
                                                    <td>
                                                      {(
                                                        (parseFloat(
                                                          s.stall_area,
                                                        ) || 0) *
                                                        (parseFloat(
                                                          s.stall_price,
                                                        ) || 0)
                                                      ).toFixed(2)}
                                                    </td>
                                                  </tr>
                                                ))}

                                                <tr
                                                  className="grand-total-row"
                                                  style={{
                                                    fontWeight: "bold",
                                                    background: "#f1f1f1",
                                                  }}
                                                >
                                                  <td
                                                    colSpan={4}
                                                    style={{
                                                      textAlign: "right",
                                                    }}
                                                  >
                                                    Total
                                                  </td>
                                                  <td>
                                                    {stallList
                                                      .reduce(
                                                        (sum, s) =>
                                                          sum +
                                                          parseFloat(
                                                            s.stall_area || 0,
                                                          ) *
                                                            parseFloat(
                                                              s.stall_price ||
                                                                0,
                                                            ),
                                                        0,
                                                      )
                                                      .toFixed(2)}
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          ) : (
                                            <>
                                              <div className="billing-row">
                                                <span>Stall Number:</span>
                                                <strong>
                                                  {stall.stall_number || "-"}
                                                </strong>
                                              </div>
                                              <div className="billing-row">
                                                <span>Hall Number:</span>
                                                <strong>
                                                  {stall.hall_number || "-"}
                                                </strong>
                                              </div>
                                              <div className="billing-row">
                                                <span>Stall Category:</span>
                                                <strong>
                                                  {stall.stall_category || "-"}
                                                </strong>
                                              </div>
                                              <div className="billing-row">
                                                <span>Stall Area:</span>
                                                <strong>
                                                  {stall.stall_area
                                                    ? `${parseFloat(
                                                        stall.stall_area,
                                                      ).toFixed(0)} sq mtr`
                                                    : "-"}
                                                </strong>
                                              </div>
                                              <div className="billing-row">
                                                <span>
                                                  Stall Price (per sq mtrs):
                                                </span>
                                                <strong>
                                                  {stall.stall_price || "-"}{" "}
                                                  {stall.currency || ""}
                                                </strong>
                                              </div>
                                              <div className="billing-row">
                                                <span>Total:</span>
                                                <strong>
                                                  {(
                                                    parseFloat(
                                                      stall.stall_area || 0,
                                                    ) *
                                                      parseFloat(
                                                        stall.stall_price || 0,
                                                      ) || 0
                                                  ).toFixed(2)}{" "}
                                                  {stall.currency}
                                                </strong>
                                              </div>
                                            </>
                                          )}

                                          <h3>Billing Details</h3>

                                          {stallList.length > 1 ? (
                                            <>
                                              <div className="billing-row">
                                                <span>Total:</span>
                                                <strong>
                                                  {stallSummary.total.toFixed(
                                                    2,
                                                  )}{" "}
                                                  {stallSummary.currency}
                                                </strong>
                                              </div>

                                              {stallSummary.discounted_amount >
                                                0 && (
                                                <div className="billing-row">
                                                  <span>
                                                    Discount (
                                                    {getDiscountPercent(
                                                      stallSummary,
                                                    )}
                                                    %):
                                                  </span>
                                                  <strong>
                                                    {stallSummary.discounted_amount.toFixed(
                                                      2,
                                                    )}{" "}
                                                    {stallSummary.currency}
                                                  </strong>
                                                </div>
                                              )}

                                              {/* ✅ TOTAL AFTER DISCOUNT */}
                                              {stallSummary.discounted_amount >
                                                0 && (
                                                <div className="billing-row">
                                                  <span>
                                                    Total After Discount:
                                                  </span>
                                                  <strong>
                                                    {(
                                                      stallSummary.total -
                                                      stallSummary.discounted_amount
                                                    ).toFixed(2)}{" "}
                                                    {stallSummary.currency}
                                                  </strong>
                                                </div>
                                              )}

                                              {formData.state?.toLowerCase() ===
                                              "delhi" ? (
                                                <>
                                                  <div className="billing-row">
                                                    <span>SGST (9%):</span>
                                                    <strong>
                                                      {stallSummary.sgst.toFixed(
                                                        2,
                                                      )}{" "}
                                                      {stallSummary.currency}
                                                    </strong>
                                                  </div>
                                                  <div className="billing-row">
                                                    <span>CGST (9%):</span>
                                                    <strong>
                                                      {stallSummary.cgst.toFixed(
                                                        2,
                                                      )}{" "}
                                                      {stallSummary.currency}
                                                    </strong>
                                                  </div>
                                                </>
                                              ) : (
                                                <div className="billing-row">
                                                  <span>IGST (18%):</span>
                                                  <strong>
                                                    {stallSummary.igst.toFixed(
                                                      2,
                                                    )}{" "}
                                                    {stallSummary.currency}
                                                  </strong>
                                                </div>
                                              )}

                                              <div className="billing-row total">
                                                <span>Grand Total:</span>
                                                <strong>
                                                  {stallSummary.grand_total.toFixed(
                                                    2,
                                                  )}{" "}
                                                  {stallSummary.currency}
                                                </strong>
                                              </div>
                                            </>
                                          ) : (
                                            <>
                                              <div className="billing-row">
                                                <span>Total:</span>
                                                <strong>
                                                  {stall.total || "0.00"}{" "}
                                                  {stall.currency}
                                                </strong>
                                              </div>

                                              {stall.discount_percent &&
                                                parseFloat(
                                                  stall.discount_percent,
                                                ) > 0 && (
                                                  <div className="billing-row">
                                                    <span>
                                                      Discount (
                                                      {stall.discount_percent}
                                                      %):
                                                    </span>
                                                    <strong>
                                                      {stall.discounted_amount}{" "}
                                                      {stall.currency}
                                                    </strong>
                                                  </div>
                                                )}

                                              {stall.discount_percent &&
                                                parseFloat(
                                                  stall.discount_percent,
                                                ) > 0 && (
                                                  <div className="billing-row">
                                                    <span>
                                                      Total After Discount (
                                                      {stall.discount_percent}
                                                      %):
                                                    </span>
                                                    <strong>
                                                      {(
                                                        parseFloat(
                                                          stall.total || 0,
                                                        ) -
                                                        parseFloat(
                                                          stall.discounted_amount ||
                                                            0,
                                                        )
                                                      ).toFixed(2)}{" "}
                                                      {stall.currency}
                                                    </strong>
                                                  </div>
                                                )}

                                              {formData.state?.toLowerCase() ===
                                              "delhi" ? (
                                                <>
                                                  <div className="billing-row">
                                                    <span>SGST (9%):</span>
                                                    <strong>
                                                      {stall.sgst_9_percent ||
                                                        "0.00"}{" "}
                                                      {stall.currency}
                                                    </strong>
                                                  </div>
                                                  <div className="billing-row">
                                                    <span>CGST (9%):</span>
                                                    <strong>
                                                      {stall.cgst_9_percent ||
                                                        "0.00"}{" "}
                                                      {stall.currency}
                                                    </strong>
                                                  </div>
                                                </>
                                              ) : (
                                                <div className="billing-row">
                                                  <span>IGST (18%):</span>
                                                  <strong>
                                                    {stall.igst_18_percent ||
                                                      "0.00"}{" "}
                                                    {stall.currency}
                                                  </strong>
                                                </div>
                                              )}

                                              <div className="billing-row total">
                                                <span>Grand Total:</span>
                                                <strong>
                                                  {stall.grand_total || "0.00"}{" "}
                                                  {stall.currency}
                                                </strong>
                                              </div>
                                            </>
                                          )}

                                          {payments.length > 0 && (
                                            <div
                                              style={{
                                                marginTop: "16px",
                                              }}
                                            >
                                              {payments.map((pay, index) => {
                                                const amount = parseFloat(
                                                  pay.amount ||
                                                    pay.amount_paid ||
                                                    0,
                                                );
                                                const tds = parseFloat(
                                                  pay.tds || 0,
                                                );

                                                return (
                                                  <div
                                                    key={index}
                                                    style={{
                                                      marginBottom: "8px",
                                                    }}
                                                  >
                                                    <div className="billing-row">
                                                      <span>
                                                        Payment {index + 1}:
                                                      </span>
                                                      <strong>
                                                        {amount.toFixed(2)}{" "}
                                                        {stall.currency}
                                                      </strong>
                                                    </div>

                                                    <div className="billing-row">
                                                      <span>
                                                        TDS {index + 1}:
                                                      </span>
                                                      <strong>
                                                        {tds.toFixed(2)}{" "}
                                                        {stall.currency}
                                                      </strong>
                                                    </div>
                                                  </div>
                                                );
                                              })}

                                              <hr
                                                style={{
                                                  borderTop: "1px dashed #999",
                                                  margin: "12px 0",
                                                }}
                                              />

                                              {/* ✅ TOTAL PAYMENT AFTER TDS */}
                                              <div className="billing-row total">
                                                <span>
                                                  Total Payment After TDS:
                                                </span>
                                                <strong>
                                                  {totalPaymentWithTDS.toFixed(
                                                    2,
                                                  )}{" "}
                                                  {stall.currency}
                                                </strong>
                                              </div>

                                              {/* ✅ PENDING / CLEARED */}
                                              <div
                                                className="billing-row total"
                                                style={{
                                                  color:
                                                    pendingAmount <= 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                <span>
                                                  {pendingAmount <= 0
                                                    ? "PAYMENT CLEARED"
                                                    : "PENDING AMOUNT"}
                                                </span>
                                                <strong>
                                                  {pendingAmount > 0
                                                    ? `${pendingAmount.toFixed(2)} ${stall.currency}`
                                                    : `0.00 ${stall.currency}`}
                                                </strong>
                                              </div>
                                            </div>
                                          )}
                                        </div>

                                        {/* 🔹 Payment Form moved here */}
                                        <div className="new-payment-form-section">
                                          <h2 className="payment-details-form-heading">
                                            Payment Details
                                          </h2>
                                          <div className="new-payment-form-grid">
                                            <div className="new-payment-form-row">
                                              <div className="new-payment-input-group">
                                                <label className="new-payment-inputlabel">
                                                  Payment Type:
                                                </label>
                                                <input
                                                  className="new-payment-inputbox"
                                                  type="text"
                                                  placeholder="CHQ/NEFT/IMPS"
                                                  value={paymentType}
                                                  onChange={(e) =>
                                                    setPaymentType(
                                                      e.target.value,
                                                    )
                                                  }
                                                />
                                              </div>
                                              <div className="new-payment-input-group">
                                                <label className="new-payment-inputlabel">
                                                  Payment Date:
                                                </label>
                                                <input
                                                  className="new-payment-inputbox"
                                                  type="date"
                                                  value={paymentDate}
                                                  onChange={(e) =>
                                                    setPaymentDate(
                                                      e.target.value,
                                                    )
                                                  }
                                                />
                                              </div>
                                            </div>

                                            {/* Row 2: Exhibitor Bank + Receiver Bank */}
                                            <div className="new-payment-form-row">
                                              <div className="new-payment-input-group">
                                                <label className="new-payment-inputlabel">
                                                  Name of Exhibitor Bank:
                                                </label>
                                                <input
                                                  className="new-payment-inputbox"
                                                  type="text"
                                                  placeholder="Exhibitor Bank Name"
                                                  value={exhibitorBankName}
                                                  onChange={(e) =>
                                                    setExhibitorBankName(
                                                      e.target.value,
                                                    )
                                                  }
                                                />
                                              </div>

                                              <div className="new-payment-input-group">
                                                <label className="new-payment-inputlabel">
                                                  Name of Receiver Bank:
                                                </label>
                                                <input
                                                  className="new-payment-inputbox"
                                                  type="text"
                                                  placeholder="Receiver Bank Name"
                                                  value={receiverBankName}
                                                  onChange={(e) =>
                                                    setReceiverBankName(
                                                      e.target.value,
                                                    )
                                                  }
                                                />
                                              </div>
                                            </div>

                                            {/* Row 3: Amount + TDS */}
                                            <div className="new-payment-form-row">
                                              <div className="new-payment-input-group">
                                                <label className="new-payment-inputlabel">
                                                  Amount:
                                                </label>
                                                <input
                                                  className="new-payment-inputbox"
                                                  type="number"
                                                  placeholder="Amount"
                                                  value={amount}
                                                  onChange={(e) =>
                                                    setAmount(e.target.value)
                                                  }
                                                />
                                              </div>

                                              <div className="new-payment-input-group">
                                                <label className="new-payment-inputlabel">
                                                  TDS:
                                                </label>
                                                <input
                                                  className="new-payment-inputbox"
                                                  type="number"
                                                  placeholder="TDS"
                                                  value={tds}
                                                  onChange={(e) =>
                                                    setTds(e.target.value)
                                                  }
                                                />
                                              </div>
                                            </div>

                                            {/* Row 4: Button */}
                                            <div className="new-payment-form-row button-row">
                                              <div className="new-payment-add-button-inline">
                                                {editingIndex === null ? (
                                                  <button
                                                    className="new-payment-add-btn"
                                                    onClick={handleAddPayment}
                                                  >
                                                    Add Payment
                                                  </button>
                                                ) : (
                                                  <button
                                                    className="new-payment-update-btn"
                                                    onClick={
                                                      handleUpdatePayment
                                                    }
                                                  >
                                                    Update Payment
                                                  </button>
                                                )}
                                              </div>
                                            </div>

                                            <div className="remark-section">
                                              {/* TEXT AREA */}
                                              <textarea
                                                style={{ width: "100%" }}
                                                className="remark-textarea"
                                                placeholder="Enter remark here..."
                                                disabled={
                                                  !editingRemarkId &&
                                                  remarkSaved
                                                }
                                                value={remarkText}
                                                onChange={(e) =>
                                                  setRemarkText(e.target.value)
                                                }
                                                rows={2}
                                              />

                                              <div className="remark-button-row">
                                                {remarkSaved && (
                                                  <button
                                                    className="remark-send-btn"
                                                    onClick={handleSendEmail}
                                                  >
                                                    Send Email
                                                  </button>
                                                )}

                                                {!remarkSaved ? (
                                                  <button
                                                    className="remark-save-btn"
                                                    onClick={handleSaveRemark}
                                                  >
                                                    Save Remark
                                                  </button>
                                                ) : (
                                                  <button
                                                    className="remark-edit-btn"
                                                    onClick={
                                                      handleUpdateCompanyRemark
                                                    }
                                                  >
                                                    update Remark
                                                  </button>
                                                )}
                                              </div>

                                              {/* 🔥 ALL COMPANY REMARKS BELOW */}
                                              {companyRemarks.length > 0 && (
                                                <div className="company-remarks-list">
                                                  <h3
                                                    style={{
                                                      marginTop: "15px",
                                                    }}
                                                  >
                                                    Previous Remarks
                                                  </h3>

                                                  {companyRemarks.map(
                                                    (item) => (
                                                      <div
                                                        key={item.id}
                                                        className="remark-history-box"
                                                      >
                                                        <div className="remark-content">
                                                          <p>{item.remark}</p>
                                                        </div>

                                                        <div className="remark-actions">
                                                          <span
                                                            className="remark-edit-icon"
                                                            onClick={() =>
                                                              handleEditCompanyRemark(
                                                                item,
                                                              )
                                                            }
                                                          >
                                                            <FaEdit />
                                                          </span>

                                                          <span
                                                            className="remark-delete-icon"
                                                            onClick={() =>
                                                              handleDeleteCompanyRemark(
                                                                item.id,
                                                              )
                                                            }
                                                          >
                                                            <FaTrash />
                                                          </span>
                                                        </div>
                                                      </div>
                                                    ),
                                                  )}
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      {/* 🔹 Payments row only shows Added Payments now */}
                                      <div className="payment-main-row">
                                        <div className="added-payments-section full-width">
                                          <h2 className="payment-details-form-heading">
                                            Added Payments
                                          </h2>
                                          {payments.length === 0 ? (
                                            <p style={{ padding: "8px 0" }}>
                                              No payment records added yet.
                                            </p>
                                          ) : (
                                            <div className="payment-table-container">
                                              <table className="payment-details-table">
                                                <thead>
                                                  <tr>
                                                    <th>Payment Type</th>
                                                    <th>Payment Date</th>
                                                    <th>Exhibitor Bank</th>
                                                    <th>Receiver Bank</th>
                                                    <th>Received Payment</th>
                                                    <th>TDS</th>
                                                    <th>Action</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {payments.map(
                                                    (pay, index) => (
                                                      <tr key={index}>
                                                        <td>
                                                          {pay.type ||
                                                            pay.payment_type}
                                                        </td>
                                                        <td>
                                                          {pay.date ||
                                                            pay.payment_date}
                                                        </td>
                                                        <td>
                                                          {pay.exhibitorBank ||
                                                            pay.name_of_exhibitor_bank}
                                                        </td>
                                                        <td>
                                                          {pay.receiverBank ||
                                                            pay.name_of_receiver_bank}
                                                        </td>

                                                        <td>
                                                          {pay.amount ||
                                                            pay.amount_paid}
                                                        </td>
                                                        <td>
                                                          {pay.tds || "0.00"}
                                                        </td>
                                                        <td>
                                                          <button
                                                            onClick={() =>
                                                              handleEditPayment(
                                                                index,
                                                              )
                                                            }
                                                            className="payment-edit-btn-table"
                                                          >
                                                            Edit
                                                          </button>
                                                          <button
                                                            onClick={() =>
                                                              handleDeletePayment(
                                                                index,
                                                              )
                                                            }
                                                            className="payment-delete-btn-table"
                                                          >
                                                            Delete
                                                          </button>
                                                        </td>
                                                      </tr>
                                                    ),
                                                  )}
                                                </tbody>
                                              </table>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  );
                                })()}

                              {activePaymentDetailsOverlay === "power" && (
                                <>
                                  <div className="payment-billing-flex-wrapper">
                                    {/* 🔹 Billing Details */}
                                    <div className="powerpayment-billing-details">
                                      <h3>Power Billing Details</h3>
                                      {exhibitorPreviewList.map(
                                        (item, index) => (
                                          <div
                                            key={index}
                                            className="power-billing-entry"
                                          >
                                            <h4>
                                              {index + 1}. {item.day}
                                            </h4>
                                            <div className="billing-row">
                                              <span>Price per KW:</span>
                                              <strong>
                                                {item.pricePerKw} ₹
                                              </strong>
                                            </div>
                                            <div className="billing-row">
                                              <span>Power Required:</span>
                                              <strong>
                                                {item.powerRequired} unit
                                              </strong>
                                            </div>
                                            <div className="billing-row">
                                              <span>Total Amount:</span>
                                              <strong>
                                                {item.totalAmount} ₹
                                              </strong>
                                            </div>
                                          </div>
                                        ),
                                      )}

                                      <hr />
                                      <div className="billing-row total">
                                        <span>Total Price:</span>
                                        <strong>
                                          {totalPrice.toFixed(2)} ₹
                                        </strong>
                                      </div>
                                      {formData.state?.toLowerCase() ===
                                      "delhi" ? (
                                        <>
                                          <div className="billing-row">
                                            <span>SGST (9%):</span>
                                            <strong>{sgst.toFixed(2)} ₹</strong>
                                          </div>
                                          <div className="billing-row">
                                            <span>CGST (9%):</span>
                                            <strong>{cgst.toFixed(2)} ₹</strong>
                                          </div>
                                        </>
                                      ) : (
                                        <div className="billing-row">
                                          <span>IGST (18%):</span>
                                          <strong>{igst.toFixed(2)} ₹</strong>
                                        </div>
                                      )}
                                      <div className="billing-row total">
                                        <span>Grand Total:</span>
                                        <strong>
                                          {grandTotal.toFixed(2)} ₹
                                        </strong>
                                      </div>

                                      {powerPayments.length > 0 && (
                                        <div style={{ marginTop: "16px" }}>
                                          {powerPayments.map((pay, index) => {
                                            const amount = parseFloat(
                                              pay.amount || 0,
                                            );
                                            const tds = parseFloat(
                                              pay.tds || 0,
                                            );
                                            const combined = amount + tds;
                                            return (
                                              <div
                                                className="billing-row"
                                                key={index}
                                              >
                                                <span>
                                                  Payment {index + 1}:{" "}
                                                  {tds > 0
                                                    ? "Amount Paid + TDS"
                                                    : "Amount Paid"}
                                                </span>
                                                <strong>
                                                  {combined.toFixed(2)} ₹
                                                </strong>
                                              </div>
                                            );
                                          })}

                                          <hr
                                            style={{
                                              borderTop: "1px dashed #999",
                                              margin: "10px 0",
                                            }}
                                          />
                                          <div
                                            className="billing-row"
                                            style={{
                                              color:
                                                powerPendingAmount <= 0
                                                  ? "green"
                                                  : "red",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            <span>
                                              {powerPendingAmount <= 0
                                                ? "PAYMENT CLEARED"
                                                : "PENDING AMOUNT"}
                                            </span>
                                            <strong>
                                              {powerPendingAmount > 0
                                                ? `${powerPendingAmount.toFixed(
                                                    2,
                                                  )} ₹`
                                                : "0.00 ₹"}
                                            </strong>
                                          </div>
                                        </div>
                                      )}
                                    </div>

                                    {/* 🔹 Payment Form moved here (replacing bank-cards-container) */}
                                    <div className="new-payment-form-section">
                                      <h2 className="payment-details-form-heading">
                                        Payment Details
                                      </h2>
                                      <div className="new-payment-form-grid">
                                        {/* Row 1: Payment Type + Date */}
                                        <div className="new-payment-form-row">
                                          <div className="new-payment-input-group">
                                            <label className="new-payment-inputlabel">
                                              Payment Type:
                                            </label>
                                            <input
                                              className="new-payment-inputbox"
                                              type="text"
                                              placeholder="CHQ/NEFT/IMPS"
                                              value={powerPaymentType}
                                              onChange={(e) =>
                                                setPowerPaymentType(
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </div>

                                          <div className="new-payment-input-group">
                                            <label className="new-payment-inputlabel">
                                              Payment Date:
                                            </label>
                                            <input
                                              className="new-payment-inputbox"
                                              type="date"
                                              value={powerPaymentDate}
                                              onChange={(e) =>
                                                setPowerPaymentDate(
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </div>
                                        </div>

                                        {/* Row 2: Exhibitor Bank + Receiver Bank */}
                                        <div className="new-payment-form-row">
                                          <div className="new-payment-input-group">
                                            <label className="new-payment-inputlabel">
                                              Name of Exhibitor Bank:
                                            </label>
                                            <input
                                              className="new-payment-inputbox"
                                              type="text"
                                              placeholder="Exhibitor Bank Name"
                                              value={powerExhibitorBankName}
                                              onChange={(e) =>
                                                setPowerExhibitorBankName(
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </div>

                                          <div className="new-payment-input-group">
                                            <label className="new-payment-inputlabel">
                                              Name of Receiver Bank:
                                            </label>
                                            <input
                                              className="new-payment-inputbox"
                                              type="text"
                                              placeholder="Receiver Bank Name"
                                              value={powerReceiverBankName}
                                              onChange={(e) =>
                                                setPowerReceiverBankName(
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </div>
                                        </div>

                                        {/* Row 3: Amount + TDS */}
                                        <div className="new-payment-form-row">
                                          <div className="new-payment-input-group">
                                            <label className="new-payment-inputlabel">
                                              Amount:
                                            </label>
                                            <input
                                              className="new-payment-inputbox"
                                              type="number"
                                              placeholder="Amount"
                                              value={powerAmount}
                                              onChange={(e) =>
                                                setPowerAmount(e.target.value)
                                              }
                                            />
                                          </div>

                                          <div className="new-payment-input-group">
                                            <label className="new-payment-inputlabel">
                                              TDS:
                                            </label>
                                            <input
                                              className="new-payment-inputbox"
                                              type="number"
                                              placeholder="TDS"
                                              value={powerTds}
                                              onChange={(e) =>
                                                setPowerTds(e.target.value)
                                              }
                                            />
                                          </div>
                                        </div>

                                        {/* Row 4: Add/Update Button */}
                                        <div className="new-payment-form-row button-row">
                                          <div className="new-payment-add-button-inline">
                                            {editingPowerIndex === null ? (
                                              <button
                                                className="new-payment-add-btn"
                                                onClick={handleAddPowerPayment}
                                              >
                                                Add Payment
                                              </button>
                                            ) : (
                                              <button
                                                className="new-payment-update-btn"
                                                onClick={
                                                  handleUpdatePowerPayment
                                                }
                                              >
                                                Update Payment
                                              </button>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* 🔹 Added Payments Section (Full Width) */}
                                  <div className="payment-main-row">
                                    <div className="added-payments-section full-width">
                                      <h2 className="payment-details-form-heading">
                                        Added Payments
                                      </h2>
                                      {powerPayments.length === 0 ? (
                                        <p style={{ padding: "8px 0" }}>
                                          No payment records added yet.
                                        </p>
                                      ) : (
                                        <div className="payment-table-container">
                                          <table className="payment-details-table">
                                            <thead>
                                              <tr>
                                                <th>Payment Type</th>
                                                <th>Payment Date</th>
                                                <th>Exhibitor Bank</th>
                                                <th>Receiver Bank</th>
                                                <th>Received Payment</th>
                                                <th>TDS</th>
                                                <th>Action</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {powerPayments.map(
                                                (pay, index) => (
                                                  <tr key={index}>
                                                    <td>{pay.type}</td>
                                                    <td>{pay.date}</td>
                                                    <td>{pay.exhibitorBank}</td>
                                                    <td>{pay.receiverBank}</td>
                                                    <td>{pay.amount}</td>
                                                    <td>{pay.tds}</td>
                                                    <td>
                                                      <button
                                                        onClick={() =>
                                                          handleEditPowerPayment(
                                                            index,
                                                          )
                                                        }
                                                        className="payment-edit-btn-table"
                                                      >
                                                        Edit
                                                      </button>
                                                      <button
                                                        onClick={() =>
                                                          handleDeletePowerPayment(
                                                            index,
                                                          )
                                                        }
                                                        className="payment-delete-btn-table"
                                                      >
                                                        Delete
                                                      </button>
                                                    </td>
                                                  </tr>
                                                ),
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </>
                              )}

                              {activePaymentDetailsOverlay === "badges" && (
                                <>
                                  <div className="payment-billing-flex-wrapper">
                                    {/* Left Side: Badge Policy and Billing */}
                                    <div className="badgepayment-billing-details">
                                      <div className="badges-instruction-box">
                                        <div className="instruction-text">
                                          <br />
                                          <br />
                                          As per your stall size, you will
                                          receive{" "}
                                          <strong>
                                            {formData.free_badges || 0}
                                          </strong>{" "}
                                          complimentary badge
                                          {formData.free_badges === 1
                                            ? ""
                                            : "s"}{" "}
                                          for the exhibition.
                                          <br />
                                        </div>
                                      </div>

                                      <div className="exhibitor-billing-section">
                                        <h3>Exhibitor Extra Badges Billing</h3>
                                        {parseInt(formData.extra_badges, 10) >
                                        0 ? (
                                          (() => {
                                            const {
                                              count,
                                              total,
                                              cgst,
                                              sgst,
                                              igst,
                                              grandTotal,
                                            } = getExhibitorBadgeBilling();

                                            // Calculate total paid amount including TDS
                                            const totalPaidWithTDS =
                                              badgePayments.reduce(
                                                (sum, pay) => {
                                                  const amount = parseFloat(
                                                    pay.amount || 0,
                                                  );
                                                  const tds = parseFloat(
                                                    pay.tds || 0,
                                                  );
                                                  return sum + amount + tds;
                                                },
                                                0,
                                              );

                                            // Calculate pending amount
                                            const badgePendingAmount =
                                              grandTotal - totalPaidWithTDS;

                                            return (
                                              <div className="billing-summary-wrapper">
                                                <div className="billing-summary-container">
                                                  <div className="billing-line">
                                                    <span>Extra Badges</span>
                                                    <span>{count}</span>
                                                  </div>
                                                  <div className="billing-line">
                                                    <span>Total Amount</span>
                                                    <span>
                                                      ₹{total.toFixed(2)}
                                                    </span>
                                                  </div>
                                                  {formData.state?.toLowerCase() ===
                                                  "delhi" ? (
                                                    <>
                                                      <div className="billing-line">
                                                        <span>CGST (9%)</span>
                                                        <span>
                                                          ₹{cgst.toFixed(2)}
                                                        </span>
                                                      </div>
                                                      <div className="billing-line">
                                                        <span>SGST (9%)</span>
                                                        <span>
                                                          ₹{sgst.toFixed(2)}
                                                        </span>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <div className="billing-line">
                                                      <span>IGST (18%)</span>
                                                      <span>
                                                        ₹{igst.toFixed(2)}
                                                      </span>
                                                    </div>
                                                  )}
                                                  <div className="billing-line grand-total">
                                                    <span>GRAND TOTAL</span>
                                                    <span>
                                                      ₹{grandTotal.toFixed(2)}
                                                    </span>
                                                  </div>

                                                  {badgePayments.length > 0 && (
                                                    <div
                                                      style={{
                                                        marginTop: "16px",
                                                      }}
                                                    >
                                                      {badgePayments.map(
                                                        (pay, index) => {
                                                          const amount =
                                                            parseFloat(
                                                              pay.amount || 0,
                                                            );
                                                          const tds =
                                                            parseFloat(
                                                              pay.tds || 0,
                                                            );
                                                          const combined =
                                                            amount + tds;
                                                          return (
                                                            <div
                                                              className="billing-row"
                                                              key={index}
                                                            >
                                                              <span>
                                                                Payment{" "}
                                                                {index + 1}:{" "}
                                                                {tds > 0
                                                                  ? "Amount Paid + TDS"
                                                                  : "Amount Paid"}
                                                              </span>
                                                              <strong>
                                                                ₹
                                                                {combined.toFixed(
                                                                  2,
                                                                )}
                                                              </strong>
                                                            </div>
                                                          );
                                                        },
                                                      )}

                                                      <hr
                                                        style={{
                                                          borderTop:
                                                            "1px dashed #999",
                                                          margin: "10px 0",
                                                        }}
                                                      />
                                                      <div
                                                        className="billing-row"
                                                        style={{
                                                          color:
                                                            badgePendingAmount <=
                                                            0
                                                              ? "green"
                                                              : "red",
                                                          fontWeight: "bold",
                                                        }}
                                                      >
                                                        <span>
                                                          {badgePendingAmount <=
                                                          0
                                                            ? "PAYMENT CLEARED"
                                                            : "PENDING AMOUNT"}
                                                        </span>
                                                        <strong>
                                                          {badgePendingAmount >
                                                          0
                                                            ? `₹${badgePendingAmount.toFixed(
                                                                2,
                                                              )}`
                                                            : "₹0.00"}
                                                        </strong>
                                                      </div>
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            );
                                          })()
                                        ) : (
                                          <p>No extra badges requested.</p>
                                        )}
                                      </div>
                                    </div>

                                    {/* Right Side: Payment Form */}
                                    <div className="new-payment-form-section">
                                      <h2 className="payment-details-form-heading">
                                        Payment Details
                                      </h2>
                                      <div className="new-payment-form-grid">
                                        {/* Row 1: Payment Type + Date */}
                                        <div className="new-payment-form-row">
                                          <div className="new-payment-input-group">
                                            <label className="new-payment-inputlabel">
                                              Payment Type:
                                            </label>
                                            <input
                                              className="new-payment-inputbox"
                                              type="text"
                                              placeholder="CHQ/NEFT/IMPS"
                                              value={badgePaymentType}
                                              onChange={(e) =>
                                                setBadgePaymentType(
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </div>
                                          <div className="new-payment-input-group">
                                            <label className="new-payment-inputlabel">
                                              Payment Date:
                                            </label>
                                            <input
                                              className="new-payment-inputbox"
                                              type="date"
                                              value={badgePaymentDate}
                                              onChange={(e) =>
                                                setBadgePaymentDate(
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </div>
                                        </div>

                                        {/* Row 2: Exhibitor Bank + Receiver Bank */}
                                        <div className="new-payment-form-row">
                                          <div className="new-payment-input-group">
                                            <label className="new-payment-inputlabel">
                                              Name of Exhibitor Bank:
                                            </label>
                                            <input
                                              className="new-payment-inputbox"
                                              type="text"
                                              placeholder="Exhibitor Bank Name"
                                              value={badgeExhibitorBankName}
                                              onChange={(e) =>
                                                setBadgeExhibitorBankName(
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </div>
                                          <div className="new-payment-input-group">
                                            <label className="new-payment-inputlabel">
                                              Name of Receiver Bank:
                                            </label>
                                            <input
                                              className="new-payment-inputbox"
                                              type="text"
                                              placeholder="Receiver Bank Name"
                                              value={badgeReceiverBankName}
                                              onChange={(e) =>
                                                setBadgeReceiverBankName(
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </div>
                                        </div>

                                        {/* Row 3: Amount + TDS */}
                                        <div className="new-payment-form-row">
                                          <div className="new-payment-input-group">
                                            <label className="new-payment-inputlabel">
                                              Amount:
                                            </label>
                                            <input
                                              className="new-payment-inputbox"
                                              type="number"
                                              placeholder="Amount"
                                              value={badgeAmount}
                                              onChange={(e) =>
                                                setBadgeAmount(e.target.value)
                                              }
                                            />
                                          </div>
                                          <div className="new-payment-input-group">
                                            <label className="new-payment-inputlabel">
                                              TDS:
                                            </label>
                                            <input
                                              className="new-payment-inputbox"
                                              type="number"
                                              placeholder="TDS"
                                              value={badgeTds}
                                              onChange={(e) =>
                                                setBadgeTds(e.target.value)
                                              }
                                            />
                                          </div>
                                        </div>

                                        {/* Row 4: Add/Update Button */}
                                        <div className="new-payment-form-row button-row">
                                          <div className="new-payment-add-button-inline">
                                            {editingBadgeIndex === null ? (
                                              <button
                                                className="new-payment-add-btn"
                                                onClick={handleAddBadgePayment}
                                              >
                                                Add Payment
                                              </button>
                                            ) : (
                                              <button
                                                className="new-payment-update-btn"
                                                onClick={
                                                  handleUpdateBadgePayment
                                                }
                                              >
                                                Update Payment
                                              </button>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Added Payments Section */}
                                  <div className="payment-main-row">
                                    <div className="added-payments-section full-width">
                                      <h2 className="payment-details-form-heading">
                                        Added Payments
                                      </h2>
                                      {badgePayments.length === 0 ? (
                                        <p style={{ padding: "8px 0" }}>
                                          No payment records added yet.
                                        </p>
                                      ) : (
                                        <div className="payment-table-container">
                                          <table className="payment-details-table">
                                            <thead>
                                              <tr>
                                                <th>Payment Type</th>
                                                <th>Payment Date</th>
                                                <th>Exhibitor Bank</th>
                                                <th>Receiver Bank</th>
                                                <th>Received Payment</th>
                                                <th>TDS</th>
                                                <th>Action</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {badgePayments.map(
                                                (pay, index) => (
                                                  <tr key={index}>
                                                    <td>{pay.type || "-"}</td>
                                                    <td>{pay.date || "-"}</td>
                                                    <td>
                                                      {pay.exhibitorBank || "-"}
                                                    </td>
                                                    <td>
                                                      {pay.receiverBank || "-"}
                                                    </td>
                                                    <td>
                                                      ₹
                                                      {parseFloat(
                                                        pay.amount || 0,
                                                      ).toFixed(2)}
                                                    </td>
                                                    <td>
                                                      ₹
                                                      {parseFloat(
                                                        pay.tds || 0,
                                                      ).toFixed(2)}
                                                    </td>
                                                    <td>
                                                      <button
                                                        onClick={() =>
                                                          handleEditBadgePayment(
                                                            index,
                                                          )
                                                        }
                                                        className="payment-edit-btn-table"
                                                      >
                                                        Edit
                                                      </button>
                                                      <button
                                                        onClick={() =>
                                                          handleDeleteBadgePayment(
                                                            index,
                                                          )
                                                        }
                                                        className="payment-delete-btn-table"
                                                      >
                                                        Delete
                                                      </button>
                                                    </td>
                                                  </tr>
                                                ),
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </>
                              )}

                              {invoiceOverlayVisible &&
                                (activePaymentDetailsOverlay === "stall" ||
                                  activePaymentDetailsOverlay === "power") && (
                                  <div className="invoice-overlay-slide">
                                    <button
                                      className="invoice-close-btn"
                                      onClick={() =>
                                        setInvoiceOverlayVisible(false)
                                      }
                                    >
                                      ✕
                                    </button>

                                    <div
                                      className="invoice-html-template"
                                      id="invoice-template"
                                    >
                                      <h2 className="template-title">
                                        PROFORMA INVOICE
                                      </h2>
                                      <hr />

                                      {/* HEADER: From & To Columns */}
                                      <div className="invoice-header-row">
                                        <div className="from-column">
                                          <img
                                            src={TemplateLogo}
                                            alt="Company Logo"
                                            className="invoice-logo"
                                          />
                                          <div className="from-address">
                                            {activeAddress ? (
                                              <>
                                                <p>
                                                  {activeAddress.data?.address}
                                                </p>
                                                <p>
                                                  {activeAddress.data?.state} -{" "}
                                                  {activeAddress.data?.pincode}
                                                </p>
                                                <p>
                                                  Phone:{" "}
                                                  {activeAddress.data?.phone}
                                                </p>
                                                <p>
                                                  Email:{" "}
                                                  {activeAddress.data?.email}
                                                </p>
                                                <p>
                                                  GST: {activeAddress.data?.gst}
                                                </p>
                                              </>
                                            ) : (
                                              <p style={{ color: "red" }}>
                                                No active address selected
                                              </p>
                                            )}
                                          </div>
                                        </div>

                                        <div className="to-column">
                                          <div className="to-details">
                                            <p>
                                              M/S {formTemplateData.recipient}
                                            </p>
                                            <p>{formTemplateData.address1}</p>
                                            <p>
                                              {
                                                formTemplateData.stateCity?.split(
                                                  ",",
                                                )[0]
                                              }{" "}
                                              - {formTemplateData.pincode}
                                            </p>
                                            <p>{formData.state}</p>
                                            <p>
                                              {formTemplateData.receiverEmail}
                                            </p>
                                            <label>
                                              <strong>GST:</strong>{" "}
                                              {formData.gst}
                                            </label>
                                          </div>
                                        </div>
                                      </div>

                                      <hr />

                                      {/* INVOICE META */}
                                      <div className="invoice-meta-row">
                                        <div className="invoice-meta-left">
                                          <p>
                                            <strong>
                                              Proforma Invoice No:
                                            </strong>{" "}
                                            {activePaymentDetailsOverlay ===
                                            "stall"
                                              ? stallProformaNumber
                                              : powerProformaNumber}
                                          </p>
                                        </div>
                                        <div className="invoice-meta-right">
                                          <p>
                                            <strong>Issue Date:</strong>{" "}
                                            {issueDate}
                                          </p>
                                        </div>
                                      </div>

                                      <hr />

                                      {/* TABLE */}
                                      <table
                                        className="invoice-table"
                                        style={{
                                          tableLayout: "fixed",
                                          width: "100%",
                                        }}
                                      >
                                        <thead>
                                          <tr>
                                            <th style={{ width: "40%" }}>
                                              PARTICULARS
                                            </th>

                                            {/* Stall dynamic columns */}
                                            {activePaymentDetailsOverlay ===
                                              "stall" &&
                                              stallService?.selectedOptions?.map(
                                                (opt, i) => (
                                                  <th
                                                    key={i}
                                                    style={{
                                                      width: "15%",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {opt}
                                                  </th>
                                                ),
                                              )}

                                            {/* Power dynamic columns */}
                                            {activePaymentDetailsOverlay ===
                                              "power" &&
                                              powerService?.selectedOptions?.map(
                                                (opt, i) => (
                                                  <th
                                                    key={i}
                                                    style={{
                                                      width: "15%",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {opt}
                                                  </th>
                                                ),
                                              )}

                                            {/* Only show PRICE column for stall */}
                                            {activePaymentDetailsOverlay ===
                                              "stall" && (
                                              <th
                                                style={{
                                                  width: "20%",
                                                  textAlign: "center",
                                                }}
                                              >
                                                PRICE (
                                                {stallSummary?.currency ||
                                                  "Rupees"}
                                                )
                                              </th>
                                            )}

                                            {/* TOTAL column is needed for both */}
                                            <th
                                              style={{
                                                width: "20%",
                                                textAlign: "center",
                                              }}
                                            >
                                              TOTAL (
                                              {stallSummary?.currency ||
                                                "Rupees"}
                                              )
                                            </th>
                                          </tr>
                                        </thead>

                                        <tbody>
                                          {activePaymentDetailsOverlay ===
                                            "stall" &&
                                            stallServiceRows.map(
                                              (row, rowIndex) => (
                                                <tr key={rowIndex}>
                                                  <td
                                                    className="particular-cell"
                                                    style={{
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    {row.particular
                                                      .split("\n")
                                                      .map((line, i) =>
                                                        line.startsWith("**") &&
                                                        line.endsWith("**") ? (
                                                          <strong key={i}>
                                                            {line.replace(
                                                              /\*\*/g,
                                                              "",
                                                            )}
                                                          </strong>
                                                        ) : (
                                                          <div key={i}>
                                                            {line}
                                                          </div>
                                                        ),
                                                      )}
                                                    {stallList[rowIndex] &&
                                                      stallList[rowIndex]
                                                        .stall_category && (
                                                        <div>
                                                          {stallList[
                                                            rowIndex
                                                          ].stall_category
                                                            .trim()
                                                            .split(" ")
                                                            .slice(0, -1)
                                                            .join(" ")}
                                                        </div>
                                                      )}
                                                  </td>

                                                  {/* Dynamic Stall Columns */}
                                                  {stallService?.selectedOptions?.map(
                                                    (opt, i) => {
                                                      let values = [];
                                                      if (
                                                        opt
                                                          .toLowerCase()
                                                          .includes("stall no")
                                                      ) {
                                                        values = stallList.map(
                                                          (st) =>
                                                            st.stall_number ||
                                                            "-",
                                                        );
                                                      } else if (
                                                        opt
                                                          .toLowerCase()
                                                          .includes("cat")
                                                      ) {
                                                        values = stallList.map(
                                                          (st) => {
                                                            if (
                                                              !st.stall_category
                                                            )
                                                              return "-";
                                                            const parts =
                                                              st.stall_category
                                                                .trim()
                                                                .split(" ");
                                                            return parts.pop();
                                                          },
                                                        );
                                                      } else if (
                                                        opt
                                                          .toLowerCase()
                                                          .includes(
                                                            "stall size",
                                                          )
                                                      ) {
                                                        values = stallList.map(
                                                          (st) =>
                                                            st.stall_area ||
                                                            "-",
                                                        );
                                                      }
                                                      return (
                                                        <td
                                                          key={i}
                                                          style={{
                                                            textAlign: "center",
                                                          }}
                                                        >
                                                          {values.map(
                                                            (val, idx) => (
                                                              <div key={idx}>
                                                                {val}
                                                              </div>
                                                            ),
                                                          )}
                                                        </td>
                                                      );
                                                    },
                                                  )}

                                                  {/* Price Column */}
                                                  <td
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {stallList.map(
                                                      (st, idx) => (
                                                        <div key={idx}>
                                                          {st.stall_price ||
                                                            "-"}
                                                        </div>
                                                      ),
                                                    )}
                                                  </td>

                                                  {/* Total Column */}
                                                  <td
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {stallList.map(
                                                      (st, idx) => (
                                                        <div key={idx}>
                                                          {(
                                                            parseFloat(
                                                              st.stall_price ||
                                                                0,
                                                            ) *
                                                            parseFloat(
                                                              st.stall_area ||
                                                                0,
                                                            )
                                                          ).toFixed(2)}
                                                        </div>
                                                      ),
                                                    )}
                                                  </td>
                                                </tr>
                                              ),
                                            )}

                                          {/* --- Power Rows --- */}
                                          {activePaymentDetailsOverlay ===
                                            "power" &&
                                            powerServiceRows.map(
                                              (row, rowIndex) => (
                                                <>
                                                  {[
                                                    "SETUP DAYS",
                                                    "EXHIBITION DAYS",
                                                  ].map((dayType, idx) => {
                                                    const item =
                                                      exhibitorPreviewList.find(
                                                        (it) =>
                                                          it.day
                                                            .toUpperCase()
                                                            .trim() ===
                                                          dayType
                                                            .toUpperCase()
                                                            .trim(),
                                                      );
                                                    if (!item) return null;

                                                    const pricePerKw =
                                                      parseFloat(
                                                        item.pricePerKw || 0,
                                                      ).toFixed(2);
                                                    const powerRequired =
                                                      parseFloat(
                                                        item.powerRequired || 0,
                                                      );
                                                    const phase =
                                                      item.phase || "-";
                                                    const total = (
                                                      pricePerKw * powerRequired
                                                    ).toFixed(2);

                                                    // Construct stall details
                                                    let stallDetails = [];
                                                    if (
                                                      stallList.length === 1
                                                    ) {
                                                      stallDetails.push(
                                                        <span key="single-stall">
                                                          STALL NO:{" "}
                                                          {stallList[0]
                                                            ?.stall_number ||
                                                            "N/A"}
                                                          , STALL AREA:{" "}
                                                          {stallList[0]
                                                            ?.stall_area ||
                                                            "N/A"}{" "}
                                                          sq mtr
                                                        </span>,
                                                      );
                                                    } else if (
                                                      stallList.length > 1
                                                    ) {
                                                      stallDetails =
                                                        stallList.map(
                                                          (stall, idx) => (
                                                            <span
                                                              key={`multi-stall-${idx}`}
                                                            >
                                                              {idx + 1}. STALL
                                                              NO:{" "}
                                                              {stall.stall_number ||
                                                                "N/A"}
                                                              , STALL AREA:{" "}
                                                              {stall.stall_area ||
                                                                "N/A"}{" "}
                                                              sq mtr
                                                              {idx <
                                                                stallList.length -
                                                                  1 && <br />}
                                                            </span>
                                                          ),
                                                        );
                                                    }

                                                    return (
                                                      <tr
                                                        key={`${rowIndex}-${dayType}`}
                                                      >
                                                        {/* PARTICULARS Column only for first row */}
                                                        {idx === 0 && (
                                                          <td
                                                            className="particular-cell"
                                                            style={{
                                                              textAlign: "left",
                                                              verticalAlign:
                                                                "top",
                                                            }}
                                                            rowSpan={2}
                                                          >
                                                            {row.particular
                                                              .split("\n")
                                                              .map((line, i) =>
                                                                line.startsWith(
                                                                  "**",
                                                                ) &&
                                                                line.endsWith(
                                                                  "**",
                                                                ) ? (
                                                                  <strong
                                                                    key={i}
                                                                  >
                                                                    {line.replace(
                                                                      /\*\*/g,
                                                                      "",
                                                                    )}
                                                                  </strong>
                                                                ) : (
                                                                  <span key={i}>
                                                                    {line}
                                                                  </span>
                                                                ),
                                                              )
                                                              .reduce(
                                                                (
                                                                  prev,
                                                                  curr,
                                                                  i,
                                                                ) => [
                                                                  prev,
                                                                  i > 0 && (
                                                                    <br
                                                                      key={`br${i}`}
                                                                    />
                                                                  ),
                                                                  curr,
                                                                ],
                                                                [],
                                                              )}
                                                            {stallDetails.length >
                                                              0 && (
                                                              <>
                                                                <br />
                                                                {stallDetails}
                                                              </>
                                                            )}
                                                          </td>
                                                        )}
                                                        {/* TYPE Column */}
                                                        <td
                                                          style={{
                                                            textAlign: "center",
                                                          }}
                                                        >
                                                          {dayType}
                                                        </td>
                                                        {/* PRICE PER KW Column */}
                                                        <td
                                                          style={{
                                                            textAlign: "center",
                                                          }}
                                                        >
                                                          {pricePerKw}
                                                        </td>
                                                        {/* POWER REQUIRED Column */}
                                                        <td
                                                          style={{
                                                            textAlign: "center",
                                                          }}
                                                        >
                                                          {powerRequired} unit
                                                        </td>
                                                        {/* PHASE Column */}
                                                        <td
                                                          style={{
                                                            textAlign: "center",
                                                          }}
                                                        >
                                                          {phase}
                                                        </td>
                                                        {/* TOTAL Column */}
                                                        <td
                                                          style={{
                                                            textAlign: "center",
                                                          }}
                                                        >
                                                          {total}
                                                        </td>
                                                      </tr>
                                                    );
                                                  })}
                                                </>
                                              ),
                                            )}

                                          {/* --- Power Summary --- */}
                                          {activePaymentDetailsOverlay ===
                                            "power" &&
                                            (() => {
                                              const totalCols = 5; // TYPE, PRICE PER KW, POWER REQUIRED, PHASE, TOTAL (exclude PARTICULARS because colSpan starts after it)
                                              const totalAmount =
                                                exhibitorPreviewList.reduce(
                                                  (sum, item) =>
                                                    sum +
                                                    parseFloat(
                                                      item.pricePerKw || 0,
                                                    ) *
                                                      parseFloat(
                                                        item.powerRequired || 0,
                                                      ),
                                                  0,
                                                );
                                              const grandTotal =
                                                formData.state?.toLowerCase() ===
                                                "delhi"
                                                  ? totalAmount * 1.18
                                                  : totalAmount * 1.18; // Including tax

                                              return (
                                                <>
                                                  <tr>
                                                    <td
                                                      colSpan={totalCols}
                                                      style={{
                                                        textAlign: "right",
                                                      }}
                                                    >
                                                      Total
                                                    </td>
                                                    <td>
                                                      {totalAmount.toFixed(2)}
                                                    </td>
                                                  </tr>

                                                  {formData.state?.toLowerCase() ===
                                                  "delhi" ? (
                                                    <>
                                                      <tr>
                                                        <td
                                                          colSpan={totalCols}
                                                          style={{
                                                            textAlign: "right",
                                                          }}
                                                        >
                                                          SGST (9%)
                                                        </td>
                                                        <td>
                                                          {(
                                                            totalAmount * 0.09
                                                          ).toFixed(2)}
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td
                                                          colSpan={totalCols}
                                                          style={{
                                                            textAlign: "right",
                                                          }}
                                                        >
                                                          CGST (9%)
                                                        </td>
                                                        <td>
                                                          {(
                                                            totalAmount * 0.09
                                                          ).toFixed(2)}
                                                        </td>
                                                      </tr>
                                                    </>
                                                  ) : (
                                                    <tr>
                                                      <td
                                                        colSpan={totalCols}
                                                        style={{
                                                          textAlign: "right",
                                                        }}
                                                      >
                                                        IGST (18%)
                                                      </td>
                                                      <td>
                                                        {(
                                                          totalAmount * 0.18
                                                        ).toFixed(2)}
                                                      </td>
                                                    </tr>
                                                  )}

                                                  <tr>
                                                    <td
                                                      colSpan={totalCols}
                                                      style={{
                                                        textAlign: "right",
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      Grand Total
                                                    </td>
                                                    <td>
                                                      <strong>
                                                        {grandTotal.toFixed(2)}
                                                      </strong>
                                                    </td>
                                                  </tr>
                                                </>
                                              );
                                            })()}

                                          {/* --- Summary Rows --- */}
                                          {activePaymentDetailsOverlay ===
                                            "stall" &&
                                            stallList.length > 1 && (
                                              <>
                                                <tr>
                                                  <td
                                                    colSpan={
                                                      (stallService
                                                        ?.selectedOptions
                                                        ?.length || 0) + 2
                                                    }
                                                  >
                                                    Total
                                                  </td>
                                                  <td>
                                                    {stallSummary?.total?.toFixed(
                                                      2,
                                                    ) || "0.00"}
                                                  </td>
                                                </tr>

                                                {stallSummary?.discounted_amount >
                                                  0 && (
                                                  <tr>
                                                    <td
                                                      colSpan={
                                                        (stallService
                                                          ?.selectedOptions
                                                          ?.length || 0) + 2
                                                      }
                                                    >
                                                      Discount (
                                                      {getDiscountPercent(
                                                        stallSummary,
                                                      )}
                                                      %)
                                                    </td>
                                                    <td>
                                                      {stallSummary?.discounted_amount?.toFixed(
                                                        2,
                                                      )}
                                                    </td>
                                                  </tr>
                                                )}

                                                {formData.state?.toLowerCase() ===
                                                "delhi" ? (
                                                  <>
                                                    <tr>
                                                      <td
                                                        colSpan={
                                                          (stallService
                                                            ?.selectedOptions
                                                            ?.length || 0) + 2
                                                        }
                                                      >
                                                        SGST (9%)
                                                      </td>
                                                      <td>
                                                        {stallSummary?.sgst?.toFixed(
                                                          2,
                                                        ) || "0.00"}
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td
                                                        colSpan={
                                                          (stallService
                                                            ?.selectedOptions
                                                            ?.length || 0) + 2
                                                        }
                                                      >
                                                        CGST (9%)
                                                      </td>
                                                      <td>
                                                        {stallSummary?.cgst?.toFixed(
                                                          2,
                                                        ) || "0.00"}
                                                      </td>
                                                    </tr>
                                                  </>
                                                ) : (
                                                  <tr>
                                                    <td
                                                      colSpan={
                                                        (stallService
                                                          ?.selectedOptions
                                                          ?.length || 0) + 2
                                                      }
                                                    >
                                                      IGST (18%)
                                                    </td>
                                                    <td>
                                                      {stallSummary?.igst?.toFixed(
                                                        2,
                                                      ) || "0.00"}
                                                    </td>
                                                  </tr>
                                                )}

                                                <tr>
                                                  <td
                                                    colSpan={
                                                      (stallService
                                                        ?.selectedOptions
                                                        ?.length || 0) + 2
                                                    }
                                                    style={{
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    Grand Total
                                                  </td>
                                                  <td>
                                                    <strong>
                                                      {stallSummary?.grand_total?.toFixed(
                                                        2,
                                                      ) || "0.00"}{" "}
                                                      {stallSummary?.currency ||
                                                        "INR"}
                                                    </strong>
                                                  </td>
                                                </tr>
                                              </>
                                            )}

                                          {/* Single Stall Case */}
                                          {activePaymentDetailsOverlay ===
                                            "stall" &&
                                            stallList.length === 1 &&
                                            (() => {
                                              const singleStall =
                                                stallList?.[0];
                                              return (
                                                <>
                                                  <tr>
                                                    <td
                                                      colSpan={
                                                        (stallService
                                                          ?.selectedOptions
                                                          ?.length || 0) + 2
                                                      }
                                                      style={{
                                                        textAlign: "right",
                                                      }}
                                                    >
                                                      Total
                                                    </td>
                                                    <td>
                                                      {singleStall?.total ||
                                                        "0.00"}
                                                    </td>
                                                  </tr>
                                                  {singleStall?.discount_percent &&
                                                    parseFloat(
                                                      singleStall.discount_percent,
                                                    ) > 0 && (
                                                      <tr>
                                                        <td
                                                          colSpan={
                                                            (stallService
                                                              ?.selectedOptions
                                                              ?.length || 0) + 2
                                                          }
                                                          style={{
                                                            textAlign: "right",
                                                          }}
                                                        >
                                                          Discount (
                                                          {
                                                            singleStall.discount_percent
                                                          }
                                                          %)
                                                        </td>
                                                        <td>
                                                          {singleStall?.discounted_amount ||
                                                            "0.00"}
                                                        </td>
                                                      </tr>
                                                    )}
                                                  {formData.state?.toLowerCase() ===
                                                  "delhi" ? (
                                                    <>
                                                      <tr>
                                                        <td
                                                          colSpan={
                                                            (stallService
                                                              ?.selectedOptions
                                                              ?.length || 0) + 2
                                                          }
                                                          style={{
                                                            textAlign: "right",
                                                          }}
                                                        >
                                                          SGST (9%)
                                                        </td>
                                                        <td>
                                                          {singleStall?.sgst_9_percent ||
                                                            "0.00"}
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td
                                                          colSpan={
                                                            (stallService
                                                              ?.selectedOptions
                                                              ?.length || 0) + 2
                                                          }
                                                          style={{
                                                            textAlign: "right",
                                                          }}
                                                        >
                                                          CGST (9%)
                                                        </td>
                                                        <td>
                                                          {singleStall?.cgst_9_percent ||
                                                            "0.00"}
                                                        </td>
                                                      </tr>
                                                    </>
                                                  ) : (
                                                    <tr>
                                                      <td
                                                        colSpan={
                                                          (stallService
                                                            ?.selectedOptions
                                                            ?.length || 0) + 2
                                                        }
                                                        style={{
                                                          textAlign: "right",
                                                        }}
                                                      >
                                                        IGST (18%)
                                                      </td>
                                                      <td>
                                                        {singleStall?.igst_18_percent ||
                                                          "0.00"}
                                                      </td>
                                                    </tr>
                                                  )}
                                                  <tr>
                                                    <td
                                                      colSpan={
                                                        (stallService
                                                          ?.selectedOptions
                                                          ?.length || 0) + 2
                                                      }
                                                      style={{
                                                        textAlign: "right",
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      Grand Total
                                                    </td>
                                                    <td>
                                                      <strong>
                                                        {stallSummary?.grand_total?.toFixed(
                                                          2,
                                                        ) ||
                                                          singleStall?.grand_total?.toFixed(
                                                            2,
                                                          ) ||
                                                          "0.00"}
                                                      </strong>
                                                    </td>
                                                  </tr>
                                                </>
                                              );
                                            })()}

                                          {/* HSN Code & INR in Words */}
                                          <tr>
                                            <td
                                              colSpan={Math.floor(
                                                ((stallService?.selectedOptions
                                                  ?.length || 0) +
                                                  4) /
                                                  2,
                                              )}
                                              style={{
                                                textAlign: "left",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              HSN CODE: 998596
                                            </td>
                                            <td
                                              colSpan={Math.ceil(
                                                ((stallService?.selectedOptions
                                                  ?.length || 0) +
                                                  4) /
                                                  2,
                                              )}
                                              style={{
                                                textAlign: "right",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              <em>
                                                {activePaymentDetailsOverlay ===
                                                "stall"
                                                  ? numberToWords(
                                                      stallSummary?.grand_total ||
                                                        stallList?.[0]
                                                          ?.grand_total ||
                                                        0,
                                                    )
                                                  : activePaymentDetailsOverlay ===
                                                      "power"
                                                    ? numberToWords(grandTotal)
                                                    : ""}
                                              </em>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>

                                      <hr />

                                      {/* Bank Details */}
                                      <div className="bank-details">
                                        <h4>BANK DETAILS</h4>
                                        <div className="bank-row">
                                          <div className="bank-column">
                                            <p>
                                              <strong>A/C Name:</strong> RSD
                                              EXPOSITIONS
                                            </p>
                                            <p>
                                              <strong>Bank Name:</strong> Kotak
                                              Mahindra Bank
                                            </p>
                                            <p>
                                              <strong>Bank A/c No.:</strong>{" "}
                                              01992000000491
                                            </p>
                                            <p>
                                              <strong>Address:</strong> Defence
                                              Colony, New Delhi
                                            </p>
                                            <p>
                                              <strong>IFSC Code:</strong>{" "}
                                              KKBK0004620
                                            </p>
                                          </div>
                                          <div className="bank-column">
                                            <p>
                                              <strong>A/C Name:</strong> RSD
                                              EXPOSITIONS
                                            </p>
                                            <p>
                                              <strong>Bank Name:</strong> HDFC
                                              BANK
                                            </p>
                                            <p>
                                              <strong>Bank A/c No.:</strong>{" "}
                                              99999811045088
                                            </p>
                                            <p>
                                              <strong>Address:</strong> Delhi
                                            </p>
                                            <p>
                                              <strong>IFSC Code:</strong>{" "}
                                              HDFC0000578
                                            </p>
                                          </div>
                                          <div className="bank-column">
                                            <p>
                                              <strong>A/C Name:</strong> RSD
                                              EXPOSITIONS
                                            </p>
                                            <p>
                                              <strong>Bank Name:</strong>{" "}
                                              IndusInd Bank
                                            </p>
                                            <p>
                                              <strong>Bank A/c No.:</strong>{" "}
                                              259811045088
                                            </p>
                                            <p>
                                              <strong>Address:</strong> Karol
                                              Bagh, New Delhi
                                            </p>
                                            <p>
                                              <strong>IFSC Code:</strong>{" "}
                                              INDB0000169
                                            </p>
                                          </div>
                                          <div className="bank-column">
                                            <p>
                                              <strong>A/C Name:</strong> RSD
                                              EXPOSITIONS
                                            </p>
                                            <p>
                                              <strong>Bank Name:</strong> Axis
                                              Bank Ltd
                                            </p>
                                            <p>
                                              <strong>Bank A/c No.:</strong>{" "}
                                              0032144225
                                            </p>
                                            <p>
                                              <strong>Address:</strong> Delhi
                                            </p>
                                            <p>
                                              <strong>IFSC Code:</strong>{" "}
                                              UTIB0005109
                                            </p>
                                          </div>
                                        </div>
                                      </div>

                                      <hr />

                                      {/* Footer */}
                                      <div className="invoice-footer">
                                        <p>
                                          <strong>
                                            ALL CHEQUES SHOULD BE SENT TO THE
                                            FOLLOWING ADDRESS
                                          </strong>
                                        </p>
                                        <p>
                                          <strong>RSD EXPOSITIONS</strong>
                                        </p>
                                        <p>
                                          <strong>
                                            A-99 Defence Colony, New Delhi -
                                            110024
                                          </strong>
                                        </p>
                                        <p>
                                          <strong>
                                            THIS IS NOT AN INVOICE, THE FINAL
                                            TAX INVOICE WILL BE ISSUED LATER
                                          </strong>
                                        </p>
                                      </div>
                                    </div>

                                    {/* Buttons */}
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: "10px",
                                        marginTop: "20px",
                                        paddingRight: "30px",
                                      }}
                                    >
                                      <button
                                        onClick={handleDownloadPDF}
                                        className="download-pdf-button"
                                      >
                                        Download PDF
                                      </button>
                                      <button
                                        onClick={handleSendPDFEmail}
                                        className="send-email-button"
                                      >
                                        Send Email
                                      </button>
                                    </div>
                                  </div>
                                )}
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {activeNavbarItem === "FACIA BOARD" && (
                      <div className="facia-board-form slide-up-form">
                        <h2 className="facia-board-heading">Facia Board</h2>

                        <div className="facia-board-row">
                          <div className="facia-board-input-section">
                            <label htmlFor="faciaText">Enter Facia Text:</label>
                            <input
                              type="text"
                              id="faciaText"
                              placeholder="Company Name or Text for Facia"
                              value={faciaText}
                              onChange={(e) => setFaciaText(e.target.value)}
                            />
                          </div>

                          <div className="facia-board-button-section">
                            <button
                              className="payment-details-add-payment-btn"
                              onClick={
                                showExhibitorEditForm
                                  ? handleUpdateFacia
                                  : handleSubmitFacia
                              }
                            >
                              {showExhibitorEditForm ? "Update" : "Submit"}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {activeNavbarItem === "BRANDS" && (
                      <div className="brands-container">
                        {/* ================= LEFT SIDE VIEW ================= */}

                        <div className="brands-form-admin slide-up-form">
                          <h2 className="brands-heading">Brands Preview</h2>

                          <div className="brands-input-row">
                            <div className="brands-field-group">
                              <label>Website:</label>
                              <p>{brandsData.website || "-"}</p>
                            </div>

                            <div className="brands-field-group">
                              <label>Products:</label>

                              <div className="selected-products-container">
                                {(brandsData.products || []).length > 0 &&
                                brandsData.products.length > 0 ? (
                                  brandsData.products.map((product, index) => (
                                    <div
                                      key={index}
                                      className="selected-product"
                                    >
                                      {product}
                                    </div>
                                  ))
                                ) : (
                                  <p>-</p>
                                )}
                              </div>
                            </div>

                            <div className="brands-field-group">
                              <label>Home Brands:</label>
                              <p>{brandsData.home_brands || "-"}</p>
                            </div>

                            <div className="brands-field-group">
                              <label>Distributors of Brands:</label>
                              <p>{brandsData.distributors || "-"}</p>
                            </div>

                            <div className="brands-field-group">
                              <label>International Brands:</label>
                              <p>{brandsData.international_brands || "-"}</p>
                            </div>
                          </div>
                        </div>

                        {/* ================= RIGHT SIDE FORM ================= */}

                        <div className="brands-form slide-up-form">
                          <h2 className="brands-heading">Brands</h2>

                          <div className="brands-input-row">
                            <div className="brands-field-group">
                              <label>Website:</label>
                              <input
                                type="text"
                                value={brandsData.website}
                                onChange={(e) =>
                                  setBrandsData((prev) => ({
                                    ...prev,
                                    website: e.target.value,
                                  }))
                                }
                              />
                            </div>

                            <div className="brands-field-group">
                              <label>Products:</label>

                              <div className="selected-products-container">
                                {Array.isArray(brandsData.products) &&
                                  brandsData.products.map((product, index) => (
                                    <div
                                      key={index}
                                      className="selected-product"
                                    >
                                      {product}

                                      <span
                                        className="remove-icon"
                                        onClick={() =>
                                          setBrandsData((prev) => ({
                                            ...prev,
                                            products: prev.products.filter(
                                              (p) => p !== product,
                                            ),
                                          }))
                                        }
                                      >
                                        ✖
                                      </span>
                                    </div>
                                  ))}
                              </div>

                              <select
                                value=""
                                onChange={(e) => {
                                  const selected = e.target.value;

                                  if (
                                    selected &&
                                    !brandsData.products.includes(selected)
                                  ) {
                                    setBrandsData((prev) => ({
                                      ...prev,
                                      products: [...prev.products, selected],
                                    }));
                                  }
                                }}
                              >
                                <option value="">-- Select Product --</option>

                                {products.map((product, index) => (
                                  <option key={index} value={product.name}>
                                    {product.name}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="brands-field-group">
                              <label>Home Brands:</label>
                              <input
                                type="text"
                                value={brandsData.home_brands}
                                onChange={(e) =>
                                  setBrandsData((prev) => ({
                                    ...prev,
                                    home_brands: e.target.value,
                                  }))
                                }
                              />
                            </div>

                            <div className="brands-field-group">
                              <label>Distributors of Brands:</label>
                              <input
                                type="text"
                                value={brandsData.distributors}
                                onChange={(e) =>
                                  setBrandsData((prev) => ({
                                    ...prev,
                                    distributors: e.target.value,
                                  }))
                                }
                              />
                            </div>

                            <div className="brands-field-group">
                              <label>International Brands:</label>
                              <input
                                type="text"
                                value={brandsData.international_brands}
                                onChange={(e) =>
                                  setBrandsData((prev) => ({
                                    ...prev,
                                    international_brands: e.target.value,
                                  }))
                                }
                              />
                            </div>
                          </div>

                          <div className="brands-button-section">
                            <button
                              className="brands-details-add-brands-btn"
                              onClick={
                                showBrandsEditForm
                                  ? handleUpdateBrands
                                  : handleSubmitBrands
                              }
                            >
                              {showBrandsEditForm ? "Update" : "Submit"}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </>
    </div>
  );
};

export default ExhibitorsPanel;
